var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 176);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 1 */

/***/
function (module, exports) {
  module.exports = require("prop-types");
  /***/
},
/* 2 */

/***/
function (module, exports) {
  module.exports = require("react-redux");
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _annotation = __webpack_require__(250);

  Object.keys(_annotation).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _annotation[key];
      }
    });
  });

  var _clipboard = __webpack_require__(251);

  Object.keys(_clipboard).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _clipboard[key];
      }
    });
  });

  var _code = __webpack_require__(252);

  Object.keys(_code).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _code[key];
      }
    });
  });

  var _comment = __webpack_require__(253);

  Object.keys(_comment).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _comment[key];
      }
    });
  });

  var _device = __webpack_require__(254);

  Object.keys(_device).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _device[key];
      }
    });
  });

  var _devTools = __webpack_require__(255);

  Object.keys(_devTools).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _devTools[key];
      }
    });
  });

  var _downloadAssets = __webpack_require__(256);

  Object.keys(_downloadAssets).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _downloadAssets[key];
      }
    });
  });

  var _embedly = __webpack_require__(257);

  Object.keys(_embedly).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _embedly[key];
      }
    });
  });

  var _grid = __webpack_require__(258);

  Object.keys(_grid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _grid[key];
      }
    });
  });

  var _handoff = __webpack_require__(259);

  Object.keys(_handoff).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _handoff[key];
      }
    });
  });

  var _homeScreen = __webpack_require__(260);

  Object.keys(_homeScreen).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _homeScreen[key];
      }
    });
  });

  var _hotspot = __webpack_require__(261);

  Object.keys(_hotspot).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _hotspot[key];
      }
    });
  });

  var _imageLoading = __webpack_require__(262);

  Object.keys(_imageLoading).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _imageLoading[key];
      }
    });
  });

  var _location = __webpack_require__(263);

  Object.keys(_location).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _location[key];
      }
    });
  });

  var _overlay = __webpack_require__(264);

  Object.keys(_overlay).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _overlay[key];
      }
    });
  });

  var _password = __webpack_require__(265);

  Object.keys(_password).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _password[key];
      }
    });
  });

  var _player = __webpack_require__(266);

  Object.keys(_player).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _player[key];
      }
    });
  });

  var _project = __webpack_require__(267);

  Object.keys(_project).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _project[key];
      }
    });
  });

  var _tracking = __webpack_require__(268);

  Object.keys(_tracking).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _tracking[key];
      }
    });
  });

  var _screen = __webpack_require__(269);

  Object.keys(_screen).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _screen[key];
      }
    });
  });

  var _user = __webpack_require__(270);

  Object.keys(_user).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _user[key];
      }
    });
  });
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _annotation = __webpack_require__(83);

  Object.keys(_annotation).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _annotation[key];
      }
    });
  });

  var _clipboard = __webpack_require__(271);

  Object.keys(_clipboard).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _clipboard[key];
      }
    });
  });

  var _code = __webpack_require__(272);

  Object.keys(_code).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _code[key];
      }
    });
  });

  var _comment = __webpack_require__(273);

  Object.keys(_comment).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _comment[key];
      }
    });
  });

  var _device = __webpack_require__(274);

  Object.keys(_device).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _device[key];
      }
    });
  });

  var _devTools = __webpack_require__(275);

  Object.keys(_devTools).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _devTools[key];
      }
    });
  });

  var _downloadAssets = __webpack_require__(84);

  Object.keys(_downloadAssets).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _downloadAssets[key];
      }
    });
  });

  var _embedly = __webpack_require__(276);

  Object.keys(_embedly).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _embedly[key];
      }
    });
  });

  var _grid = __webpack_require__(277);

  Object.keys(_grid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _grid[key];
      }
    });
  });

  var _handoff = __webpack_require__(85);

  Object.keys(_handoff).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _handoff[key];
      }
    });
  });

  var _homeScreen = __webpack_require__(278);

  Object.keys(_homeScreen).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _homeScreen[key];
      }
    });
  });

  var _hotspots = __webpack_require__(279);

  Object.keys(_hotspots).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _hotspots[key];
      }
    });
  });

  var _hover = __webpack_require__(280);

  Object.keys(_hover).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _hover[key];
      }
    });
  });

  var _imageLoading = __webpack_require__(281);

  Object.keys(_imageLoading).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _imageLoading[key];
      }
    });
  });

  var _location = __webpack_require__(282);

  Object.keys(_location).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _location[key];
      }
    });
  });

  var _overlay = __webpack_require__(283);

  Object.keys(_overlay).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _overlay[key];
      }
    });
  });

  var _player = __webpack_require__(284);

  Object.keys(_player).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _player[key];
      }
    });
  });

  var _project = __webpack_require__(285);

  Object.keys(_project).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _project[key];
      }
    });
  });

  var _tracking = __webpack_require__(293);

  Object.keys(_tracking).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _tracking[key];
      }
    });
  });

  var _screen = __webpack_require__(132);

  Object.keys(_screen).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _screen[key];
      }
    });
  });

  var _user = __webpack_require__(294);

  Object.keys(_user).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _user[key];
      }
    });
  });
  /***/
},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.hasHandoffData = hasHandoffData;
  exports.getCurrentCanvasID = getCurrentCanvasID;
  exports.getArtboardTitle = getArtboardTitle;
  exports.getArtboardSize = getArtboardSize;
  exports.getDocumentColors = getDocumentColors;
  exports.isInHandoffMode = isInHandoffMode;
  exports.getZoomScale = getZoomScale;
  exports.getInitialZoom = getInitialZoom;
  exports.getElements = getElements;
  exports.getElementHotspots = getElementHotspots;
  exports.isElementSelected = isElementSelected;
  exports.isElementHovered = isElementHovered;
  exports.isElementHoverable = isElementHoverable;
  exports.isElementSelectable = isElementSelectable;
  exports.getSelectedElementIndex = getSelectedElementIndex;
  exports.getSelectedElement = getSelectedElement;
  exports.getSelectedElementType = getSelectedElementType;
  exports.getSelectedElementLayout = getSelectedElementLayout;
  exports.getHoveredElement = getHoveredElement;
  exports.getHoveredElementLayout = getHoveredElementLayout;
  exports.showGuides = showGuides;
  exports.showRelativeGuides = showRelativeGuides;
  exports.isHandoffEnabled = isHandoffEnabled;
  exports.getHandoffState = getHandoffState;
  exports.isHandoffAvaible = isHandoffAvaible;
  exports.isHandoffButtonVisible = isHandoffButtonVisible;
  exports.getEaselConfig = getEaselConfig;
  exports.getUnit = getUnit;
  exports.getPixelRatio = getPixelRatio;
  exports.getArtboard = getArtboard;
  exports.getZoomPercentage = getZoomPercentage;
  exports.getZoomFit = getZoomFit;

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _uniqWith = __webpack_require__(199);

  var _uniqWith2 = babelHelpers.interopRequireDefault(_uniqWith);

  var _findIndex = __webpack_require__(53);

  var _findIndex2 = babelHelpers.interopRequireDefault(_findIndex);

  var _screen = __webpack_require__(9);

  var _zoom = __webpack_require__(117);

  var zoom = babelHelpers.interopRequireWildcard(_zoom);

  var _element = __webpack_require__(16);

  var _colors = __webpack_require__(119);

  var _convertColours = __webpack_require__(27);

  var convert = babelHelpers.interopRequireWildcard(_convertColours);

  var _requestStatus = __webpack_require__(31);

  var requestStatus = babelHelpers.interopRequireWildcard(_requestStatus);

  var _handoffState = __webpack_require__(120);

  var handoffState = babelHelpers.interopRequireWildcard(_handoffState);

  var _tree = __webpack_require__(121);

  var tree = babelHelpers.interopRequireWildcard(_tree);

  function hasHandoffData(state) {
    return !!(0, _screen.getCurrentScreen)(state).canvasID;
  }

  function getCurrentCanvasID(state) {
    return (0, _get2.default)(state, 'handoff.canvas.id');
  }

  function getArtboardTitle(state) {
    return (0, _get2.default)(state, 'handoff.canvas.title', 'Handoff');
  }

  function getArtboardSize(state) {
    return (0, _get2.default)(state, 'handoff.canvas.artboard.size');
  }

  function getDocumentColors(state) {
    var allColors = state.handoff.flatCanvas.reduce(function (colors, element) {
      return colors.concat((0, _element.getElementColors)(element));
    }, []);
    allColors.push.apply(allColors, babelHelpers.toConsumableArray(getArtboard(state).fills.map(function (c) {
      return c.color;
    })));
    var opacityCols = [];
    var solidCols = [];
    allColors.forEach(function (col) {
      return convert.hasOpacity(col) ? opacityCols.push(col) : solidCols.push(col);
    });
    solidCols = getUniqueNonEmptyColors(solidCols, convert.rgbArray2css);
    opacityCols = getUniqueNonEmptyColors(opacityCols, convert.rgbaArray2rgba);
    solidCols.sort(_colors.compareColors);
    opacityCols.sort(_colors.compareColors);
    return {
      solidCols: solidCols,
      opacityCols: opacityCols
    };
  }

  function getUniqueNonEmptyColors(colors, compareValueFunc) {
    return (0, _uniqWith2.default)(colors, function (a, b) {
      return compareValueFunc(a) === compareValueFunc(b);
    }).filter(function (e) {
      return e.length;
    });
  }

  function isInHandoffMode(state) {
    // Note we need to check if handoff is enabled here as deeplink to
    // handoff will set isOpen = true _before_ the project has loaded and we
    // know whether handoff is enabled
    //  return state.handoff.isOpen;
    return state.handoff.isOpen && (isHandoffEnabled(state) || !state.user.isAuthenticated);
  }

  function getZoomScale(state) {
    return getZoomPercentage(state) / 100;
  }

  function getInitialZoom(state, availableWidth) {
    if (!(0, _get2.default)(state, 'project.config.isWeb')) {
      return zoom.DEFAULT_POSITION;
    }

    var renderedDimensions = (0, _screen.getRenderedScreenDimensions)(state);
    var imageWidth = (0, _get2.default)(state, 'screen.currentScreen.img.width');

    if (imageWidth && renderedDimensions) {
      if (imageWidth <= availableWidth) {
        return zoom.getPositionForPercentage(100);
      }

      return getFittedZoomPosition(imageWidth, availableWidth);
    }

    return zoom.DEFAULT_POSITION;
  }

  function getFittedZoomPosition(imageWidth, availableWidth) {
    var fittedZoom = availableWidth * 100 / imageWidth;
    var closestZoom = 0;

    for (var i = 0; i < zoom.LEVELS.length; i += 1) {
      if (zoom.LEVELS[i] <= fittedZoom) {
        closestZoom = i;
      } else {
        break;
      }
    }

    return closestZoom;
  }

  function getElements(state) {
    if (!isInHandoffMode(state) || !isHandoffAvaible(state) || !state.handoff.flatCanvas) {
      return [];
    }

    return state.handoff.flatCanvas;
  }

  function getElementHotspots(state) {
    return getElements(state).map(function (element, index) {
      return babelHelpers.extends({
        id: index
      }, (0, _element.getElementLayout)(element));
    });
  }

  function isElementSelected(state, elementID) {
    return state.handoff.selectedItemID === elementID;
  }

  function isElementHovered(state, elementID) {
    return state.handoff.hoveredItemID === elementID;
  }

  function isElementHoverable(state, elementID) {
    var _state$handoff = state.handoff,
        selectedItemID = _state$handoff.selectedItemID,
        hoveredItemID = _state$handoff.hoveredItemID;
    return selectedItemID !== null && selectedItemID !== elementID || hoveredItemID === null;
  }

  function isElementSelectable(state, index) {
    var actual = getSelectedElementIndex(state, index);
    return actual === index;
  }

  function getSelectedElementIndex(state, clickedElementIndex) {
    var clicked = state.handoff.flatCanvas[clickedElementIndex];
    var current = state.handoff.flatCanvas[state.handoff.selectedItemID];

    if (tree.isElementNested(clicked) && !tree.isElementInSameTopLevelGroupAsCurrentSelectionAndNoDeeper(current, clicked)) {
      var selected = tree.getAncestorOfElementThatIsChildOfCurrrentSelection(current, clicked);

      if (!selected) {
        selected = tree.getTopLevelGroup(clicked);
      }
      /* eslint-disable no-param-reassign */


      var newIndex = getElementIndex(state, selected);
      return newIndex;
    }

    return clickedElementIndex;
  }

  function getElementIndex(state, element) {
    return (0, _findIndex2.default)(state.handoff.flatCanvas, function (el) {
      return el === element;
    });
  }

  function getSelectedElement(state) {
    if (state.handoff.selectedItemID === null) {
      return null;
    }

    return state.handoff.flatCanvas[state.handoff.selectedItemID];
  }

  function getSelectedElementType(state) {
    var selectedElement = getSelectedElement(state);

    if (!selectedElement) {
      return 'default';
    }

    return selectedElement.className.toLowerCase();
  }

  function getSelectedElementLayout(state) {
    var element = getSelectedElement(state);

    if (!element) {
      return {};
    }

    return (0, _element.getElementLayout)(element);
  }

  function getHoveredElement(state) {
    if (state.handoff.hoveredItemID === null) {
      return null;
    }

    return state.handoff.flatCanvas[state.handoff.hoveredItemID];
  }

  function getHoveredElementLayout(state) {
    var element = getHoveredElement(state);

    if (!element) {
      return {};
    }

    return (0, _element.getElementLayout)(element);
  }

  function showGuides(state, id) {
    var _state$handoff2 = state.handoff,
        selectedItemID = _state$handoff2.selectedItemID,
        hoveredItemID = _state$handoff2.hoveredItemID;
    return isElementSelectedAndNoneHovered(selectedItemID, hoveredItemID, id) || isElementHoveredAndNoneSelected(selectedItemID, hoveredItemID, id) || isSameElementSelectedAndHovered(selectedItemID, hoveredItemID, id);
  }

  function showRelativeGuides(state) {
    var _state$handoff3 = state.handoff,
        hoveredItemID = _state$handoff3.hoveredItemID,
        selectedItemID = _state$handoff3.selectedItemID;
    return hoveredItemID !== null && selectedItemID !== null && selectedItemID !== hoveredItemID;
  }

  function isElementSelectedAndNoneHovered(selectedItemID, hoveredItemID, id) {
    return selectedItemID === id && hoveredItemID === null;
  }

  function isElementHoveredAndNoneSelected(selectedItemID, hoveredItemID, id) {
    return hoveredItemID === id && selectedItemID === null;
  }

  function isSameElementSelectedAndHovered(selectedItemID, hoveredItemID, id) {
    return hoveredItemID === id && selectedItemID === id;
  } // TODO: remove selector, it's always enabled now


  function isHandoffEnabled() {
    return true;
  } // TODO Mock properly in tests


  function getHandoffState(state) {
    if (false) {
      return handoffState.AVAILABLE;
    }

    if (!hasHandoffData(state)) {
      return handoffState.NO_HANDOFF_DATA;
    }

    if (state.handoff.requestStatus === requestStatus.ERROR) {
      return handoffState.REQUEST_ERROR;
    }

    return handoffState.AVAILABLE;
  }

  function isHandoffAvaible(state) {
    return getHandoffState(state) === handoffState.AVAILABLE;
  } // TODO remove selector, it's always visible now


  function isHandoffButtonVisible() {
    return true;
  }

  function getEaselConfig(state) {
    return {
      canvasEaselHost: state.project.canvasEaselHost
    };
  }

  function getUnit(state) {
    return state.handoff.unit;
  }

  function getPixelRatio(state) {
    return (0, _get2.default)(state, 'handoff.canvas.artboard.pixelRatio', 1);
  }

  function getArtboard(state) {
    if (!state.handoff.canvas) {
      return {};
    }

    var artboard = state.handoff.canvas.artboard;
    var data = {
      width: artboard.size[0],
      height: artboard.size[1],
      fills: (0, _colors.getColorFills)((0, _get2.default)(artboard, 'fills', []))
    };
    return data;
  }

  function getZoomPercentage(state) {
    return zoom.getZoomPercentage(state.handoff.zoomPosition);
  }

  function getZoomFit(state) {
    return state.handoff.zoomFit;
  }
  /***/

},
/* 6 */

/***/
function (module, exports) {
  module.exports = require("classnames");
  /***/
},
/* 7 */

/***/
function (module, exports) {
  module.exports = require("redux");
  /***/
},
/* 8 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = onlyIf;

  var _branch = __webpack_require__(194);

  var _branch2 = babelHelpers.interopRequireDefault(_branch);

  var _renderNothing = __webpack_require__(195);

  var _renderNothing2 = babelHelpers.interopRequireDefault(_renderNothing);

  var _identity = __webpack_require__(196);

  var _identity2 = babelHelpers.interopRequireDefault(_identity);

  function onlyIf(condition) {
    return (0, _branch2.default)(function (props) {
      return condition(props);
    }, _identity2.default, _renderNothing2.default);
  }
  /***/

},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getCurrentScreenProps = getCurrentScreenProps;
  exports.getPreviousScreenProps = getPreviousScreenProps;
  exports.getPendingAndLoadedScreenCounts = getPendingAndLoadedScreenCounts;
  exports.getPreviewScreenImgURL = getPreviewScreenImgURL;
  exports.getCurrentScreen = getCurrentScreen;
  exports.getCurrentScreenImageWidth = getCurrentScreenImageWidth;
  exports.getCurrentOverlayScreen = getCurrentOverlayScreen;
  exports.getPreviousScreen = getPreviousScreen;
  exports.getRenderedScreenDimensions = getRenderedScreenDimensions;
  exports.getScreen = getScreen;
  exports.getTopBackgroundColour = getTopBackgroundColour;
  exports.getBottomBackgroundColour = getBottomBackgroundColour;
  exports.isTransitionComplete = isTransitionComplete;
  exports.isGIFResetRequired = isGIFResetRequired;
  exports.areInitialScreensPreloaded = areInitialScreensPreloaded;
  exports.getCurrentScreenIndex = getCurrentScreenIndex;

  var _findIndex = __webpack_require__(53);

  var _findIndex2 = babelHelpers.interopRequireDefault(_findIndex);

  var _isNumber = __webpack_require__(116);

  var _isNumber2 = babelHelpers.interopRequireDefault(_isNumber);

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _annotation = __webpack_require__(20);

  var _overlay = __webpack_require__(36);

  var _hotspot = __webpack_require__(28);

  var _project = __webpack_require__(11);

  var _imagePreloading = __webpack_require__(75);

  var _handoff = __webpack_require__(5);

  var _screen = __webpack_require__(76);

  function getCurrentScreenProps(state) {
    var screen = getCurrentScreen(state);
    var isLoaded = (0, _imagePreloading.isImageLoaded)(state, screen.id);
    var isDownloadFailed = (0, _imagePreloading.isImageError)(state, screen.id);
    return babelHelpers.extends({
      isVisible: true,
      isCurrent: true,
      isPlacingAnnotation: (0, _annotation.isInAnnotationMode)(state),
      isLoaded: isLoaded,
      isDownloadFailed: isDownloadFailed,
      isScreenTransitionComplete: isTransitionComplete(state)
    }, screen, getCommonProps(state));
  }

  function getPreviousScreenProps(state) {
    var transition = state.screen.transition;

    if (!transition || isTransitionComplete(state)) {
      // If there's no transition we don't need to show the previous
      // screen as it's just being directly replaced with no animation
      return {};
    }

    var screen = getPreviousScreen(state);
    var isLoaded = false;
    var isDownloadFailed = false;

    if (screen) {
      isLoaded = (0, _imagePreloading.isImageLoaded)(state, screen.id);
      isDownloadFailed = (0, _imagePreloading.isImageError)(state, screen.id);
    }

    var isTransitioning = !isTransitionComplete(state);
    return babelHelpers.extends({
      isCurrent: false,
      isScreenTransitionComplete: !isTransitioning,
      isVisible: screen.id && isTransitioning,
      isLoaded: isLoaded,
      isDownloadFailed: isDownloadFailed
    }, screen, getCommonProps(state));
  }

  function getCommonProps(state) {
    return {
      size: state.screen.renderedDimensions,
      backgroundColor: state.project.config.screenBackgroundColour,
      transition: state.screen.transition,
      isTransitionReversed: state.screen.isTransitionReversed
    };
  }

  function getPendingAndLoadedScreenCounts(state) {
    var noOfLoadedImages = 0;
    var screenSequence = state.screen.screenSequence;
    screenSequence.forEach(function (screen) {
      /*
       * Loaded screen should be neither PRELOADING nor IDLE
       * Can't check for `isImageLoaded`, because that fails for images RELOADING,
       * which casuses player to rerender and breaks scroll (i.e. doesn't remember scroll position)
      */
      var isLoaded = !(0, _imagePreloading.isImageLoading)(state, screen.id) && !(0, _imagePreloading.isImageIdle)(state, screen.id);

      if (isLoaded) {
        noOfLoadedImages += 1;
      }
    });
    var noOfImagesToPreload = getNoOfImagesToPreloadBeforeShowingFirstScreen(state);
    var noOfPendingImages = Math.max(0, noOfImagesToPreload - noOfLoadedImages);
    return {
      noOfPendingImages: noOfPendingImages,
      noOfLoadedImages: noOfLoadedImages
    };
  }

  function getPreviewScreenImgURL(state) {
    var screen = getCurrentScreen(state);
    return screen.img.url;
  }

  function getCurrentScreen(state) {
    var currentOverlayScreen = getCurrentOverlayScreen(state);

    if (currentOverlayScreen && (0, _handoff.isInHandoffMode)(state)) {
      return currentOverlayScreen;
    }

    return state.screen.currentScreen || {};
  }

  function getCurrentScreenImageWidth(state) {
    return (0, _get2.default)(state, 'screen.currentScreen.img.width');
  }

  function getCurrentOverlayScreen(state) {
    var currentOverlayHotspotID = state.screen.currentOverlayHotspot.id;

    if (currentOverlayHotspotID) {
      var currentOverlayID = (0, _hotspot.getHotspotByID)(state, currentOverlayHotspotID);

      if (currentOverlayID) {
        return (0, _overlay.getOverlayByID)(state, currentOverlayID.destinationScreenID);
      }
    }

    return null;
  }

  function getPreviousScreen(state) {
    return state.screen.previousScreen || {};
  }

  function getRenderedScreenDimensions(state) {
    return state.screen.renderedDimensions;
  }

  function getScreen(state, isCurrentOrScreenID) {
    if ((0, _isNumber2.default)(isCurrentOrScreenID)) {
      return state.project.config.screenMap[isCurrentOrScreenID];
    }

    if (isCurrentOrScreenID) {
      return getCurrentScreen(state);
    }

    return getPreviousScreen(state);
  }

  function getTopBackgroundColour(state, isCurrent) {
    return getColour(state, 'top', isCurrent);
  }

  function getBottomBackgroundColour(state, isCurrent) {
    return getColour(state, 'bottom', isCurrent);
  }

  function getColour(state, prop, isCurrent) {
    if (!isCurrent) {
      return null;
    }

    return state.screen.currentScreen.colorSamples[prop];
  }

  function isTransitionComplete(state) {
    var _state$screen$isTrans = state.screen.isTransitionComplete,
        previous = _state$screen$isTrans.previous,
        current = _state$screen$isTrans.current;
    return previous && current;
  }

  function isGIFResetRequired(state) {
    return getCurrentScreen(state).img.url === state.screen.resetGIF;
  }

  function areInitialScreensPreloaded(state) {
    var _getPendingAndLoadedS = getPendingAndLoadedScreenCounts(state),
        noOfPendingImages = _getPendingAndLoadedS.noOfPendingImages;

    return noOfPendingImages === 0;
  }

  function getCurrentScreenIndex(state) {
    var currentScreen = getCurrentScreen(state);
    return (0, _findIndex2.default)(state.screenSequence, function (s) {
      return s.id === currentScreen.id;
    });
  }

  function getNoOfImagesToPreloadBeforeShowingFirstScreen(state) {
    if ((0, _project.isEmbedded)(state)) {
      return _screen.NO_OF_SCREENS_TO_PRELOAD_WHEN_EMBEDDED;
    }

    var images = state.project.config.screens.filter(function (screen) {
      return (0, _imagePreloading.isImageLoadable)(screen);
    });
    return Math.min(_screen.NO_OF_SCREENS_TO_PRELOAD, images.length);
  }
  /***/

},
/* 10 */

/***/
function (module, exports) {
  module.exports = require("redux-saga/effects");
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getOverallImageLoadingProgress = getOverallImageLoadingProgress;
  exports.getProjectID = getProjectID;
  exports.getProjectNumericID = getProjectNumericID;
  exports.getIsCommentingEnabled = getIsCommentingEnabled;
  exports.isCentredWebPrototype = isCentredWebPrototype;
  exports.getOrientation = getOrientation;
  exports.getFrame = getFrame;
  exports.isWeb = isWeb;
  exports.isPro = isPro;
  exports.isEmbedded = isEmbedded;
  exports.getCompanyColourAndLogo = getCompanyColourAndLogo;
  exports.getPlatform = getPlatform;
  exports.isAppleWatch = isAppleWatch;
  exports.getNoOfScreens = getNoOfScreens;
  exports.getScreenById = getScreenById;
  exports.getScreenByIndex = getScreenByIndex;

  var _filter = __webpack_require__(68);

  var _filter2 = babelHelpers.interopRequireDefault(_filter);

  var _size = __webpack_require__(107);

  var _size2 = babelHelpers.interopRequireDefault(_size);

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _platform = __webpack_require__(69);

  var platform = babelHelpers.interopRequireWildcard(_platform);

  var _imagePreloading = __webpack_require__(30);

  var imagePreloadingStatus = babelHelpers.interopRequireWildcard(_imagePreloading);

  function getOverallImageLoadingProgress(state) {
    var imagePreloading = state.imagePreloading;
    var noOfImages = (0, _size2.default)(imagePreloading);
    var noOfLoadedImages = (0, _size2.default)((0, _filter2.default)(imagePreloading, isLoaded));
    return {
      noOfImages: noOfImages,
      noOfLoadedImages: noOfLoadedImages
    };
  }

  function getProjectID(state) {
    return (0, _get2.default)(state, 'project.config.id');
  }

  function getProjectNumericID(state) {
    return (0, _get2.default)(state, 'project.config.numericID');
  }

  function getIsCommentingEnabled(state) {
    return (0, _get2.default)(state, 'project.config.isCommentingEnabled', false);
  }

  function isCentredWebPrototype(state) {
    return state.project.config.centerImage && state.project.config.isWeb;
  }

  function getOrientation(state) {
    return state.project.config.device.orientation;
  }

  function getFrame(state) {
    return (0, _get2.default)(state, 'project.config.device.frame');
  }

  function isLoaded(status) {
    return status === imagePreloadingStatus.DONE;
  }

  function isWeb(state) {
    return state.project.config.isWeb;
  }

  function isPro(state) {
    return state.project.config.isPro;
  }

  function isEmbedded(state) {
    return state.project.isEmbedded;
  }

  function getCompanyColourAndLogo(state) {
    return {
      companyIcon: state.project.config.companyData.loadingScreenIcon,
      companyColour: state.project.config.companyData.loadingScreenColour
    };
  }

  function getPlatform(state) {
    if (isWeb(state)) {
      return platform.WEB;
    }

    if (isAppleWatch(state)) {
      return platform.WATCHOS;
    }

    if (isAndroid(state)) {
      return platform.ANDROID;
    }

    return platform.IOS;
  }

  function isAppleWatch(state) {
    var frame = getFrame(state);

    if (!frame) {
      return false;
    }

    return frame.indexOf('apple-watch') !== -1;
  }

  function isAndroid(state) {
    var frame = getFrame(state);

    if (!frame) {
      return false;
    }

    return frame.indexOf('nexus5') !== -1;
  }

  function getNoOfScreens(state) {
    return (0, _get2.default)(state, 'project.config.screens', []).length;
  }

  function getScreenById(state, id) {
    return (0, _get2.default)(state, 'project.config.screenMap', {})[id];
  }

  function getScreenByIndex(state, index) {
    return (0, _get2.default)(state, 'project.config.screens', [])[index];
  }
  /***/

},
/* 12 */

/***/
function (module, exports) {
  module.exports = require("lodash/noop");
  /***/
},
/* 13 */

/***/
function (module, exports) {
  module.exports = require("lodash/get");
  /***/
},
/* 14 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _Check = __webpack_require__(211);

  Object.defineProperty(exports, 'CheckIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Check).default;
    }
  });

  var _CheckSmall = __webpack_require__(212);

  Object.defineProperty(exports, 'CheckSmallIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_CheckSmall).default;
    }
  });

  var _Click = __webpack_require__(213);

  Object.defineProperty(exports, 'ClickIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Click).default;
    }
  });

  var _CloseBig = __webpack_require__(214);

  Object.defineProperty(exports, 'CloseBigIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_CloseBig).default;
    }
  });

  var _Close = __webpack_require__(215);

  Object.defineProperty(exports, 'CloseIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Close).default;
    }
  });

  var _Comment = __webpack_require__(216);

  Object.defineProperty(exports, 'CommentIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Comment).default;
    }
  });

  var _DownArrow = __webpack_require__(217);

  Object.defineProperty(exports, 'DownArrow', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_DownArrow).default;
    }
  });

  var _FailedIcon = __webpack_require__(218);

  Object.defineProperty(exports, 'FailedIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_FailedIcon).default;
    }
  });

  var _Grid = __webpack_require__(219);

  Object.defineProperty(exports, 'GridIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Grid).default;
    }
  });

  var _Handoff = __webpack_require__(220);

  Object.defineProperty(exports, 'HandoffIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Handoff).default;
    }
  });

  var _Logo = __webpack_require__(221);

  Object.defineProperty(exports, 'MarvelLogo', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Logo).default;
    }
  });

  var _Next = __webpack_require__(222);

  Object.defineProperty(exports, 'NextIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Next).default;
    }
  });

  var _Prev = __webpack_require__(223);

  Object.defineProperty(exports, 'PrevIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Prev).default;
    }
  });

  var _Rotate = __webpack_require__(224);

  Object.defineProperty(exports, 'RotateIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Rotate).default;
    }
  });

  var _SearchClose = __webpack_require__(225);

  Object.defineProperty(exports, 'SearchCloseIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_SearchClose).default;
    }
  });

  var _Search = __webpack_require__(226);

  Object.defineProperty(exports, 'SearchIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Search).default;
    }
  });

  var _SeeApp = __webpack_require__(227);

  Object.defineProperty(exports, 'SeeAppIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_SeeApp).default;
    }
  });

  var _SettingsAndroid = __webpack_require__(228);

  Object.defineProperty(exports, 'SettingsAndroidIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_SettingsAndroid).default;
    }
  });

  var _ShareIOS = __webpack_require__(229);

  Object.defineProperty(exports, 'ShareIOSIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_ShareIOS).default;
    }
  });

  var _Tap = __webpack_require__(230);

  Object.defineProperty(exports, 'TapIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Tap).default;
    }
  });

  var _BrokenImage = __webpack_require__(231);

  Object.defineProperty(exports, 'BrokenImageIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_BrokenImage).default;
    }
  });

  var _UpsellLogo = __webpack_require__(232);

  Object.defineProperty(exports, 'UpsellLogo', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_UpsellLogo).default;
    }
  });

  var _Text = __webpack_require__(233);

  Object.defineProperty(exports, 'TextIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Text).default;
    }
  });

  var _Group = __webpack_require__(234);

  Object.defineProperty(exports, 'GroupIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Group).default;
    }
  });

  var _Shape = __webpack_require__(235);

  Object.defineProperty(exports, 'ShapeIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Shape).default;
    }
  });

  var _Gear = __webpack_require__(236);

  Object.defineProperty(exports, 'GearIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Gear).default;
    }
  });

  var _Image = __webpack_require__(237);

  Object.defineProperty(exports, 'ImageIcon', {
    enumerable: true,
    get: function get() {
      return babelHelpers.interopRequireDefault(_Image).default;
    }
  });
  /***/
},
/* 15 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getScreenStyles = getScreenStyles;
  exports.getHotspotStyle = getHotspotStyle;
  exports.getOverlayStyle = getOverlayStyle;
  exports.getCurrentScale = getCurrentScale;
  exports.getScale = getScale;

  var _mapValues = __webpack_require__(26);

  var _mapValues2 = babelHelpers.interopRequireDefault(_mapValues);

  var _marvelCore = __webpack_require__(25);

  var _screen3 = __webpack_require__(9);

  var _statusBar = __webpack_require__(35);

  var _project = __webpack_require__(11);

  var _handoff = __webpack_require__(5);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);

  function getScreenStyles(state, isCurrent, overlayScreen, overlayWidth, overlayHeight) {
    var renderedDimensions = void 0;
    var screen = void 0;

    if (overlayScreen) {
      renderedDimensions = {
        width: overlayWidth,
        height: overlayHeight
      };
      screen = overlayScreen;
    } else {
      screen = (0, _screen3.getScreen)(state, isCurrent);
      renderedDimensions = (0, _screen3.getRenderedScreenDimensions)(state);
    }

    var _screen = screen,
        img = _screen.img;
    var _screen2 = screen,
        header = _screen2.header,
        footer = _screen2.footer;

    if ((0, _handoff.isInHandoffMode)(state)) {
      header = undefined;
      footer = undefined;
    }

    var scale = getScale(state, img);
    var fullHeaderHeight = header ? getHeaderHeight(header) : 0;
    var statusBarTrimHeight = (0, _statusBar.getStatusBarTrimHeight)(state);
    var fullFooterHeight = footer ? getFooterHeight(footer, img) : 0;
    var headerHeight = scale(fullHeaderHeight);
    var trimmedHeaderHeight = headerHeight;

    if (statusBarTrimHeight && header) {
      trimmedHeaderHeight = headerHeight - statusBarTrimHeight;
    }

    var footerHeight = scale(fullFooterHeight);
    var scrollableAreaHeight = renderedDimensions.height;
    var scrollableAreaWidth = renderedDimensions.width;
    var scrollableAreaPadding = {
      paddingTop: trimmedHeaderHeight,
      paddingBottom: footerHeight
    };
    var scrollableHeight = scrollableAreaHeight - trimmedHeaderHeight - footerHeight;
    var imageHeight = scale(img.height, true - headerHeight - footerHeight);
    var isScrollableAreaScrollable = imageHeight > scrollableHeight;
    var imageWidth = getImageWidth(state, renderedDimensions, img);
    var marginLeft = 0;

    if ((0, _handoff.isInHandoffMode)(state)) {
      if (renderedDimensions.width > imageWidth) {
        marginLeft = (renderedDimensions.width - imageWidth) / 2;
      }
    } else if (renderedDimensions.width < imageWidth) {
      if ((0, _project.isCentredWebPrototype)(state)) {
        marginLeft = (renderedDimensions.width - imageWidth) / 2;
      }
    } else {
      marginLeft = (renderedDimensions.width - imageWidth) / 2;
    }

    var imageMarginTop = void 0;

    if (header) {
      imageMarginTop = -headerHeight;
    } else {
      imageMarginTop = -statusBarTrimHeight;
    }

    var imageMargin = {
      marginTop: imageMarginTop,
      marginBottom: -footerHeight,
      marginLeft: marginLeft
    };
    var _state$screen = state.screen,
        scrollTo = _state$screen.scrollTo,
        scrollPos = _state$screen.scrollPos;
    var scrollTop = null;

    if (isCurrent) {
      scrollTop = scrollPos.current;

      if (scrollTo !== null) {
        // TODO fix for when status bar trimmed
        scrollTop = scale(scrollTo) - headerHeight;

        if (state.screen.scrollingToAnnotation !== null) {
          scrollTop -= 17; // TODO ANNOTATION_SIZE / 2
        }
      } else {
        scrollTop = scrollPos.current;
      }
    } else {
      scrollTop = scrollPos.previous;
    }

    return {
      imgURL: screen.img.url,
      headerHeight: trimmedHeaderHeight,
      headerBackgroundOffset: -statusBarTrimHeight,
      footerHeight: footerHeight,
      scrollableAreaHeight: scrollableAreaHeight,
      scrollableAreaWidth: scrollableAreaWidth,
      scrollableAreaPadding: scrollableAreaPadding,
      isScrollableAreaScrollable: isScrollableAreaScrollable,
      scrollTop: scrollTop,
      imageMargin: imageMargin,
      imageWidth: imageWidth,
      imageHeight: imageHeight
    };
  } // Calculate the layout properties required for each component.
  // All positions/sizes from the API are in actual pixels. To render
  // the prototype everything is scaled down to fit in the current
  // rendered screen size.
  // Note: we calculate everything in *pixels*. We tried percentage
  // layouts but in CSS they are weird and unintuitive. Pixels are
  // explicit, reliable, and easier to debug.


  function getHotspotStyle(_ref) {
    var state = _ref.state,
        hotspot = _ref.hotspot,
        location = _ref.location,
        screenID = _ref.screenID;

    var _getScreen = (0, _screen3.getScreen)(state, screenID),
        header = _getScreen.header,
        footer = _getScreen.footer;

    switch (location) {
      case screenLocation.HEADER:
        return getHeaderHotspotStyle(state, hotspot);

      case screenLocation.FOOTER:
        return getFooterHotspotStyle(state, footer, hotspot);

      case screenLocation.BODY:
        return getBodyHotspotStyle(state, header, hotspot);

      case screenLocation.OVERLAY:
        return getOverlayHotspotStyle(state, hotspot);

      default:
        throw new Error('\'' + location + '\' is not a valid hotspot location');
    }
  }

  function getHeaderHotspotStyle(state, hotspot) {
    var top = hotspot.y;
    var layout = getCommonHotspotStyle(state, top, hotspot);
    var statusBarTrimHeight = (0, _statusBar.getStatusBarTrimHeight)(state);
    layout.top -= statusBarTrimHeight;
    return layout;
  }

  function getFooterHotspotStyle(state, footer, hotspot) {
    var top = hotspot.y - footer.y;
    return getCommonHotspotStyle(state, top, hotspot);
  }

  function getBodyHotspotStyle(state, header, hotspot) {
    var offset = header ? header.y : 0;
    var top = hotspot.y - offset;
    var layout = getCommonHotspotStyle(state, top, hotspot);

    if (!header) {
      var statusBarTrimHeight = (0, _statusBar.getStatusBarTrimHeight)(state);
      layout.top -= statusBarTrimHeight;
    }

    return layout;
  }

  function getOverlayHotspotStyle(state, hotspot) {
    var top = hotspot.y;
    return getCommonHotspotStyle(state, top, hotspot);
  }

  function getCommonHotspotStyle(state, top, hotspot) {
    var _getCurrentScreen = (0, _screen3.getCurrentScreen)(state),
        currentScreenImage = _getCurrentScreen.img;

    var left = hotspot.x;

    var _getHotspotSize = getHotspotSize(hotspot),
        width = _getHotspotSize.width,
        height = _getHotspotSize.height;

    return scaled(state, currentScreenImage, {
      top: top,
      left: left,
      width: width,
      height: height
    });
  }

  function getOverlayStyle(state, renderedScreenDimensions, hotspot, overlay, isCurrentScreen, positionParent) {
    var screenGetter = isCurrentScreen ? _screen3.getCurrentScreen : _screen3.getPreviousScreen;
    var screen = screenGetter(state);
    var top = hotspot.overlayY;
    var left = hotspot.overlayX;

    if (positionParent) {
      if (isManuallyPositioned(hotspot)) {
        var parentHotspot = state.screen.hotspotMap[positionParent];

        if (isManuallyPositioned(parentHotspot)) {
          top += parentHotspot.overlayY;
          left += parentHotspot.overlayX;
        } else {
          var fixedPosition = calcFixedPosition(parentHotspot, screen, overlay);
          top += fixedPosition.top;
          left += fixedPosition.left;
        }
      }
    }

    return scaled(state, screen.img, {
      top: top,
      left: left,
      width: overlay.img.width,
      height: overlay.img.height
    });
  }

  function isManuallyPositioned(hotspot) {
    return hotspot.overlayPosition === _marvelCore.constants.OVERLAY_CUSTOM;
  }

  function calcFixedPosition(hotspot, screen, overlay) {
    switch (hotspot.overlayPosition) {
      case _marvelCore.constants.OVERLAY_CENTERED:
        return {
          top: (screen.img.height - overlay.img.height) / 2,
          left: (screen.img.width - overlay.img.width) / 2
        };

      case _marvelCore.constants.OVERLAY_TOP_LEFT:
        return {
          left: 0,
          top: 0
        };

      case _marvelCore.constants.OVERLAY_TOP_CENTER:
        return {
          left: (screen.img.width - overlay.img.width) / 2,
          top: 0
        };

      case _marvelCore.constants.OVERLAY_TOP_RIGHT:
        return {
          left: screen.img.width - overlay.img.width,
          top: 0
        };

      case _marvelCore.constants.OVERLAY_BOTTOM_LEFT:
        return {
          top: screen.img.height - overlay.img.height,
          left: 0
        };

      case _marvelCore.constants.OVERLAY_BOTTOM_CENTER:
        return {
          top: screen.img.height - overlay.img.height,
          left: (screen.img.width - overlay.img.width) / 2
        };

      case _marvelCore.constants.OVERLAY_BOTTOM_RIGHT:
        return {
          top: screen.img.height - overlay.img.height,
          left: screen.img.width - overlay.img.width
        };

      default:
        throw new Error('\'' + hotspot.overlayPosition + '\' is not a valid overlay position');
    }
  }

  function getCurrentScale(state) {
    var _getCurrentScreen2 = (0, _screen3.getCurrentScreen)(state),
        img = _getCurrentScreen2.img;

    return getScale(state, img);
  }

  function getScale(state, image) {
    var renderedScreenDimensions = (0, _screen3.getRenderedScreenDimensions)(state);
    var isMobile = state.deviceDetection.isMobile;
    var renderedImageWidth = getImageWidth(state, renderedScreenDimensions, image);
    var screenImageWidth = (0, _screen3.getCurrentScreenImageWidth)(state);
    var scale = renderedImageWidth / screenImageWidth;

    function scaleValue(value) {
      var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var rawScaledValue = scale * value;

      if (raw) {
        return rawScaledValue;
      }

      if (!isMobile) {
        return Math.round(rawScaledValue);
      }

      return rawScaledValue;
    }

    return scaleValue;
  }

  function getImageWidth(state, renderedScreenSize, image) {
    var _state$project$config = state.project.config,
        isWeb = _state$project$config.isWeb,
        isResponsive = _state$project$config.isResponsive,
        scaleRetinaImages = _state$project$config.scaleRetinaImages;
    var actualImageWidth = image.width;
    var maxImageWidth = void 0;

    if (scaleRetinaImages && !(0, _handoff.isInHandoffMode)(state)) {
      maxImageWidth = actualImageWidth / 2;
    } else {
      maxImageWidth = actualImageWidth;
    }

    var renderedImageWidth = void 0;

    if ((0, _handoff.isInHandoffMode)(state)) {
      renderedImageWidth = maxImageWidth * (0, _handoff.getZoomScale)(state);
    } else if (renderedScreenSize.width <= maxImageWidth) {
      if (isWeb && !isResponsive) {
        renderedImageWidth = maxImageWidth;
      } else {
        renderedImageWidth = renderedScreenSize.width;
      }
    } else {
      renderedImageWidth = maxImageWidth;
    }

    return renderedImageWidth;
  }

  function scaled(state, image, values) {
    var scale = getScale(state, image);
    return (0, _mapValues2.default)(values, function (value) {
      return scale(value);
    });
  }

  function getHeaderHeight(header) {
    return header.y;
  }

  function getFooterHeight(footer, image) {
    return image.height - footer.y;
  }

  function getHotspotSize(hotspot) {
    return {
      width: hotspot.x2 - hotspot.x,
      height: hotspot.y2 - hotspot.y
    };
  }
  /***/

},
/* 16 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.hasAssets = hasAssets;
  exports.getAssets = getAssets;
  exports.getElementColors = getElementColors;
  exports.getTextColor = getTextColor;
  exports.getContent = getContent;
  exports.getTextSnippet = getTextSnippet;
  exports.getElementThumbURL = getElementThumbURL;
  exports.getElementBlendMode = getElementBlendMode;
  exports.getElementBlur = getElementBlur;
  exports.getElementBorders = getElementBorders;
  exports.getElementLayout = getElementLayout;
  exports.getElementRadius = getElementRadius;
  exports.getElementShadows = getElementShadows;
  exports.getElementInnerShadows = getElementInnerShadows;
  exports.getFills = getFills;
  exports.getLayerName = getLayerName;

  var _capitalize = __webpack_require__(73);

  var _capitalize2 = babelHelpers.interopRequireDefault(_capitalize);

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _handoffItems = __webpack_require__(118);

  var handoffItems = babelHelpers.interopRequireWildcard(_handoffItems);

  var _colors = __webpack_require__(119);

  function hasAssets(element) {
    return getAssets(element).length > 0;
  }

  function getAssets(element) {
    var assets = (0, _get2.default)(element, 'itemProps.assets', []) || [];
    return assets;
  }

  function getElementColors(element) {
    var colors = [];
    [getElementBorders, getFills].forEach(function (getPropWithColours) {
      var props = getPropWithColours(element);
      props.forEach(function (prop) {
        if (prop.color) {
          colors.push(prop.color);
        } else if (prop.colors) {
          colors = colors.concat(prop.colors);
        }
      });
    });
    [getElementShadows, getElementInnerShadows].forEach(function (getShadows) {
      var shadows = getShadows(element);
      shadows.forEach(function (shadow) {
        return colors.push(shadow.color.rgbaValues);
      });
    });

    if (element.className === handoffItems.TEXT) {
      colors.push(getTextColor(element));
    }

    return colors;
  }

  function getTextColor(element) {
    // TODO remove the 'get' when test fixtures are upconverted to v2
    return (0, _get2.default)(element, 'style.color.rgbaValues', []);
  }

  function getContent(element) {
    return element.blocks.map(function (b) {
      return b.text;
    }).join('\n');
  }

  function getTextSnippet(element) {
    return element.blocks[0].text.substr(0, 30);
  }

  function getElementThumbURL(element) {
    // TODO this could be HUGE -- should we generate thumbs for the Header?
    return element.source;
  }

  function getElementBlendMode(element) {
    return element.itemProps.blendMode;
  }

  function getElementBlur(element) {
    return element.itemProps.blur;
  }

  function getElementBorders(element) {
    var borders = (0, _get2.default)(element, 'strokes', []);
    return borders.map(function (border) {
      if (border.color.className === 'Color') {
        return {
          type: 'color',
          color: border.color.rgbaValues,
          position: (0, _capitalize2.default)(border.strokePosition),
          width: border.width
        };
      }

      return {
        type: 'gradient',
        gradientType: border.color.type,
        colors: (0, _colors.getColorStops)(border.color.stops),
        position: (0, _capitalize2.default)(border.strokePosition),
        width: border.width
      };
    });
  }

  function getElementLayout(element) {
    return element.layout;
  }

  function getElementRadius(element) {
    return element.type !== 'ellipse' && element.radius;
  }

  function getElementShadows(element) {
    var shadows = [];
    var parent = element;

    while (parent) {
      shadows.push.apply(shadows, babelHelpers.toConsumableArray((0, _get2.default)(parent, 'shadows', [])));
      parent = parent.positionParent;
    }

    return shadows;
  }

  function getElementInnerShadows(element) {
    return element.innerShadows || [];
  }

  function getFills(element) {
    var fills = (0, _get2.default)(element, 'fillStyle.fills', []);
    return (0, _colors.getColorFills)(fills);
  }

  function getLayerName(element) {
    var layerName = element.itemProps.name;
    if (!layerName) return (0, _capitalize2.default)(element.className);
    return layerName;
  }
  /***/

},
/* 17 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Panel;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _Panel = __webpack_require__(45);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  function Panel(_ref) {
    var children = _ref.children,
        header = _ref.header,
        customHeader = _ref.customHeader,
        action = _ref.action,
        withoutPadding = _ref.withoutPadding;
    var style = withoutPadding ? {
      padding: 0
    } : null;
    return _react2.default.createElement('div', {
      className: _Panel2.default.container
    }, !!header && _react2.default.createElement('div', {
      className: _Panel2.default.panel
    }, customHeader && _react2.default.createElement('div', {
      className: _Panel2.default.inlineChild
    }, customHeader), _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_Panel2.default.title, _Panel2.default.inlineChild)
    }, header), action && _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_Panel2.default.inlineChild, _Panel2.default.action)
    }, action)), _react2.default.createElement('div', {
      className: _Panel2.default.content,
      style: style
    }, children));
  }

  Panel.propTypes = {
    children: _propTypes2.default.node,
    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    withoutPadding: _propTypes2.default.bool,
    customHeader: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    action: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
  };
  Panel.defaultProps = {
    hidden: false
  };
  /***/
},
/* 18 */

/***/
function (module, exports) {
  module.exports = require("immutability-helper");
  /***/
},
/* 19 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var HEADER = exports.HEADER = 'HEADER';
  var BODY = exports.BODY = 'BODY';
  var FOOTER = exports.FOOTER = 'FOOTER';
  var OVERLAY = exports.OVERLAY = 'OVERLAY';
  /***/
},
/* 20 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isInAnnotationMode = isInAnnotationMode;
  exports.getHeaderAnnotations = getHeaderAnnotations;
  exports.getFooterAnnotations = getFooterAnnotations;
  exports.getBodyAnnotations = getBodyAnnotations;
  exports.getOverlayAnnotations = getOverlayAnnotations;
  exports.isHighlighted = isHighlighted;
  exports.isDehighlighted = isDehighlighted;
  exports.isPulsing = isPulsing;
  exports.isMoveable = isMoveable;

  var _filter = __webpack_require__(68);

  var _filter2 = babelHelpers.interopRequireDefault(_filter);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);

  function isInAnnotationMode(state) {
    return state.annotation.nextAnnotation !== null;
  }

  function getHeaderAnnotations(state) {
    return getVisibleAnnotations(state, screenLocation.HEADER);
  }

  function getFooterAnnotations(state) {
    return getVisibleAnnotations(state, screenLocation.FOOTER);
  }

  function getBodyAnnotations(state) {
    return getVisibleAnnotations(state, screenLocation.BODY);
  }

  function getOverlayAnnotations(state) {
    return getVisibleAnnotations(state, screenLocation.OVERLAY);
  }

  function isHighlighted(state, commentUUID) {
    return state.annotation.highlightAnnotation === commentUUID;
  }

  function isDehighlighted(state, commentUUID) {
    return state.annotation.highlightAnnotation !== null && state.annotation.highlightAnnotation !== commentUUID;
  }

  function isPulsing(state, commentUUID) {
    return state.screen.scrollingToAnnotation === commentUUID;
  }

  function isMoveable(state, annotation) {
    if (!annotation.isSaved) {
      return true;
    }

    return state.annotation.isAnnotationMoveable[annotation.commentUUID];
  }

  function getVisibleAnnotations(state, screenArea) {
    if (state.comment.areVisible) {
      return (0, _filter2.default)(state.annotation.annotations, function (annotation) {
        return annotation.screenArea === screenArea;
      });
    }

    return [];
  }
  /***/

},
/* 21 */

/***/
function (module, exports) {
  module.exports = require("lodash/assign");
  /***/
},
/* 22 */

/***/
function (module, exports) {
  module.exports = require("lodash/partial");
  /***/
},
/* 23 */

/***/
function (module, exports) {
  module.exports = require("velocity-react");
  /***/
},
/* 24 */

/***/
function (module, exports) {
  module.exports = require("recompose/compose");
  /***/
},
/* 25 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/marvel-core");
  /***/
},
/* 26 */

/***/
function (module, exports) {
  module.exports = require("lodash/mapValues");
  /***/
},
/* 27 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.rgbArray2css = rgbArray2css;
  exports.rgbArray2hybridCSS = rgbArray2hybridCSS;
  exports.rgbaArray2rgba = rgbaArray2rgba;
  exports.hasOpacity = hasOpacity;
  exports.colourIsDark = colourIsDark;
  exports.rgbToHsl = rgbToHsl;

  function rgbArray2css(rgbaArray) {
    if (hasOpacity(rgbaArray)) {
      return rgbaArray2rgba(rgbaArray);
    }

    return '#' + rgbaArray2hex(rgbaArray);
  }

  function rgbArray2hybridCSS(rgbaArray) {
    var value = '#' + rgbaArray2hex(rgbaArray);

    if (hasOpacity(rgbaArray)) {
      var opacityPct = Math.round(rgbaArray[3] * 100);
      value += ' - ' + opacityPct + '%';
    }

    return value;
  }

  function rgbaArray2rgba(rgbaArray) {
    var rgbValues = rgbaArray.slice(0, 3).map(function (v) {
      return Math.round(v * 255);
    });

    if (hasOpacity(rgbaArray)) {
      rgbValues.push(rgbaArray[3]);
      return 'rgba(' + rgbValues.join(', ') + ')';
    }

    return 'rgb(' + rgbValues.join(', ') + ')';
  }

  function hasOpacity(rgbaArray) {
    return rgbaArray[3] < 1;
  }

  function rgbaArray2hex(rgbaArray) {
    return rgbaArray.slice(0, 3).map(function (v) {
      return paddedHex(Math.round(v * 255));
    }).join('').toUpperCase();
  }

  function paddedHex(hexValue) {
    var leftPad = '';

    if (hexValue < 16) {
      leftPad = '0';
    }

    return '' + leftPad + hexValue.toString(16);
  }

  function colourIsDark(rgbaArray) {
    /* eslint-disable no-bitwise */
    var rgb = parseInt(rgbaArray2hex(rgbaArray), 16);
    var r = rgb >> 16 & 0xff; // extract red

    var g = rgb >> 8 & 0xff; // extract green

    var b = rgb >> 0 & 0xff; // extract blue

    var luma = 0.213 * (r / 255) + 0.715 * (g / 255) + 0.072 * (b / 255);
    var opacity = rgbaArray[3];
    return luma < 0.5 || opacity < 0.5; // returns true is luma is below 0.5, meaning it's a dark colour
  }

  function rgbToHsl(r, g, b) {
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = void 0;
    var s = void 0;
    var l = (max + min) / 2;

    if (max === min) {
      h = 0;
      s = 0;
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max) {
        default:
          break;

        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;

        case g:
          h = (b - r) / d + 2;
          break;

        case b:
          h = (r - g) / d + 4;
          break;
      }

      h /= 6;
    }

    return [h * 8, s * 8, l * 8];
  }
  /***/

},
/* 28 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getCurrentOverlayHotspot = getCurrentOverlayHotspot;
  exports.getHotspotByID = getHotspotByID;
  exports.getHeaderHotspots = getHeaderHotspots;
  exports.getFooterHotspots = getFooterHotspots;
  exports.getBodyHotspots = getBodyHotspots;
  exports.doesHotspotExist = doesHotspotExist;
  exports.areHotspotsVisible = areHotspotsVisible;
  exports.areHotspotsLoaded = areHotspotsLoaded;

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _marvelCore = __webpack_require__(25);

  var _screen = __webpack_require__(9);

  var _overlay = __webpack_require__(36);

  var _comment = __webpack_require__(74);

  var _handoff = __webpack_require__(5);

  function getCurrentOverlayHotspot(state) {
    if ((0, _get2.default)(state.project.config, 'hotspotMap')) {
      return state.project.config.hotspotMap[state.screen.currentOverlayHotspot.id];
    }

    return null;
  }

  function getHotspotByID(state, id) {
    return (0, _get2.default)(state, ['project', 'config', 'hotspotMap', id]);
  }

  function getHeaderHotspots(state, screen) {
    return getVisibleHotspots(state, 'header.hotspots', screen);
  }

  function getFooterHotspots(state, screen) {
    return getVisibleHotspots(state, 'footer.hotspots', screen);
  }

  function getBodyHotspots(state) {
    return getVisibleHotspots(state, 'hotspots');
  }

  function doesHotspotExist(state, hotspotID) {
    return getHotspotByID(state, hotspotID);
  }

  function areHotspotsVisible(state) {
    return state.hotspots.areVisible;
  }

  function areHotspotsLoaded(state) {
    return state.hotspots.areLoaded;
  }

  function getVisibleHotspots(state, screenProperty, optionalScreen) {
    var screen = void 0;
    var currentScreen = (0, _screen.getCurrentScreen)(state);
    var currentOverlayScreen = (0, _screen.getCurrentOverlayScreen)(state);

    if (optionalScreen) {
      screen = optionalScreen;
    } else {
      screen = currentScreen;
    }

    var hotspots = (0, _get2.default)(screen, screenProperty, []);

    if ((0, _comment.areCommentsVisible)(state) || (0, _handoff.isInHandoffMode)(state) || // Only render hotspots for the current overlay or current screen
    (0, _overlay.isShowingOverlay)(state) && screen.id !== currentOverlayScreen.id || !(0, _overlay.isShowingOverlay)(state) && screen.id !== currentScreen.id) {
      return hotspots.filter(function (h) {
        return h.type === _marvelCore.constants.TYPE_EMBED;
      });
    }

    return hotspots;
  }
  /***/

},
/* 29 */

/***/
function (module, exports) {
  module.exports = require("recompose/getContext");
  /***/
},
/* 30 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var IDLE = exports.IDLE = 'IDLE';
  var DONE = exports.DONE = 'DONE';
  var ERROR = exports.ERROR = 'ERROR';
  var RELOADING = exports.RELOADING = 'RELOADING';
  var PRELOADING = exports.PRELOADING = 'PRELOADING';
  /***/
},
/* 31 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var IDLE = exports.IDLE = 'IDLE';
  var PENDING = exports.PENDING = 'PENDING';
  var ERROR = exports.ERROR = 'ERROR';
  var SUCCESS = exports.SUCCESS = 'SUCCESS';
  /***/
},
/* 32 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Label;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _Panel = __webpack_require__(45);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  function Label(_ref) {
    var children = _ref.children,
        inline = _ref.inline;
    var propertyClass = !inline ? _Panel2.default.property : (0, _classnames2.default)(_Panel2.default.property, _Panel2.default.inlineProperty);
    return _react2.default.createElement('div', {
      className: propertyClass
    }, children);
  }

  Label.propTypes = {
    children: _propTypes2.default.node,
    inline: _propTypes2.default.bool
  };
  /***/
},
/* 33 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Box;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Box = __webpack_require__(342);

  var _Box2 = babelHelpers.interopRequireDefault(_Box);

  function Box(_ref) {
    var children = _ref.children,
        withoutPadding = _ref.withoutPadding;
    var style = withoutPadding ? {
      padding: 0
    } : null;
    return _react2.default.createElement('div', {
      className: _Box2.default.box,
      style: style
    }, children);
  }

  Box.propTypes = {
    children: _propTypes2.default.node.isRequired,
    withoutPadding: _propTypes2.default.bool
  };
  /***/
},
/* 34 */

/***/
function (module, exports) {
  module.exports = require("redux-saga");
  /***/
},
/* 35 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getStatusBarUnderlayHeight = getStatusBarUnderlayHeight;
  exports.getStatusBarUnderlayColor = getStatusBarUnderlayColor;
  exports.getStatusBarTrimHeight = getStatusBarTrimHeight;
  exports.bodyNeedsDeviceHeight = bodyNeedsDeviceHeight;
  exports.getStatusBarHeight = getStatusBarHeight;

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _screen = __webpack_require__(9);

  var _project = __webpack_require__(11);

  var _statusBar = __webpack_require__(122);

  var statusBar = babelHelpers.interopRequireWildcard(_statusBar);

  function getStatusBarUnderlayHeight(state) {
    return state.project.config.statusBar.screenNeedsMovedDown ? getStatusBarHeight(state) : 0;
  }

  function getStatusBarUnderlayColor(state) {
    var screen = (0, _screen.getCurrentScreen)(state);
    return screen.colorSamples.statusBar;
  }

  function getStatusBarTrimHeight(state) {
    return state.project.config.statusBar.trimHeight;
  }

  function bodyNeedsDeviceHeight(state) {
    return (0, _get2.default)(state, 'project.config.statusBar.bodyNeedsDeviceHeight', false);
  }

  function getStatusBarHeight(state) {
    return statusBar.getHeight((0, _project.getFrame)(state));
  }
  /***/

},
/* 36 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getOverlayByID = getOverlayByID;
  exports.getOverlay = getOverlay;
  exports.getOverlayProps = getOverlayProps;
  exports.getOverlayBackgroundColour = getOverlayBackgroundColour;
  exports.getOverlayBackgroundAnimate = getOverlayBackgroundAnimate;
  exports.isShowingOverlay = isShowingOverlay;

  var _cloneDeep = __webpack_require__(71);

  var _cloneDeep2 = babelHelpers.interopRequireDefault(_cloneDeep);

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _isNil = __webpack_require__(72);

  var _isNil2 = babelHelpers.interopRequireDefault(_isNil);

  var _layout = __webpack_require__(15);

  var _overlayTransitions = __webpack_require__(201);

  var _overlayTransitions2 = babelHelpers.interopRequireDefault(_overlayTransitions);

  var _hotspot = __webpack_require__(28);

  var _statusBar = __webpack_require__(35);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);

  function getOverlayByID(state, id) {
    return (0, _get2.default)(state, ['project', 'config', 'overlayMap', id]);
  }

  function getOverlay(state, isCurrentScreen) {
    var _state$screen = state.screen,
        previousOverlayHotspot = _state$screen.previousOverlayHotspot,
        currentOverlayHotspot = _state$screen.currentOverlayHotspot;
    var hotspotID = void 0;
    var hotspot = void 0;
    var overlay = void 0;
    var animationDirection = void 0;
    var transition = '';
    var screenScrollPos = void 0;

    if (isCurrentScreen) {
      if (currentOverlayHotspot.id) {
        hotspotID = currentOverlayHotspot.id;
        screenScrollPos = currentOverlayHotspot.screenScrollPos;

        if (currentOverlayHotspot.animate) {
          animationDirection = 'enter';

          if (currentOverlayHotspot.transition) {
            transition = (0, _overlayTransitions.getTransitionForTransitionToSameScreen)(currentOverlayHotspot.transition);
          }
        }
      } else if (isAnimatingAwayPreviousOverlay(previousOverlayHotspot)) {
        hotspotID = previousOverlayHotspot.id;
        screenScrollPos = previousOverlayHotspot.screenScrollPos;
        animationDirection = 'leave';

        if (previousOverlayHotspot.transition) {
          transition = (0, _overlayTransitions.getTransitionForTransitionToSameScreen)(previousOverlayHotspot.transition);
        }
      }
    } else if (isTransitioningToScreenFromOverlay(previousOverlayHotspot)) {
      hotspotID = previousOverlayHotspot.id; // We don't set animationDirection as the previous overlay
      // animates away with the screen it was showing on
    }

    if (hotspotID && (0, _hotspot.doesHotspotExist)(state, hotspotID)) {
      hotspot = state.project.config.hotspotMap[hotspotID];
      overlay = getOverlayByID(state, hotspot.destinationScreenID);

      if (!hotspot.isScrollable) {
        overlay = getOverlayWithMergedHotspots(overlay);
      }

      transition = transition || hotspot.transition;
    }

    return {
      hotspot: hotspot,
      overlay: overlay,
      animationDirection: animationDirection,
      transition: transition,
      screenScrollPos: screenScrollPos,
      positionParent: isCurrentScreen ? currentOverlayHotspot.positionParent : previousOverlayHotspot.positionParent
    };
  }

  function getOverlayProps(state, isCurrentScreen) {
    var _getOverlay = getOverlay(state, isCurrentScreen),
        hotspot = _getOverlay.hotspot,
        overlay = _getOverlay.overlay,
        animationDirection = _getOverlay.animationDirection,
        transition = _getOverlay.transition,
        screenScrollPos = _getOverlay.screenScrollPos,
        positionParent = _getOverlay.positionParent;

    if (noOverlay(hotspot) || hidingOverlayWithNoAnimation(animationDirection, transition)) {
      return {};
    }

    var renderedScreenDimensions = state.screen.renderedDimensions;
    var overlayStyle = (0, _layout.getOverlayStyle)(state, renderedScreenDimensions, hotspot, overlay, isCurrentScreen, positionParent);
    var animationConf = void 0;

    if (animationDirection && transition) {
      animationConf = (0, _overlayTransitions2.default)(transition, renderedScreenDimensions)[animationDirection];
    }

    var animationName = transition + '-' + animationDirection;
    var statusBarTrimHeight = (0, _statusBar.getStatusBarTrimHeight)(state);
    return babelHelpers.extends({
      id: hotspot.id,
      screenID: overlay.id,
      transition: animationName,
      key: animationName,
      hotspots: overlay.hotspots,
      imgURL: overlay.img.url,
      animation: animationConf,
      position: hotspot.overlayPosition,
      isScrollable: hotspot.isScrollable,
      screenScrollPos: hotspot.location === screenLocation.BODY ? screenScrollPos : 0,
      renderedScreenDimensions: renderedScreenDimensions,
      statusBarTrimHeight: statusBarTrimHeight
    }, overlayStyle);
  }

  function getOverlayBackgroundColour(state, isCurrentScreen) {
    var _getOverlay2 = getOverlay(state, isCurrentScreen),
        animationDirection = _getOverlay2.animationDirection,
        hotspot = _getOverlay2.hotspot;

    if (animationDirection !== 'leave' && hotspot) {
      return hotspot.overlayBackgroundColour;
    }

    return null;
  }

  function getOverlayBackgroundAnimate(state, isCurrentScreen) {
    if (!isCurrentScreen) {
      return false;
    }

    if (isTransitioningToOverlayFromOverlay(state)) {
      return false;
    }

    var _getOverlay3 = getOverlay(state, isCurrentScreen),
        hotspot = _getOverlay3.hotspot;

    if (hotspot) {
      return !!hotspot.transition;
    }

    return false;
  }

  function isAnimatingAwayPreviousOverlay(previousOverlayHotspot) {
    return previousOverlayHotspot.animate;
  }

  function isTransitioningToScreenFromOverlay(previousOverlayHotspot) {
    return previousOverlayHotspot.id && !previousOverlayHotspot.animate;
  }

  function isTransitioningToOverlayFromOverlay(state) {
    var currentOverlayId = (0, _get2.default)(state, 'screen.currentOverlayHotspot.id');
    var previousOverlayId = (0, _get2.default)(state, 'screen.previousOverlayHotspot.id');
    return !(0, _isNil2.default)(currentOverlayId) && !(0, _isNil2.default)(previousOverlayId);
  }

  function noOverlay(hotspot) {
    return !hotspot;
  }

  function hidingOverlayWithNoAnimation(animationDirection, transition) {
    return animationDirection === 'leave' && !transition;
  } // when rendering an overlay we need to ignore the partitioning of hotspots into
  // header/footer/body as overlays have no fixed areas.


  function getOverlayWithMergedHotspots(overlay) {
    var overlayClone = (0, _cloneDeep2.default)(overlay);
    ['footer', 'header'].forEach(function (location) {
      overlayClone.hotspots = overlayClone.hotspots.concat((0, _get2.default)(overlay, [location, 'hotspots'], []));
    });
    return overlayClone;
  }

  function isShowingOverlay(state) {
    return state.screen.currentOverlayHotspot.id;
  }
  /***/

},
/* 37 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var IMAGE_UPLOAD_ERROR = exports.IMAGE_UPLOAD_ERROR = -2;
  var IMAGE_UPLOAD_PENDING = exports.IMAGE_UPLOAD_PENDING = 2;
  var IMAGE_UPLOAD_DONE = exports.IMAGE_UPLOAD_DONE = 5;
  /***/
},
/* 38 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var CONTACT_SUPPORT = exports.CONTACT_SUPPORT = 'https://help.marvelapp.com/hc/en-us/requests/new';
  var SIGN_IN = exports.SIGN_IN = 'https://marvelapp.com/?signin';
  var UPGRADE = exports.UPGRADE = 'https://marvelapp.com/upgrade/';
  var SIGN_UP = exports.SIGN_UP = 'https://marvelapp.com/?signup';
  var HOMEPAGE = exports.HOMEPAGE = 'https://marvelapp.com/';
  var HANDOFF = exports.HANDOFF = 'https://marvelapp.com/handoff';
  var DOWNLOAD_ASSETS_USING_HANDOFF = exports.DOWNLOAD_ASSETS_USING_HANDOFF = 'https://help.marvelapp.com/hc/en-us/articles/115004519369-Get-started-with-Handoff?utm_source=handoff&utm_medium=sidebar&utm_campaign=assets';
  /***/
},
/* 39 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _Measurement = __webpack_require__(333);

  var _Measurement2 = babelHelpers.interopRequireDefault(_Measurement);

  var _handoff = __webpack_require__(5);

  var _project = __webpack_require__(11);

  function mapStateToProps(state) {
    return {
      unit: (0, _handoff.getUnit)(state),
      pixelRatio: (0, _handoff.getPixelRatio)(state),
      platform: (0, _project.getPlatform)(state)
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_Measurement2.default);
  /***/
},
/* 40 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = BoxSection;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _BoxSection = __webpack_require__(343);

  var _BoxSection2 = babelHelpers.interopRequireDefault(_BoxSection);

  var _BoxSectionBackground = __webpack_require__(344);

  var _BoxSectionBackground2 = babelHelpers.interopRequireDefault(_BoxSectionBackground);

  function BoxSection(_ref) {
    var children = _ref.children,
        background = _ref.background,
        paddingSize = _ref.paddingSize;
    var classes = (0, _classnames2.default)(_BoxSection2.default.boxSection, _BoxSectionBackground2.default[background], babelHelpers.defineProperty({}, 'padding-' + paddingSize, paddingSize));
    return _react2.default.createElement('div', {
      className: classes
    }, children);
  }

  BoxSection.propTypes = {
    background: _propTypes2.default.oneOf(Object.keys(_BoxSectionBackground2.default)),
    children: _propTypes2.default.node.isRequired,
    paddingSize: _propTypes2.default.string
  };
  BoxSection.defaultProps = {
    background: 'white',
    paddingSize: 'xs'
  };
  /***/
},
/* 41 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getRowsEnabled = getRowsEnabled;
  exports.getColumnsEnabled = getColumnsEnabled;
  exports.getIsRowOverlayOn = getIsRowOverlayOn;
  exports.getIsColumnOverlayOn = getIsColumnOverlayOn;
  exports.getRowConfig = getRowConfig;
  exports.getColumnConfig = getColumnConfig;
  exports.getRowSettings = getRowSettings;
  exports.getColumnSettings = getColumnSettings;

  var _layout = __webpack_require__(15);

  function getRowsEnabled(state) {
    return getRowSettings(state).enabled;
  }

  function getColumnsEnabled(state) {
    return getColumnSettings(state).enabled;
  }

  function getIsRowOverlayOn(state) {
    return state.layoutOverlay.isRowOverlayOn;
  }

  function getIsColumnOverlayOn(state) {
    return state.layoutOverlay.isColumnOverlayOn;
  }

  function getRowConfig(state) {
    var _getRowSettings = getRowSettings(state),
        gutterHeight = _getRowSettings.gutterHeight,
        heightAsGutterMultiple = _getRowSettings.heightAsGutterMultiple;

    var pixelRatio = getPixelRatio(state);
    var scaleFunc = (0, _layout.getCurrentScale)(state);

    var _getScreenStyles = (0, _layout.getScreenStyles)(state, true),
        imageHeight = _getScreenStyles.imageHeight;

    var scaledGutterHeight = scaleFunc(gutterHeight, true) * pixelRatio;
    var rowCount = imageHeight / (scaledGutterHeight * (1 + heightAsGutterMultiple));
    return babelHelpers.extends({
      count: rowCount,
      gutterHeight: scaledGutterHeight,
      heightAsGutterMultiple: heightAsGutterMultiple
    }, getVisuals(state));
  }

  function getColumnConfig(state) {
    var _getColumnSettings = getColumnSettings(state),
        offset = _getColumnSettings.offset,
        count = _getColumnSettings.count,
        isGutterOnOutside = _getColumnSettings.isGutterOnOutside,
        gutterWidth = _getColumnSettings.gutterWidth,
        columnWidth = _getColumnSettings.columnWidth,
        totalWidth = _getColumnSettings.totalWidth;

    var scaleFunc = (0, _layout.getCurrentScale)(state);
    var pixelRatio = getPixelRatio(state);
    return babelHelpers.extends({
      count: count,
      isGutterOnOutside: isGutterOnOutside,
      offset: scaleFunc(offset, true) * pixelRatio,
      gutterWidth: scaleFunc(gutterWidth, true) * pixelRatio,
      columnWidth: scaleFunc(columnWidth, true) * pixelRatio,
      totalWidth: scaleFunc(totalWidth, true) * pixelRatio
    }, getVisuals(state));
  }

  function getVisuals(state) {
    var _getVisualSettings = getVisualSettings(state),
        gridType = _getVisualSettings.gridType,
        lightColor = _getVisualSettings.lightColor,
        darkColor = _getVisualSettings.darkColor;

    var fillColor = void 0;
    var strokeColor = void 0;

    if (gridType === 'fillGrid') {
      fillColor = lightColor.rgbaValues;
    } else {
      strokeColor = darkColor.rgbaValues;
    }

    return {
      fillColor: fillColor,
      strokeColor: strokeColor
    };
  }

  function getPixelRatio(state) {
    return getArtboard(state).pixelRatio;
  }

  function getArtboard(state) {
    return state.handoff.canvas.artboard;
  }

  function getRowSettings(state) {
    var rows = getArtboard(state).layout.rows;

    if (!rows) {
      return {
        enabled: false
      };
    }

    return babelHelpers.extends({}, rows, {
      heightAsGutterMultiple: rows.rowHeight
    });
  }

  function getColumnSettings(state) {
    var columns = getArtboard(state).layout.columns;

    if (!columns) {
      return {
        enabled: false
      };
    }

    columns = babelHelpers.extends({}, columns, {
      count: columns.numberOfColumns,
      isGutterOnOutside: columns.gutterOnOutside
    });
    return columns;
  }

  function getVisualSettings(state) {
    return getArtboard(state).layout.visuals;
  }
  /***/

},
/* 42 */

/***/
function (module, exports) {
  module.exports = require("recompose/toClass");
  /***/
},
/* 43 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/marvel-ui/popover");
  /***/
},
/* 44 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var PORTRAIT = exports.PORTRAIT = 'portrait';
  var LANDSCAPE = exports.LANDSCAPE = 'landscape';
  /***/
},
/* 45 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "container": "Panel__container___1fnzh",
    "panel": "Panel__panel___15f4v bg-snow padding-xs paddingLeftRight-s borderWidth-0 borderStyle-solid borderBottomWidth-1 borderTopWidth-1 borderColor-snow--xd userSelect-none zi-300 inline",
    "inlineChild": "Panel__inlineChild___37N3L verticalAlign-top",
    "action": "Panel__action___kH8mb float-right fontSize-xs",
    "title": "Panel__title___1GK9g textTransform-uppercase c-slate fontSize-xs",
    "content": "Panel__content___29_lW padding-s",
    "property": "Panel__property___MKa-c textTransform-capitalize c-silver",
    "inlineProperty": "Panel__inlineProperty___1bQBJ display-inlineBlock verticalAlign-top marginRight-xxs",
    "value": "Panel__value___2lD1B paddingTop-xxs",
    "inlineValue": "Panel__inlineValue___2Sidm display-inlineBlock verticalAlign-top"
  };
  /***/
},
/* 46 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _PanelGrid = __webpack_require__(135);

  var _PanelGrid2 = babelHelpers.interopRequireDefault(_PanelGrid);

  var PanelGrid = function PanelGrid(_ref) {
    var children = _ref.children,
        columns = _ref.columns;

    var childrenWithProps = _react2.default.Children.map(children, function (child) {
      return child ? _react2.default.cloneElement(child, {
        columns: columns
      }) : null;
    });

    return _react2.default.createElement('ul', {
      className: _PanelGrid2.default.grid,
      style: {
        gridTemplateColumns: 'repeat(' + columns + ', 1fr)'
      }
    }, childrenWithProps);
  };

  exports.default = PanelGrid;
  PanelGrid.propTypes = {
    children: _propTypes2.default.node,
    columns: _propTypes2.default.number
  };
  PanelGrid.defaultProps = {
    columns: 2
  };
  /***/
},
/* 47 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Value;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _Panel = __webpack_require__(45);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  function Value(_ref) {
    var children = _ref.children,
        inline = _ref.inline;
    var valueClass = !inline ? _Panel2.default.value : _Panel2.default.inlineValue;
    return _react2.default.createElement('div', {
      className: valueClass
    }, children);
  }

  Value.propTypes = {
    children: _propTypes2.default.node,
    inline: _propTypes2.default.bool
  };
  /***/
},
/* 48 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _codeLangMap;

  exports.getSelectedElementCode = getSelectedElementCode;
  exports.getCurrentLanguage = getCurrentLanguage;
  exports.getDefaultCodeLang = getDefaultCodeLang;

  var _mapValues = __webpack_require__(26);

  var _mapValues2 = babelHelpers.interopRequireDefault(_mapValues);

  var _code = __webpack_require__(143);

  var codeLanguages = babelHelpers.interopRequireWildcard(_code);

  var _platform = __webpack_require__(69);

  var platforms = babelHelpers.interopRequireWildcard(_platform);

  var _project = __webpack_require__(11);

  function getSelectedElementCode(state) {
    var selectedItemID = state.handoff.selectedItemID;
    var itemCode = (0, _mapValues2.default)(state.code.code, function (code) {
      return code[selectedItemID];
    });
    return {
      code: itemCode,
      requestStatus: state.code.requestStatus,
      currentLang: getCurrentLanguage(state)
    };
  }

  function getCurrentLanguage(state) {
    return state.code.currentLang;
  }

  var codeLangMap = (_codeLangMap = {}, babelHelpers.defineProperty(_codeLangMap, platforms.ANDROID, codeLanguages.ANDROID), babelHelpers.defineProperty(_codeLangMap, platforms.WEB, codeLanguages.CSS), babelHelpers.defineProperty(_codeLangMap, platforms.IOS, codeLanguages.SWIFT), babelHelpers.defineProperty(_codeLangMap, platforms.WATCHOS, codeLanguages.SWIFT), _codeLangMap);

  function getDefaultCodeLang(state) {
    var platform = (0, _project.getPlatform)(state);
    return codeLangMap[platform];
  }
  /***/

},
/* 49 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/marvel-ui/button");
  /***/
},
/* 50 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _values = __webpack_require__(95);

  var _values2 = babelHelpers.interopRequireDefault(_values);

  var _HotspotLayer = __webpack_require__(159);

  var _HotspotLayer2 = babelHelpers.interopRequireDefault(_HotspotLayer);

  var _Image = __webpack_require__(469);

  var _Image2 = babelHelpers.interopRequireDefault(_Image);

  var _image = __webpack_require__(51);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);
  var hiddenImageMap = {};

  var Image = function (_Component) {
    babelHelpers.inherits(Image, _Component);

    function Image(props) {
      babelHelpers.classCallCheck(this, Image);

      var _this = babelHelpers.possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

      _this.setRef = function (node) {
        _this.image = node;

        if (_this.props.withRef) {
          _this.props.withRef(node);
        }
      };

      var src = _this.props.src;

      if ((0, _image.isGIF)(src)) {
        _this.createHiddenImage(src);
      }

      _this._timeouts = [];
      return _this;
    }

    babelHelpers.createClass(Image, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.resetGIFAnimation();
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate() {
        this.resetGIFAnimation();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._timeouts.map(function (timeout) {
          return clearTimeout(timeout);
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            type = _props.type,
            hotspots = _props.hotspots,
            annotations = _props.annotations,
            getScreenScrollPos = _props.getScreenScrollPos,
            getOverlayScrollPos = _props.getOverlayScrollPos,
            onClick = _props.onClick,
            screenID = _props.screenID,
            style = babelHelpers.objectWithoutProperties(_props, ['type', 'hotspots', 'annotations', 'getScreenScrollPos', 'getOverlayScrollPos', 'onClick', 'screenID']);
        var imageClass = (0, _classnames2.default)(_Image2.default.image, babelHelpers.defineProperty({}, _Image2.default.annotating, this.props.isAnnotating));
        return _react2.default.createElement('div', {
          ref: this.setRef,
          className: imageClass,
          style: style,
          onClick: onClick
        }, _react2.default.createElement(_HotspotLayer2.default, {
          screenID: screenID,
          height: style.height,
          getScreenScrollPos: getScreenScrollPos,
          getOverlayScrollPos: getOverlayScrollPos,
          location: type,
          hotspots: hotspots,
          annotations: annotations
        }));
      }
    }, {
      key: 'resetGIFAnimation',
      value: function resetGIFAnimation() {
        var _this2 = this;

        if (!this.props.isOverlay) {
          // This component is used for the header, footer, and overlay.
          // The ScreenImage component already handles GIF resetting for
          // the screen so we only need do it here if we're an overlay.
          // Probably better to move this reset stuff to a HOC and only
          // wrap in containers/overlay.
          return;
        }

        var src = this.props.src;

        if (!(0, _image.isGIF)(src)) {
          return;
        }

        var hiddenImage = hiddenImageMap[src]; // setTimeout needed for Safari

        this._timeouts.push(setTimeout(function () {
          hiddenImage.src = _this2.props.src;
        }, 0)); // setTimeout works in Firefox too but *not* in Chrome so we set
        // the src here again *without* the timeout for Chrome


        hiddenImage.src = this.props.src;
        this.image.style.opacity = 0.99;

        this._timeouts.push(setTimeout(function () {
          _this2.image.style.opacity = 1;
        }, 0));
      }
    }, {
      key: 'createHiddenImage',
      value: function createHiddenImage(src) {
        if (!hiddenImageMap[src]) {
          var hiddenImage = new window.Image();
          hiddenImage.src = src;
          hiddenImage.className = _Image2.default.hiddenImage;
          hiddenImageMap[src] = hiddenImage;
          document.body.appendChild(hiddenImage);
        }
      }
    }]);
    return Image;
  }(_react.Component);

  Image.propTypes = {
    type: _propTypes2.default.oneOf((0, _values2.default)(screenLocation)),
    src: _propTypes2.default.string.isRequired,
    hotspots: _propTypes2.default.array,
    isAnnotating: _propTypes2.default.bool,
    areCommentsDisplayed: _propTypes2.default.bool,
    getScreenScrollPos: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    scrollTop: _propTypes2.default.number,
    annotations: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      left: _propTypes2.default.number,
      top: _propTypes2.default.number
    })),
    isOverlay: _propTypes2.default.bool,
    withRef: _propTypes2.default.func,
    getOverlayScrollPos: _propTypes2.default.func,
    screenID: _propTypes2.default.number.isRequired
  };
  exports.default = Image;
  /***/
},
/* 51 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.loadImage = loadImage;
  exports.isGIF = isGIF;
  exports.preloadImages = preloadImages;
  var GIF = /.gif$/;
  var imageBucket = document.createElement('div');
  imageBucket.style.display = 'none';
  document.body.appendChild(imageBucket);

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new window.Image();
      imageBucket.appendChild(img); // Note we set onload *first* so that it's fired even if the
      // image is loaded from cache

      img.onload = resolve;
      img.onerror = reject;
      img.src = url;
    });
  }

  function isGIF(url) {
    return GIF.test(url);
  }

  function preloadImages(_ref) {
    var dispatch = _ref.dispatch,
        images = _ref.images,
        successActionCreator = _ref.successActionCreator,
        failureActionCreator = _ref.failureActionCreator,
        loadingStartActionCreator = _ref.loadingStartActionCreator;
    return Promise.all(images.map(function (_ref2) {
      var id = _ref2.id,
          url = _ref2.url;
      if (loadingStartActionCreator) dispatch(loadingStartActionCreator(id));
      return loadImage(url).then(function () {
        return dispatch(successActionCreator(id));
      }).catch(function () {
        return failureActionCreator && dispatch(failureActionCreator(id));
      });
    }));
  }
  /***/

},
/* 52 */

/***/
function (module, exports) {
  module.exports = require("react-dnd");
  /***/
},
/* 53 */

/***/
function (module, exports) {
  module.exports = require("lodash/findIndex");
  /***/
},
/* 54 */

/***/
function (module, exports) {
  module.exports = require("lodash/forEach");
  /***/
},
/* 55 */

/***/
function (module, exports) {
  module.exports = require("lodash/find");
  /***/
},
/* 56 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isBrowserInFullScreenMode;

  function isBrowserInFullScreenMode() {
    return (// Chrome: http://stackoverflow.com/questions/21125337/how-to-detect-if-web-app-running-standalone-on-chrome-mobile
      window.matchMedia('(display-mode: standalone)').matches || // Safari (and others?)
      window.navigator.standalone
    );
  }
  /***/

},
/* 57 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _PanelGrid = __webpack_require__(135);

  var _PanelGrid2 = babelHelpers.interopRequireDefault(_PanelGrid);

  var columnGap = '20px';

  var PanelGridItem = function PanelGridItem(_ref) {
    var children = _ref.children,
        columns = _ref.columns,
        fullWidth = _ref.fullWidth;
    var percentage = 100 / columns;
    var style = {
      flexBasis: 'calc(' + percentage + '% - ' + columnGap + ')'
    };

    if (fullWidth) {
      style.flexBasis = '100%';
      style.gridColumn = 'span ' + columns;
    }

    return _react2.default.createElement('li', {
      className: _PanelGrid2.default.gridItem,
      style: style
    }, children);
  };

  exports.default = PanelGridItem;
  PanelGridItem.propTypes = {
    children: _propTypes2.default.node,
    columns: _propTypes2.default.number,
    fullWidth: _propTypes2.default.bool
  };
  PanelGridItem.defaultProps = {
    columns: 2
  };
  /***/
},
/* 58 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _partial = __webpack_require__(22);

  var _partial2 = babelHelpers.interopRequireDefault(_partial);

  var _CopyToClipboard = __webpack_require__(336);

  var _CopyToClipboard2 = babelHelpers.interopRequireDefault(_CopyToClipboard);

  var _actionCreators = __webpack_require__(4);

  var _clipboard = __webpack_require__(142);

  var _code = __webpack_require__(48);

  var _track = __webpack_require__(80);

  var _track2 = babelHelpers.interopRequireDefault(_track);

  function mapStateToProps(state) {
    return {
      isCopying: (0, _partial2.default)(_clipboard.isCopying, state),
      language: (0, _code.getCurrentLanguage)(state)
    };
  }

  function mergeProps(stateProps, _ref, ownProps) {
    var dispatch = _ref.dispatch;
    var newProps = {
      onCopy: function onCopy(id) {
        (0, _track2.default)('copied-handoff-code', {
          language: stateProps.language
        });
        dispatch((0, _actionCreators.showCopying)(id));
      }
    };
    return babelHelpers.extends({}, ownProps, stateProps, newProps);
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, null, mergeProps)(_CopyToClipboard2.default);
  /***/
},
/* 59 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _PanelProperties = __webpack_require__(372);

  var _PanelProperties2 = babelHelpers.interopRequireDefault(_PanelProperties);

  var _handoff = __webpack_require__(5);

  var _element = __webpack_require__(16);

  var handoff = babelHelpers.interopRequireWildcard(_element);

  var _css = __webpack_require__(374);

  var css = babelHelpers.interopRequireWildcard(_css);

  function mapStateToProps(state) {
    var element = (0, _handoff.getSelectedElement)(state);
    return {
      blendMode: css.getBlendMode(element),
      blur: handoff.getElementBlur(element),
      layout: handoff.getElementLayout(element),
      opacity: css.getOpacity(element),
      radius: handoff.getElementRadius(element)
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_PanelProperties2.default);
  /***/
},
/* 60 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _PanelBorder = __webpack_require__(376);

  var _PanelBorder2 = babelHelpers.interopRequireDefault(_PanelBorder);

  var _handoff = __webpack_require__(5);

  var _element = __webpack_require__(16);

  var handoff = babelHelpers.interopRequireWildcard(_element);

  function mapStateToProps(state) {
    var element = (0, _handoff.getSelectedElement)(state);
    return {
      borders: handoff.getElementBorders(element)
    };
  }

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(function (props) {
    return props.borders.length;
  }))(_PanelBorder2.default);
  /***/
},
/* 61 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _isEmpty = __webpack_require__(378);

  var _isEmpty2 = babelHelpers.interopRequireDefault(_isEmpty);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _PanelCode = __webpack_require__(379);

  var _PanelCode2 = babelHelpers.interopRequireDefault(_PanelCode);

  var _code = __webpack_require__(48);

  var _handoff = __webpack_require__(5);

  var _actionCreators = __webpack_require__(4);

  function mapStateToProps(state) {
    var element = (0, _handoff.getSelectedElement)(state);

    if (!element) {
      return {};
    }

    return babelHelpers.extends({
      element: element
    }, (0, _code.getSelectedElementCode)(state));
  }

  function mapDispatchToProps(dispatch) {
    return {
      setCurrentLang: function setCurrentLang(lang) {
        dispatch((0, _actionCreators.setCurrentLang)(lang));
      }
    };
  }

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _onlyIf2.default)(function (_ref) {
    var code = _ref.code,
        currentLang = _ref.currentLang;
    return !(0, _isEmpty2.default)(code[currentLang]);
  }))(_PanelCode2.default);
  /***/
},
/* 62 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _PanelShadows = __webpack_require__(390);

  var _PanelShadows2 = babelHelpers.interopRequireDefault(_PanelShadows);

  var _handoff = __webpack_require__(5);

  var _element = __webpack_require__(16);

  var handoff = babelHelpers.interopRequireWildcard(_element);

  function mapStateToProps(state) {
    var element = (0, _handoff.getSelectedElement)(state);
    return {
      shadows: handoff.getElementShadows(element),
      innerShadows: handoff.getElementInnerShadows(element)
    };
  }

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(function (props) {
    return props.shadows.length || props.innerShadows.length;
  }))(_PanelShadows2.default);
  /***/
},
/* 63 */

/***/
function (module, exports) {
  module.exports = require("react-dom");
  /***/
},
/* 64 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _annotation = __webpack_require__(20);

  Object.keys(_annotation).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _annotation[key];
      }
    });
  });

  var _app = __webpack_require__(445);

  Object.keys(_app).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _app[key];
      }
    });
  });

  var _clipboard = __webpack_require__(142);

  Object.keys(_clipboard).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _clipboard[key];
      }
    });
  });

  var _code = __webpack_require__(48);

  Object.keys(_code).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _code[key];
      }
    });
  });

  var _comment = __webpack_require__(74);

  Object.keys(_comment).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _comment[key];
      }
    });
  });

  var _device = __webpack_require__(96);

  Object.keys(_device).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _device[key];
      }
    });
  });

  var _deviceOrientation = __webpack_require__(99);

  Object.keys(_deviceOrientation).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _deviceOrientation[key];
      }
    });
  });

  var _documentHead = __webpack_require__(106);

  Object.keys(_documentHead).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _documentHead[key];
      }
    });
  });

  var _downloadAssets = __webpack_require__(93);

  Object.keys(_downloadAssets).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _downloadAssets[key];
      }
    });
  });

  var _embedly = __webpack_require__(163);

  Object.keys(_embedly).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _embedly[key];
      }
    });
  });

  var _grid = __webpack_require__(82);

  Object.keys(_grid).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _grid[key];
      }
    });
  });

  var _handoff = __webpack_require__(5);

  Object.keys(_handoff).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _handoff[key];
      }
    });
  });

  var _homeScreen = __webpack_require__(133);

  Object.keys(_homeScreen).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _homeScreen[key];
      }
    });
  });

  var _hotspot = __webpack_require__(28);

  Object.keys(_hotspot).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _hotspot[key];
      }
    });
  });

  var _hover = __webpack_require__(100);

  Object.keys(_hover).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _hover[key];
      }
    });
  });

  var _imagePreloading = __webpack_require__(75);

  Object.keys(_imagePreloading).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _imagePreloading[key];
      }
    });
  });

  var _layout = __webpack_require__(15);

  Object.keys(_layout).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _layout[key];
      }
    });
  });

  var _layoutOverlay = __webpack_require__(41);

  Object.keys(_layoutOverlay).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _layoutOverlay[key];
      }
    });
  });

  var _location = __webpack_require__(446);

  Object.keys(_location).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _location[key];
      }
    });
  });

  var _overlay = __webpack_require__(36);

  Object.keys(_overlay).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _overlay[key];
      }
    });
  });

  var _player = __webpack_require__(164);

  Object.keys(_player).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _player[key];
      }
    });
  });

  var _project = __webpack_require__(11);

  Object.keys(_project).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _project[key];
      }
    });
  });

  var _screen = __webpack_require__(9);

  Object.keys(_screen).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _screen[key];
      }
    });
  });

  var _statusBar = __webpack_require__(35);

  Object.keys(_statusBar).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _statusBar[key];
      }
    });
  });

  var _timer = __webpack_require__(165);

  Object.keys(_timer).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _timer[key];
      }
    });
  });

  var _user = __webpack_require__(448);

  Object.keys(_user).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function get() {
        return _user[key];
      }
    });
  });
  /***/
},
/* 65 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getPathName = getPathName;
  exports.parse = parse;
  exports.isEmbedded = isEmbedded;
  exports.getFullPath = getFullPath;

  var _querystring = __webpack_require__(447);

  var _querystring2 = babelHelpers.interopRequireDefault(_querystring);

  function getPathName(projectID, screenID, hotspotID, commentID, isHandoff) {
    var url = '';
    if (projectID) url += '/' + projectID;
    if (screenID) url += '/screen/' + screenID;
    if (hotspotID) url += '/layer/' + hotspotID;
    if (commentID) url += '/comment/' + commentID;
    if (isHandoff) url += '/handoff';
    return url;
  } // url can be a node url (https://nodejs.org/api/url.html#url_url_strings_and_url_objects)
  // or window.Location (type https://developer.mozilla.org/en-US/docs/Web/API/Location) object


  function parse(url) {
    var isLegacy = legacyUrlRegexp.test(url.pathname + url.hash);

    if (isLegacy) {
      return parseLegacyURL(url);
    }

    return parseURL(url);
  }

  var urlRegexp = /^\/(\w+)(?:\/screen\/(\d+))?(?:\/layer\/(\d+)?)?(?:\/(?:comment\/?([\-\w]+)?|(handoff)))?\/?$/;

  function parseURL(url) {
    var pathname = url.pathname;
    pathname = pathname || '';
    var match = urlRegexp.exec(pathname);

    if (!match) {
      return {};
    }

    var _match = babelHelpers.toArray(match),
        projectID = _match[1],
        rest = _match.slice(2);

    var _rest$map = rest.map(function (n) {
      return n ? parseInt(n, 10) : undefined;
    }),
        _rest$map2 = babelHelpers.slicedToArray(_rest$map, 1),
        screenID = _rest$map2[0];

    var hotspotID = rest[1] ? parseInt(rest[1], 10) : null;

    var _rest$slice = rest.slice(2),
        _rest$slice2 = babelHelpers.slicedToArray(_rest$slice, 2),
        highlightedComment = _rest$slice2[0],
        handoff = _rest$slice2[1];

    var inHandoff = !!handoff;
    return babelHelpers.extends({
      projectID: projectID,
      screenID: screenID,
      hotspotID: hotspotID,
      highlightedComment: highlightedComment,
      inHandoff: inHandoff
    }, parseQueryString(url));
  }

  var legacyUrlRegexp = /^\/(\w+)#(?:(\d+))?[\?|\/&]?(?:\?overlay=(\d+)?)?(?:\/comments?\/?([\-\w]+)?)?\/?$/;

  function parseLegacyURL(url) {
    var match = legacyUrlRegexp.exec(url.pathname + url.hash);

    if (!match) {
      // eslint-disable-next-line no-console
      console.warn('url does not match legacy URL');
      return {};
    }

    var _match2 = babelHelpers.toArray(match),
        projectID = _match2[1],
        rest = _match2.slice(2);

    var _rest = babelHelpers.slicedToArray(rest, 1),
        screenID = _rest[0];

    if (screenID) {
      screenID = parseInt(screenID, 10);
    }

    var highlightedComment = rest[2];
    return babelHelpers.extends({
      projectID: projectID,
      screenID: screenID,
      highlightedComment: highlightedComment,
      inHandoff: false,
      hotspotID: null
    }, parseQueryString(url));
  }

  function parseQueryString(url) {
    var search = url.search;
    search = search || '';

    var qs = _querystring2.default.parse(search.slice(1));

    return {
      isEmbedded: qs.emb === '1',
      isInTheExploreView: qs.exp === '1',
      hideAddToHomeScreen: qs.iosapp === 'true',
      // ¯\_(ツ)_/¯ Consistency?
      isFrameless: qs.frameless === 'true'
    };
  }

  function isEmbedded() {
    var qs = _querystring2.default.parse(window.location.search.slice(1));

    return !!qs.emb;
  }

  function getFullPath() {
    return window.location.href.split(window.location.host)[1];
  }
  /***/

},
/* 66 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getHeaderProps = getHeaderProps;
  exports.getFooterProps = getFooterProps;
  exports.getOverlayHeaderProps = getOverlayHeaderProps;
  exports.getOverlayFooterProps = getOverlayFooterProps;

  var _layout = __webpack_require__(15);

  var _screen = __webpack_require__(9);

  var _annotation = __webpack_require__(20);

  var _hotspot = __webpack_require__(28);

  var _statusBar = __webpack_require__(35);

  var _screenLocation = __webpack_require__(19);

  function getHeaderProps(state, isCurrentScreen) {
    var screen = (0, _screen.getScreen)(state, isCurrentScreen);
    var screenStyles = (0, _layout.getScreenStyles)(state, isCurrentScreen);
    return babelHelpers.extends({}, _getHeaderProps(state, screen, screenStyles), {
      marginLeft: screenStyles.imageMargin.marginLeft
    });
  }

  function getFooterProps(state, isCurrentScreen) {
    var screen = (0, _screen.getScreen)(state, isCurrentScreen);
    var screenStyles = (0, _layout.getScreenStyles)(state, isCurrentScreen);
    return babelHelpers.extends({}, _getFooterProps(state, screen, screenStyles), {
      marginLeft: screenStyles.imageMargin.marginLeft
    });
  }

  function getOverlayHeaderProps(state, screenID, overlayWidth, overlayHeight) {
    var screen = (0, _screen.getScreen)(state, screenID);
    var screenStyles = (0, _layout.getScreenStyles)(state, null, screen, overlayWidth, overlayHeight);
    return _getHeaderProps(state, screen, screenStyles);
  }

  function getOverlayFooterProps(state, screenID, overlayWidth, overlayHeight) {
    var screen = (0, _screen.getScreen)(state, screenID);
    var screenStyles = (0, _layout.getScreenStyles)(state, null, screen, overlayWidth, overlayHeight);
    return _getFooterProps(state, screen, screenStyles);
  }

  function _getHeaderProps(state, screen, screenStyles) {
    return babelHelpers.extends({}, _getCommonProps(screenStyles), {
      type: _screenLocation.HEADER,
      top: 0,
      height: screenStyles.headerHeight,
      backgroundPositionY: screenStyles.headerBackgroundOffset,
      header: screen.header,
      hotspots: (0, _hotspot.getHeaderHotspots)(state, screen),
      annotations: (0, _annotation.getHeaderAnnotations)(state)
    });
  }

  function _getFooterProps(state, screen, screenStyles) {
    var statusBarTrimHack = (0, _statusBar.getStatusBarUnderlayHeight)(state);
    return babelHelpers.extends({}, _getCommonProps(screenStyles), {
      type: _screenLocation.FOOTER,
      bottom: 0,
      height: screenStyles.footerHeight + statusBarTrimHack,
      backgroundPosition: 'left calc(100% - ' + statusBarTrimHack + 'px)',
      footer: screen.footer,
      hotspots: (0, _hotspot.getFooterHotspots)(state, screen),
      annotations: (0, _annotation.getFooterAnnotations)(state)
    });
  }

  function _getCommonProps(screenStyles) {
    return {
      src: screenStyles.imgURL,
      width: screenStyles.imageWidth,
      backgroundImage: 'url(' + screenStyles.imgURL + ')'
    };
  }
  /***/

},
/* 67 */

/***/
function (module, exports) {
  module.exports = require("js-cookie");
  /***/
},
/* 68 */

/***/
function (module, exports) {
  module.exports = require("lodash/filter");
  /***/
},
/* 69 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var WEB = exports.WEB = 'WEB';
  var IOS = exports.IOS = 'IOS';
  var WATCHOS = exports.WATCHOS = 'WATCHOS';
  var ANDROID = exports.ANDROID = 'ANDROID';
  /***/
},
/* 70 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var IPHONE_X = exports.IPHONE_X = 'iphonex-frame';
  /***/
},
/* 71 */

/***/
function (module, exports) {
  module.exports = require("lodash/cloneDeep");
  /***/
},
/* 72 */

/***/
function (module, exports) {
  module.exports = require("lodash/isNil");
  /***/
},
/* 73 */

/***/
function (module, exports) {
  module.exports = require("lodash/capitalize");
  /***/
},
/* 74 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.areCommentsVisible = areCommentsVisible;

  function areCommentsVisible(state) {
    return state.comment.areVisible && !state.deviceDetection.isMobile;
  }
  /***/

},
/* 75 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isImageLoading = isImageLoading;
  exports.isImageIdle = isImageIdle;
  exports.isImageError = isImageError;
  exports.isImageLoaded = isImageLoaded;
  exports.isImageLoadable = isImageLoadable;

  var _imagePreloading = __webpack_require__(30);

  var requestStatus = babelHelpers.interopRequireWildcard(_imagePreloading);

  var _contentStatus = __webpack_require__(37);

  var contentStatus = babelHelpers.interopRequireWildcard(_contentStatus);

  function isImageLoading(state, screenID) {
    return state.imagePreloading[screenID] === requestStatus.PRELOADING;
  }

  function isImageIdle(state, screenID) {
    return state.imagePreloading[screenID] === requestStatus.IDLE;
  }

  function isImageError(state, screenID) {
    return state.imagePreloading[screenID] === requestStatus.ERROR;
  }

  function isImageLoaded(state, screenID) {
    return state.imagePreloading[screenID] === requestStatus.DONE;
  }

  function isImageLoadable(screen) {
    return screen.contentStatus !== contentStatus.IMAGE_UPLOAD_ERROR && screen.contentStatus !== contentStatus.IMAGE_UPLOAD_PENDING;
  }
  /***/

},
/* 76 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var IMAGE_PRELOAD_BATCH_SIZE = exports.IMAGE_PRELOAD_BATCH_SIZE = 3;
  var NO_OF_SCREENS_TO_PRELOAD = exports.NO_OF_SCREENS_TO_PRELOAD = IMAGE_PRELOAD_BATCH_SIZE;
  var NO_OF_SCREENS_TO_PRELOAD_WHEN_EMBEDDED = exports.NO_OF_SCREENS_TO_PRELOAD_WHEN_EMBEDDED = 1;
  var PRELOADING_DEPTH = exports.PRELOADING_DEPTH = 3;
  /***/
},
/* 77 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var popover = function popover() {
    var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (BaseComponent) {
      return function (_Component) {
        babelHelpers.inherits(Popover, _Component);

        function Popover() {
          var _ref;

          var _temp, _this, _ret;

          babelHelpers.classCallCheck(this, Popover);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isOpen: isOpen
          }, _this.toggle = function () {
            _this.setState({
              isOpen: !_this.state.isOpen
            });
          }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
        }

        babelHelpers.createClass(Popover, [{
          key: 'render',
          value: function render() {
            return _react2.default.createElement(BaseComponent, babelHelpers.extends({
              isPopoverOpen: this.state.isOpen,
              togglePopover: this.toggle
            }, this.props));
          }
        }]);
        return Popover;
      }(_react.Component);
    };
  };

  exports.default = popover;
  /***/
},
/* 78 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isOwner = isOwner;
  exports.isCollaborator = isCollaborator;
  exports.isNormalSignedUp = isNormalSignedUp;
  var CLIENT = exports.CLIENT = 'Client';
  var VIEWER = exports.VIEWER = 'Viewer';
  var TEAM_MEMBER = exports.TEAM_MEMBER = 'Team Member';
  var TEAM_ADMIN = exports.TEAM_ADMIN = 'Team Admin';
  var COLLABORATOR = exports.COLLABORATOR = 'Collaborator';
  var REVIEWER = exports.REVIEWER = 'Reviewer';
  var OWNER = exports.OWNER = 'Owner';
  var ADMIN = exports.ADMIN = 'Administrator';

  function isOwner(role) {
    return role === OWNER || role === ADMIN;
  }

  function isCollaborator(role) {
    return role === COLLABORATOR || role === TEAM_MEMBER || role === TEAM_ADMIN || role === REVIEWER;
  }

  function isNormalSignedUp(role) {
    return role === VIEWER || role === CLIENT;
  }
  /***/

},
/* 79 */

/***/
function (module, exports) {
  module.exports = require("classnames/bind");
  /***/
},
/* 80 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = track;

  function track() {
    if (window.Intercom) {
      var _window;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_window = window).Intercom.apply(_window, ['trackEvent'].concat(args));
    }
  }
  /***/

},
/* 81 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ImageError;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _icons = __webpack_require__(14);

  var _ImageError = __webpack_require__(245);

  var _ImageError2 = babelHelpers.interopRequireDefault(_ImageError);

  function ImageError(_ref) {
    var isThumb = _ref.isThumb,
        isLoading = _ref.isLoading,
        hasError = _ref.hasError,
        message = _ref.message;
    var paddingClasses = isThumb ? _ImageError2.default.thumbnailPadding : _ImageError2.default.screenPadding;
    var textClasses = isThumb ? _ImageError2.default.thumbnailText : _ImageError2.default.screenText;
    var wrapperClasses = (0, _classnames2.default)(_ImageError2.default.wrapper, babelHelpers.defineProperty({}, _ImageError2.default.thumbWrapper, isThumb));
    return _react2.default.createElement('div', {
      className: wrapperClasses
    }, _react2.default.createElement('div', {
      className: _ImageError2.default.cell
    }, _react2.default.createElement('div', {
      className: paddingClasses
    }, _react2.default.createElement('div', null, isLoading ? _react2.default.createElement('div', {
      className: _ImageError2.default.loader,
      style: {
        width: 40,
        height: 40
      }
    }) : null, hasError ? _react2.default.createElement('div', {
      className: _ImageError2.default.errorIcon
    }, _react2.default.createElement(_icons.FailedIcon, null)) : null, _react2.default.createElement('div', {
      className: textClasses
    }, message)))));
  }

  ImageError.propTypes = {
    message: _propTypes2.default.string.isRequired,
    isLoading: _propTypes2.default.bool,
    isThumb: _propTypes2.default.bool,
    hasError: _propTypes2.default.bool
  };
  /***/
},
/* 82 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isOpen = isOpen;
  exports.getThumbStatus = getThumbStatus;

  var _imagePreloading = __webpack_require__(30);

  var requestStatus = babelHelpers.interopRequireWildcard(_imagePreloading);

  var _contentStatus = __webpack_require__(37);

  var contentStatus = babelHelpers.interopRequireWildcard(_contentStatus);

  function isOpen(state) {
    return state.grid.isOpen;
  }

  function getThumbStatus(state, screenID) {
    var screen = state.project.config.screenMap[screenID];
    var loadingStatus = state.grid.isThumbLoaded[screenID];
    var uploadError = screen.contentStatus === contentStatus.IMAGE_UPLOAD_ERROR;
    var uploadPending = screen.contentStatus === contentStatus.IMAGE_UPLOAD_PENDING;
    var isDownloading = !uploadError && !uploadPending && !loadingStatus;
    var downloadError = loadingStatus === requestStatus.ERROR;
    return {
      uploadError: uploadError,
      uploadPending: uploadPending,
      isDownloading: isDownloading,
      downloadError: downloadError,
      isLoaded: !uploadPending && !uploadError && !isDownloading && !downloadError
    };
  }
  /***/

},
/* 83 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.enterAnnotationMode = enterAnnotationMode;
  exports.leaveAnnotationMode = leaveAnnotationMode;
  exports.cancelCurrentAnnotation = cancelCurrentAnnotation;
  exports.addNewAnnotation = addNewAnnotation;
  exports.removeAnnotation = removeAnnotation;
  exports.addAnnotation = addAnnotation;
  exports.positionAnnotation = positionAnnotation;
  exports.scrollToAnnotation = scrollToAnnotation;
  exports.clearAnnotations = clearAnnotations;
  exports.highlightAnnotation = highlightAnnotation;
  exports.unhighlightAnnotation = unhighlightAnnotation;
  exports.makeAnnotationMoveable = makeAnnotationMoveable;
  exports.markAnnotationSaved = markAnnotationSaved;
  exports.annotationCommentUpdated = annotationCommentUpdated;
  exports.updateAnnotation = updateAnnotation;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function enterAnnotationMode(nextCommentUUID, nextReference) {
    return {
      type: actionTypes.ENTER_ANNOTATION_MODE,
      nextCommentUUID: nextCommentUUID,
      nextReference: nextReference
    };
  }

  function leaveAnnotationMode() {
    return {
      type: actionTypes.LEAVE_ANNOTATION_MODE
    };
  }

  function cancelCurrentAnnotation() {
    return {
      type: actionTypes.CANCEL_ANNOTATION
    };
  }

  function addNewAnnotation(screenArea, offset) {
    return {
      type: actionTypes.ADD_NEW_ANNOTATION,
      screenArea: screenArea,
      offset: offset
    };
  }

  function removeAnnotation(commentUUID) {
    return {
      type: actionTypes.REMOVE_ANNOTATION,
      commentUUID: commentUUID
    };
  }

  function addAnnotation(annotation) {
    return {
      type: actionTypes.ADD_ANNOTATION,
      annotation: annotation
    };
  }

  function positionAnnotation(commentUUID, toScreenArea, offset) {
    return {
      type: actionTypes.POSITION_ANNOTATION,
      commentUUID: commentUUID,
      toScreenArea: toScreenArea,
      offset: offset
    };
  }

  function scrollToAnnotation(commentUUID) {
    // TODO move to saga
    return function (dispatch) {
      dispatch({
        type: actionTypes.SCROLL_TO_ANNOTATION,
        commentUUID: commentUUID
      });
      setTimeout(function () {
        return dispatch(pulseAnnotation());
      }, 0);
    };
  }

  function pulseAnnotation() {
    return {
      type: actionTypes.PULSE_ANNOTATION
    };
  }

  function clearAnnotations() {
    return {
      type: actionTypes.CLEAR_ANNOTATIONS
    };
  }

  function highlightAnnotation(commentUUID) {
    return {
      type: actionTypes.HIGHLIGHT_ANNOTATION,
      commentUUID: commentUUID
    };
  }

  function unhighlightAnnotation(commentUUID) {
    return {
      type: actionTypes.UNHIGHLIGHT_ANNOTATION,
      commentUUID: commentUUID
    };
  }

  function makeAnnotationMoveable(commentUUID) {
    return {
      type: actionTypes.MAKE_ANNOTATION_MOVEABLE,
      commentUUID: commentUUID
    };
  }

  function markAnnotationSaved(commentUUID) {
    return {
      type: actionTypes.MARK_ANNOTATION_SAVED,
      commentUUID: commentUUID
    };
  }

  function annotationCommentUpdated(commentUUID, isDone) {
    return {
      type: actionTypes.ANNOTATION_COMMENT_UPDATED,
      commentUUID: commentUUID,
      isDone: isDone
    };
  }

  function updateAnnotation(commentUUID, annotation) {
    return {
      type: actionTypes.UPDATE_ANNOTATION,
      commentUUID: commentUUID,
      annotation: annotation
    };
  }
  /***/

},
/* 84 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.downloadAssets = downloadAssets;
  exports.downloadAssetsStart = downloadAssetsStart;
  exports.assetsZipCreated = assetsZipCreated;
  exports.assetsZipDownloaded = assetsZipDownloaded;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function downloadAssets(_ref) {
    var screenID = _ref.screenID,
        elementID = _ref.elementID,
        assetType = _ref.assetType;
    return {
      type: actionTypes.DOWNLOAD_ASSETS,
      screenID: screenID,
      elementID: elementID,
      assetType: assetType
    };
  }

  function downloadAssetsStart(_ref2) {
    var screenID = _ref2.screenID,
        elementID = _ref2.elementID,
        assetType = _ref2.assetType,
        requestID = _ref2.requestID;
    return {
      type: actionTypes.DOWNLOAD_ASSETS_START,
      screenID: screenID,
      elementID: elementID,
      assetType: assetType,
      requestID: requestID
    };
  }

  function assetsZipCreated(url, _ref3) {
    var elementID = _ref3.elementID,
        assetType = _ref3.assetType,
        requestID = _ref3.requestID;
    return {
      type: actionTypes.ASSETS_ZIP_CREATED,
      elementID: elementID,
      assetType: assetType,
      requestID: requestID,
      url: url
    };
  }

  function assetsZipDownloaded(_ref4) {
    var elementID = _ref4.elementID,
        assetType = _ref4.assetType,
        requestID = _ref4.requestID;
    return {
      type: actionTypes.ASSETS_ZIP_DOWNLOADED,
      elementID: elementID,
      assetType: assetType,
      requestID: requestID
    };
  }
  /***/

},
/* 85 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.showHandoff = showHandoff;
  exports.hideHandoff = hideHandoff;
  exports.changeHandoffSelectedItem = changeHandoffSelectedItem;
  exports.incrementZoom = incrementZoom;
  exports.decrementZoom = decrementZoom;
  exports.deselectHandoffItem = deselectHandoffItem;
  exports.changeHandoffHoveredItem = changeHandoffHoveredItem;
  exports.setCanvas = setCanvas;
  exports.loadCanvasStarting = loadCanvasStarting;
  exports.loadCanvasDone = loadCanvasDone;
  exports.loadCanvasFailed = loadCanvasFailed;
  exports.toggleColumnOverlay = toggleColumnOverlay;
  exports.toggleRowOverlay = toggleRowOverlay;
  exports.setUnit = setUnit;
  exports.updateZoomPosition = updateZoomPosition;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function showHandoff(initialZoomPosition) {
    return {
      type: actionTypes.SHOW_HANDOFF,
      initialZoomPosition: initialZoomPosition
    };
  }

  function hideHandoff() {
    return {
      type: actionTypes.HIDE_HANDOFF
    };
  }

  function changeHandoffSelectedItem(index) {
    return {
      type: actionTypes.CHANGE_HANDOFF_SELECTED_ITEM,
      index: index
    };
  }

  function incrementZoom() {
    return {
      type: actionTypes.INCREMENT_ZOOM
    };
  }

  function decrementZoom() {
    return {
      type: actionTypes.DECREMENT_ZOOM
    };
  }

  function deselectHandoffItem(index) {
    return {
      type: actionTypes.DESELECT_HANDOFF_ITEM,
      index: index
    };
  }

  function changeHandoffHoveredItem(index) {
    return {
      type: actionTypes.CHANGE_HANDOFF_HOVERED_ITEM,
      index: index
    };
  }

  function setCanvas(canvas, sourcePlatform) {
    return {
      type: actionTypes.SET_CANVAS,
      canvas: canvas,
      sourcePlatform: sourcePlatform
    };
  }

  function loadCanvasStarting() {
    return {
      type: actionTypes.LOAD_CANVAS_STARTING
    };
  }

  function loadCanvasDone(canvas, sourcePlatform) {
    return {
      type: actionTypes.LOAD_CANVAS_DONE,
      canvas: canvas,
      sourcePlatform: sourcePlatform
    };
  }

  function loadCanvasFailed() {
    return {
      type: actionTypes.LOAD_CANVAS_FAILED
    };
  }

  function toggleColumnOverlay() {
    return {
      type: actionTypes.TOGGLE_COLUMN_OVERLAY
    };
  }

  function toggleRowOverlay() {
    return {
      type: actionTypes.TOGGLE_ROW_OVERLAY
    };
  }

  function setUnit(unit) {
    return {
      type: actionTypes.SET_UNIT,
      unit: unit
    };
  }

  function updateZoomPosition(zoomPosition) {
    return {
      type: actionTypes.UPDATE_ZOOM_POSITION,
      zoomPosition: zoomPosition
    };
  }
  /***/

},
/* 86 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.hasTouch = exports.isIOS = exports.isIPhone = exports.isIPad = exports.isAndroid = exports.isMobile = undefined;

  var _mobileDetect = __webpack_require__(288);

  var _mobileDetect2 = babelHelpers.interopRequireDefault(_mobileDetect); // http://hgoebl.github.io/mobile-detect.js/doc/MobileDetect.html


  var md = new _mobileDetect2.default(navigator.userAgent);
  var os = md.os();
  var mobile = md.mobile();
  var isMobile = exports.isMobile = !!mobile;
  var isAndroid = exports.isAndroid = os === 'AndroidOS';
  var isIPad = exports.isIPad = md.tablet() === 'iPad';
  var isIPhone = exports.isIPhone = mobile === 'iPhone';
  var isIOS = exports.isIOS = isIPad || isIPhone; // TODO:
  // Use something like
  // https://github.com/rafrex/detect-touch
  // to detect touch devices?

  var hasTouch = exports.hasTouch = isMobile;
  /***/
},
/* 87 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isHeader = isHeader;
  exports.isFooter = isFooter;
  exports.isTimer = isTimer;
  exports.overlapsHeader = overlapsHeader;
  exports.overlapsFooter = overlapsFooter;
  exports.hasValidDestination = hasValidDestination;
  exports.isMouseOutsideHotspot = isMouseOutsideHotspot;

  var _marvelCore = __webpack_require__(25);

  var _isNumber = __webpack_require__(116);

  var _isNumber2 = babelHelpers.interopRequireDefault(_isNumber);

  var _hotspotAction = __webpack_require__(130);

  var hotspotAction = babelHelpers.interopRequireWildcard(_hotspotAction);

  function isHeader(_ref) {
    var type = _ref.type,
        location = _ref.location;
    return type === _marvelCore.constants.TYPE_FIXED_HORIZONTAL && location === _marvelCore.constants.TYPE_POSITION_TOP;
  }

  function isFooter(_ref2) {
    var type = _ref2.type,
        location = _ref2.location;
    return type === _marvelCore.constants.TYPE_FIXED_HORIZONTAL && location === _marvelCore.constants.TYPE_POSITION_BOTTOM;
  }

  function isTimer(_ref3) {
    var action = _ref3.action,
        type = _ref3.type,
        timer = _ref3.timer;
    return type === _marvelCore.constants.TYPE_STANDARD && action === hotspotAction.TIMER && (0, _isNumber2.default)(timer) && timer > 0;
  }

  function overlapsHeader(headerHotspot, _ref4) {
    var y = _ref4.y,
        y2 = _ref4.y2;
    return headerHotspot && (y <= headerHotspot.y || y2 <= headerHotspot.y);
  }

  function overlapsFooter(footerHotspot, _ref5) {
    var y = _ref5.y,
        y2 = _ref5.y2;
    return footerHotspot && (y >= footerHotspot.y || y2 >= footerHotspot.y);
  }

  function hasValidDestination(hotspot, screenIDList) {
    return screenIDList.indexOf(hotspot.destinationScreenID) !== -1;
  }

  function isMouseOutsideHotspot(event, hotspotInfo, scrollPos) {
    var hotspotPosition = hotspotInfo.coordinates;
    var amountScrolled = 0; // This is required to ensure that we keep existing behaviour
    // and consistency of how maintainScroll is expected to work.
    //
    // The user should only be able to scroll out of hotspots
    // for hotspots with maintainScroll === true, otherwise all hotspots
    // will partially behave as if maintainScroll is true.
    //
    // If you can scroll out of the hotspot, it implies that the original screen has also scrolled.
    // Therefore when you hover out, you should see the new scroll position of the original screen.
    // This would mean that it partially behaves like maintainScroll is true,
    // i.e. it maintains the scroll positioning of the original screen.

    if (hotspotInfo.maintainScroll) {
      // account for user scrolling out of the hotspot
      amountScrolled = hotspotInfo.scrollPos.previous - scrollPos;
    }

    return event.pageX < hotspotPosition.left || event.pageX > hotspotPosition.right || event.pageY < hotspotPosition.top + amountScrolled || event.pageY > hotspotPosition.bottom + amountScrolled;
  }
  /***/

},
/* 88 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/marvel-ui/toolbar");
  /***/
},
/* 89 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var WIDTH = exports.WIDTH = 301;
  var PADDING = exports.PADDING = 30;
  /***/
},
/* 90 */

/***/
function (module, exports) {
  module.exports = require("lodash/round");
  /***/
},
/* 91 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Swatch;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _tooltip = __webpack_require__(334);

  var _tooltip2 = babelHelpers.interopRequireDefault(_tooltip);

  var _Swatch = __webpack_require__(335);

  var _Swatch2 = babelHelpers.interopRequireDefault(_Swatch);

  var _AssetPreview = __webpack_require__(141);

  var _AssetPreview2 = babelHelpers.interopRequireDefault(_AssetPreview);

  var _convertColours = __webpack_require__(27);

  var convert = babelHelpers.interopRequireWildcard(_convertColours);

  function Swatch(_ref) {
    var color = _ref.color,
        isCopying = _ref.isCopying,
        width = _ref.width,
        height = _ref.height,
        position = _ref.position;
    var swatchAnimation = (0, _classnames2.default)(_Swatch2.default.swatchAnimation, babelHelpers.defineProperty({}, _Swatch2.default.isAnimating, isCopying));
    var labelAnimation = (0, _classnames2.default)(_Swatch2.default.copiedLabel, babelHelpers.defineProperty({}, _Swatch2.default.labelAnimating, isCopying));
    var swatchClass = (0, _classnames2.default)(_Swatch2.default.swatch, _Swatch2.default[position]);
    var colourClass = (0, _classnames2.default)(_Swatch2.default.colour, _Swatch2.default[position]);
    var borderClass = (0, _classnames2.default)(_Swatch2.default.border, _Swatch2.default[position]);
    var lineClass = (0, _classnames2.default)(_Swatch2.default.gradientLine, _Swatch2.default[position + 'Line']);
    return _react2.default.createElement('div', {
      className: _Swatch2.default.swatchWrapper,
      style: {
        width: width
      }
    }, _react2.default.createElement(_tooltip2.default, {
      text: 'Click to copy',
      size: 'medium',
      position: 'middle left'
    }, _react2.default.createElement('div', {
      className: swatchClass,
      style: {
        width: width,
        height: height
      }
    }, _react2.default.createElement('div', {
      className: _Swatch2.default.transparentWrapper
    }, _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_Swatch2.default.transparent, _AssetPreview2.default.transparentPattern)
    })), _react2.default.createElement('div', {
      className: colourClass,
      style: {
        backgroundColor: convert.rgbaArray2rgba(color)
      }
    }), position !== 'alone' && _react2.default.createElement('div', {
      className: _Swatch2.default.gradientStop
    }), _react2.default.createElement('div', {
      className: lineClass
    }), _react2.default.createElement('div', {
      className: borderClass
    })), _react2.default.createElement('div', null, _react2.default.createElement('div', {
      className: swatchAnimation
    }), _react2.default.createElement('div', {
      className: labelAnimation
    }, 'Copied!'))));
  }

  Swatch.propTypes = {
    color: _propTypes2.default.array,
    isCopying: _propTypes2.default.bool,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    position: _propTypes2.default.oneOf(['top', 'middle', 'bottom', 'alone'])
  };
  Swatch.defaultProps = {
    position: 'alone'
  };
  /***/
},
/* 92 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ColorFill;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _PanelColorSection = __webpack_require__(140);

  var _PanelColorSection2 = babelHelpers.interopRequireDefault(_PanelColorSection);

  function ColorFill(_ref) {
    var color = _ref.color;
    return _react2.default.createElement(_PanelColorSection2.default, {
      label: 'Colour',
      colors: [color]
    });
  }

  ColorFill.propTypes = {
    color: _propTypes2.default.array.isRequired
  };
  /***/
},
/* 93 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isDownloading = isDownloading;
  exports.hasDownloaded = hasDownloaded;

  var _find = __webpack_require__(55);

  var _find2 = babelHelpers.interopRequireDefault(_find);

  var _isEqual = __webpack_require__(366);

  var _isEqual2 = babelHelpers.interopRequireDefault(_isEqual);

  var _pick = __webpack_require__(367);

  var _pick2 = babelHelpers.interopRequireDefault(_pick);

  var _requestStatus = __webpack_require__(31);

  var status = babelHelpers.interopRequireWildcard(_requestStatus);

  function isDownloading(state, _ref) {
    var screenID = _ref.screenID,
        elementID = _ref.elementID,
        assetType = _ref.assetType;
    var request = getRequestStatus(state, {
      screenID: screenID,
      elementID: elementID,
      assetType: assetType
    });

    if (!request) {
      return false;
    }

    return request.status === status.PENDING;
  }

  function hasDownloaded(state, _ref2) {
    var screenID = _ref2.screenID,
        elementID = _ref2.elementID,
        assetType = _ref2.assetType;
    var request = getRequestStatus(state, {
      screenID: screenID,
      elementID: elementID,
      assetType: assetType
    });

    if (!request) {
      return false;
    }

    return request.status === status.SUCCESS;
  }

  function getRequestStatus(state, _ref3) {
    var screenID = _ref3.screenID,
        elementID = _ref3.elementID,
        assetType = _ref3.assetType;
    return (0, _find2.default)(state.downloadAssets, function (o) {
      return (0, _isEqual2.default)((0, _pick2.default)(o, ['screenID', 'elementID', 'assetType']), {
        screenID: screenID,
        elementID: elementID,
        assetType: assetType
      });
    });
  }
  /***/

},
/* 94 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SKETCH = exports.SKETCH = 8;
  var DESIGN_TOOL = exports.DESIGN_TOOL = 7;
  /***/
},
/* 95 */

/***/
function (module, exports) {
  module.exports = require("lodash/values");
  /***/
},
/* 96 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getDimensions = getDimensions;

  var _marvelCore = __webpack_require__(25);

  var _project = __webpack_require__(11);

  var _orientation = __webpack_require__(44);

  var deviceOrientation = babelHelpers.interopRequireWildcard(_orientation);

  function getDimensions(state) {
    var dimensions = _marvelCore.devices.getDeviceInfo((0, _project.getFrame)(state));

    var orientation = (0, _project.getOrientation)(state);

    if (orientation === deviceOrientation.LANDSCAPE) {
      dimensions = rotate(dimensions);
    }

    return dimensions;
  }

  function rotate(_ref) {
    var width = _ref.width,
        height = _ref.height,
        padding = _ref.padding,
        borderRadius = _ref.borderRadius; // Rotate right

    return {
      width: height,
      height: width,
      padding: [padding[3], padding[0], padding[1], padding[2]],
      borderRadius: borderRadius
    };
  }
  /***/

},
/* 97 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Hotspot;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _Hotspot = __webpack_require__(161);

  var _Hotspot2 = babelHelpers.interopRequireDefault(_Hotspot);

  function Hotspot(_ref) {
    var isVisible = _ref.isVisible,
        left = _ref.left,
        top = _ref.top,
        width = _ref.width,
        height = _ref.height,
        onClick = _ref.onClick;
    var style = {
      left: left,
      top: top,
      width: width,
      height: height
    };
    return _react2.default.createElement('div', {
      onClick: onClick,
      className: (0, _classnames2.default)(_Hotspot2.default.hotspot, babelHelpers.defineProperty({}, _Hotspot2.default.visibleHotspot, isVisible)),
      style: style
    });
  }

  Hotspot.propTypes = {
    left: _propTypes2.default.number.isRequired,
    top: _propTypes2.default.number.isRequired,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    isVisible: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
  };
  Hotspot.defaultProps = {
    onClick: _noop2.default
  };
  /***/
},
/* 98 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getMissedClickPosition = getMissedClickPosition;
  exports.getOverlayMissedClickPosition = getOverlayMissedClickPosition;
  exports.getClickPosition = getClickPosition;

  var _round = __webpack_require__(90);

  var _round2 = babelHelpers.interopRequireDefault(_round);

  var _selectors = __webpack_require__(64);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);

  function getMissedClickPosition(state, screenID, clickLocation, event) {
    var relativeClickPosition = getRelativeClickPosition(state, event);
    var screen = (0, _selectors.getScreen)(state, screenID);

    if (clickLocation === screenLocation.FOOTER) {
      relativeClickPosition.y += screen.footer.y;
    }

    if (clickLocation === screenLocation.BODY && screen.header) {
      relativeClickPosition.y += screen.header.y;
    }

    return relativeClickPosition;
  }

  function getOverlayMissedClickPosition(state, hotspotID, clickLocation, event) {
    var relativeClickPosition = getRelativeClickPosition(state, event);
    var hotspot = (0, _selectors.getHotspotByID)(state, hotspotID);
    var screen = (0, _selectors.getScreen)(state, hotspot.destinationScreenID);

    if (clickLocation === screenLocation.FOOTER) {
      relativeClickPosition.y += screen.footer.y;
    }

    return relativeClickPosition;
  }

  function getClickPosition(state, hotspotID, event) {
    var relativeClickPosition = getRelativeClickPosition(state, event);
    var hotspot = (0, _selectors.getHotspotByID)(state, hotspotID);
    return {
      x: hotspot.x + relativeClickPosition.x,
      y: hotspot.y + relativeClickPosition.y
    };
  }

  function getRelativeClickPosition(state, event) {
    var pageX = event.pageX,
        pageY = event.pageY;
    var clickedElemet = event.target;

    var _clickedElemet$getBou = clickedElemet.getBoundingClientRect(),
        left = _clickedElemet$getBou.left,
        top = _clickedElemet$getBou.top;

    var relativeClickPosition = {
      x: pageX - left,
      y: pageY - top
    };
    return unscale(state, relativeClickPosition);
  }

  function unscale(state, point) {
    var scale = (0, _selectors.getCurrentScale)(state); // TODO remove this hack to get actual scale value

    var actualScale = scale(100000) / 100000; //////////////////////////////////////////////////

    return {
      x: (0, _round2.default)(point.x / actualScale),
      y: (0, _round2.default)(point.y / actualScale)
    };
  }
  /***/

},
/* 99 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.shouldDetectDeviceOrientation = shouldDetectDeviceOrientation;
  exports.shouldRotateTheDevice = shouldRotateTheDevice;

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  function shouldDetectDeviceOrientation(state) {
    var isOnMobile = state.deviceDetection.isMobile;
    var isWebPrototype = (0, _get2.default)(state, 'project.config.isWeb');
    return isOnMobile && // We can't check for falseyness, isWebPrototype can be undefined in
    // password-protected prototypes before inserting the right password
    // and loading projectConfig
    isWebPrototype === false;
  }

  function shouldRotateTheDevice(state) {
    return shouldDetectDeviceOrientation(state) && state.device.orientation !== (0, _get2.default)(state, 'project.config.device.orientation');
  }
  /***/

},
/* 100 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getHoverStack = getHoverStack;
  exports.isHovering = isHovering;

  function getHoverStack(state) {
    return state.hoverStack;
  }

  function isHovering(state) {
    return state.hoverStack.length > 0;
  }
  /***/

},
/* 101 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "outer": "Layout__outer___3aqTF position-absolute width-100 height-100 pointerEvents-none",
    "inner": "Layout__inner___3-neR position-relative height-100",
    "overlay": "Layout__overlay___1rTYq position-absolute",
    "row": "Layout__row___Di0il borderWidth-0 borderStyle-solid width-100",
    "column": "Layout__column___1aRf6 height-100",
    "strokeRow": "Layout__strokeRow___2mDxk"
  };
  /***/
},
/* 102 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = controlScroll;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _velocityAnimateShim = __webpack_require__(486);

  var _velocityAnimateShim2 = babelHelpers.interopRequireDefault(_velocityAnimateShim);

  var _isNil = __webpack_require__(72);

  var _isNil2 = babelHelpers.interopRequireDefault(_isNil);

  function controlScroll(Component) {
    var Scrollable = function (_React$Component) {
      babelHelpers.inherits(Scrollable, _React$Component);

      function Scrollable() {
        var _ref;

        var _temp, _this, _ret;

        babelHelpers.classCallCheck(this, Scrollable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = Scrollable.__proto__ || Object.getPrototypeOf(Scrollable)).call.apply(_ref, [this].concat(args))), _this), _this.setRef = function (node) {
          _this.scrollable = node;
        }, _this.getScrollPos = function () {
          return _this.scrollable.scrollTop;
        }, _this.removeSmoothScrollHack = function () {
          _this.smoothScrollFix.parentNode.removeChild(_this.smoothScrollFix);
        }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
      }

      babelHelpers.createClass(Scrollable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.setScrollPos();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          this.setScrollPos();
        }
      }, {
        key: 'setScrollPos',
        value: function setScrollPos() {
          if (!this.scrollable) {
            return;
          }

          var _props = this.props,
              scrollTop = _props.scrollTop,
              smoothScroll = _props.smoothScroll,
              onSetScrollEnd = _props.onSetScrollEnd;

          if (!(0, _isNil2.default)(scrollTop)) {
            if (smoothScroll) {
              this.addSmoothScrollHack();
              (0, _velocityAnimateShim2.default)(this.smoothScrollFix, 'scroll', {
                duration: 1000,
                easing: 'easeInOutQuad',
                container: this.scrollable,
                complete: this.removeSmoothScrollHack
              });
            } else {
              this.scrollable.scrollTop = scrollTop;
            }

            if (onSetScrollEnd) {
              onSetScrollEnd();
            }
          }
        }
      }, {
        key: 'addSmoothScrollHack',
        value: function addSmoothScrollHack() {
          var smoothScrollFix = document.createElement('div');
          smoothScrollFix.setAttribute('style', 'position: absolute; top: ' + this.props.scrollTop + 'px');
          this.smoothScrollFix = this.scrollable.appendChild(smoothScrollFix);
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, babelHelpers.extends({}, this.props, {
            withRef: this.setRef,
            getScrollPos: this.getScrollPos
          }));
        }
      }]);
      return Scrollable;
    }(_react2.default.Component);

    Scrollable.defaultProps = {
      smoothScroll: false
    };
    Scrollable.propTypes = {
      scrollTop: _propTypes2.default.number,
      smoothScroll: _propTypes2.default.bool,
      onSetScrollEnd: _propTypes2.default.func
    };
    return Scrollable;
  }
  /***/

},
/* 103 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getProject = getProject;
  exports.getProjectPreview = getProjectPreview;
  exports.getHotspots = getHotspots;
  exports.getZip = getZip;

  var _url = __webpack_require__(570);

  var _jsCookie = __webpack_require__(67);

  var _jsCookie2 = babelHelpers.interopRequireDefault(_jsCookie);

  var _merge = __webpack_require__(571);

  var _merge2 = babelHelpers.interopRequireDefault(_merge);

  function fetchJsonOrEmpty(url) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        token = _ref.token,
        projectID = _ref.projectID,
        requestProps = _ref.requestProps;

    var savedToken = getOrUpdateToken(projectID, token);
    var request = {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    };

    if (savedToken) {
      request.headers['X-Prototype-Token'] = savedToken;
    }

    if (requestProps) {
      request = (0, _merge2.default)(request, requestProps);
    }

    return fetch(url, request).then(function (res) {
      if (res.ok) {
        // Some backend endpoints can return *either* an empty
        // response or json
        var contentType = res.headers.get('content-type');

        if ("production" === 'test' || contentType && contentType.indexOf('application/json') !== -1) {
          return res.json();
        }

        return res.text();
      }

      return Promise.reject(res);
    });
  }

  function getAPIURL() {
    return babelHelpers.extends({}, (0, _url.parse)('/api/'), {
      query: {}
    });
  }

  function getProject(projectID, token) {
    var url = getAPIURL();
    url.pathname = (0, _url.resolve)(url.pathname, 'project-retrieve/' + projectID + '/');
    return fetchJsonOrEmpty((0, _url.format)(url), {
      projectID: projectID,
      token: token
    });
  }

  function getProjectPreview(projectID, screenID, token) {
    var url = getAPIURL();
    url.pathname = (0, _url.resolve)(url.pathname, 'prototype/' + projectID + '/');

    if (screenID) {
      url.pathname = (0, _url.resolve)(url.pathname, screenID + '/');
    } else {
      url.query.limit = 1;
    }

    return fetchJsonOrEmpty((0, _url.format)(url), {
      projectID: projectID,
      token: token
    });
  }

  function getHotspots(projectID, token) {
    var url = getAPIURL();
    url.pathname = (0, _url.resolve)(url.pathname, 'project-hotspots/' + projectID + '/');
    return fetchJsonOrEmpty((0, _url.format)(url), {
      projectID: projectID,
      token: token
    });
  }

  function getZip(zipHandoff) {
    var url = getAPIURL();
    url.pathname = (0, _url.resolve)(url.pathname, 'prototype/assets/');
    return fetchJsonOrEmpty((0, _url.format)(url), {
      requestProps: {
        method: 'POST',
        body: JSON.stringify(zipHandoff),
        headers: {
          'X-CSRFToken': _jsCookie2.default.get('csrftoken'),
          'Content-Type': 'application/json'
        }
      }
    });
  }

  function getOrUpdateToken(projectID, token) {
    var savedToken = void 0;

    if (token) {
      savedToken = token;
      localStorage.setItem(projectID, token);
    } else {
      savedToken = localStorage.getItem(projectID);
    }

    return savedToken;
  }
  /***/

},
/* 104 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var API_KEY = exports.API_KEY = '70744d379f87a37df68a'; // TODO: Move to marvel-core?
  // New content has been created

  var EVENT_CONTENT_CREATED = exports.EVENT_CONTENT_CREATED = 'event_content_created'; // Existing content has been updated

  var EVENT_CONTENT_UPDATED = exports.EVENT_CONTENT_UPDATED = 'event_content_updated'; // A hotspot has been added or updated

  var EVENT_HOTSPOT = exports.EVENT_HOTSPOT = 'event_hotspot'; // ZIP dowload of assets has been created

  var EVENT_ASSESTS_ZIP_CREATED = exports.EVENT_ASSESTS_ZIP_CREATED = 'event_assets_zip_created';
  /***/
},
/* 105 */

/***/
function (module, exports) {
  module.exports = require("react-dnd-html5-backend");
  /***/
},
/* 106 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getDocumentHeadProps = getDocumentHeadProps;

  var _project = __webpack_require__(11);

  var _deviceFrames = __webpack_require__(70);

  var deviceFrames = babelHelpers.interopRequireWildcard(_deviceFrames);

  function getDocumentHeadProps(state) {
    var isLoading = state.project.isLoading;

    if (isLoading) {
      return {
        isLoading: isLoading
      };
    }

    return babelHelpers.extends({
      projectID: state.project.config.id,
      projectTitle: state.project.config.name
    }, state.project.config, {
      viewportFitCover: (0, _project.getFrame)(state) === deviceFrames.IPHONE_X
    });
  }
  /***/

},
/* 107 */

/***/
function (module, exports) {
  module.exports = require("lodash/size");
  /***/
},
/* 108 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getRandomIconUrl;

  var _isString = __webpack_require__(109);

  var _isString2 = babelHelpers.interopRequireDefault(_isString);

  var _stringHash = __webpack_require__(189);

  var _stringHash2 = babelHelpers.interopRequireDefault(_stringHash);

  var _requireAll = __webpack_require__(190);

  var _requireAll2 = babelHelpers.interopRequireDefault(_requireAll); // Require apple touch icons


  (0, _requireAll2.default)(__webpack_require__(191));
  var MARVEL_ICONS_COUNT = 6;

  function getRandomIconUrl(projectId) {
    if (!(0, _isString2.default)(projectId)) {
      throw new Error('Expected "projectId" to be an instance of string');
    }

    var iconType = (0, _stringHash2.default)(projectId) % MARVEL_ICONS_COUNT + 1;
    /* eslint-disable import/no-dynamic-require */

    return __webpack_require__(192)("./apple-touch-icon-" + iconType + '.png');
  }
  /***/

},
/* 109 */

/***/
function (module, exports) {
  module.exports = require("lodash/isString");
  /***/
},
/* 110 */

/***/
function (module, exports) {
  module.exports = require("./assets/images/icons/apple-touch-icon-1.png");
  /***/
},
/* 111 */

/***/
function (module, exports) {
  module.exports = require("./assets/images/icons/apple-touch-icon-2.png");
  /***/
},
/* 112 */

/***/
function (module, exports) {
  module.exports = require("./assets/images/icons/apple-touch-icon-3.png");
  /***/
},
/* 113 */

/***/
function (module, exports) {
  module.exports = require("./assets/images/icons/apple-touch-icon-4.png");
  /***/
},
/* 114 */

/***/
function (module, exports) {
  module.exports = require("./assets/images/icons/apple-touch-icon-5.png");
  /***/
},
/* 115 */

/***/
function (module, exports) {
  module.exports = require("./assets/images/icons/apple-touch-icon-6.png");
  /***/
},
/* 116 */

/***/
function (module, exports) {
  module.exports = require("lodash/isNumber");
  /***/
},
/* 117 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getZoomPercentage = getZoomPercentage;
  exports.getPositionForPercentage = getPositionForPercentage;
  var LEVELS = exports.LEVELS = [25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 150, 200, 250, 300, 400, 500];
  var DEFAULT_POSITION = exports.DEFAULT_POSITION = LEVELS.indexOf(50);
  var MAX_POSITION = exports.MAX_POSITION = LEVELS.length - 1;
  var MIN_POSITION = exports.MIN_POSITION = 0;

  function getZoomPercentage(zoomPosition) {
    return LEVELS[zoomPosition];
  }

  function getPositionForPercentage(zoomPercentage) {
    return LEVELS.indexOf(zoomPercentage);
  }
  /***/

},
/* 118 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var DEFAULT = exports.DEFAULT = 'default';
  var IMAGE = exports.IMAGE = 'Raster';
  var TEXT = exports.TEXT = 'Text';
  var SHAPE = exports.SHAPE = 'Shape';
  var GROUP = exports.GROUP = 'Group';
  var MASK = exports.MASK = 'Mask';
  /***/
},
/* 119 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.compareColors = compareColors;
  exports.getColorFills = getColorFills;
  exports.getColorStops = getColorStops;

  var _convertColours = __webpack_require__(27);

  var convert = babelHelpers.interopRequireWildcard(_convertColours);

  var _fillTypes = __webpack_require__(200);

  var fillTypes = babelHelpers.interopRequireWildcard(_fillTypes);

  function compareColors(a, b) {
    var aHsl = convert.rgbToHsl.apply(convert, babelHelpers.toConsumableArray(a));
    var bHsl = convert.rgbToHsl.apply(convert, babelHelpers.toConsumableArray(b));
    return aHsl[0] - bHsl[0];
  }

  var FILLS = [fillTypes.COLOR, fillTypes.GRADIENT, fillTypes.PATTERN];

  function getColorFills(fills) {
    return fills.filter(function (fill) {
      return FILLS.indexOf(fill.content.className) !== -1;
    }).map(function (fill) {
      if (fill.content.className === fillTypes.COLOR) {
        return {
          type: 'color',
          color: fill.content.rgbaValues
        };
      }

      if (fill.content.className === fillTypes.GRADIENT) {
        return {
          type: 'gradient',
          gradientType: fill.content.type,
          colors: getColorStops(fill.content.stops)
        };
      }

      return {
        type: 'image',
        url: fill.content.source
      };
    });
  }

  function getColorStops(colorStops) {
    return colorStops.map(function (_ref) {
      var color = _ref.color;
      return color.rgbaValues;
    });
  }
  /***/

},
/* 120 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var UNAVAILABLE = exports.UNAVAILABLE = 'UNAVAILABLE';
  var UNAUTHORIZED = exports.UNAUTHORIZED = 'UNAUTHORIZED';
  var NO_HANDOFF_DATA = exports.NO_HANDOFF_DATA = 'NO_HANDOFF_DATA';
  var REQUEST_ERROR = exports.REQUEST_ERROR = 'REQUEST_ERROR';
  var AVAILABLE = exports.AVAILABLE = 'AVAILABLE';
  /***/
},
/* 121 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isElementNested = isElementNested;
  exports.getAncestorOfElementThatIsChildOfCurrrentSelection = getAncestorOfElementThatIsChildOfCurrrentSelection;
  exports.getAncestorOfElementThatIsSiblingOfCurrrentSelection = getAncestorOfElementThatIsSiblingOfCurrrentSelection;
  exports.getAncestorOfElementThatIsParentOfCurrrentSelection = getAncestorOfElementThatIsParentOfCurrrentSelection;
  exports.isElementInSameTopLevelGroupAsCurrentSelection = isElementInSameTopLevelGroupAsCurrentSelection;
  exports.isElementInSameTopLevelGroupAsCurrentSelectionAndNoDeeper = isElementInSameTopLevelGroupAsCurrentSelectionAndNoDeeper;
  exports.getTopLevelGroup = getTopLevelGroup;
  exports.getDepth = getDepth;

  function isElementNested(element) {
    return !!element.parent;
  }

  function getAncestorOfElementThatIsChildOfCurrrentSelection(currentSelection, element) {
    if (currentSelection) {
      var ancestor = element;

      while (ancestor) {
        if (ancestor.parent === currentSelection) {
          return ancestor;
        }

        ancestor = ancestor.parent;
      }
    }

    return undefined;
  }

  function getAncestorOfElementThatIsSiblingOfCurrrentSelection(currentSelection, element) {
    if (currentSelection) {
      var ancestor = element;

      while (ancestor) {
        if (ancestor.parent === currentSelection.parent) {
          return ancestor;
        }

        ancestor = ancestor.parent;
      }
    }

    return undefined;
  }

  function getAncestorOfElementThatIsParentOfCurrrentSelection(currentSelection, element) {
    if (currentSelection) {
      var ancestor = element;

      while (ancestor) {
        if (ancestor === currentSelection.parent) {
          return ancestor;
        }

        ancestor = ancestor.parent;
      }
    }

    return undefined;
  }

  function isElementInSameTopLevelGroupAsCurrentSelection(currentSelection, element) {
    if (!currentSelection) {
      return false;
    }

    return getTopLevelGroup(element) === getTopLevelGroup(currentSelection);
  }

  function isElementInSameTopLevelGroupAsCurrentSelectionAndNoDeeper(currentSelection, element) {
    if (!currentSelection) {
      return false;
    }

    var isInSameGroup = isElementInSameTopLevelGroupAsCurrentSelection(currentSelection, element);

    if (!isInSameGroup) {
      return false;
    }

    return getDepth(element) <= getDepth(currentSelection);
  }

  function getTopLevelGroup(element, currentSelection) {
    var parent = element;

    while (parent.parent) {
      if (parent.parent === currentSelection) {
        return parent;
      }

      parent = parent.parent;
    }

    return parent;
  }

  function getDepth(element) {
    var parent = element;
    var depth = 0;

    while (parent.parent) {
      depth += 1;
      parent = parent.parent;
    }

    return depth;
  }
  /***/

},
/* 122 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.STATUS_BAR_TYPE_MAP = exports.STATUS_BAR_BLACK_WHITE_CLEAR = exports.STATUS_BAR_BLACK_CLEAR = exports.STATUS_BAR_BLACK = undefined;

  var _STATUS_BAR_TYPE_MAP;

  exports.getHeight = getHeight;

  var _deviceFrames = __webpack_require__(70);

  var deviceFrames = babelHelpers.interopRequireWildcard(_deviceFrames);
  var STATUS_BAR_BLACK = exports.STATUS_BAR_BLACK = '0';
  var STATUS_BAR_BLACK_CLEAR = exports.STATUS_BAR_BLACK_CLEAR = '1';
  var STATUS_BAR_BLACK_WHITE_CLEAR = exports.STATUS_BAR_BLACK_WHITE_CLEAR = '2';
  var STATUS_BAR_TYPE_MAP = exports.STATUS_BAR_TYPE_MAP = (_STATUS_BAR_TYPE_MAP = {}, babelHelpers.defineProperty(_STATUS_BAR_TYPE_MAP, STATUS_BAR_BLACK, 'black'), babelHelpers.defineProperty(_STATUS_BAR_TYPE_MAP, STATUS_BAR_BLACK_CLEAR, 'black-translucent'), babelHelpers.defineProperty(_STATUS_BAR_TYPE_MAP, STATUS_BAR_BLACK_WHITE_CLEAR, 'black-translucent'), _STATUS_BAR_TYPE_MAP);
  var DEFAULT_STATUS_BAR_HEIGHT = 20;
  var IPHONE_X_STATUS_BAR_HEIGHT = 44;

  function getHeight(deviceFrame) {
    if (deviceFrame === deviceFrames.IPHONE_X) {
      return IPHONE_X_STATUS_BAR_HEIGHT;
    }

    return DEFAULT_STATUS_BAR_HEIGHT;
  }
  /***/

},
/* 123 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Close;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _bind = __webpack_require__(79);

  var _bind2 = babelHelpers.interopRequireDefault(_bind);

  var _icons = __webpack_require__(14);

  var _Close = __webpack_require__(238);

  var _Close2 = babelHelpers.interopRequireDefault(_Close);

  function Close(_ref) {
    var style = _ref.style,
        onClick = _ref.onClick,
        isHidden = _ref.isHidden;

    var cx = _bind2.default.bind(_Close2.default);

    var closeClasses = cx('close', 'close--' + style, {
      hidden: isHidden
    });
    return _react2.default.createElement('div', {
      className: closeClasses,
      onClick: onClick
    }, _react2.default.createElement('div', {
      className: _Close2.default.icon
    }, _react2.default.createElement(_icons.CloseIcon, null)));
  }

  Close.propTypes = {
    style: _propTypes2.default.oneOf(['negative', 'light']).isRequired,
    onClick: _propTypes2.default.func.isRequired,
    isHidden: _propTypes2.default.bool.isRequired
  };
  Close.defaultProps = {
    isHidden: false
  };
  /***/
},
/* 124 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = UploadFailed;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _ImageError = __webpack_require__(81);

  var _ImageError2 = babelHelpers.interopRequireDefault(_ImageError);

  function UploadFailed(_ref) {
    var isThumb = _ref.isThumb;
    return _react2.default.createElement(_ImageError2.default, {
      isThumb: isThumb,
      message: 'This image has failed to upload and needs to be reuploaded!',
      hasError: true
    });
  }

  UploadFailed.propTypes = {
    isThumb: _propTypes2.default.bool
  };
  /***/
},
/* 125 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = UploadPending;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _ImageError = __webpack_require__(81);

  var _ImageError2 = babelHelpers.interopRequireDefault(_ImageError);

  function UploadPending(_ref) {
    var isThumb = _ref.isThumb;
    return _react2.default.createElement(_ImageError2.default, {
      isThumb: isThumb,
      message: 'This image is still uploading to the server! Check back in a few seconds.',
      isLoading: true
    });
  }

  UploadPending.propTypes = {
    isThumb: _propTypes2.default.bool
  };
  /***/
},
/* 126 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = DownloadFailed;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _ImageError = __webpack_require__(81);

  var _ImageError2 = babelHelpers.interopRequireDefault(_ImageError);

  function DownloadFailed(_ref) {
    var isThumb = _ref.isThumb;
    return _react2.default.createElement(_ImageError2.default, {
      isThumb: isThumb,
      message: 'This image has failed to download, please try to reupload.',
      hasError: true
    });
  }

  DownloadFailed.propTypes = {
    isThumb: _propTypes2.default.bool
  };
  /***/
},
/* 127 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createPartialProjectConfig = createPartialProjectConfig;
  exports.createProjectConfig = createProjectConfig;

  var _mapValues = __webpack_require__(26);

  var _mapValues2 = babelHelpers.interopRequireDefault(_mapValues);

  var _find = __webpack_require__(55);

  var _find2 = babelHelpers.interopRequireDefault(_find);

  var _forEach = __webpack_require__(54);

  var _forEach2 = babelHelpers.interopRequireDefault(_forEach);

  var _partial = __webpack_require__(22);

  var _partial2 = babelHelpers.interopRequireDefault(_partial);

  var _transform = __webpack_require__(286);

  var _transform2 = babelHelpers.interopRequireDefault(_transform);

  var _sortBy = __webpack_require__(128);

  var _sortBy2 = babelHelpers.interopRequireDefault(_sortBy);

  var _map = __webpack_require__(129);

  var _map2 = babelHelpers.interopRequireDefault(_map);

  var _get2 = __webpack_require__(13);

  var _get3 = babelHelpers.interopRequireDefault(_get2);

  var _marvelCore = __webpack_require__(25);

  var _projectProperties = __webpack_require__(287);

  var projectProperties = babelHelpers.interopRequireWildcard(_projectProperties);

  var _contentStatus = __webpack_require__(37);

  var contentStatus = babelHelpers.interopRequireWildcard(_contentStatus);

  var _statusBar = __webpack_require__(122);

  var statusBar = babelHelpers.interopRequireWildcard(_statusBar);

  var _orientation = __webpack_require__(44);

  var _deviceFrames = __webpack_require__(70);

  var deviceFrames = babelHelpers.interopRequireWildcard(_deviceFrames);

  var _deviceDetection = __webpack_require__(86);

  var _hotspot = __webpack_require__(87);

  var _isBrowserInFullScreenMode = __webpack_require__(56);

  var _isBrowserInFullScreenMode2 = babelHelpers.interopRequireDefault(_isBrowserInFullScreenMode);

  var _isEmail = __webpack_require__(290);

  var _isEmail2 = babelHelpers.interopRequireDefault(_isEmail);

  var _getEmbedUrl = __webpack_require__(291);

  var _getEmbedUrl2 = babelHelpers.interopRequireDefault(_getEmbedUrl);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);

  var _plans = __webpack_require__(131);

  var plans = babelHelpers.interopRequireWildcard(_plans);

  function createPartialProjectConfig(partialProjectConfig) {
    if (!partialProjectConfig) {
      throw new Error('partialProjectConfig is required');
    }

    var device = getDeviceProperties(partialProjectConfig);
    var isPartial = true;

    var _processScreens = processScreens(partialProjectConfig, isPartial),
        screenMap = _processScreens.screenMap,
        hotspotMap = _processScreens.hotspotMap,
        overlayMap = _processScreens.overlayMap;

    return getProjectConfig(partialProjectConfig, device, screenMap, hotspotMap, overlayMap);
  } // Restructure the project configuration.
  //
  // The current API is not in the best structure to consume in the web
  // player. Here we restructure the project config to what we think a
  // v2 API might look like. This keeps the downstream react/redux code
  // cleaner as we deal with any quirks here.


  function createProjectConfig(origProjectConfig) {
    if (!origProjectConfig) {
      throw new Error('origProjectConfig is required');
    }

    var device = getDeviceProperties(origProjectConfig);
    var isPartial = false;

    var _processScreens2 = processScreens(origProjectConfig, isPartial),
        screenMap = _processScreens2.screenMap,
        hotspotMap = _processScreens2.hotspotMap,
        overlayMap = _processScreens2.overlayMap;

    return getProjectConfig(origProjectConfig, device, screenMap, hotspotMap, overlayMap);
  }

  function getProjectConfig(origProjectConfig, device, screenMap, hotspotMap, overlayMap) {
    var screens = getScreenSequence(screenMap);
    return {
      origProjectConfig: origProjectConfig,
      screenMap: screenMap,
      hotspotMap: hotspotMap,
      overlayMap: overlayMap,
      companyData: getCompanyData(origProjectConfig),
      id: getVanityID(origProjectConfig),
      numericID: origProjectConfig.id,
      name: origProjectConfig.name,
      device: device,
      screens: screens,
      appIcon: getAppIcon(origProjectConfig),
      // TODO: Remove and use plan instead
      isPro: origProjectConfig.is_pro,
      plan: getPlan(origProjectConfig),
      pusherChannel: origProjectConfig.pusher_public_channel,
      pusherAnonChannelPrefix: origProjectConfig.pusher_anon_channel_prefix,
      isWeb: device.frame === 'web-frame',
      isResponsive: !parseInt(getProperty(origProjectConfig, 'ui-prj-responsive')),
      centerImage: !!parseInt(getProperty(origProjectConfig, 'ui-prj-center-overflow')),
      statusBar: getStatusBarProperties(origProjectConfig),
      screenBackgroundColour: getProperty(origProjectConfig, 'ui-prj-prototype-background-hex'),
      backgroundColour: getProperty(origProjectConfig, 'ui-prj-background-hex'),
      isCommentingEnabled: !!parseInt(getProperty(origProjectConfig, 'prj-comments-enabled')),
      isNavigationEnabled: !parseInt(getProperty(origProjectConfig, 'ui-prj-disable-frame')),
      scaleRetinaImages: !!parseInt(getProperty(origProjectConfig, 'ui-prj-retina-scale')),
      swipeThroughScreens: !parseInt(getProperty(origProjectConfig, projectProperties.DISABLE_SWIPE_THROUGH_SCREENS)),
      areHotspotHintsEnabled: !parseInt(getProperty(origProjectConfig, projectProperties.DISABLE_HOTSPOT_HINTS))
    };
  }

  function getPlan(origProjectConfig) {
    var company = getCompanyData(origProjectConfig); // All real companies have isEnterprise = true and companies
    // attached to pro accounts don't

    if (company.isEnterprise) {
      return plans.COMPANY;
    }

    if (origProjectConfig.is_pro) {
      return plans.PRO;
    }

    return plans.FREE;
  }

  function getVanityID(conf) {
    return conf.vanity_url.split('/').pop();
  }

  function getAppIcon(projectConfig) {
    if (!projectConfig.app_icon) {
      return null;
    }

    return projectConfig.app_icon.preview_thumbnail || projectConfig.app_icon.preview_thumbnail_640;
  }

  function processScreens(projectConfig, isPartial) {
    var screenMap = getScreenMap(projectConfig.images);
    var hotspotMap = {};
    var overlayMap = {};

    if (!isPartial) {
      (0, _forEach2.default)(screenMap, function (screen) {
        duplicateHotspots(screenMap, screen);
        screen.allHotspots.forEach(function (hotspot) {
          hotspotMap[hotspot.id] = hotspot;

          if (hotspot.isOverlay) {
            overlayMap[hotspot.destinationScreenID] = screenMap[hotspot.destinationScreenID];
          }
        });
      });
      (0, _forEach2.default)(screenMap, function (screen) {
        partitionScreenHotspots(screen);
      });
    }

    return {
      screenMap: screenMap,
      hotspotMap: hotspotMap,
      overlayMap: overlayMap
    };
  }

  function getScreenSequence(screenMap) {
    return (0, _sortBy2.default)(screenMap, function (screen) {
      return screen.order;
    });
  }

  function getScreenMap(screens) {
    // The API returns screens in an object where the key is the display
    // order of the screen.  We convert this to an object where the key
    // is the image ID to make it easier to deal with.
    var screenIDList = (0, _map2.default)(screens, 'id');
    return (0, _transform2.default)(screens, function (screenMap, screen, order) {
      /* eslint-disable no-param-reassign */
      screen = createScreen(screen, screenIDList);
      screen.order = parseInt(order, 10);
      screenMap[screen.id] = screen;
    }, {});
  }

  function createScreen(conf, screenIDList) {
    var screen = {
      uuid: conf.uuid,
      id: conf.id,
      name: conf.display_name || conf.name,
      contentStatus: getContentStatus(conf),
      img: {
        width: conf.width,
        height: conf.height,
        url: conf.url,
        previewURL: conf.thumbnail || conf.url
      },
      // this is needed by the annotation view
      originalImg: conf,
      colorSamples: mapColorSamples(conf),
      allHotspots: conf.hotspots,
      canvasID: conf.es_canvas_id,
      sourcePlatform: parseInt(conf.source_platform)
    };
    processHotspots(screen, screenIDList);
    return screen;
  }

  function getContentStatus(conf) {
    if (conf.url) {
      // If content is being replaced or there was an error replacing
      // content we show the _existing_ content in the meantime
      return contentStatus.IMAGE_UPLOAD_DONE;
    }

    return conf.status;
  }

  function processHotspots(screen, screenIDList) {
    var hotspots = screen.allHotspots.map(createHotspot); // Detect header, footer and timer

    var realHotspots = hotspots.filter(function (hotspot) {
      if ((0, _hotspot.isHeader)(hotspot)) {
        screen.header = {
          y: hotspot.y,
          height: hotspot.y,
          hotspots: []
        };
        return false;
      }

      if ((0, _hotspot.isFooter)(hotspot)) {
        screen.footer = {
          y: hotspot.y,
          height: screen.img.height - hotspot.y,
          hotspots: []
        };
        return false;
      }

      if ((0, _hotspot.isTimer)(hotspot)) {
        screen.timer = {
          ms: hotspot.timer * 1000,
          destScreenID: hotspot.destinationScreenID,
          transition: hotspot.transition
        };
        return false;
      }

      if (!(0, _hotspot.hasValidDestination)(hotspot, screenIDList)) {
        return false;
      }

      return true;
    });
    screen.allHotspots = realHotspots;
  }

  function partitionScreenHotspots(screen) {
    screen.hotspots = [];
    screen.allHotspots.forEach(function (hotspot) {
      if (screen.header && (0, _hotspot.overlapsHeader)(screen.header, hotspot)) {
        hotspot.location = screenLocation.HEADER;
        screen.header.hotspots.push(hotspot);
      } else if (screen.footer && (0, _hotspot.overlapsFooter)(screen.footer, hotspot)) {
        hotspot.location = screenLocation.FOOTER;
        screen.footer.hotspots.push(hotspot);
      } else {
        hotspot.location = screenLocation.BODY;
        screen.hotspots.push(hotspot);
      }
    });
  }

  function createHotspot(conf) {
    var x = conf.x,
        y = conf.y,
        x2 = conf.x2,
        y2 = conf.y2;
    var hotspot = {
      id: conf.id,
      type: conf.type,
      location: conf.location,
      transition: conf.transition === 'none' ? '' : conf.transition,
      timer: conf.timer,
      action: conf.action,
      // TODO use camelCaseUnderscore to automatically convert
      // between python style and js style
      externalUrl: conf.external_url,
      newWindow: conf.new_window,
      destinationScreenID: conf.dest_img_fk,
      ownerScreenID: conf.img_owner_fk,
      // TODO: Find a cleaner way to distinguish hotspots from overlays?
      isOverlay: conf.is_overlay,
      overlayBackgroundColour: conf.overlay_background_colour,
      overlayPosition: conf.overlay_position,
      overlayX: conf.overlay_x,
      overlayY: conf.overlay_y,
      anchorYPos: conf.anchor_y_pos,
      smoothScroll: conf.smooth_scroll,
      stayOnTarget: conf.stay_on_page,
      duplicatedOn: conf.images || [],
      maintainScroll: conf.maintain_scroll,
      isScrollable: conf.overlay_scroll,
      x: x,
      y: y,
      x2: x2,
      y2: y2
    };
    var externalUrl = conf.external_url;

    if (hotspot.type === _marvelCore.constants.TYPE_EMBED) {
      externalUrl = (0, _getEmbedUrl2.default)(externalUrl);
    }

    if (hotspot.type === _marvelCore.constants.TYPE_URL && (0, _isEmail2.default)(externalUrl)) {
      externalUrl = 'mailto:' + externalUrl;
    }

    hotspot.externalUrl = externalUrl; // hovers should not have a transition property set

    if (hotspot.action === 'hover') {
      hotspot.transition = null;
    }

    return hotspot;
  }

  function duplicateHotspots(screenMap, sourceScreen) {
    sourceScreen.allHotspots.forEach(function (sourceHotspot) {
      sourceHotspot.duplicatedOn.forEach(function (targetScreenID) {
        if (sourceScreen.id !== targetScreenID) {
          var targetScreen = screenMap[targetScreenID];

          if (!targetScreen) {
            // eslint-disable-next-line no-console
            console.warn(targetScreenID + ' is not a valid screen ID');
            return;
          }

          var duplicatedHotspot = createDuplicatedHotspot(sourceHotspot, targetScreen);
          targetScreen.allHotspots.push(duplicatedHotspot);
        }
      });
    });
  }

  function createDuplicatedHotspot(sourceHotspot, targetScreen) {
    return babelHelpers.extends({}, sourceHotspot, {
      originScreenID: sourceHotspot.ownerScreenID,
      ownerScreenID: targetScreen.id,
      duplicatedOn: []
    });
  }

  function getDeviceProperties(origProjectConfig) {
    var _get = (0, _partial2.default)(getProperty, origProjectConfig);

    var frame = _get(projectProperties.DEVICE_FRAME);

    var orientation = void 0;

    if (frame.indexOf('apple-watch') !== -1) {
      orientation = _orientation.PORTRAIT;
    } else {
      orientation = _get(projectProperties.DEVICE_ORIENTATION) || _orientation.PORTRAIT;
    }

    var device = {
      frame: frame,
      orientation: orientation
    };
    normalizeLegacyDevices(device);
    return device;
  }

  function normalizeLegacyDevices(device) {
    /* eslint-disable no-param-reassign */
    device.frame = device.frame.replace('photo', '');

    if (device.frame === 'desktop-view') {
      device.frame = 'web-frame';
    } // Replacing legacy frames


    if (device.frame === 's5-frame' || device.frame === 'htc-one-frame') {
      device.frame = 'nexus5-frame';
    }

    if (device.frame === 'apple-watch-38-frame') {
      device.frame = 'apple-watch-42-frame';
    }
  }

  function getCompanyData(origProjectConfig) {
    var companyData = origProjectConfig.company_data;

    if (companyData) {
      return {
        id: companyData.id,
        name: companyData.name,
        companyImage: companyData.company_image,
        avatar: companyData.avatar,
        loadingScreenIcon: companyData.loading_screen_icon ? companyData.loading_screen_icon : null,
        loadingScreenColour: getScreenColour(companyData),
        isOpen: companyData.is_open,
        city: companyData.city,
        country: companyData.country,
        isEnterprise: companyData.is_enterprise,
        isOpenHandoff: companyData.is_open_handoff
      };
    }

    var ownerCompanyId = (0, _get3.default)(origProjectConfig, 'owner.company_id');

    if (ownerCompanyId) {
      return {
        id: ownerCompanyId,
        isEnterprise: (0, _get3.default)(origProjectConfig, 'owner.company_is_enterprise')
      };
    }

    return {};
  }

  function getScreenColour(companyData) {
    if (companyData.loading_screen_icon) {
      return companyData.loading_screen_colour;
    }

    return null;
  }

  function getStatusBarProperties(project) {
    var type = getProperty(project, projectProperties.STATUS_BAR_TYPE_PROPERTY);
    var trimStatusBar = getProperty(project, projectProperties.TRIM_STATUS_BAR_PROPERTY);

    var _getDeviceProperties = getDeviceProperties(project),
        deviceFrame = _getDeviceProperties.frame;

    var screenNeedsTrimmed = trimStatusBar === '1' && (_deviceDetection.isIPhone || _deviceDetection.isIPad);
    var screenNeedsMovedDown = screenNeedsTrimmed && type === statusBar.STATUS_BAR_BLACK_WHITE_CLEAR && (0, _isBrowserInFullScreenMode2.default)();
    var bodyNeedsDeviceHeight = (_deviceDetection.isIPhone || _deviceDetection.isIPad) && deviceFrame === deviceFrames.IPHONE_X && type === statusBar.STATUS_BAR_BLACK_WHITE_CLEAR && (0, _isBrowserInFullScreenMode2.default)();
    return {
      appleStatusBarStyle: statusBar.STATUS_BAR_TYPE_MAP[type],
      screenNeedsMovedDown: screenNeedsMovedDown,
      bodyNeedsDeviceHeight: bodyNeedsDeviceHeight,
      trimHeight: screenNeedsTrimmed ? statusBar.getHeight(deviceFrame) : 0
    };
  }

  function getProperty(config, name) {
    var prop = (0, _find2.default)(config.properties, function (p) {
      return p.name === name;
    });

    if (!prop) {
      throw new Error('Cannot find property "' + name + '"');
    }

    return prop.value;
  }

  function mapColorSamples(image) {
    return (0, _mapValues2.default)({
      bottom: image.bottom_pixel_colour,
      top: image.top_pixel_colour,
      statusBar: image.status_pixel_colour
    }, colorToRGBA);
  }

  function colorToRGBA(color) {
    return color ? 'rgba(' + color + ')' : undefined;
  }
  /***/

},
/* 128 */

/***/
function (module, exports) {
  module.exports = require("lodash/sortBy");
  /***/
},
/* 129 */

/***/
function (module, exports) {
  module.exports = require("lodash/map");
  /***/
},
/* 130 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PINCH_OUT = exports.PINCH_IN = exports.SWIPE_DOWN = exports.SWIPE_UP = exports.SWIPE_RIGHT = exports.SWIPE_LEFT = exports.DOUBLE_TAP = exports.TIMER = exports.HOVER = exports.CLICK = undefined;
  exports.isTouchAction = isTouchAction;

  var _keyBy = __webpack_require__(289);

  var _keyBy2 = babelHelpers.interopRequireDefault(_keyBy);

  var CLICK = exports.CLICK = 'click';
  var HOVER = exports.HOVER = 'hover';
  var TIMER = exports.TIMER = 'timer';
  var DOUBLE_TAP = exports.DOUBLE_TAP = 'doubletap';
  var SWIPE_LEFT = exports.SWIPE_LEFT = 'swipeleft';
  var SWIPE_RIGHT = exports.SWIPE_RIGHT = 'swiperight';
  var SWIPE_UP = exports.SWIPE_UP = 'swipeup';
  var SWIPE_DOWN = exports.SWIPE_DOWN = 'swipedown';
  var PINCH_IN = exports.PINCH_IN = 'pinch';
  var PINCH_OUT = exports.PINCH_OUT = 'pinchout';
  var touchActions = (0, _keyBy2.default)([DOUBLE_TAP, SWIPE_LEFT, SWIPE_RIGHT, SWIPE_UP, SWIPE_DOWN, PINCH_IN, PINCH_OUT]);

  function isTouchAction(action) {
    return action in touchActions;
  }
  /***/

},
/* 131 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var FREE = exports.FREE = 'Free';
  var PRO = exports.PRO = 'Pro';
  var COMPANY = exports.COMPANY = 'Company';
  /***/
},
/* 132 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setInitialScreen = setInitialScreen;
  exports.showNext = showNext;
  exports.showPrevious = showPrevious;
  exports.showHome = showHome;
  exports.showScreen = showScreen;
  exports.screenResized = screenResized;
  exports.scrollTo = scrollTo;
  exports.unsetScrollPos = unsetScrollPos;
  exports.screenTimer = screenTimer;
  exports.imageLoaded = imageLoaded;
  exports.imageLoadFailed = imageLoadFailed;
  exports.screenTransitionCompleted = screenTransitionCompleted;
  exports.showScreenInfo = showScreenInfo;
  exports.hideScreenInfo = hideScreenInfo;
  exports.gifResetDone = gifResetDone;
  exports.showHoverScreen = showHoverScreen;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function setInitialScreen(screenID) {
    return {
      type: actionTypes.SET_INITIAL_SCREEN,
      screenID: screenID
    };
  }

  function showNext(transition) {
    return {
      type: actionTypes.SHOW_NEXT,
      transition: transition
    };
  }

  function showPrevious(transition) {
    return {
      type: actionTypes.SHOW_PREVIOUS,
      transition: transition
    };
  }

  function showHome() {
    return {
      type: actionTypes.SHOW_HOME
    };
  }

  function showScreen(screenID, transition, scrollPos) {
    return {
      type: actionTypes.SHOW_SCREEN,
      screenID: screenID,
      transition: transition,
      scrollPos: scrollPos
    };
  }

  function screenResized(renderedScreenDimensions) {
    return {
      type: actionTypes.SCREEN_RESIZED,
      renderedScreenDimensions: renderedScreenDimensions
    };
  }

  function scrollTo(position, smoothScroll) {
    return {
      type: actionTypes.SCROLL_TO,
      position: position,
      smoothScroll: smoothScroll
    };
  }

  function unsetScrollPos() {
    return {
      type: actionTypes.UNSET_SCROLL_POS
    };
  }

  function screenTimer(timer) {
    return {
      type: actionTypes.SCREEN_TIMER,
      timer: timer
    };
  }

  function imageLoaded(id) {
    return {
      type: actionTypes.IMAGE_LOADED,
      id: id
    };
  }

  function imageLoadFailed(id) {
    return {
      type: actionTypes.IMAGE_LOAD_FAILED,
      id: id
    };
  }

  function screenTransitionCompleted(_ref) {
    var isCurrent = _ref.isCurrent;
    return {
      type: actionTypes.SCREEN_TRANSITION_COMPLETED,
      isCurrent: isCurrent
    };
  }

  function showScreenInfo() {
    return {
      type: actionTypes.SHOW_SCREEN_INFO
    };
  }

  function hideScreenInfo() {
    return {
      type: actionTypes.HIDE_SCREEN_INFO
    };
  }

  function gifResetDone() {
    return {
      type: actionTypes.GIF_RESET_DONE
    };
  }

  function showHoverScreen(screenID, scrollPos) {
    return {
      type: actionTypes.SHOW_HOVER_SCREEN,
      screenID: screenID,
      scrollPos: scrollPos
    };
  }
  /***/

},
/* 133 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getAddToHomeScreenProps = getAddToHomeScreenProps;

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _getRandomIconUrl = __webpack_require__(108);

  var _getRandomIconUrl2 = babelHelpers.interopRequireDefault(_getRandomIconUrl);

  var _isBrowserInFullScreenMode = __webpack_require__(56);

  var _isBrowserInFullScreenMode2 = babelHelpers.interopRequireDefault(_isBrowserInFullScreenMode);

  function getAddToHomeScreenProps(state) {
    var projectID = (0, _get2.default)(state, 'project.config.id');
    var appIconUrl = (0, _get2.default)(state, 'project.config.appIcon');

    if (!appIconUrl) {
      appIconUrl = (0, _getRandomIconUrl2.default)(projectID);
    }

    return {
      device: getDevice(state.deviceDetection),
      isVisible: isVisible(state),
      appIconUrl: appIconUrl,
      projectID: projectID
    };
  }

  function isVisible(state) {
    return state.addToHomeScreenVisible && getDevice(state.deviceDetection) && !(0, _isBrowserInFullScreenMode2.default)() && !state.project.isDownloaded && !state.project.hideAddToHomeScreen;
  }

  function getDevice(deviceDetection) {
    if (deviceDetection.isIPhone) return 'iphone';
    if (deviceDetection.isAndroid) return 'android';
    if (deviceDetection.isIPad) return 'ipad';
    return null;
  }
  /***/

},
/* 134 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "handoffSidebar": "SidebarHandoff__handoffSidebar___3Ojdd position-fixed pinTR overflowY-scroll bg-white borderWidth-0 borderLeftWidth-1 borderStyle-solid borderColor-snow--xd fontSize-s",
    "iconClose": "SidebarHandoff__iconClose___2Ev5k modal-icon modal-icon--s modal-icon--light modal-iconClose--outside modal-iconClose zi-100",
    "iconBack": "SidebarHandoff__iconBack___2bCCx modal-icon modal-icon--s modal-icon--light modal-iconBack--outside modal-iconBack zi-100",
    "title": "SidebarHandoff__title___232U2 padding-m fontSize-l",
    "handoffMode": "SidebarHandoff__handoffMode___1XAJJ",
    "sidebarSwitcher": "SidebarHandoff__sidebarSwitcher___2i9Ly bg-snow borderWidth-0 borderTopWidth-1 borderStyle-solid borderColor-snow--xd"
  };
  /***/
},
/* 135 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "grid": "PanelGrid__grid___3ofw9 display-flex flexWrap-wrap justifyContent-between",
    "gridItem": "PanelGrid__gridItem___3yhZf listStyle-none"
  };
  /***/
},
/* 136 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _PanelGridItem = __webpack_require__(57);

  var _PanelGridItem2 = babelHelpers.interopRequireDefault(_PanelGridItem);

  var _Label = __webpack_require__(32);

  var _Label2 = babelHelpers.interopRequireDefault(_Label);

  var _Value = __webpack_require__(47);

  var _Value2 = babelHelpers.interopRequireDefault(_Value);

  var PanelProperty = function PanelProperty(_ref) {
    var label = _ref.label,
        children = _ref.children;
    return _react2.default.createElement(_PanelGridItem2.default, null, _react2.default.createElement(_Label2.default, null, label), _react2.default.createElement(_Value2.default, null, children));
  };

  PanelProperty.propTypes = {
    label: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.node
  };
  exports.default = PanelProperty;
  /***/
},
/* 137 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var PIXEL = exports.PIXEL = 'px';
  var POINT = exports.POINT = 'pt';
  var DENSITY_INDEPENDENT_PIXEL = exports.DENSITY_INDEPENDENT_PIXEL = 'dp';
  var SCALE_INDEPENDENT_PIXEL = exports.SCALE_INDEPENDENT_PIXEL = 'sp';
  /***/
},
/* 138 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Fills;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _GradientFill = __webpack_require__(139);

  var _GradientFill2 = babelHelpers.interopRequireDefault(_GradientFill);

  var _ColorFill = __webpack_require__(92);

  var _ColorFill2 = babelHelpers.interopRequireDefault(_ColorFill);

  var _ImageFill = __webpack_require__(341);

  var _ImageFill2 = babelHelpers.interopRequireDefault(_ImageFill);

  var _Box = __webpack_require__(33);

  var _Box2 = babelHelpers.interopRequireDefault(_Box);

  var _BoxSection = __webpack_require__(40);

  var _BoxSection2 = babelHelpers.interopRequireDefault(_BoxSection);

  var fillComponents = {
    color: _ColorFill2.default,
    image: _ImageFill2.default,
    gradient: _GradientFill2.default
  };

  function Fills(_ref) {
    var fills = _ref.fills;
    var header = 'Fill';

    if (fills.length > 1) {
      header += 's';
    }

    return _react2.default.createElement(_Panel2.default, {
      header: header
    }, fills.map(function (fill, i) {
      var Fill = fillComponents[fill.type];

      if (fill.type === 'image') {
        // eslint-disable-next-line react/no-array-index-key
        return _react2.default.createElement(Fill, babelHelpers.extends({
          key: i
        }, fill));
      }

      return (// eslint-disable-next-line react/no-array-index-key
        _react2.default.createElement(_Box2.default, {
          key: i
        }, _react2.default.createElement(_BoxSection2.default, null, _react2.default.createElement(Fill, fill)))
      );
    }));
  }

  Fills.propTypes = {
    fills: _propTypes2.default.array.isRequired
  };
  /***/
},
/* 139 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = GradientFill;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _capitalize = __webpack_require__(73);

  var _capitalize2 = babelHelpers.interopRequireDefault(_capitalize);

  var _PanelColorSection = __webpack_require__(140);

  var _PanelColorSection2 = babelHelpers.interopRequireDefault(_PanelColorSection);

  function GradientFill(_ref) {
    var gradientType = _ref.gradientType,
        colors = _ref.colors;
    return _react2.default.createElement(_PanelColorSection2.default, {
      label: (0, _capitalize2.default)(gradientType) + '\nGradient',
      colors: colors
    });
  }

  GradientFill.propTypes = {
    gradientType: _propTypes2.default.string.isRequired,
    colors: _propTypes2.default.array.isRequired
  };
  /***/
},
/* 140 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PanelColorSection;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Swatch = __webpack_require__(91);

  var _Swatch2 = babelHelpers.interopRequireDefault(_Swatch);

  var _CopyToClipboard = __webpack_require__(58);

  var _CopyToClipboard2 = babelHelpers.interopRequireDefault(_CopyToClipboard);

  var _convertColours = __webpack_require__(27);

  var convert = babelHelpers.interopRequireWildcard(_convertColours);

  var _Label = __webpack_require__(32);

  var _Label2 = babelHelpers.interopRequireDefault(_Label);

  var _PanelColorSection = __webpack_require__(340);

  var _PanelColorSection2 = babelHelpers.interopRequireDefault(_PanelColorSection);

  function PanelColorSection(_ref) {
    var label = _ref.label,
        colors = _ref.colors;
    return _react2.default.createElement('div', {
      className: _PanelColorSection2.default.section
    }, _react2.default.createElement('div', {
      className: _PanelColorSection2.default.labelWrapper
    }, _react2.default.createElement(_Label2.default, null, label)), _react2.default.createElement('div', {
      className: _PanelColorSection2.default.swatchWrapper
    }, colors.map(function (color, index) {
      return (// eslint-disable-next-line react/no-array-index-key
        _react2.default.createElement('div', {
          key: index
        }, _react2.default.createElement('span', {
          className: _PanelColorSection2.default.swatchLabel
        }, convert.rgbArray2hybridCSS(color)), _react2.default.createElement(_CopyToClipboard2.default, {
          text: convert.rgbArray2css(color)
        }, function (isCopying) {
          return _react2.default.createElement(_Swatch2.default, {
            color: color,
            isCopying: isCopying,
            width: 20,
            height: 20,
            position: getSwatchPosition(index, colors.length)
          });
        }))
      );
    })));
  }

  function getSwatchPosition(index, noOfSwatches) {
    if (noOfSwatches === 1) {
      return 'alone';
    }

    if (index === 0) {
      return 'top';
    }

    if (index === noOfSwatches - 1) {
      return 'bottom';
    }

    return 'middle';
  }

  PanelColorSection.propTypes = {
    colors: _propTypes2.default.array.isRequired,
    label: _propTypes2.default.string.isRequired
  };
  /***/
},
/* 141 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "thumbContainer": "AssetPreview__thumbContainer___1NkSM padding-xxs display-table borderStyle-solid borderColor-snow--xd width-100",
    "thumb": "AssetPreview__thumb___23e6N textAlign-center verticalAlign-middle display-tableCell",
    "image": "AssetPreview__image___2aDOU verticalAlign-middle",
    "transparentPattern": "AssetPreview__transparentPattern___1tnTB",
    "centered": "AssetPreview__centered___TdVBK borderRadius-m marginTop-s marginLeftRight-s borderWidth-1",
    "top": "AssetPreview__top___1NeGe borderWidth-0 borderBottomWidth-1",
    "bottom": "AssetPreview__bottom___1-lEt borderWidth-0 borderTopWidth-1"
  };
  /***/
},
/* 142 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isCopying = isCopying;

  function isCopying(state, target) {
    return !!state.clipboard[target];
  }
  /***/

},
/* 143 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var CSS = exports.CSS = 'css';
  var ANDROID = exports.ANDROID = 'android';
  var SWIFT = exports.SWIFT = 'swift';
  var OBJECTIVE_C = exports.OBJECTIVE_C = 'objective-c';
  var REACT_NATIVE = exports.REACT_NATIVE = 'reactNative';
  var LANGUAGES = exports.LANGUAGES = {
    css: {
      id: CSS,
      label: 'CSS'
    },
    android: {
      id: ANDROID,
      label: 'Android (XML)'
    },
    swift: {
      id: SWIFT,
      label: 'Swift'
    },
    'objective-c': {
      id: OBJECTIVE_C,
      label: 'Objective-C'
    },
    reactNative: {
      id: REACT_NATIVE,
      label: 'React Native'
    }
  };
  /***/
},
/* 144 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = AssetPreview;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _icons = __webpack_require__(14);

  var _AssetPreview = __webpack_require__(141);

  var _AssetPreview2 = babelHelpers.interopRequireDefault(_AssetPreview);

  function AssetPreview(_ref) {
    var _cx;

    var url = _ref.url,
        centered = _ref.centered,
        top = _ref.top,
        bottom = _ref.bottom;
    var thumbContainerClass = (0, _classnames2.default)(_AssetPreview2.default.thumbContainer, _AssetPreview2.default.transparentPattern, (_cx = {}, babelHelpers.defineProperty(_cx, _AssetPreview2.default.centered, centered), babelHelpers.defineProperty(_cx, _AssetPreview2.default.top, top), babelHelpers.defineProperty(_cx, _AssetPreview2.default.bottom, bottom), _cx));
    return _react2.default.createElement('div', {
      className: thumbContainerClass
    }, _react2.default.createElement('div', {
      className: _AssetPreview2.default.thumb
    }, url ? _react2.default.createElement('img', {
      src: url,
      className: _AssetPreview2.default.image
    }) : _react2.default.createElement(_icons.BrokenImageIcon, null)));
  }

  AssetPreview.propTypes = {
    url: _propTypes2.default.string,
    centered: _propTypes2.default.bool,
    top: _propTypes2.default.bool,
    bottom: _propTypes2.default.bool
  };
  AssetPreview.defaultProps = {
    url: '',
    centered: true,
    top: false,
    bottom: false
  };
  /***/
},
/* 145 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/marvel-ui/checkbox");
  /***/
},
/* 146 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = SidebarState;
  exports.ContactButton = ContactButton;
  exports.FindOutMoreButtton = FindOutMoreButtton;
  exports.SignInButton = SignInButton;
  exports.FindHowToDownloadAssetsButton = FindHowToDownloadAssetsButton;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _button = __webpack_require__(49);

  var _button2 = babelHelpers.interopRequireDefault(_button);

  var _marvelURL = __webpack_require__(38);

  var marvelURL = babelHelpers.interopRequireWildcard(_marvelURL);

  var _SidebarState = __webpack_require__(357);

  var _SidebarState2 = babelHelpers.interopRequireDefault(_SidebarState);

  var _SidebarImages = __webpack_require__(358);

  var _SidebarImages2 = babelHelpers.interopRequireDefault(_SidebarImages);

  function SidebarState(_ref) {
    var image = _ref.image,
        heading = _ref.heading,
        message = _ref.message,
        children = _ref.children;
    return _react2.default.createElement('div', {
      className: _SidebarState2.default.wrap
    }, _react2.default.createElement('div', {
      className: _SidebarState2.default.table
    }, _react2.default.createElement('div', {
      className: _SidebarState2.default.cell
    }, image && _react2.default.createElement('div', {
      className: _SidebarImages2.default[image]
    }), _react2.default.createElement('div', {
      className: _SidebarState2.default.heading
    }, heading), _react2.default.createElement('div', {
      className: _SidebarState2.default.message
    }, message), children)));
  }

  SidebarState.propTypes = {
    image: _propTypes2.default.oneOf(Object.keys(_SidebarImages2.default)),
    heading: _propTypes2.default.node.isRequired,
    message: _propTypes2.default.node.isRequired,
    children: _propTypes2.default.node
  };

  function ContactButton() {
    return _react2.default.createElement('a', {
      href: marvelURL.CONTACT_SUPPORT,
      target: '_blank',
      rel: 'noopener noreferrer',
      className: _SidebarState2.default.contact
    }, _react2.default.createElement(_button2.default, {
      size: 'small',
      style: 'outlined',
      background: 'white',
      hover: 'blue'
    }, 'Contact support'));
  }

  function FindOutMoreButtton() {
    return _react2.default.createElement('a', {
      href: marvelURL.DOWNLOAD_ASSETS_USING_HANDOFF,
      target: '_blank',
      rel: 'noopener noreferrer',
      className: _SidebarState2.default.contact
    }, _react2.default.createElement(_button2.default, {
      size: 'small',
      style: 'flat',
      background: 'blue',
      hover: 'blue'
    }, 'How to use Handoff'));
  }

  function SignInButton() {
    return _react2.default.createElement('a', {
      href: marvelURL.SIGN_IN,
      target: '_blank',
      rel: 'noopener noreferrer',
      className: _SidebarState2.default.contact
    }, _react2.default.createElement(_button2.default, {
      size: 'small',
      style: 'flat',
      background: 'blue',
      hover: 'blue'
    }, 'Sign In'));
  }

  function FindHowToDownloadAssetsButton() {
    return _react2.default.createElement('a', {
      href: marvelURL.DOWNLOAD_ASSETS_USING_HANDOFF,
      target: '_blank',
      rel: 'noopener noreferrer',
      className: _SidebarState2.default.asset
    }, _react2.default.createElement(_button2.default, {
      size: 'small',
      style: 'outlined',
      background: 'white',
      hover: 'blue'
    }, 'Find out how'));
  }
  /***/

},
/* 147 */

/***/
function (module, exports) {
  module.exports = require("lodash/uniqBy");
  /***/
},
/* 148 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _compose = __webpack_require__(24);

  var _compose2 = babelHelpers.interopRequireDefault(_compose);

  var _assign = __webpack_require__(21);

  var _assign2 = babelHelpers.interopRequireDefault(_assign);

  var _groupBy = __webpack_require__(149);

  var _groupBy2 = babelHelpers.interopRequireDefault(_groupBy);

  var _sortBy = __webpack_require__(128);

  var _sortBy2 = babelHelpers.interopRequireDefault(_sortBy);

  var _partial = __webpack_require__(22);

  var _partial2 = babelHelpers.interopRequireDefault(_partial);

  var _downloadAssets = __webpack_require__(84);

  var _ElementAssets = __webpack_require__(362);

  var _ElementAssets2 = babelHelpers.interopRequireDefault(_ElementAssets);

  var _element = __webpack_require__(16);

  var elementUtils = babelHelpers.interopRequireWildcard(_element);

  var _assets = __webpack_require__(151);

  var _downloadAssets2 = __webpack_require__(93);

  var assetDownloadSelectors = babelHelpers.interopRequireWildcard(_downloadAssets2);

  var _screen = __webpack_require__(9);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state, _ref) {
    var element = _ref.element;
    var currentScreen = (0, _screen.getCurrentScreen)(state);
    var assets = elementUtils.getAssets(element);

    if (!assets.length) {
      return {};
    }

    var assetsGroupedByType = (0, _groupBy2.default)((0, _sortBy2.default)(assets, 'format'), 'format');
    return {
      assets: assetsGroupedByType,
      bestAssetUrl: (0, _assets.getBestAsset)(assetsGroupedByType),
      screenID: currentScreen.id,
      elementID: element.id,
      isDownloading: (0, _partial2.default)(assetDownloadSelectors.isDownloading, state),
      hasDownloaded: (0, _partial2.default)(assetDownloadSelectors.hasDownloaded, state)
    };
  }

  function mergeProps(stateProps, _ref2, ownProps) {
    var dispatch = _ref2.dispatch;
    var screenID = stateProps.screenID,
        elementID = stateProps.elementID,
        isDownloading = stateProps.isDownloading,
        hasDownloaded = stateProps.hasDownloaded;
    var newProps = {
      downloadType: function downloadType(assetType) {
        dispatch((0, _downloadAssets.downloadAssets)({
          screenID: screenID,
          elementID: elementID,
          assetType: assetType
        }));
      },
      downloadAll: function downloadAll() {
        dispatch((0, _downloadAssets.downloadAssets)({
          screenID: screenID,
          elementID: elementID
        }));
      },
      isDownloadingType: function isDownloadingType(assetType) {
        return isDownloading({
          screenID: screenID,
          elementID: elementID,
          assetType: assetType
        });
      },
      hasDownloadedType: function hasDownloadedType(assetType) {
        return hasDownloaded({
          screenID: screenID,
          elementID: elementID,
          assetType: assetType
        });
      },
      isDownloadingAll: function isDownloadingAll() {
        return isDownloading({
          screenID: screenID,
          elementID: elementID
        });
      },
      hasDownloadedAll: function hasDownloadedAll() {
        return hasDownloaded({
          screenID: screenID,
          elementID: elementID
        });
      }
    };
    return (0, _assign2.default)({}, ownProps, stateProps, newProps);
  }

  exports.default = (0, _compose2.default)((0, _reactRedux.connect)(mapStateToProps, null, mergeProps), (0, _onlyIf2.default)(function (props) {
    return props.assets;
  }))(_ElementAssets2.default);
  /***/
},
/* 149 */

/***/
function (module, exports) {
  module.exports = require("lodash/groupBy");
  /***/
},
/* 150 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/marvel-ui/badge");
  /***/
},
/* 151 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getBestAsset = getBestAsset;
  exports.getDesignToolScreenAssets = getDesignToolScreenAssets;
  exports.getScreenAssets = getScreenAssets;
  exports.getElementAssets = getElementAssets;
  exports.getElementAssetsOfType = getElementAssetsOfType;

  var _groupBy = __webpack_require__(149);

  var _groupBy2 = babelHelpers.interopRequireDefault(_groupBy);

  var _toPairs = __webpack_require__(364);

  var _toPairs2 = babelHelpers.interopRequireDefault(_toPairs);

  var _maxBy = __webpack_require__(365);

  var _maxBy2 = babelHelpers.interopRequireDefault(_maxBy);

  var _element = __webpack_require__(16);

  var preferredAssetFormats = ['webp', 'png', 'jpg', 'svg', 'UNKNOWN'];

  function getBestAsset(groupedAssets) {
    for (var i = 0; i < preferredAssetFormats.length; i += 1) {
      var assets = groupedAssets[preferredAssetFormats[i]];

      if (assets) {
        return getBiggestAsset(assets).url;
      }
    }

    return null;
  }

  function getBiggestAsset(assets) {
    return (0, _maxBy2.default)(assets, function (asset) {
      return asset.scale;
    });
  }

  function getDesignToolScreenAssets(screenName, elements) {
    var contents = elements.reduce(function (acc, element) {
      if ((0, _element.hasAssets)(element)) {
        // Until Design Tool switches to easel v2 there's only one asset
        var asset = element.itemProps.assets[0];
        acc[asset.name] = {
          type: 'file',
          url: asset.url
        };
      }

      return acc;
    }, {});
    return getZIP(screenName, contents);
  }

  function getScreenAssets(screenName, elements) {
    var contents = elements.reduce(function (acc, element) {
      if ((0, _element.hasAssets)(element)) {
        var elementAssets = getElementAssetsFolder(element);
        var folder = escapeName((0, _element.getLayerName)(element));
        folder = getUniqueKey(acc, folder);
        acc[folder] = {
          type: 'folder',
          contents: elementAssets
        };
      }

      return acc;
    }, {});
    return getZIP(screenName, contents);
  }

  function getElementAssets(element) {
    var zipName = '' + escapeName((0, _element.getLayerName)(element));
    var contents = getElementAssetsFolder(element);
    return getZIP(zipName, contents);
  }

  function getElementAssetsOfType(element, assetType) {
    var assets = (0, _groupBy2.default)((0, _element.getAssets)(element), 'format')[assetType];
    var layerName = (0, _element.getLayerName)(element);
    var zipName = escapeName(layerName) + '_' + assetType;
    var assetContents = getAssetTypeFolder(layerName, assets, assetType);
    return getZIP(zipName, assetContents);
  }

  function getElementAssetsFolder(element) {
    var elementAssets = (0, _toPairs2.default)((0, _groupBy2.default)((0, _element.getAssets)(element), 'format'));
    var layerName = (0, _element.getLayerName)(element);
    var folder = elementAssets.reduce(function (acc, _ref) {
      var _ref2 = babelHelpers.slicedToArray(_ref, 2),
          assetType = _ref2[0],
          assets = _ref2[1];

      var contents = getAssetTypeFolder(layerName, assets, assetType);
      acc[assetType] = {
        type: 'folder',
        contents: contents
      };
      return acc;
    }, {});
    return folder;
  }

  function getAssetTypeFolder(layerName, assets, assetType) {
    return assets.reduce(function (acc, asset) {
      acc['' + escapeName(layerName) + asset.suffix + '.' + assetType] = {
        type: 'file',
        url: asset.url
      };
      return acc;
    }, {});
  }

  function getZIP(filename, contents) {
    return {
      name: escapeName(filename),
      contents: contents
    };
  }

  function escapeName(name) {
    // TODO what about Windows? Should we even use layer names for
    // directory names?
    return name.replace(/[\\\/<>:"\|\?\*]/g, '_');
  }

  function getUniqueKey(obj, key) {
    if (!(key in obj)) {
      return key;
    }

    var suffix = 1;

    while (key + '_' + suffix in obj) {
      suffix += 1;
    }

    return key + '_' + suffix;
  }
  /***/

},
/* 152 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "header": "Header__header___X2Zwc padding-s position-relative fontSize-m",
    "icon": "Header__icon___1_BEc verticalAlign-middle borderRadius-s borderWidth-1 borderStyle-solid borderColor-smoke position-absolute",
    "iconContainer": "Header__iconContainer___3RLDi position-absolute pinCenter",
    "heading": "Header__heading___2VPYn truncateText verticalAlign-middle",
    "largeHeading": "Header__largeHeading___23FFP fontSize-xl fontWeight-5",
    "subheading": "Header__subheading___2A6WA fontSize-s c-silver lineHeight-s"
  };
  /***/
},
/* 153 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var NORMAL = exports.NORMAL = 'normal';
  /***/
},
/* 154 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Label = __webpack_require__(32);

  var _Label2 = babelHelpers.interopRequireDefault(_Label);

  var _Value = __webpack_require__(47);

  var _Value2 = babelHelpers.interopRequireDefault(_Value);

  var _PanelInlineProperty = __webpack_require__(377);

  var _PanelInlineProperty2 = babelHelpers.interopRequireDefault(_PanelInlineProperty);

  var PanelInlineProperty = function PanelInlineProperty(_ref) {
    var label = _ref.label,
        children = _ref.children;
    return _react2.default.createElement('div', {
      className: _PanelInlineProperty2.default.inlinePanel
    }, _react2.default.createElement(_Label2.default, {
      inline: true
    }, label), _react2.default.createElement(_Value2.default, {
      inline: true
    }, children));
  };

  PanelInlineProperty.propTypes = {
    label: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.node
  };
  exports.default = PanelInlineProperty;
  /***/
},
/* 155 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = CopyToClipboardButton;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _CopyToClipboard = __webpack_require__(58);

  var _CopyToClipboard2 = babelHelpers.interopRequireDefault(_CopyToClipboard);

  var _CopyToClipboardButton = __webpack_require__(387);

  var _CopyToClipboardButton2 = babelHelpers.interopRequireDefault(_CopyToClipboardButton);

  function CopyToClipboardButton(_ref) {
    var target = _ref.target;
    return _react2.default.createElement(_CopyToClipboard2.default, {
      target: target
    }, function (isCopying) {
      return _react2.default.createElement('div', {
        className: _CopyToClipboardButton2.default.link
      }, isCopying ? 'Copied!' : 'Copy');
    });
  }

  CopyToClipboardButton.propTypes = {
    target: _propTypes2.default.string
  };
  /***/
},
/* 156 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "value": "Code__value___13gsx",
    "unit": "Code__unit___1vXzo",
    "codeBlock": "Code__codeBlock___3_zWC borderWidth-1 borderStyle-solid borderColor-smoke padding-xs bg-snow fontSize-xs lineHeight-xs",
    "font": "Code__font___A3scD",
    "inline": "Code__inline___3fB2l inline",
    "label": "Code__label___1x6cD verticalAlign-middle fontSize-m",
    "badge": "Code__badge___UUIdp verticalAlign-middle marginLeft-xs"
  };
  /***/
},
/* 157 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = 'marvel-prototype-resize-root';
  /***/
},
/* 158 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _includes = __webpack_require__(429);

  var _includes2 = babelHelpers.interopRequireDefault(_includes);

  var _HoverOutLayer = __webpack_require__(430);

  var _HoverOutLayer2 = babelHelpers.interopRequireDefault(_HoverOutLayer);

  var _Header = __webpack_require__(434);

  var _Header2 = babelHelpers.interopRequireDefault(_Header);

  var _Footer = __webpack_require__(470);

  var _Footer2 = babelHelpers.interopRequireDefault(_Footer);

  var _ScreenImage = __webpack_require__(471);

  var _ScreenImage2 = babelHelpers.interopRequireDefault(_ScreenImage);

  var _ScrollableArea = __webpack_require__(475);

  var _ScrollableArea2 = babelHelpers.interopRequireDefault(_ScrollableArea);

  var _LoadingSpinner = __webpack_require__(480);

  var _LoadingSpinner2 = babelHelpers.interopRequireDefault(_LoadingSpinner);

  var _Overlay = __webpack_require__(483);

  var _Overlay2 = babelHelpers.interopRequireDefault(_Overlay);

  var _OverlayBackground = __webpack_require__(490);

  var _OverlayBackground2 = babelHelpers.interopRequireDefault(_OverlayBackground);

  var _TopBackground = __webpack_require__(493);

  var _TopBackground2 = babelHelpers.interopRequireDefault(_TopBackground);

  var _BottomBackground = __webpack_require__(496);

  var _BottomBackground2 = babelHelpers.interopRequireDefault(_BottomBackground);

  var _SwipeThroughScreens = __webpack_require__(499);

  var _SwipeThroughScreens2 = babelHelpers.interopRequireDefault(_SwipeThroughScreens);

  var _UploadFailed = __webpack_require__(124);

  var _UploadFailed2 = babelHelpers.interopRequireDefault(_UploadFailed);

  var _UploadPending = __webpack_require__(125);

  var _UploadPending2 = babelHelpers.interopRequireDefault(_UploadPending);

  var _DownloadFailed = __webpack_require__(126);

  var _DownloadFailed2 = babelHelpers.interopRequireDefault(_DownloadFailed);

  var _Screen = __webpack_require__(500);

  var _Screen2 = babelHelpers.interopRequireDefault(_Screen);

  var _contentStatus = __webpack_require__(37);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);
  var NO_ANIMATION = ['fade-previous', 'fade-reverse-current', 'slidedown-current', 'slidedown-reverse-previous', 'slideup-previous', 'slideup-reverse-current'];

  var Screen = function (_React$Component) {
    babelHelpers.inherits(Screen, _React$Component);

    function Screen() {
      babelHelpers.classCallCheck(this, Screen);
      return babelHelpers.possibleConstructorReturn(this, (Screen.__proto__ || Object.getPrototypeOf(Screen)).apply(this, arguments));
    }

    babelHelpers.createClass(Screen, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          isCurrentScreen: this.props.isCurrent
        };
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!this.hasAnimation()) {
          this.props.onAnimationComplete();
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        if (!this.hasAnimation()) {
          this.props.onAnimationComplete();
        }
      }
    }, {
      key: 'hasAnimation',
      value: function hasAnimation() {
        return this.props.transition && !(0, _includes2.default)(NO_ANIMATION, this.getAnimationClass());
      }
    }, {
      key: 'getAnimationClass',
      value: function getAnimationClass() {
        if (this.props.isScreenTransitionComplete) {
          return null;
        }

        var _props = this.props,
            isCurrent = _props.isCurrent,
            transition = _props.transition,
            isTransitionReversed = _props.isTransitionReversed;
        var screenName = isCurrent ? 'current' : 'previous';
        var animation = [transition, screenName];

        if (isTransitionReversed) {
          animation.splice(1, 0, 'reverse');
        }

        return animation.join('-');
      }
    }, {
      key: 'render',
      value: function render() {
        var _cx;

        var _props2 = this.props,
            id = _props2.id,
            isPlacingAnnotation = _props2.isPlacingAnnotation,
            transition = _props2.transition,
            _onClick = _props2.onClick,
            onAnimationComplete = _props2.onAnimationComplete;

        if (!id) {
          return null;
        }

        var animationClass = this.getAnimationClass();
        var className = (0, _classnames2.default)(_Screen2.default.screenWrap, (_cx = {}, babelHelpers.defineProperty(_cx, _Screen2.default[transition], _Screen2.default[transition]), babelHelpers.defineProperty(_cx, _Screen2.default[animationClass], _Screen2.default[animationClass]), babelHelpers.defineProperty(_cx, _Screen2.default.screenWrapPlacingAnnotation, isPlacingAnnotation), _cx));

        var screen = _react2.default.createElement('div', {
          className: className,
          onClick: function onClick(e) {
            return _onClick(id, screenLocation.BODY, e);
          },
          onAnimationEnd: onAnimationComplete
        }, this._renderScreen());

        return _react2.default.createElement(_SwipeThroughScreens2.default, null, screen);
      }
    }, {
      key: '_renderScreen',
      value: function _renderScreen() {
        var _props3 = this.props,
            contentStatus = _props3.contentStatus,
            isLoaded = _props3.isLoaded,
            isDownloadFailed = _props3.isDownloadFailed,
            fixBounce = _props3.fixBounce,
            withRef = _props3.withRef,
            getScrollPos = _props3.getScrollPos,
            id = _props3.id,
            _onClick2 = _props3.onClick;

        if (contentStatus === _contentStatus.IMAGE_UPLOAD_ERROR) {
          return _react2.default.createElement(_UploadFailed2.default, null);
        }

        if (contentStatus === _contentStatus.IMAGE_UPLOAD_PENDING) {
          return _react2.default.createElement(_UploadPending2.default, null);
        }

        if (isDownloadFailed) {
          return _react2.default.createElement(_DownloadFailed2.default, null);
        }

        if (!isLoaded) {
          return _react2.default.createElement(_LoadingSpinner2.default, null);
        }

        return _react2.default.createElement(_HoverOutLayer2.default, {
          getScreenScrollPos: getScrollPos
        }, fixBounce && _react2.default.createElement(_TopBackground2.default, null), fixBounce && _react2.default.createElement(_BottomBackground2.default, null), _react2.default.createElement(_ScrollableArea2.default, {
          withRef: withRef
        }, _react2.default.createElement(_ScreenImage2.default, {
          screenID: id,
          getScreenScrollPos: getScrollPos
        })), _react2.default.createElement(_Header2.default, {
          screenID: id,
          getScreenScrollPos: getScrollPos,
          onClick: function onClick(e) {
            return _onClick2(id, screenLocation.HEADER, e);
          }
        }), _react2.default.createElement(_Footer2.default, {
          screenID: id,
          getScreenScrollPos: getScrollPos,
          onClick: function onClick(e) {
            return _onClick2(id, screenLocation.FOOTER, e);
          }
        }), _react2.default.createElement(_OverlayBackground2.default, null), _react2.default.createElement(_Overlay2.default, {
          getScreenScrollPos: getScrollPos
        }));
      }
    }]);
    return Screen;
  }(_react2.default.Component);

  Screen.childContextTypes = {
    isCurrentScreen: _propTypes2.default.bool.isRequired
  };
  exports.default = Screen;
  Screen.propTypes = {
    id: _propTypes2.default.number,
    isLoaded: _propTypes2.default.bool.isRequired,
    isDownloadFailed: _propTypes2.default.bool.isRequired,
    contentStatus: _propTypes2.default.oneOf([_contentStatus.IMAGE_UPLOAD_PENDING, _contentStatus.IMAGE_UPLOAD_ERROR, _contentStatus.IMAGE_UPLOAD_DONE]),
    isScreenTransitionComplete: _propTypes2.default.bool,
    isTransitionReversed: _propTypes2.default.bool,
    isPlacingAnnotation: _propTypes2.default.bool.isRequired,
    transition: _propTypes2.default.string,
    onClick: _propTypes2.default.func.isRequired,
    onAnimationComplete: _propTypes2.default.func,
    isCurrent: _propTypes2.default.bool,
    fixBounce: _propTypes2.default.bool,
    withRef: _propTypes2.default.func,
    getScrollPos: _propTypes2.default.func
  };
  Screen.defaultProps = {
    onClick: _noop2.default,
    onAnimationComplete: _noop2.default,
    isCurrent: false,
    isLoaded: false,
    isDownloadFailed: false,
    isTransitionReversed: false,
    isPlacingAnnotation: false
  };
  /***/
},
/* 159 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _reactRedux = __webpack_require__(2);

  var _recompose = __webpack_require__(160);

  var _HotspotLayer = __webpack_require__(435);

  var _HotspotLayer2 = babelHelpers.interopRequireDefault(_HotspotLayer);

  var _annotation = __webpack_require__(20);

  var _screen = __webpack_require__(9);

  var _layoutOverlay = __webpack_require__(41);

  var _annotation2 = __webpack_require__(83);

  var _handoff = __webpack_require__(5);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state) {
    var areLayoutRowsEnabled = void 0;
    var areLayoutColumnsEnabled = void 0;

    if ((0, _handoff.isInHandoffMode)(state)) {
      // TODO can remove this try/catch when using the v2 canvas api
      try {
        areLayoutRowsEnabled = (0, _layoutOverlay.getRowsEnabled)(state);
        areLayoutColumnsEnabled = (0, _layoutOverlay.getColumnsEnabled)(state); // eslint-disable-next-line no-empty
      } catch (e) {}
    }

    return {
      isInAnnotationMode: (0, _annotation.isInAnnotationMode)(state),
      isInHandoffMode: (0, _handoff.isInHandoffMode)(state),
      isScreenTransitionComplete: (0, _screen.isTransitionComplete)(state),
      areLayoutRowsEnabled: areLayoutRowsEnabled,
      areLayoutColumnsEnabled: areLayoutColumnsEnabled
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      onClick: function onClick(screenArea, clickPosition) {
        dispatch((0, _annotation2.addNewAnnotation)(screenArea, clickPosition));
      },
      positionAnnotation: function positionAnnotation(commentUUID, screenArea, position) {
        dispatch((0, _annotation2.positionAnnotation)(commentUUID, screenArea, position));
      }
    };
  }

  var shouldRender = function shouldRender(props) {
    return props.isCurrentScreen && props.isScreenTransitionComplete;
  };

  exports.default = (0, _recompose.compose)((0, _recompose.getContext)({
    isCurrentScreen: _propTypes2.default.bool.isRequired
  }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _onlyIf2.default)(shouldRender))(_HotspotLayer2.default);
  /***/
},
/* 160 */

/***/
function (module, exports) {
  module.exports = require("recompose");
  /***/
},
/* 161 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "hotspot": "Hotspot__hotspot___1uv7p",
    "visibleHotspot": "Hotspot__visibleHotspot___AT5g-"
  };
  /***/
},
/* 162 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.DIRECTION_VERTICAL = exports.DIRECTION_HORIZONTAL = exports.DIRECTION_DOWN = exports.DIRECTION_UP = exports.DIRECTION_RIGHT = exports.DIRECTION_LEFT = undefined;
  exports.default = Gesture;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactHammerjs = __webpack_require__(440);

  var _reactHammerjs2 = babelHelpers.interopRequireDefault(_reactHammerjs); // These constants are defined in hammerjs, but they are replicated here,
  // because the library is imported by react-hammerjs and I don't want to add
  // hammerjs to package.json as direct dependency


  var DIRECTION_LEFT = exports.DIRECTION_LEFT = 2;
  var DIRECTION_RIGHT = exports.DIRECTION_RIGHT = 4;
  var DIRECTION_UP = exports.DIRECTION_UP = 8;
  var DIRECTION_DOWN = exports.DIRECTION_DOWN = 16;
  /* eslint-disable no-bitwise */

  var DIRECTION_HORIZONTAL = exports.DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
  var DIRECTION_VERTICAL = exports.DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
  var actionMap = {
    click: {
      eventType: 'onTap',
      options: {}
    },
    doubletap: {
      eventType: 'onDoubleTap',
      options: {
        recognizers: {
          tap: {
            time: 600,
            taps: 2,
            interval: 400,
            threshold: 45
          }
        }
      }
    },
    swipeleft: {
      eventType: 'onSwipe',
      options: {
        recognizers: {
          swipe: {
            direction: DIRECTION_LEFT
          }
        }
      }
    },
    swiperight: {
      eventType: 'onSwipe',
      options: {
        recognizers: {
          swipe: {
            direction: DIRECTION_RIGHT
          }
        }
      }
    },
    swipeup: {
      eventType: 'onSwipe',
      options: {
        recognizers: {
          swipe: {
            direction: DIRECTION_UP
          }
        }
      }
    },
    swipedown: {
      eventType: 'onSwipe',
      options: {
        recognizers: {
          swipe: {
            direction: DIRECTION_DOWN
          }
        }
      }
    },
    swipehorizontally: {
      eventType: 'onSwipe',
      options: {
        recognizers: {
          swipe: {
            direction: DIRECTION_HORIZONTAL
          }
        }
      }
    },
    pinch: {
      eventType: 'onPinchIn',
      options: {
        recognizers: {
          pinch: {
            enable: true
          }
        }
      }
    },
    pinchout: {
      eventType: 'onPinchOut',
      options: {
        recognizers: {
          pinch: {
            enable: true
          }
        }
      }
    }
  };

  function Gesture(_ref) {
    var _props;

    var children = _ref.children,
        action = _ref.action,
        eventHandler = _ref.eventHandler;
    var _actionMap$action = actionMap[action],
        eventType = _actionMap$action.eventType,
        options = _actionMap$action.options;
    var props = (_props = {}, babelHelpers.defineProperty(_props, eventType, eventHandler), babelHelpers.defineProperty(_props, 'options', options), _props);
    return _react2.default.createElement(_reactHammerjs2.default, props, children);
  }

  Gesture.propTypes = {
    children: _propTypes2.default.node.isRequired,
    action: _propTypes2.default.oneOf(Object.keys(actionMap)).isRequired,
    eventHandler: _propTypes2.default.func.isRequired
  };
  /***/
},
/* 163 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.shouldSizeEmbedlyContainer = shouldSizeEmbedlyContainer;

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  function shouldSizeEmbedlyContainer(state) {
    var isWeb = (0, _get2.default)(state, 'project.config.isWeb');
    return state.project.isEmbedded && !isWeb;
  }
  /***/

},
/* 164 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isPlaying = isPlaying;

  function isPlaying(state) {
    return !state.project.isEmbedded || state.player.isPlaying;
  }
  /***/

},
/* 165 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.areTimersEnabled = areTimersEnabled;

  var _handoff = __webpack_require__(5);

  var _comment = __webpack_require__(74);

  var _hover = __webpack_require__(100);

  function areTimersEnabled(state) {
    return !(0, _handoff.isInHandoffMode)(state) && !(0, _comment.areCommentsVisible)(state) && !(0, _hover.isHovering)(state);
  }
  /***/

},
/* 166 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactDom = __webpack_require__(63);

  var _reactDnd = __webpack_require__(52);

  var _reactDndHtml5Backend = __webpack_require__(105);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _velocityReact = __webpack_require__(23);

  var _icons = __webpack_require__(14);

  var _Annotation = __webpack_require__(450);

  var _Annotation2 = babelHelpers.interopRequireDefault(_Annotation); // TODO calculate this from ANNOTATION_SIZE?


  var pulseAnimation = {
    animation: {
      width: [200, 100],
      height: [200, 100],
      opacity: [0, 0.6]
    }
  };
  var annotationSource = {
    beginDrag: function beginDrag(props, monitor, component) {
      var comp = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();
      return {
        id: props.id,
        commentUUID: props.commentUUID,
        screenArea: props.screenArea,
        isDone: props.isDone,
        isSaved: props.isSaved,
        isHiddenForDrag: true,
        isDragging: true,
        initialPosition: {
          top: comp.top,
          left: comp.left
        }
      };
    }
  };

  function collect(connect, monitor) {
    return {
      isHiddenForDrag: monitor.isDragging(),
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview()
    };
  }

  var Annotation = function (_React$Component) {
    babelHelpers.inherits(Annotation, _React$Component);

    function Annotation() {
      babelHelpers.classCallCheck(this, Annotation);
      return babelHelpers.possibleConstructorReturn(this, (Annotation.__proto__ || Object.getPrototypeOf(Annotation)).apply(this, arguments));
    }

    babelHelpers.createClass(Annotation, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // Use empty image as a drag preview so browsers don't draw it
        // and we can draw whatever we want on the custom drag layer instead.
        this.props.connectDragPreview((0, _reactDndHtml5Backend.getEmptyImage)());
      }
    }, {
      key: 'render',
      value: function render() {
        var _cx;

        var _props = this.props,
            id = _props.id,
            position = _props.position,
            isMoveable = _props.isMoveable,
            isDragging = _props.isDragging,
            isHiddenForDrag = _props.isHiddenForDrag,
            isHighlighted = _props.isHighlighted,
            isDehighlighted = _props.isDehighlighted,
            isPulsing = _props.isPulsing,
            isDone = _props.isDone,
            isSaved = _props.isSaved,
            connectDragSource = _props.connectDragSource,
            onClick = _props.onClick,
            onMouseEnter = _props.onMouseEnter,
            onMouseLeave = _props.onMouseLeave;
        var annotationClass = (0, _classnames2.default)(_Annotation2.default.annotation, (_cx = {}, babelHelpers.defineProperty(_cx, _Annotation2.default.hiddenForDrag, isHiddenForDrag), babelHelpers.defineProperty(_cx, _Annotation2.default.draggingDone, isDragging && isDone), babelHelpers.defineProperty(_cx, _Annotation2.default.dragging, isDragging), babelHelpers.defineProperty(_cx, _Annotation2.default.moveable, isMoveable), babelHelpers.defineProperty(_cx, _Annotation2.default.highlight, isHighlighted), babelHelpers.defineProperty(_cx, _Annotation2.default.highlightDone, isHighlighted && isDone), babelHelpers.defineProperty(_cx, _Annotation2.default.dehighlight, isDehighlighted), babelHelpers.defineProperty(_cx, _Annotation2.default.done, !isDehighlighted && !isDragging && !isHighlighted && isDone), babelHelpers.defineProperty(_cx, _Annotation2.default.normal, !isDehighlighted && !isDone), babelHelpers.defineProperty(_cx, _Annotation2.default.new, !isSaved), _cx));

        var annotation = _react2.default.createElement('div', {
          className: annotationClass,
          style: position,
          onClick: onClick,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave
        }, _react2.default.createElement(_velocityReact.VelocityTransitionGroup, {
          runOnMount: true,
          enter: {
            animation: {
              scale: [1, 0]
            },
            style: {
              scale: 0
            },
            easing: [0, 0.89, 0.44, 1],
            delay: 25,
            duration: 300
          }
        }, isDone ? _react2.default.createElement('span', {
          className: _Annotation2.default.annotationNumber
        }, _react2.default.createElement('span', {
          className: _Annotation2.default.completedIcon
        }, _react2.default.createElement(_icons.CheckSmallIcon, null))) : undefined), _react2.default.createElement(_velocityReact.VelocityTransitionGroup, {
          runOnMount: true,
          leave: {
            animation: {
              scale: [0, 1]
            },
            easing: [0, 0.89, 0.44, 1],
            delay: 25,
            duration: 300
          }
        }, !isDone ? _react2.default.createElement('span', {
          className: _Annotation2.default.completed
        }, id) : undefined), _react2.default.createElement(_velocityReact.VelocityTransitionGroup, {
          leave: pulseAnimation,
          runOnMount: true
        }, isPulsing ? _react2.default.createElement('div', {
          className: _Annotation2.default.notification
        }) : undefined));

        if (isMoveable) {
          return connectDragSource(annotation);
        }

        return annotation;
      }
    }]);
    return Annotation;
  }(_react2.default.Component);

  Annotation.propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    commentUUID: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired,
    position: _propTypes2.default.shape({
      top: _propTypes2.default.number.isRequired,
      left: _propTypes2.default.number.isRequired
    }).isRequired,
    isMoveable: _propTypes2.default.bool,
    isDragging: _propTypes2.default.bool,
    isHiddenForDrag: _propTypes2.default.bool,
    isHighlighted: _propTypes2.default.bool,
    isDehighlighted: _propTypes2.default.bool,
    isPulsing: _propTypes2.default.bool,
    isDone: _propTypes2.default.bool,
    isSaved: _propTypes2.default.bool,
    connectDragSource: _propTypes2.default.func.isRequired,
    connectDragPreview: _propTypes2.default.func.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    onMouseEnter: _propTypes2.default.func.isRequired,
    onMouseLeave: _propTypes2.default.func.isRequired
  };
  Annotation.defaultProps = {
    connectDragSource: _noop2.default,
    connectDragPreview: _noop2.default,
    onClick: _noop2.default,
    onMouseEnter: _noop2.default,
    onMouseLeave: _noop2.default
  };
  exports.default = (0, _reactDnd.DragSource)('annotation', annotationSource, collect)(Annotation);
  /***/
},
/* 167 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _Guide = __webpack_require__(453);

  var _Guide2 = babelHelpers.interopRequireDefault(_Guide);

  var _handoff = __webpack_require__(5);

  function mapStateToProps(state) {
    return {
      zoomScale: (0, _handoff.getZoomScale)(state)
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(_Guide2.default);
  /***/
},
/* 168 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "guide": "Guide__guide___wgXGr position-absolute pointerEvents-none borderStyle-dotted"
  };
  /***/
},
/* 169 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Layout;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _Layout = __webpack_require__(101);

  var _Layout2 = babelHelpers.interopRequireDefault(_Layout);

  function Layout(_ref) {
    var children = _ref.children;
    return _react2.default.createElement('div', {
      className: _Layout2.default.outer
    }, _react2.default.createElement('div', {
      className: _Layout2.default.inner
    }, children));
  }

  Layout.propTypes = {
    children: _propTypes2.default.node
  };
  /***/
},
/* 170 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ScrollableArea;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _fixMobileSafariScrollBounce = __webpack_require__(476);

  var _fixMobileSafariScrollBounce2 = babelHelpers.interopRequireDefault(_fixMobileSafariScrollBounce);

  var _prettifyScrollbar = __webpack_require__(477);

  var _prettifyScrollbar2 = babelHelpers.interopRequireDefault(_prettifyScrollbar);

  var _ScrollableArea = __webpack_require__(479);

  var _ScrollableArea2 = babelHelpers.interopRequireDefault(_ScrollableArea);

  var BaseScrollableArea = function (_React$Component) {
    babelHelpers.inherits(BaseScrollableArea, _React$Component);

    function BaseScrollableArea() {
      babelHelpers.classCallCheck(this, BaseScrollableArea);
      return babelHelpers.possibleConstructorReturn(this, (BaseScrollableArea.__proto__ || Object.getPrototypeOf(BaseScrollableArea)).apply(this, arguments));
    }

    babelHelpers.createClass(BaseScrollableArea, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            width = _props.width,
            height = _props.height,
            paddingTop = _props.padding.paddingTop,
            isMobile = _props.isMobile,
            withRef = _props.withRef;
        return _react2.default.createElement('div', {
          ref: withRef,
          className: (0, _classnames2.default)(_ScrollableArea2.default.scrollable, babelHelpers.defineProperty({}, _ScrollableArea2.default.isMobile, isMobile)),
          style: {
            width: width,
            height: height,
            paddingTop: paddingTop
          }
        }, children);
      }
    }]);
    return BaseScrollableArea;
  }(_react2.default.Component);

  BaseScrollableArea.propTypes = {
    height: _propTypes2.default.number.isRequired,
    width: _propTypes2.default.number.isRequired,
    padding: _propTypes2.default.shape({
      paddingTop: _propTypes2.default.number.isRequired,
      paddingBottom: _propTypes2.default.number.isRequired
    }),
    children: _propTypes2.default.object,
    isMobile: _propTypes2.default.bool.isRequired,
    withRef: _propTypes2.default.func
  };
  var IOSScrollableArea = (0, _fixMobileSafariScrollBounce2.default)(BaseScrollableArea);
  var DesktopScrollableArea = (0, _prettifyScrollbar2.default)(BaseScrollableArea, {
    getTopOffset: function getTopOffset() {
      return this.props.padding.paddingTop;
    },
    getBottomOffset: function getBottomOffset() {
      return this.props.padding.paddingBottom;
    }
  });

  function ScrollableArea(props) {
    if (props.isIOS) {
      return _react2.default.createElement(IOSScrollableArea, props);
    }

    if (props.isMobile) {
      return _react2.default.createElement(BaseScrollableArea, props);
    }

    return _react2.default.createElement(DesktopScrollableArea, props);
  }

  ScrollableArea.propTypes = {
    isIOS: _propTypes2.default.bool.isRequired,
    isMobile: _propTypes2.default.bool.isRequired
  };
  /***/
},
/* 171 */

/***/
function (module, exports) {
  module.exports = require("lodash/pickBy");
  /***/
},
/* 172 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.connect = connect;

  var _pusherJs = __webpack_require__(572);

  var _pusherJs2 = babelHelpers.interopRequireDefault(_pusherJs);

  var _isString = __webpack_require__(109);

  var _isString2 = babelHelpers.interopRequireDefault(_isString);

  var _pusher = __webpack_require__(104);

  function connect(channelName) {
    if (!(0, _isString2.default)(channelName)) {
      throw new Error('Invalid channel, ' + channelName);
    }

    var pusher = new _pusherJs2.default(_pusher.API_KEY, {
      encrypted: true
    }); // eslint-disable-next-line no-console

    pusher.connection.bind('error', function (err) {
      return console.error('pusher', err);
    });
    var channel = pusher.subscribe(channelName);

    var unsubscribe = function unsubscribe() {
      return pusher.unsubscribe(channelName);
    };

    return {
      channel: channel,
      unsubscribe: unsubscribe
    };
  }
  /***/

},
/* 173 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/easel-client");
  /***/
},
/* 174 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/easel-client/lib/api");
  /***/
},
/* 175 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.addHotspots = exports.updateHotspot = undefined;

  var _find = __webpack_require__(55);

  var _find2 = babelHelpers.interopRequireDefault(_find);

  var _cloneDeep = __webpack_require__(71);

  var _cloneDeep2 = babelHelpers.interopRequireDefault(_cloneDeep);

  var _remove = __webpack_require__(578);

  var _remove2 = babelHelpers.interopRequireDefault(_remove);

  var _forEach = __webpack_require__(54);

  var _forEach2 = babelHelpers.interopRequireDefault(_forEach);

  var _hotspotStatus = __webpack_require__(579);

  var cloneProject = function cloneProject(fn) {
    return function (origProjectConfig) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (!origProjectConfig) {
        throw new Error('origProjectConfig is required');
      }

      var newConfig = (0, _cloneDeep2.default)(origProjectConfig);
      fn.apply(undefined, [newConfig].concat(args));
      return newConfig;
    };
  };

  var updateHotspot = cloneProject(function (origProjectConfig, hotspot) {
    var imageID = hotspot.img_owner_fk;
    var image = (0, _find2.default)(origProjectConfig.images, function (_ref) {
      var id = _ref.id;
      return id === imageID;
    });

    if (image) {
      var predicate = function predicate(_ref2) {
        var id = _ref2.id;
        return id === hotspot.id;
      };

      if (hotspot.status === _hotspotStatus.HOTSPOT_DELETED) {
        (0, _remove2.default)(image.hotspots, predicate);
      } else {
        addOrReplace(image.hotspots, hotspot, predicate);
      }
    }
  });
  var addHotspots = cloneProject(function (origProjectConfig, hotspots) {
    var imageMap = {};
    (0, _forEach2.default)(origProjectConfig.images, function (image) {
      imageMap[image.id] = image;

      if (!image.hotspots) {
        // eslint-disable-next-line no-param-reassign
        image.hotspots = [];
      }
    });
    hotspots.forEach(function (hotspot) {
      var image = imageMap[hotspot.img_owner_fk];
      image.hotspots.push(hotspot);
    });
  });

  function addOrReplace(array, element, predicate) {
    /* eslint-disable no-param-reassign */
    for (var i = 0; i < array.length; i += 1) {
      if (predicate(array[i])) {
        array[i] = element;
        return;
      }
    }

    array.push(element);
  }

  exports.updateHotspot = updateHotspot;
  exports.addHotspots = addHotspots;
  /***/
},
/* 176 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(177);

  module.exports = __webpack_require__(178);
  /***/
},
/* 177 */

/***/
function (module, exports) {
  // Generated with
  // babel-external-helpers > app/babelHelpers.js
  (function (global) {
    var babelHelpers = global.babelHelpers = {};
    babelHelpers.typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    };

    babelHelpers.jsx = function () {
      var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;
      return function createRawReactElement(type, props, key, children) {
        var defaultProps = type && type.defaultProps;
        var childrenLength = arguments.length - 3;

        if (!props && childrenLength !== 0) {
          props = {};
        }

        if (props && defaultProps) {
          for (var propName in defaultProps) {
            if (props[propName] === void 0) {
              props[propName] = defaultProps[propName];
            }
          }
        } else if (!props) {
          props = defaultProps || {};
        }

        if (childrenLength === 1) {
          props.children = children;
        } else if (childrenLength > 1) {
          var childArray = Array(childrenLength);

          for (var i = 0; i < childrenLength; i++) {
            childArray[i] = arguments[i + 3];
          }

          props.children = childArray;
        }

        return {
          $$typeof: REACT_ELEMENT_TYPE,
          type: type,
          key: key === undefined ? null : '' + key,
          ref: null,
          props: props,
          _owner: null
        };
      };
    }();

    babelHelpers.asyncIterator = function (iterable) {
      if (typeof Symbol === 'function') {
        if (Symbol.asyncIterator) {
          var method = iterable[Symbol.asyncIterator];
          if (method != null) return method.call(iterable);
        }

        if (Symbol.iterator) {
          return iterable[Symbol.iterator]();
        }
      }

      throw new TypeError('Object is not async iterable');
    };

    babelHelpers.asyncGenerator = function () {
      function AwaitValue(value) {
        this.value = value;
      }

      function AsyncGenerator(gen) {
        var front, back;

        function send(key, arg) {
          return new Promise(function (resolve, reject) {
            var request = {
              key: key,
              arg: arg,
              resolve: resolve,
              reject: reject,
              next: null
            };

            if (back) {
              back = back.next = request;
            } else {
              front = back = request;
              resume(key, arg);
            }
          });
        }

        function resume(key, arg) {
          try {
            var result = gen[key](arg);
            var value = result.value;

            if (value instanceof AwaitValue) {
              Promise.resolve(value.value).then(function (arg) {
                resume('next', arg);
              }, function (arg) {
                resume('throw', arg);
              });
            } else {
              settle(result.done ? 'return' : 'normal', result.value);
            }
          } catch (err) {
            settle('throw', err);
          }
        }

        function settle(type, value) {
          switch (type) {
            case 'return':
              front.resolve({
                value: value,
                done: true
              });
              break;

            case 'throw':
              front.reject(value);
              break;

            default:
              front.resolve({
                value: value,
                done: false
              });
              break;
          }

          front = front.next;

          if (front) {
            resume(front.key, front.arg);
          } else {
            back = null;
          }
        }

        this._invoke = send;

        if (typeof gen.return !== 'function') {
          this.return = undefined;
        }
      }

      if (typeof Symbol === 'function' && Symbol.asyncIterator) {
        AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
          return this;
        };
      }

      AsyncGenerator.prototype.next = function (arg) {
        return this._invoke('next', arg);
      };

      AsyncGenerator.prototype.throw = function (arg) {
        return this._invoke('throw', arg);
      };

      AsyncGenerator.prototype.return = function (arg) {
        return this._invoke('return', arg);
      };

      return {
        wrap: function wrap(fn) {
          return function () {
            return new AsyncGenerator(fn.apply(this, arguments));
          };
        },
        await: function _await(value) {
          return new AwaitValue(value);
        }
      };
    }();

    babelHelpers.asyncGeneratorDelegate = function (inner, awaitWrap) {
      var iter = {},
          waiting = false;

      function pump(key, value) {
        waiting = true;
        value = new Promise(function (resolve) {
          resolve(inner[key](value));
        });
        return {
          done: false,
          value: awaitWrap(value)
        };
      }

      if (typeof Symbol === 'function' && Symbol.iterator) {
        iter[Symbol.iterator] = function () {
          return this;
        };
      }

      iter.next = function (value) {
        if (waiting) {
          waiting = false;
          return value;
        }

        return pump('next', value);
      };

      if (typeof inner.throw === 'function') {
        iter.throw = function (value) {
          if (waiting) {
            waiting = false;
            throw value;
          }

          return pump('throw', value);
        };
      }

      if (typeof inner.return === 'function') {
        iter.return = function (value) {
          return pump('return', value);
        };
      }

      return iter;
    };

    babelHelpers.asyncToGenerator = function (fn) {
      return function () {
        var gen = fn.apply(this, arguments);
        return new Promise(function (resolve, reject) {
          function step(key, arg) {
            try {
              var info = gen[key](arg);
              var value = info.value;
            } catch (error) {
              reject(error);
              return;
            }

            if (info.done) {
              resolve(value);
            } else {
              return Promise.resolve(value).then(function (value) {
                step('next', value);
              }, function (err) {
                step('throw', err);
              });
            }
          }

          return step('next');
        });
      };
    };

    babelHelpers.classCallCheck = function (instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
      }
    };

    babelHelpers.createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ('value' in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    babelHelpers.defineEnumerableProperties = function (obj, descs) {
      for (var key in descs) {
        var desc = descs[key];
        desc.configurable = desc.enumerable = true;
        if ('value' in desc) desc.writable = true;
        Object.defineProperty(obj, key, desc);
      }

      return obj;
    };

    babelHelpers.defaults = function (obj, defaults) {
      var keys = Object.getOwnPropertyNames(defaults);

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = Object.getOwnPropertyDescriptor(defaults, key);

        if (value && value.configurable && obj[key] === undefined) {
          Object.defineProperty(obj, key, value);
        }
      }

      return obj;
    };

    babelHelpers.defineProperty = function (obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    };

    babelHelpers.extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    babelHelpers.get = function get(object, property, receiver) {
      if (object === null) object = Function.prototype;
      var desc = Object.getOwnPropertyDescriptor(object, property);

      if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);

        if (parent === null) {
          return undefined;
        } else {
          return get(parent, property, receiver);
        }
      } else if ('value' in desc) {
        return desc.value;
      } else {
        var getter = desc.get;

        if (getter === undefined) {
          return undefined;
        }

        return getter.call(receiver);
      }
    };

    babelHelpers.inherits = function (subClass, superClass) {
      if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };

    babelHelpers.instanceof = function (left, right) {
      if (right != null && typeof Symbol !== 'undefined' && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
      } else {
        return left instanceof right;
      }
    };

    babelHelpers.interopRequireDefault = function (obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    };

    babelHelpers.interopRequireWildcard = function (obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};

        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }

        newObj.default = obj;
        return newObj;
      }
    };

    babelHelpers.newArrowCheck = function (innerThis, boundThis) {
      if (innerThis !== boundThis) {
        throw new TypeError('Cannot instantiate an arrow function');
      }
    };

    babelHelpers.objectDestructuringEmpty = function (obj) {
      if (obj == null) throw new TypeError('Cannot destructure undefined');
    };

    babelHelpers.objectWithoutProperties = function (obj, keys) {
      var target = {};

      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }

      return target;
    };

    babelHelpers.possibleConstructorReturn = function (self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === 'object' || typeof call === 'function') ? call : self;
    };

    babelHelpers.selfGlobal = typeof global === 'undefined' ? self : global;

    babelHelpers.set = function set(object, property, value, receiver) {
      var desc = Object.getOwnPropertyDescriptor(object, property);

      if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);

        if (parent !== null) {
          set(parent, property, value, receiver);
        }
      } else if ('value' in desc && desc.writable) {
        desc.value = value;
      } else {
        var setter = desc.set;

        if (setter !== undefined) {
          setter.call(receiver, value);
        }
      }

      return value;
    };

    babelHelpers.slicedToArray = function () {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;

        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);

            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i['return']) _i['return']();
          } finally {
            if (_d) throw _e;
          }
        }

        return _arr;
      }

      return function (arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError('Invalid attempt to destructure non-iterable instance');
        }
      };
    }();

    babelHelpers.slicedToArrayLoose = function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        var _arr = [];

        for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
          _arr.push(_step.value);

          if (i && _arr.length === i) break;
        }

        return _arr;
      } else {
        throw new TypeError('Invalid attempt to destructure non-iterable instance');
      }
    };

    babelHelpers.taggedTemplateLiteral = function (strings, raw) {
      return Object.freeze(Object.defineProperties(strings, {
        raw: {
          value: Object.freeze(raw)
        }
      }));
    };

    babelHelpers.taggedTemplateLiteralLoose = function (strings, raw) {
      strings.raw = raw;
      return strings;
    };

    babelHelpers.temporalRef = function (val, name, undef) {
      if (val === undef) {
        throw new ReferenceError(name + ' is not defined - temporal dead zone');
      } else {
        return val;
      }
    };

    babelHelpers.temporalUndefined = {};

    babelHelpers.toArray = function (arr) {
      return Array.isArray(arr) ? arr : Array.from(arr);
    };

    babelHelpers.toConsumableArray = function (arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }

        return arr2;
      } else {
        return Array.from(arr);
      }
    };
  })(typeof global === 'undefined' ? self : global);
  /***/

},
/* 178 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = prototypeViewer;

  __webpack_require__(179);

  var _createPrototypeViewer = __webpack_require__(184);

  var _createPrototypeViewer2 = babelHelpers.interopRequireDefault(_createPrototypeViewer);

  var _createStore = __webpack_require__(536);

  var _createStore2 = babelHelpers.interopRequireDefault(_createStore);

  function prototypeViewer(listeners, options) {
    var store = (0, _createStore2.default)(undefined, listeners, options.isDownloaded, options.isAppBuild);
    return (0, _createPrototypeViewer2.default)(store, options);
  }
  /***/

},
/* 179 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  __webpack_require__(180);

  __webpack_require__(181);

  __webpack_require__(182);

  __webpack_require__(23);

  __webpack_require__(183);
  /***/

},
/* 180 */

/***/
function (module, exports) {
  module.exports = require("babel-regenerator-runtime");
  /***/
},
/* 181 */

/***/
function (module, exports) {
  module.exports = require("velocity-animate");
  /***/
},
/* 182 */

/***/
function (module, exports) {
  module.exports = require("velocity-animate/velocity.ui");
  /***/
},
/* 183 */

/***/
function (module, exports) {// removed by extract-text-webpack-plugin

  /***/
},
/* 184 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = createPrototypeViewer;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactRedux = __webpack_require__(2);

  var _App = __webpack_require__(185);

  var _App2 = babelHelpers.interopRequireDefault(_App);

  var _bindKeyboardShortcuts = __webpack_require__(533);

  var _bindKeyboardShortcuts2 = babelHelpers.interopRequireDefault(_bindKeyboardShortcuts);

  var _addPublicAPIs = __webpack_require__(535);

  var _addPublicAPIs2 = babelHelpers.interopRequireDefault(_addPublicAPIs);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _userRole = __webpack_require__(78);

  var userRoles = babelHelpers.interopRequireWildcard(_userRole);

  function createPrototypeViewer(store) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        areKeyboardControlsEnabled = _ref.areKeyboardControlsEnabled,
        _ref$isDownloaded = _ref.isDownloaded,
        isDownloaded = _ref$isDownloaded === undefined ? false : _ref$isDownloaded,
        _ref$isFrameless = _ref.isFrameless,
        isFrameless = _ref$isFrameless === undefined ? false : _ref$isFrameless,
        initialScreen = _ref.initialScreen,
        _ref$userRole = _ref.userRole,
        userRole = _ref$userRole === undefined ? userRoles.VIEWER : _ref$userRole,
        companyId = _ref.companyId,
        userIsSuperUser = _ref.userIsSuperUser,
        userIsInHandoffTestGroup = _ref.userIsInHandoffTestGroup,
        userIsAuthenticated = _ref.userIsAuthenticated,
        _ref$canvasEaselHost = _ref.canvasEaselHost,
        canvasEaselHost = _ref$canvasEaselHost === undefined ? "https://easel.marvelapp.com" || 'https://easel-staging.marvelapp.com' : _ref$canvasEaselHost;

    var PrototypeViewer = function PrototypeViewer() {
      return _react2.default.createElement(_reactRedux.Provider, {
        store: store
      }, _react2.default.createElement(_App2.default, null));
    };

    store.dispatch(actionCreators.setIsDownloaded(isDownloaded));

    if (isFrameless) {
      store.dispatch(actionCreators.setFrameless(isFrameless));
    }

    if (initialScreen) {
      store.dispatch(actionCreators.setInitialScreen(initialScreen));
    }

    store.dispatch(actionCreators.setUserRole(userRole));
    store.dispatch(actionCreators.setCanvasEaselURLs(canvasEaselHost));
    store.dispatch(actionCreators.setIsUserAuthenticated(userIsAuthenticated));
    store.dispatch(actionCreators.setUserCompanyId(companyId));
    store.dispatch(actionCreators.setIsSuperUser(userIsSuperUser));
    store.dispatch(actionCreators.setIsUserInHandoffTestGroup(userIsInHandoffTestGroup));
    (0, _bindKeyboardShortcuts2.default)(store, areKeyboardControlsEnabled);
    (0, _addPublicAPIs2.default)(PrototypeViewer, store);
    return PrototypeViewer;
  }
  /***/

},
/* 185 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactDnd = __webpack_require__(52);

  var _reactDndHtml5Backend = __webpack_require__(105);

  var _reactDndHtml5Backend2 = babelHelpers.interopRequireDefault(_reactDndHtml5Backend);

  var _toClass = __webpack_require__(42);

  var _toClass2 = babelHelpers.interopRequireDefault(_toClass);

  var _DocumentHead = __webpack_require__(186);

  var _DocumentHead2 = babelHelpers.interopRequireDefault(_DocumentHead);

  var _BodyStyle = __webpack_require__(197);

  var _BodyStyle2 = babelHelpers.interopRequireDefault(_BodyStyle);

  var _Project = __webpack_require__(204);

  var _Project2 = babelHelpers.interopRequireDefault(_Project);

  var _DeviceOrientation = __webpack_require__(526);

  var _DeviceOrientation2 = babelHelpers.interopRequireDefault(_DeviceOrientation);

  var _EmbedlySizer = __webpack_require__(528);

  var _EmbedlySizer2 = babelHelpers.interopRequireDefault(_EmbedlySizer);

  var _CustomDragLayer = __webpack_require__(530);

  var _CustomDragLayer2 = babelHelpers.interopRequireDefault(_CustomDragLayer);

  var _ImageReloader = __webpack_require__(531);

  var _ImageReloader2 = babelHelpers.interopRequireDefault(_ImageReloader);

  var _deviceDetection = __webpack_require__(86); // Include redux DevTools on development
  // (if redux-devtools-extension is not installed)
  // https://github.com/zalmoxisus/redux-devtools-extension


  var DevTools = void 0;

  if (false // DevTools slow down the player on mobile devices (and cannot be toggled)
  ) {
      DevTools = require('../containers/DevTools').default;
    } // TODO: use something like https://github.com/nrako/react-component-resizable
  // and dispatch an action when <App /> is resized


  function App() {
    return _react2.default.createElement('div', {
      className: 'height-100 position-relative'
    }, _react2.default.createElement(_DocumentHead2.default, null), _react2.default.createElement(_BodyStyle2.default, null), _react2.default.createElement(_DeviceOrientation2.default, null), "production" !== 'test' && _react2.default.createElement(_ImageReloader2.default, null), _react2.default.createElement(_EmbedlySizer2.default, null), _react2.default.createElement(_CustomDragLayer2.default, null), _react2.default.createElement(_Project2.default, null), DevTools && _react2.default.createElement(DevTools, null));
  }

  exports.default = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default)((0, _toClass2.default)(App));
  /***/
},
/* 186 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _compose = __webpack_require__(24);

  var _compose2 = babelHelpers.interopRequireDefault(_compose);

  var _documentHead = __webpack_require__(106);

  var _DocumentHead = __webpack_require__(187);

  var _DocumentHead2 = babelHelpers.interopRequireDefault(_DocumentHead);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var isNotLoading = function isNotLoading(_ref) {
    var isLoading = _ref.isLoading;
    return !isLoading;
  };

  exports.default = (0, _compose2.default)((0, _reactRedux.connect)(_documentHead.getDocumentHeadProps), (0, _onlyIf2.default)(isNotLoading))(_DocumentHead2.default);
  /***/
},
/* 187 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = DocumentHead;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactHelmet = __webpack_require__(188);

  var _reactHelmet2 = babelHelpers.interopRequireDefault(_reactHelmet);

  var _getRandomIconUrl = __webpack_require__(108);

  var _getRandomIconUrl2 = babelHelpers.interopRequireDefault(_getRandomIconUrl);

  function DocumentHead(_ref) {
    var projectID = _ref.projectID,
        projectTitle = _ref.projectTitle,
        statusBar = _ref.statusBar,
        appIcon = _ref.appIcon,
        viewportFitCover = _ref.viewportFitCover;
    var metas = getMetaTags(statusBar, viewportFitCover);
    var links = getIconLinks(projectID, appIcon); // Add favicon

    links.push({
      href: __webpack_require__(193),
      rel: 'shortcut icon',
      type: 'image/png'
    });
    return _react2.default.createElement(_reactHelmet2.default, {
      title: projectTitle,
      meta: metas,
      link: links
    });
  }

  DocumentHead.propTypes = {
    projectID: _propTypes2.default.string.isRequired,
    projectTitle: _propTypes2.default.string.isRequired,
    appIcon: _propTypes2.default.string,
    statusBar: _propTypes2.default.object.isRequired,
    viewportFitCover: _propTypes2.default.bool.isRequired
  };

  function getIconLinks(projectID, appIcon) {
    var href = void 0;

    if (appIcon) {
      href = appIcon;
    } else {
      href = (0, _getRandomIconUrl2.default)(projectID);
    }

    return [{
      href: href,
      rel: 'apple-touch-icon'
    }, {
      href: href,
      rel: 'icon'
    }];
  }

  function getMetaTags(statusBar, viewportFitCover) {
    var viewportContent = ['width=device-width', 'initial-scale=1.0', 'maximum-scale=1.0', 'user-scalable=no'];

    if (viewportFitCover) {
      viewportContent.push('viewport-fit=cover');
    }

    return [{
      name: 'viewport',
      content: viewportContent.join(', ')
    }, {
      name: 'apple-mobile-web-app-status-bar-style',
      content: statusBar.appleStatusBarStyle
    }];
  }
  /***/

},
/* 188 */

/***/
function (module, exports) {
  module.exports = require("react-helmet");
  /***/
},
/* 189 */

/***/
function (module, exports) {
  module.exports = require("string-hash");
  /***/
},
/* 190 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = requireAll;
  /*
  Usage:
  requireAll(require.context(
    './modules', // path
    false, // recursive
    /\.js$/ // regex
  ));
  Docs:
  https://webpack.github.io/docs/context.html
  */

  function requireAll(requireContext) {
    return requireContext.keys().map(requireContext);
  }
  /***/

},
/* 191 */

/***/
function (module, exports, __webpack_require__) {
  var map = {
    "./apple-touch-icon-1.png": 110,
    "./apple-touch-icon-2.png": 111,
    "./apple-touch-icon-3.png": 112,
    "./apple-touch-icon-4.png": 113,
    "./apple-touch-icon-5.png": 114,
    "./apple-touch-icon-6.png": 115
  };

  function webpackContext(req) {
    return __webpack_require__(webpackContextResolve(req));
  }

  ;

  function webpackContextResolve(req) {
    var id = map[req];
    if (!(id + 1)) // check for number or string
      throw new Error("Cannot find module '" + req + "'.");
    return id;
  }

  ;

  webpackContext.keys = function webpackContextKeys() {
    return Object.keys(map);
  };

  webpackContext.resolve = webpackContextResolve;
  module.exports = webpackContext;
  webpackContext.id = 191;
  /***/
},
/* 192 */

/***/
function (module, exports, __webpack_require__) {
  var map = {
    "./apple-touch-icon-1.png": 110,
    "./apple-touch-icon-2.png": 111,
    "./apple-touch-icon-3.png": 112,
    "./apple-touch-icon-4.png": 113,
    "./apple-touch-icon-5.png": 114,
    "./apple-touch-icon-6.png": 115
  };

  function webpackContext(req) {
    return __webpack_require__(webpackContextResolve(req));
  }

  ;

  function webpackContextResolve(req) {
    var id = map[req];
    if (!(id + 1)) // check for number or string
      throw new Error("Cannot find module '" + req + "'.");
    return id;
  }

  ;

  webpackContext.keys = function webpackContextKeys() {
    return Object.keys(map);
  };

  webpackContext.resolve = webpackContextResolve;
  module.exports = webpackContext;
  webpackContext.id = 192;
  /***/
},
/* 193 */

/***/
function (module, exports) {
  module.exports = require("./assets/images/favicon.png");
  /***/
},
/* 194 */

/***/
function (module, exports) {
  module.exports = require("recompose/branch");
  /***/
},
/* 195 */

/***/
function (module, exports) {
  module.exports = require("recompose/renderNothing");
  /***/
},
/* 196 */

/***/
function (module, exports) {
  module.exports = require("lodash/identity");
  /***/
},
/* 197 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _marvelCore = __webpack_require__(25);

  var _BodyStyle = __webpack_require__(198);

  var _BodyStyle2 = babelHelpers.interopRequireDefault(_BodyStyle);

  var _statusBar = __webpack_require__(35);

  var _project = __webpack_require__(11);

  function mapStateToProps(state) {
    var style = {};

    if ((0, _statusBar.bodyNeedsDeviceHeight)(state)) {
      var frame = (0, _project.getFrame)(state);

      var _devices$getDeviceInf = _marvelCore.devices.getDeviceInfo(frame),
          height = _devices$getDeviceInf.height;

      style.height = height + 'px';
    }

    return {
      style: style
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_BodyStyle2.default);
  /***/
},
/* 198 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _assign = __webpack_require__(21);

  var _assign2 = babelHelpers.interopRequireDefault(_assign);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var BodyStyle = function (_Component) {
    babelHelpers.inherits(BodyStyle, _Component);

    function BodyStyle() {
      babelHelpers.classCallCheck(this, BodyStyle);
      return babelHelpers.possibleConstructorReturn(this, (BodyStyle.__proto__ || Object.getPrototypeOf(BodyStyle)).apply(this, arguments));
    }

    babelHelpers.createClass(BodyStyle, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.setStyle();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.setStyle();
      }
    }, {
      key: 'setStyle',
      value: function setStyle() {
        (0, _assign2.default)(document.body.style, this.props.style);
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);
    return BodyStyle;
  }(_react.Component);

  exports.default = BodyStyle;
  BodyStyle.propTypes = {
    style: _propTypes2.default.object
  };
  /***/
},
/* 199 */

/***/
function (module, exports) {
  module.exports = require("lodash/uniqWith");
  /***/
},
/* 200 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var COLOR = exports.COLOR = 'Color';
  var GRADIENT = exports.GRADIENT = 'Gradient';
  var PATTERN = exports.PATTERN = 'Pattern';
  /***/
},
/* 201 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getAnimation;
  exports.getTransitionForTransitionToSameScreen = getTransitionForTransitionToSameScreen;

  var _screenTransitions = __webpack_require__(202);

  var _screenTransitions2 = babelHelpers.interopRequireDefault(_screenTransitions);

  var LEFT_RIGHT_EASING = [0.145, 0.82, 0.34, 1.015];
  var UP_DOWN_EASING = [0.272, 0.224, 0.265, 0.975];
  var FADE_DURATION = 400;
  var POP_DURATION = 300;
  var LEFT_RIGHT_DURATION = 350;
  var UP_DOWN_DURATION = 300;
  var animations = {
    fade: function fade() {
      return {
        enter: {
          animation: {
            opacity: [1, 0]
          },
          duration: FADE_DURATION
        },
        leave: {
          animation: {
            opacity: [0, 1]
          },
          duration: FADE_DURATION,
          display: 'none'
        }
      };
    },
    // pushleft in the editor!
    pushright: function pushright(_ref) {
      var width = _ref.width;
      var translateX = width + 'px';
      return {
        enter: {
          animation: {
            translateX: [0, translateX],
            opacity: [1, 1]
          },
          easing: LEFT_RIGHT_EASING,
          duration: LEFT_RIGHT_DURATION
        },
        leave: {
          animation: {
            translateX: [translateX, 0]
          },
          easing: LEFT_RIGHT_EASING,
          duration: LEFT_RIGHT_DURATION
        }
      };
    },
    // pushright in the editor!
    pushleft: function pushleft(_ref2) {
      var width = _ref2.width;
      var translateX = '-' + width + 'px';
      return {
        enter: {
          animation: {
            translateX: [0, translateX],
            opacity: [1, 1]
          },
          easing: LEFT_RIGHT_EASING,
          duration: LEFT_RIGHT_DURATION
        },
        leave: {
          animation: {
            translateX: translateX
          },
          easing: LEFT_RIGHT_EASING,
          duration: LEFT_RIGHT_DURATION
        }
      };
    },
    slideup: function slideup(_ref3) {
      var height = _ref3.height;
      var translateY = height + 'px';
      return {
        enter: {
          animation: {
            translateY: [0, translateY],
            opacity: [1, 1]
          },
          easing: UP_DOWN_EASING,
          duration: UP_DOWN_DURATION
        },
        leave: {
          animation: {
            translateY: translateY
          },
          easing: UP_DOWN_EASING,
          duration: UP_DOWN_DURATION
        }
      };
    },
    slidedown: function slidedown(_ref4) {
      var height = _ref4.height;
      var translateY = '-' + height;
      return {
        enter: {
          animation: {
            translateY: [0, translateY]
          },
          easing: UP_DOWN_EASING,
          duration: UP_DOWN_DURATION
        },
        leave: {
          animation: {
            translateY: translateY
          },
          easing: UP_DOWN_EASING,
          duration: UP_DOWN_DURATION
        }
      };
    },
    pop: function pop() {
      return {
        enter: {
          animation: {
            scale: [1, 0],
            opacity: [1, 0]
          },
          duration: POP_DURATION
        },
        leave: {
          animation: {
            scale: [0, 1],
            opacity: [0, 1]
          },
          duration: POP_DURATION
        }
      };
    },
    flip: function flip() {
      return copyScreenAnimations(_screenTransitions2.default.flip.currentScreen, _screenTransitions2.default.flip.previousScreen);
    },
    flow: function flow() {
      return copyScreenAnimations(_screenTransitions2.default.flow.currentScreen, _screenTransitions2.default.flowReverse.previousScreen);
    },
    slidefade: function slidefade() {
      return copyScreenAnimations(_screenTransitions2.default.slidefade.currentScreen, _screenTransitions2.default.slidefadeReverse.previousScreen);
    },
    slidefadeReverse: function slidefadeReverse() {
      return copyScreenAnimations(_screenTransitions2.default.slidefadeReverse.currentScreen, _screenTransitions2.default.slidefade.previousScreen);
    },
    flowReverse: function flowReverse() {
      return copyScreenAnimations(_screenTransitions2.default.flowReverse.currentScreen, _screenTransitions2.default.flow.previousScreen);
    }
  };
  animations['slide-left'] = animations.pushleft;
  animations.slide = animations.pushright;

  function getAnimation(transition, renderedScreenDimensions) {
    var transitionsFactory = animations[transition];

    if (!transitionsFactory) {
      return undefined;
    }

    return transitionsFactory(renderedScreenDimensions);
  }

  function copyScreenAnimations(enterAnimation, leaveAnimation) {
    var _enterAnimation = babelHelpers.slicedToArray(enterAnimation, 2),
        animation = _enterAnimation[0],
        options = _enterAnimation[1];

    var enter = babelHelpers.extends({
      animation: animation
    }, options);

    var _leaveAnimation = babelHelpers.slicedToArray(leaveAnimation, 2);

    animation = _leaveAnimation[0];
    options = _leaveAnimation[1];
    var leave = babelHelpers.extends({
      animation: animation
    }, options);
    return {
      enter: enter,
      leave: leave
    };
  }

  function getTransitionForTransitionToSameScreen(transition) {
    switch (transition) {
      case 'fade':
      case 'pop':
      case 'flip':
        return transition;

      case 'flow':
        return 'flowReverse';

      case 'flowReverse':
        return 'flow';

      case 'slidefade':
        return 'slidefadeReverse';

      case 'slidefadeReverse':
        return 'slidefade';

      case 'pushleft':
        return 'pushright';

      case 'pushright':
        return 'pushleft';

      case 'slide-left':
        return 'slide';

      case 'slide':
        return 'slide-left';

      case 'slideup':
        return 'slidedown';

      case 'slidedown':
        return 'slideup';

      default:
        throw new Error('Transition \'' + transition + '\' is not a valid overlay transition');
    }
  }
  /***/

},
/* 202 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.reverseTransitions = undefined;

  var _forEach = __webpack_require__(54);

  var _forEach2 = babelHelpers.interopRequireDefault(_forEach);

  var _defaults = __webpack_require__(203);

  var _defaults2 = babelHelpers.interopRequireDefault(_defaults);

  var _velocityReact = __webpack_require__(23);

  var pushEasing = [0.272, 0.224, 0.265, 0.975]; // Velocity animation configuration for screen transitions.
  //
  // We have 'display: none' on each previous screen animation so it
  // disappears when the animation is complete.
  //
  // Where a property is an array the meaning is:
  //
  //   property: [<final value>, <initial value>]
  //
  // Note the comments where the name of the transition in the Editor UI
  // does not match the transition name stored in the database!
  //

  var flowScale = 0.7;
  var flowOutToLeftFrames = [[{
    scale: flowScale
  }, 0.6, {
    easing: 'ease'
  }], [{
    scale: flowScale
  }, 0.1, {
    easing: 'ease'
  }], [{
    translateX: '-' + 100 / flowScale + '%'
  }, 0.3, {
    easing: 'ease'
  }]];
  var flowInFromRightFrames = [[{
    translateX: [0, '100%'],
    scale: [flowScale, flowScale]
  }, 0.3, {
    easing: 'ease'
  }], [{
    translateX: 0
  }, 0.1, {
    easing: 'ease'
  }], [{
    scale: 1
  }, 0.6, {
    easing: 'ease'
  }]];
  var flowInFromLeftFrames = [[{
    translateX: [0, '-' + 100 / flowScale + '%'],
    scale: [flowScale, flowScale]
  }, 0.3, {
    easing: 'ease'
  }], // TODO better way to specify pause than 'noop' animation?
  [{
    translateX: 0
  }, 0.1, {
    easing: 'ease'
  }], [{
    scale: 1
  }, 0.6, {
    easing: 'ease'
  }]];
  var flowOutToRightFrames = [[{
    scale: flowScale
  }, 0.6, {
    easing: 'ease'
  }], // TODO better way to specify pause than 'noop' animation?
  [{
    scale: flowScale
  }, 0.1, {
    easing: 'ease'
  }], [{
    translateX: 100 / flowScale + '%'
  }, 0.3, {
    easing: 'ease'
  }]];

  var flowOutToLeft = _velocityReact.velocityHelpers.registerEffect({
    calls: flowOutToLeftFrames
  });

  var flowInFromRight = _velocityReact.velocityHelpers.registerEffect({
    calls: flowInFromRightFrames
  });

  var flowOutToRight = _velocityReact.velocityHelpers.registerEffect({
    calls: flowOutToRightFrames
  });

  var flowInFromLeft = _velocityReact.velocityHelpers.registerEffect({
    calls: flowInFromLeftFrames
  }); // Define animations as
  //
  // {previous,current}Screen:
  // [ <CSS properties to animate>, <animation options> ]
  //


  var transitions = {
    fade: {
      currentScreen: [{
        opacity: [1, 0]
      }]
    },
    // This is 'push left' in the Editor UI
    pushright: {
      previousScreen: [{
        translateX: ['-30%', pushEasing, 0],
        opacity: [0.75, pushEasing]
      }, {
        duration: 420
      }],
      currentScreen: [{
        translateX: ['0', pushEasing, '100%']
      }, {
        duration: 420
      }]
    },
    // This is 'push right' in the Editor UI
    pushleft: {
      previousScreen: [{
        translateX: ['30%', pushEasing, 0],
        opacity: [0.75, pushEasing]
      }, {
        duration: 420
      }],
      currentScreen: [{
        translateX: [0, pushEasing, '-100%']
      }, {
        duration: 420
      }]
    },
    // This is 'slide left' in the Editor UI
    slide: {
      previousScreen: [{
        translateX: ['-100%', 'ease-in-out', 0]
      }, {
        duration: 350
      }],
      currentScreen: [{
        translateX: ['0', 'ease-in-out', '100%']
      }, {
        duration: 350
      }]
    },
    // This is 'slide right' in the Editor UI
    'slide-left': {
      previousScreen: [{
        translateX: ['100%', 'ease-in-out', 0]
      }],
      currentScreen: [{
        translateX: [0, 'ease-in-out', '-100%']
      }]
    },
    slideup: {
      previousScreen: null,
      currentScreen: [{
        translateY: [0, pushEasing, '100%']
      }, {
        duration: 450
      }]
    },
    slidedown: {
      previousScreen: [{
        translateY: ['100%', pushEasing, 0]
      }, {
        duration: 450
      }],
      currentScreen: null
    },
    pop: {
      previousScreen: [{
        scale: [0, 1],
        opacity: [0, 1]
      }, {
        duration: 300
      }],
      currentScreen: [{
        scale: [1, 0],
        opacity: [1, 0]
      }, {
        duration: 400,
        delay: 100
      }]
    },
    flip: {
      previousScreen: [{
        rotateY: ['-180deg', 'ease-in-out', 0],
        opacity: [0, 1]
      }, {
        duration: 400
      }],
      currentScreen: [{
        rotateY: [0, 'ease-in-out', '180deg'],
        opacity: [1, 0]
      }, {
        duration: 400
      }]
    },
    flow: {
      previousScreen: [flowOutToLeft, {
        duration: 600
      }],
      currentScreen: [flowInFromRight, {
        duration: 800,
        delay: 600
      }]
    },
    flowReverse: {
      previousScreen: [flowOutToRight, {
        duration: 600
      }],
      currentScreen: [flowInFromLeft, {
        duration: 800,
        delay: 600
      }]
    },
    slidefade: {
      previousScreen: [{
        translateX: ['-100%', 0]
      }, {
        duration: 400
      }],
      currentScreen: [{
        opacity: [1, 0]
      }, {
        duration: 400
      }]
    },
    slidefadeReverse: {
      previousScreen: [{
        opacity: [0, 1]
      }, {
        duration: 400
      }],
      currentScreen: [{
        translateX: [0, '-100%']
      }, {
        duration: 400
      }]
    }
  };
  var defaultPreviousScreenOpts = {
    display: 'none',
    duration: 400
  };
  var defaultCurrentScreenOpts = {
    display: 'block',
    duration: 400
  };

  function assignDefaultScreenOptions(screen, defaultOpts) {
    /* eslint-disable no-param-reassign */
    if (screen) {
      var opts = screen[1] || {};
      (0, _defaults2.default)(opts, defaultOpts);
      screen[1] = opts;
    }
  }

  (0, _forEach2.default)(transitions, function (_ref) {
    var previousScreen = _ref.previousScreen,
        currentScreen = _ref.currentScreen;
    assignDefaultScreenOptions(previousScreen, defaultPreviousScreenOpts);
    assignDefaultScreenOptions(currentScreen, defaultCurrentScreenOpts);
  });
  exports.default = transitions;
  var reverseTransitions = exports.reverseTransitions = {
    fade: 'fade',
    pushright: 'pushleft',
    pushleft: 'pushright',
    slide: 'slide-left',
    'slide-left': 'slide',
    slideup: 'slidedown',
    slidedown: 'slideup',
    pop: 'pop',
    flip: 'flip',
    flow: 'flowReverse',
    slidefade: 'slidefadeReverse'
  };
  /***/
},
/* 203 */

/***/
function (module, exports) {
  module.exports = require("lodash/defaults");
  /***/
},
/* 204 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactRedux = __webpack_require__(2);

  var _Project = __webpack_require__(205);

  var _Project2 = babelHelpers.interopRequireDefault(_Project);

  var _NotFound = __webpack_require__(518);

  var _NotFound2 = babelHelpers.interopRequireDefault(_NotFound);

  var _Password = __webpack_require__(521);

  var _Password2 = babelHelpers.interopRequireDefault(_Password);

  var _RotateDevice = __webpack_require__(524);

  var _RotateDevice2 = babelHelpers.interopRequireDefault(_RotateDevice);

  var _annotation = __webpack_require__(20);

  var _handoff = __webpack_require__(5);

  var _deviceOrientation = __webpack_require__(99);

  var _grid = __webpack_require__(82);

  var grid = babelHelpers.interopRequireWildcard(_grid);

  function Project(props) {
    var isPasswordRequired = props.isPasswordRequired,
        isPasswordValid = props.isPasswordValid,
        notFound = props.notFound,
        isLoading = props.isLoading,
        onMobileDevice = props.onMobileDevice,
        rotate = props.rotate;

    if (isPasswordRequired && !isPasswordValid) {
      return _react2.default.createElement(_Password2.default, null);
    }

    if (notFound) {
      return _react2.default.createElement(_NotFound2.default, null);
    }

    if (isLoading) {
      return null;
    }

    if (rotate) {
      return _react2.default.createElement(_RotateDevice2.default, null);
    }

    return _react2.default.createElement(_Project2.default, babelHelpers.extends({
      onMobileDevice: onMobileDevice
    }, props));
  }

  Project.propTypes = {
    isPasswordRequired: _propTypes2.default.bool,
    isPasswordValid: _propTypes2.default.bool,
    notFound: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    onMobileDevice: _propTypes2.default.bool,
    rotate: _propTypes2.default.bool.isRequired
  };

  var mapStateToProps = function mapStateToProps(state) {
    return babelHelpers.extends({}, state.project.config, {
      isInAnnotationMode: (0, _annotation.isInAnnotationMode)(state),
      isInHandoffMode: (0, _handoff.isInHandoffMode)(state),
      areCommentsVisible: state.comment.areVisible,
      isEmbedded: state.project.isEmbedded,
      isInTheExploreView: state.project.isInTheExploreView,
      isLoading: state.project.isLoading && !state.player.isAboutToPlay,
      notFound: state.project.notFound,
      isPasswordRequired: state.password.isRequired,
      isPasswordValid: state.password.isValid,
      showGridNav: grid.isOpen(state),
      onMobileDevice: state.deviceDetection.isMobile,
      rotate: (0, _deviceOrientation.shouldRotateTheDevice)(state),
      isDownloaded: state.project.isDownloaded,
      isFrameless: state.project.isFrameless
    });
  };

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(Project);
  /***/
},
/* 205 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _MadeWithMarvel = __webpack_require__(206);

  var _MadeWithMarvel2 = babelHelpers.interopRequireDefault(_MadeWithMarvel);

  var _Upsell = __webpack_require__(208);

  var _Upsell2 = babelHelpers.interopRequireDefault(_Upsell);

  var _NavigationGrid = __webpack_require__(240);

  var _NavigationGrid2 = babelHelpers.interopRequireDefault(_NavigationGrid);

  var _AddToHomeScreen = __webpack_require__(295);

  var _AddToHomeScreen2 = babelHelpers.interopRequireDefault(_AddToHomeScreen);

  var _Sidebar = __webpack_require__(300);

  var _Sidebar2 = babelHelpers.interopRequireDefault(_Sidebar);

  var _SidebarHandoff = __webpack_require__(325);

  var _SidebarHandoff2 = babelHelpers.interopRequireDefault(_SidebarHandoff);

  var _Player = __webpack_require__(406);

  var _Player2 = babelHelpers.interopRequireDefault(_Player);

  var _ExitAnnotationMode = __webpack_require__(507);

  var _ExitAnnotationMode2 = babelHelpers.interopRequireDefault(_ExitAnnotationMode);

  var _AnnotationHint = __webpack_require__(510);

  var _AnnotationHint2 = babelHelpers.interopRequireDefault(_AnnotationHint);

  var _Zoom = __webpack_require__(512);

  var _Zoom2 = babelHelpers.interopRequireDefault(_Zoom);

  var _Project = __webpack_require__(517);

  var _Project2 = babelHelpers.interopRequireDefault(_Project);

  var _resizeRootId = __webpack_require__(157);

  var _resizeRootId2 = babelHelpers.interopRequireDefault(_resizeRootId);

  var _handoffSidebar = __webpack_require__(89);

  var Project = function Project(_ref) {
    var _cx;

    var onMobileDevice = _ref.onMobileDevice,
        isEmbedded = _ref.isEmbedded,
        isFrameless = _ref.isFrameless,
        isInTheExploreView = _ref.isInTheExploreView,
        isPro = _ref.isPro,
        showGridNav = _ref.showGridNav,
        isInAnnotationMode = _ref.isInAnnotationMode,
        isInHandoffMode = _ref.isInHandoffMode,
        areCommentsVisible = _ref.areCommentsVisible;
    var showSidebar = !onMobileDevice && !isEmbedded && !areCommentsVisible && !isFrameless;
    var showUpsell = !isPro && !(isEmbedded || onMobileDevice || isInAnnotationMode || isFrameless) && !isInHandoffMode;
    var showMadeWithMarvel = !isPro && !isInTheExploreView && isEmbedded;
    var projectClass = (0, _classnames2.default)(_Project2.default.project, (_cx = {}, babelHelpers.defineProperty(_cx, _Project2.default.annotationMode, isInAnnotationMode), babelHelpers.defineProperty(_cx, _Project2.default.handoffMode, isInHandoffMode), babelHelpers.defineProperty(_cx, 'mobile', onMobileDevice), _cx));
    return _react2.default.createElement('div', {
      className: projectClass,
      style: isInHandoffMode ? {
        paddingRight: _handoffSidebar.WIDTH
      } : undefined
    }, showSidebar && _react2.default.createElement(_Sidebar2.default, null), showGridNav && _react2.default.createElement(_NavigationGrid2.default, null), _react2.default.createElement('div', {
      className: 'height-100',
      id: _resizeRootId2.default
    }, _react2.default.createElement(_Player2.default, null), showMadeWithMarvel && _react2.default.createElement(_MadeWithMarvel2.default, null), showUpsell && _react2.default.createElement(_Upsell2.default, null), !isEmbedded && _react2.default.createElement(_AddToHomeScreen2.default, null), isInAnnotationMode && _react2.default.createElement(_ExitAnnotationMode2.default, null), isInAnnotationMode && _react2.default.createElement(_AnnotationHint2.default, null), isInHandoffMode && _react2.default.createElement(_Zoom2.default, null)), _react2.default.createElement(_SidebarHandoff2.default, null));
  };

  Project.propTypes = {
    onMobileDevice: _propTypes2.default.bool,
    isEmbedded: _propTypes2.default.bool,
    isInTheExploreView: _propTypes2.default.bool,
    isPro: _propTypes2.default.bool,
    showGridNav: _propTypes2.default.bool,
    isInAnnotationMode: _propTypes2.default.bool,
    isInHandoffMode: _propTypes2.default.bool,
    areCommentsVisible: _propTypes2.default.bool,
    isFrameless: _propTypes2.default.bool
  };
  exports.default = Project;
  /***/
},
/* 206 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = MadeWithMarvel;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _MadeWithMarvel = __webpack_require__(207);

  var _MadeWithMarvel2 = babelHelpers.interopRequireDefault(_MadeWithMarvel);

  var _marvelURL = __webpack_require__(38);

  var marvelURL = babelHelpers.interopRequireWildcard(_marvelURL);

  function MadeWithMarvel() {
    return _react2.default.createElement('a', {
      className: (0, _classnames2.default)(_MadeWithMarvel2.default.madeWithMarvel, 'zi-500'),
      href: marvelURL.HOMEPAGE,
      target: '_parent'
    }, 'Made with Marvel');
  }
  /***/

},
/* 207 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "madeWithMarvel": "MadeWithMarvel__madeWithMarvel___39lLt"
  };
  /***/
},
/* 208 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _Upsell = __webpack_require__(209);

  var _Upsell2 = babelHelpers.interopRequireDefault(_Upsell);

  function mapStateToProps(state) {
    return {
      userRole: state.user.role
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_Upsell2.default);
  /***/
},
/* 209 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.UpgradeUpsell = UpgradeUpsell;
  exports.SignUpUpsell = SignUpUpsell;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _popover = __webpack_require__(77);

  var _popover2 = babelHelpers.interopRequireDefault(_popover);

  var _userRole = __webpack_require__(78);

  var userRoles = babelHelpers.interopRequireWildcard(_userRole);

  var _Banner = __webpack_require__(210);

  var _Banner2 = babelHelpers.interopRequireDefault(_Banner);

  var _track = __webpack_require__(80);

  var _track2 = babelHelpers.interopRequireDefault(_track);

  var _marvelURL = __webpack_require__(38);

  var marvelURL = babelHelpers.interopRequireWildcard(_marvelURL);
  /* eslint-disable react/no-unused-prop-types */

  function Upsell(props) {
    var userRole = props.userRole;
    var Component = SignUpUpsell;

    if (userRoles.isOwner(userRole) || userRoles.isCollaborator(userRole) || userRole === userRoles.VIEWER) {
      Component = UpgradeUpsell;
    }

    return _react2.default.createElement(Component, props);
  }

  Upsell.propTypes = {
    isPopoverOpen: _propTypes2.default.bool.isRequired,
    togglePopover: _propTypes2.default.func.isRequired,
    userRole: _propTypes2.default.string.isRequired
  };

  function UpgradeUpsell(props) {
    var upsellText = _react2.default.createElement('div', null, 'Create unlimited projects with no branding &', ' ', _react2.default.createElement('a', {
      onClick: trackUpgradeToPro,
      className: 'link link--light link--underline',
      target: '_blank',
      rel: 'noopener noreferrer',
      href: marvelURL.UPGRADE
    }, 'more'), '.');

    var ownProps = {
      buttonHref: marvelURL.UPGRADE,
      buttonText: 'Upgrade to Pro',
      closeButton: true,
      onButtonClick: trackUpgradeToPro,
      subheading: 'Upgrade to Pro',
      upsellText: upsellText
    };
    return _react2.default.createElement(_Banner2.default, babelHelpers.extends({}, props, ownProps));
  }

  function SignUpUpsell(props) {
    var upsellText = _react2.default.createElement('div', {
      className: 'paddingLeftRight-s'
    }, 'Design, prototype and collaborate for free.');

    var ownProps = {
      buttonHref: marvelURL.SIGN_UP,
      buttonText: 'Sign up now',
      subheading: 'Create your own',
      upsellText: upsellText
    };
    return _react2.default.createElement(_Banner2.default, babelHelpers.extends({}, props, ownProps));
  }

  exports.default = (0, _popover2.default)(false)(Upsell);

  function trackUpgradeToPro() {
    (0, _track2.default)('paywall_viewed', {
      source: 'clicked_play_powered_upgrade'
    });
  }
  /***/

},
/* 210 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Banner;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _popover = __webpack_require__(43);

  var _popover2 = babelHelpers.interopRequireDefault(_popover);

  var _Close = __webpack_require__(123);

  var _Close2 = babelHelpers.interopRequireDefault(_Close);

  var _icons = __webpack_require__(14);

  var _Banner = __webpack_require__(239);

  var _Banner2 = babelHelpers.interopRequireDefault(_Banner);

  function Banner(_ref) {
    var buttonHref = _ref.buttonHref,
        buttonText = _ref.buttonText,
        closeButton = _ref.closeButton,
        isPopoverOpen = _ref.isPopoverOpen,
        onButtonClick = _ref.onButtonClick,
        subheading = _ref.subheading,
        togglePopover = _ref.togglePopover,
        upsellText = _ref.upsellText;
    var closeProps = {
      style: 'negative',
      isHidden: isPopoverOpen
    };
    return _react2.default.createElement('aside', {
      className: _Banner2.default.wrapper
    }, _react2.default.createElement('div', {
      className: _Banner2.default.upsell
    }, _react2.default.createElement('div', {
      className: _Banner2.default.click,
      onClick: togglePopover
    }, _react2.default.createElement('div', {
      className: _Banner2.default.logo
    }, _react2.default.createElement(_icons.UpsellLogo, null)), _react2.default.createElement('div', {
      className: _Banner2.default.copy
    }, subheading)), closeButton && _react2.default.createElement(_Close2.default, babelHelpers.extends({}, closeProps, {
      onClick: togglePopover
    }))), _react2.default.createElement(_popover2.default, {
      size: 'small',
      width: '100%',
      align: 'right',
      isActive: isPopoverOpen
    }, _react2.default.createElement('div', {
      className: _Banner2.default.popoverPadding
    }, _react2.default.createElement('div', {
      className: _Banner2.default.popoverCopy
    }, upsellText), _react2.default.createElement('div', {
      className: _Banner2.default.buttonWrap
    }, _react2.default.createElement('a', {
      href: buttonHref,
      onClick: onButtonClick,
      className: _Banner2.default.button
    }, buttonText))), _react2.default.createElement('div', {
      className: _Banner2.default.arrow,
      onClick: togglePopover
    }, _react2.default.createElement(_icons.DownArrow, null))));
  }

  Banner.propTypes = {
    buttonHref: _propTypes2.default.string.isRequired,
    buttonText: _propTypes2.default.node.isRequired,
    closeButton: _propTypes2.default.bool.isRequired,
    isPopoverOpen: _propTypes2.default.bool.isRequired,
    onButtonClick: _propTypes2.default.func.isRequired,
    subheading: _propTypes2.default.node.isRequired,
    togglePopover: _propTypes2.default.func.isRequired,
    upsellText: _propTypes2.default.node.isRequired
  };
  Banner.defaultProps = {
    closeButton: false,
    onButtonClick: _noop2.default
  };
  /***/
},
/* 211 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = CheckIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function CheckIcon() {
    return _react2.default.createElement("svg", {
      width: "50",
      height: "38",
      viewBox: "0 0 50 38"
    }, _react2.default.createElement("path", {
      d: "M18,23.73l-8-8A5.82,5.82,0,0,0,1.7,23.94l11,11A5.87,5.87,0,0,0,18,38a5.83,5.83,0,0,0,5.22-2.94l25-25A5.87,5.87,0,1,0,40,1.72Z"
    }));
  }
  /***/

},
/* 212 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = CheckSmallIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function CheckSmallIcon() {
    return _react2.default.createElement("svg", {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30"
    }, _react2.default.createElement("path", {
      fill: "#fff",
      d: "M12.1 22c-.4 0-.8-.1-1.1-.4l-5.1-5.2c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l4.1 4.1 9.8-9.8c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-10.9 10.9c-.2.3-.6.4-1 .4z"
    }));
  }
  /***/

},
/* 213 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Click;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function Click() {
    return _react2.default.createElement("svg", {
      className: "display-block centered",
      width: "40",
      height: "52",
      viewBox: "0 0 40 52"
    }, _react2.default.createElement("path", {
      d: "M26.64,16.27a1.53,1.53,0,0,1-1.82-1.14,7.28,7.28,0,0,0-.91-2.39A8.58,8.58,0,0,0,12.5,9.41,8.05,8.05,0,0,0,9.77,20.66a8.67,8.67,0,0,0,1.69,2,1.45,1.45,0,0,1,.07,2.1,1.56,1.56,0,0,1-2.16.07,11.66,11.66,0,0,1-2.25-2.67A11,11,0,0,1,11,6.84a11.69,11.69,0,0,1,15.59,4.41,10.2,10.2,0,0,1,1.25,3.26,1.47,1.47,0,0,1-.73,1.59,1.57,1.57,0,0,1-.45.17ZM12.9,29.92a1.54,1.54,0,0,1-1.95.91,16.3,16.3,0,0,1-8.76-7.07,15.61,15.61,0,0,1,6-21.64,16.63,16.63,0,0,1,22.31,5.8A15.86,15.86,0,0,1,32.4,18.81a1.48,1.48,0,0,1-.74,1,1.57,1.57,0,0,1-1,.17,1.49,1.49,0,0,1-1.23-1.73A12.93,12.93,0,0,0,27.82,9.4,13.51,13.51,0,0,0,9.69,4.69,12.68,12.68,0,0,0,4.84,22.28,13.25,13.25,0,0,0,12,28,1.47,1.47,0,0,1,12.9,29.92Zm14.89,1.3L36.94,46.6,32.6,49,23.45,33.65l-5.08,7.41L15.3,14.13,36.93,30.66ZM17.2,11.79a3.14,3.14,0,0,0-3.38-.26l0,0a3,3,0,0,0-1.51,2.9l3.06,26.93a3,3,0,0,0,2.32,2.56,3.15,3.15,0,0,0,2.26-.31,3,3,0,0,0,1-.93l2.35-3.42L30,50.52a3.12,3.12,0,0,0,4.18,1.09l4.33-2.43a2.92,2.92,0,0,0,1.12-4.06L32.91,33.89l4.22-.26a3.12,3.12,0,0,0,1.34-.39,3,3,0,0,0,1.39-1.69,2.92,2.92,0,0,0-1-3.22L17.2,11.79Z"
    }));
  }
  /***/

},
/* 214 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = CloseBigIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function CloseBigIcon() {
    return _react2.default.createElement("svg", {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12"
    }, _react2.default.createElement("path", {
      d: "M6 4.44l-4.116-4.116c-.428-.428-1.13-.431-1.56 0-.434.434-.431 1.129 0 1.56l4.116 4.116-4.116 4.116c-.431.431-.434 1.127 0 1.56.431.431 1.132.428 1.56 0l4.116-4.116 4.116 4.116c.428.428 1.13.431 1.56 0 .434-.434.431-1.129 0-1.56l-4.116-4.116 4.116-4.116c.431-.431.434-1.127 0-1.56-.431-.431-1.132-.428-1.56 0l-4.116 4.116z"
    }));
  }
  /***/

},
/* 215 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = CloseIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function CloseIcon() {
    return _react2.default.createElement("svg", {
      className: "display-block",
      width: "6",
      height: "6",
      viewBox: "0 0 6 6"
    }, _react2.default.createElement("path", {
      d: "M5.72,1.64A1,1,0,0,0,4.36.28L3,1.64,1.64,0.28A1,1,0,0,0,.28, 1.64L1.64,3,0.28,4.36A1,1,0,0,0,1.64,5.72L3,4.36,4.36, 5.72A1,1,0,0,0,5.72,4.36L4.36,3Z"
    }));
  }
  /***/

},
/* 216 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = CommentIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function CommentIcon() {
    return _react2.default.createElement("svg", {
      width: "17",
      height: "16",
      viewBox: "0 0 17 16"
    }, _react2.default.createElement("path", {
      d: "M17 7.241c0-4.051-3.804-7.241-8.5-7.241s-8.5 3.19-8.5 7.241c0 4.052 3.804 7.241 8.5 7.241.729 0 1.457-.087 2.186-.259h.404c2.429 2.241 4.453 1.724 4.776 1.724.324 0 .567-.431.324-.517-2.186-.689-1.781-2.931-1.7-3.103 1.539-1.292 2.51-3.103 2.51-5.086z"
    }));
  }
  /***/

},
/* 217 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = DownArrow;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function DownArrow() {
    return _react2.default.createElement("svg", {
      className: "display-block",
      width: "11",
      height: "6",
      viewBox: "0 0 11 6"
    }, _react2.default.createElement("path", {
      d: "M5.028 3.55l3.255-3.255c.391-.391 1.021-.395 1.412-.004l.069.069c.389.389.391 1.017-.004 1.412l-3.834 3.834c-.245.245-.583.338-.897.278-.315.06-.653-.033-.897-.278l-3.834-3.834c-.395-.395-.393-1.023-.004-1.412l.069-.069c.391-.391 1.021-.387 1.412.004l3.255 3.255z"
    }));
  }
  /***/

},
/* 218 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = FailedIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function FailedIcon() {
    return _react2.default.createElement("svg", {
      className: "display-block centered",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40"
    }, _react2.default.createElement("path", {
      d: "M39.5,35.49a2.94,2.94,0,0,1,.5,1.65,2.82,2.82,0,0,1-.79,2,2.51,2.51,0,0,1-1.87.83H2.7A2.56,2.56,0,0,1,.41,38.62a2.76,2.76,0,0,1,0-2.81L17.68,1.47a2.58,2.58,0,0,1,4.66,0ZM19.92,27H20a1.46,1.46,0,0,0,1.07-.52,2.07,2.07,0,0,0,.57-1.2Q22.17,22.33,23,14a1.82,1.82,0,0,0-.31-1.13,1.48,1.48,0,0,0-.92-.68,8.48,8.48,0,0,0-3.49,0,1.64,1.64,0,0,0-.92.68A1.7,1.7,0,0,0,17,14q.82,8.34,1.31,11.28a2.07,2.07,0,0,0,.57,1.2A1.42,1.42,0,0,0,19.92,27ZM20,35a3,3,0,1,0-3-3A3,3,0,0,0,20,35Z"
    }));
  }
  /***/

},
/* 219 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = GridIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function GridIcon() {
    return _react2.default.createElement("svg", {
      height: "16",
      viewBox: "0 0 16 16",
      width: "16"
    }, _react2.default.createElement("path", {
      d: "M5 16h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2zM5 7h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2zM14 7h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2zM14 16h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2z"
    }));
  }
  /***/

},
/* 220 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Handoff;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function Handoff() {
    return _react2.default.createElement("svg", {
      width: "22",
      height: "16",
      viewBox: "0 0 22 16"
    }, _react2.default.createElement("path", {
      d: "M16.5 13.5c-.4 0-.7-.1-1-.4-.5-.5-.5-1.4 0-1.9l3.2-3.2-3.2-3.2c-.5-.5-.5-1.4 0-1.9s1.4-.5 1.9 0l4.2 4.1c.5.5.5 1.4 0 1.9l-4.1 4.1c-.3.4-.6.5-1 .5zm-11 0c.4 0 .7-.1 1-.4.5-.5.5-1.4 0-1.9l-3.2-3.2 3.2-3.2c.5-.5.5-1.4 0-1.9s-1.4-.5-1.9 0l-4.2 4.1c-.5.5-.5 1.4 0 1.9l4.1 4.1c.3.4.6.5 1 .5zm4.1 1.4c.6 0 1.2-.4 1.3-1l2.7-11c.2-.7-.3-1.5-1-1.7-.6-.2-1.4.2-1.6 1l-2.7 11c-.2.7.3 1.5 1 1.7h.3z"
    }));
  }
  /***/

},
/* 221 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = MarvelLogo;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function MarvelLogo() {
    return _react2.default.createElement("svg", {
      width: "80",
      height: "34",
      viewBox: "0 0 80 34"
    }, _react2.default.createElement("path", {
      d: "M67.93,22c-29.1-2.21-53.16,4.67-58.54,7.22-3,1.36-3.21,3.06-2.78,4C7,33.94,8.43,34.36,10,33.6c11.55-6.12,34.92-11,57.94-9.6A1,1,0,0,0,67.93,22Zm7.21-8.58c-1.22,1.36-3,2.38-3.56,1.87s0-2.12,0-2.12C74.44,11.34,80,6.67,80,3.1c0-3.31-3-4.33-6.17-1.27a22.83,22.83,0,0,0-5.39,9.68c-1.65,1.61-4.26,3.65-6.6,3.65-1.22,0-1.56-.85-1.39-2C62.45,13.13,68,11.6,68,7a2.76,2.76,0,0,0-3-2.72c-2.52,0-5.73,2.55-7.3,6.12A5.1,5.1,0,0,1,56.46,10a17,17,0,0,0,1-2.72c0.35-1.87-.43-3.06-2-2.89-1,.08-2.17.93-2.43,2.89a5.25,5.25,0,0,0,.52,2.89c-0.69,2.12-3.47,4.76-4.43,4.67S49.25,11,50.21,8.2a5.72,5.72,0,0,0,1.22-1.87A1.19,1.19,0,0,0,51,4.8a2.92,2.92,0,0,0-3.65,1.53,16.81,16.81,0,0,0-1,2.12c-0.78.93-2,2.12-2.35,2-0.52-.34,1.22-2.63,1-3.91a2,2,0,0,0-2.17-1.7C41.26,5.06,39.18,8,39.18,8a4.91,4.91,0,0,0,.43-1.7c-0.09-1.1-2.17-1.61-3.21.42a32.07,32.07,0,0,0-1.56,6c-0.43.93-2.17,3.65-3.56,3.74-1.13.08,0.26-4.84,0.43-5.1,0.61-.93,1.39-2.89,1.22-3.74a1.28,1.28,0,0,0-1.65-1.27,2.67,2.67,0,0,0-1.65,1.27,2.15,2.15,0,0,0-2.08-.76C22.93,7.35,20,15.25,20.33,19c0.26,2,1.22,3.23,3,3,2-.25,3.65-3.14,3.65-3.14s0.43,2.38,2.61,2.12a8.25,8.25,0,0,0,4.08-2.8,1.46,1.46,0,0,0-.09.42c-0.35,2,3,1.78,3.3.25,1-7.56,3.56-10.7,4.34-10.7,0.61,0-1.65,3.57-.35,4.93,1,1.19,2.78.25,4.26-1a12.24,12.24,0,0,0-.43,2.89c-0.09,2.12.69,3.82,2.78,3.74,2.78-.08,5.73-3.48,7.64-6.71a4.79,4.79,0,0,0,1.65.68A7.17,7.17,0,0,0,56.55,15c0.17,2.46,1.91,3.4,3.91,3.31,2.35-.08,5.12-1.87,7-3.48a0.31,0.31,0,0,1-.09.25c-0.17,1.19.09,3.4,1.82,3.48,2,0.17,5.47-1.87,7.21-4C77.65,13.64,76.18,12.28,75.14,13.38ZM77,3.19a0.39,0.39,0,0,1,.35.42c0,2.12-5.39,6.63-5.39,6.63S75.48,3.19,77,3.19ZM64,7.6a0.57,0.57,0,0,1,.61.68c0,1.19-1.65,2.12-3.47,2.12C62.11,9,63.24,7.6,64,7.6ZM28,10.92c-0.17,1.27-2.43,7-3.65,7-1.56.08,0.78-8.07,3.3-8C28.14,9.9,28.14,10.24,28,10.92ZM8.43,12.45c1.48,0-1.22,7.56-.87,10.87s4.08,2.38,3.82.42c-0.43-3.23,1.82-13.51,4.08-13.51,1.65,0-1.82,7.05-1.13,11.47,0.43,2.89,4.43,2,4,.17C17.11,16.1,21.2,10.49,20.67,6.42c-0.26-1.7-1.22-2.63-2.35-2.63-3.74,0-6.78,7.47-6.78,7.47S11.9,7,8.86,6.84C4.43,6.58-.09,17.46,0,27.31c0.09,3.14,4.08,2.63,3.82.08C3.56,23,6.17,12.45,8.43,12.45h0Z"
    }));
  }
  /***/

},
/* 222 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = NextIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function NextIcon() {
    return _react2.default.createElement("svg", {
      width: "50",
      height: "180",
      viewBox: "0 0 50 180"
    }, _react2.default.createElement("path", {
      fill: "#000000",
      d: "M0 90c.052 34.018 19.445 65.046 50 80v-160c-30.555 14.954-49.948 45.982-50 80zm24.63 10.302l10.17-10.302-10.13-10.302c-.839-.856-.839-2.227 0-3.084.833-.819 2.167-.819 3 0l11.7 11.844c.839.856.839 2.227 0 3.084l-11.75 11.844c-.833.819-2.167.819-3 0-.841-.857-.837-2.233.01-3.084z"
    }), _react2.default.createElement("path", {
      fill: "#fff",
      d: "M27.67 76.614l11.7 11.844c.839.856.839 2.227 0 3.084l-11.75 11.844c-.833.819-2.167.819-3 0-.841-.857-.837-2.232.01-3.084l10.17-10.302-10.13-10.302c-.839-.856-.839-2.227 0-3.084.833-.819 2.167-.819 3 0"
    }));
  }
  /***/

},
/* 223 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PrevIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function PrevIcon() {
    return _react2.default.createElement("svg", {
      width: "50",
      height: "180",
      viewBox: "0 0 50 180"
    }, _react2.default.createElement("path", {
      fill: "#000000",
      d: "M0 10v160c30.555-14.954 49.948-45.982 50-80-.052-34.018-19.445-65.046-50-80zm25.38 93.386c-.833.819-2.167.819-3 0l-11.75-11.844c-.839-.856-.839-2.227 0-3.084l11.7-11.844c.833-.819 2.167-.819 3 0 .839.856.839 2.227 0 3.084l-10.13 10.302 10.17 10.302c.847.851.851 2.227.01 3.084z"
    }), _react2.default.createElement("path", {
      fill: "#fff",
      d: "M22.33 76.614c.833-.819 2.167-.819 3 0 .839.856.839 2.227 0 3.084l-10.13 10.302 10.17 10.302c.847.852.851 2.227.01 3.084-.833.819-2.167.819-3 0l-11.75-11.844c-.839-.856-.839-2.227 0-3.084l11.7-11.844"
    }));
  }
  /***/

},
/* 224 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = RotateIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function RotateIcon() {
    return _react2.default.createElement("svg", {
      className: "fill-blue",
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40"
    }, _react2.default.createElement("path", {
      d: "M0 3.5c0-.5.4-1.1.8-1.2.6-.3 1.3-.2 1.6.2l4.1 4.5c3.6-4 8.7-6.3 14.2-6.3 3.1 0 6.2.8 8.9 2.2 2.6 1.4 4.9 3.3 6.7 5.7s3 5.1 3.5 8.2c.3 1.5.3 3.1.2 4.7-.5 5.6-3.2 10.6-7.7 14-2.2 1.7-4.7 2.8-7.4 3.4-6.2 1.2-12.5-.5-17.1-4.7-1.1-.9-1.1-2.8-.1-3.8 1-1.1 2.7-1.2 3.8-.1 2.5 2.3 5.7 3.6 9.2 3.6 2.6 0 5.2-.8 7.3-2.1 2.1-1.3 3.9-3.3 5-5.5s1.6-4.9 1.3-7.6c-.5-4-2.7-7.5-6.1-9.8-1.7-1.1-3.5-1.8-5.5-2.2-4.9-.8-9.5 1-12.7 4.6l4.7 5.1c.5.5.6.9.3 1.5-.2.5-.7.8-1.3.8h-11c-1.5 0-2.8-1.2-2.8-2.8l.1-12.4z"
    }));
  }
  /***/

},
/* 225 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = SearchCloseIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function SearchCloseIcon() {
    return _react2.default.createElement("svg", {
      className: "svgIcon display-block",
      width: "8",
      height: "8",
      viewBox: "0 0 8 8"
    }, _react2.default.createElement("path", {
      d: "M4 2.752l-2.492-2.492c-.341-.341-.904-.346-1.249-.001-.347.347-.344.904.001 1.249l2.492 2.492-2.492 2.492c-.345.345-.348.902-.001 1.249.345.345.908.34 1.249-.001l2.492-2.492 2.492 2.492c.341.341.904.346 1.249.001.347-.347.344-.904-.001-1.249l-2.492-2.492 2.492-2.492c.345-.345.348-.902.001-1.249-.345-.345-.908-.34-1.249.001l-2.492 2.492z"
    }));
  }
  /***/

},
/* 226 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = SearchIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function SearchIcon() {
    return _react2.default.createElement("svg", {
      className: "svgIcon fill-silver",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, _react2.default.createElement("path", {
      d: "M10.676 15.33c2.561 0 4.637-2.091 4.637-4.67s-2.076-4.67-4.637-4.67-4.637 2.091-4.637 4.67v.01c0 2.574 2.072 4.66 4.627 4.66h.01zm0-11.33c3.658.001 6.622 2.988 6.621 6.672 0 .951-.203 1.892-.594 2.758l2.979 4c.424.569.424 1.351 0 1.92-.51.705-1.491.861-2.192.347l-.022-.017-3.972-3c-3.296 1.597-7.254.202-8.84-3.118s-.2-7.305 3.096-8.903c.912-.441 1.912-.667 2.924-.659z"
    }));
  }
  /***/

},
/* 227 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = SeeAppIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function SeeAppIcon() {
    return _react2.default.createElement("svg", {
      width: "130",
      height: "100",
      viewBox: "0 0 130 100"
    }, _react2.default.createElement("path", {
      d: "M26,19.49c1.22,1.57,3,2.18,4.25,3.74a0.81,0.81,0,0,1-.17,1,2.2,2.2,0,0,1-1.9.35,4,4,0,0,0-1-.17c-0.33-.1-0.33-0.7-0.78-0.62-0.78.35-1.32,1.51-.43,1.91,2,0.91,5.28.52,5.88-1.73,0.7-2.59-2.85-3.29-4.15-5.3a0.38,0.38,0,0,1,.27-0.43c1.12-.6,2.41-0.43,3.63-0.87,0.35-.08.87-0.43,0.68-0.86a0.92,0.92,0,0,0-1-.52c-2,.51-4.33.52-5.7,2.26C25.11,18.71,25.6,19,26,19.49h0Zm6.62,2.21c0,1.53.38,3.32,2,4a3.88,3.88,0,0,0,2.25,0,0.84,0.84,0,0,0,.38-1.46c-0.89.46-1.9,0.89-2.46-.08-0.1-.16.19-0.32,0.25-0.33,0.6-.57,2.38-1.22,2.63-2a2.82,2.82,0,0,0-2.34-2.7,2.31,2.31,0,0,0-2.68,2.5h0Zm1.73,0.81c-0.38,0-.59-1.51.11-1.88s1.95,0.08,1.6.87a1.64,1.64,0,0,1-1.71,1h0ZM38,21.7c0,1.53.38,3.32,2,4a3.88,3.88,0,0,0,2.25,0,0.84,0.84,0,0,0,.38-1.46c-0.89.46-1.9,0.89-2.46-.08-0.1-.16.19-0.32,0.25-0.33,0.6-.57,2.38-1.22,2.63-2a2.82,2.82,0,0,0-2.34-2.7A2.31,2.31,0,0,0,38,21.7h0Zm1.73,0.81c-0.38,0-.59-1.51.11-1.88s1.95,0.08,1.6.87a1.64,1.64,0,0,1-1.71,1h0Zm8.87-3.44a3.71,3.71,0,0,1-.3,1.62c-0.38.46-1.24,0.38-1.84,0.68a0.75,0.75,0,0,0-.4.7c0.3,0.86,1.44.48,2,0,0.46,0.84.36,5.46,0.7,6.36a0.59,0.59,0,0,0,.67.51A0.55,0.55,0,0,0,50,28.43c0.06-1-.46-5.38-0.32-6.38,0.84,0,2.27.11,2.5-.67,0.3-1-1.38-.6-2.23-0.52a7.89,7.89,0,0,1,.62-3.24,0.58,0.58,0,0,0-.08-0.54c-0.6-.38-1.6-0.38-1.68.38-0.06.54-.16,1.07-0.24,1.62h0Zm4.21,2.4A32.66,32.66,0,0,0,52.58,25a0.69,0.69,0,0,0,.52.25A1,1,0,0,0,54,24.92a8.84,8.84,0,0,1,1.73-2.58c0.65,1.26-.14,2.78.71,3.83a0.78,0.78,0,0,0,1.12-.32,15.4,15.4,0,0,0-.67-5c-1.17-.52-2.11.6-2.63,1.53a9.38,9.38,0,0,1,0-3.58A0.71,0.71,0,0,0,54,18.17a0.85,0.85,0,0,0-1.11.32c-0.48.87,0,2-.14,3h0ZM57.9,21.7c0,1.53.38,3.32,2,4a3.88,3.88,0,0,0,2.25,0,0.84,0.84,0,0,0,.38-1.46c-0.89.46-1.9,0.89-2.46-.08-0.1-.16.19-0.32,0.25-0.33,0.6-.57,2.38-1.22,2.63-2a2.82,2.82,0,0,0-2.34-2.7,2.31,2.31,0,0,0-2.68,2.5h0Zm1.73,0.81c-0.38,0-.59-1.51.11-1.88s1.95,0.08,1.6.87a1.64,1.64,0,0,1-1.71,1h0Zm10.31,4c0.87,0.59,1-1.53,1-2.5,0.11-1.48.87-2.83,0.24-4.18s-3.07-1-4.21-.27c-0.14.14,0,1.43,0.63,1.21A4,4,0,0,1,70,20.27c0.35,0.06.25,0.78,0.11,1,0,0-2.27-.49-3.55,1.24a2.17,2.17,0,0,0-.14,2.23c0.63,1.07,1.9,1,3,1.21a2.38,2.38,0,0,1,.51.57h0ZM69.66,24.6c-0.13.3-2.36,0-2.34-.75,0-1.37,1.63-1.1,2.55-1.45,0.35,0.84-.06,1.38-0.21,2.2h0Zm2.46-3.88a25.44,25.44,0,0,0-.35,6.12c0.08,0.65.13,1.46,0.71,1.67s1.46,0.16,1.17-.43c-0.11-.21-0.33-0.45-0.35-0.54a6,6,0,0,1-.22-3.5c1.38-.51,3.61-0.35,3.83-2.45,0.16-1.54-1.68-2-3-2.12a6.6,6.6,0,0,0-.22-0.8,0.88,0.88,0,0,0-1.24,0c-0.51.35-.06,1-0.51,1.38a1.39,1.39,0,0,0,.14.65h0Zm1.68,0.08a1.08,1.08,0,0,1,1.08,0,0.56,0.56,0,0,1,.54.68,1.57,1.57,0,0,1-2,1.26c-0.35-.17-0.06-1.53.35-1.94h0Zm3.77-.08a25.44,25.44,0,0,0-.35,6.12c0.08,0.65.13,1.46,0.71,1.67s1.46,0.16,1.17-.43c-0.11-.21-0.33-0.45-0.35-0.54a6,6,0,0,1-.22-3.5c1.38-.51,3.61-0.35,3.83-2.45,0.16-1.54-1.68-2-3-2.12a6.61,6.61,0,0,0-.22-0.8,0.88,0.88,0,0,0-1.24,0c-0.51.35-.06,1-0.51,1.38a1.39,1.39,0,0,0,.14.65h0Zm1.68,0.08a1.08,1.08,0,0,1,1.08,0,0.56,0.56,0,0,1,.54.68,1.57,1.57,0,0,1-2,1.26c-0.35-.17-0.06-1.53.35-1.94h0ZM86,22.16A9.55,9.55,0,0,0,86,24.93a0.92,0.92,0,0,0,1.25.29A0.25,0.25,0,0,0,87.42,25c0.21-.76-0.27-1.46,0-2.23s-0.08-1.32.41-2c0.27-.27-0.06-0.64-0.35-0.76a0.94,0.94,0,0,0-1.24.35A3.87,3.87,0,0,0,86,22.16h0Zm0.4-3.59a1,1,0,0,0,1.22.29,1.12,1.12,0,0,0,.43-1.3,1.09,1.09,0,0,0-1.43-.14,1,1,0,0,0-.22,1.16h0Zm2.09,3.48a3,3,0,0,0,2,3.48c1.22,0.35,2.69.52,3.49-.7,0.16-.25.6-1.26-0.1-1.21s-1.25,1.18-2.09.86a2.46,2.46,0,0,1-1.46-.8A2.51,2.51,0,0,1,90,22.21a2.78,2.78,0,0,1,1.24-1.91c0.76-.56,1.65-0.49,2-1.46A0.45,0.45,0,0,0,93,18.22c-1.2-.54-2.33.6-3.2,1.38a4,4,0,0,0-1.32,2.45h0Zm7.45,2.05A1.53,1.53,0,0,0,97.5,24a3.36,3.36,0,0,0,1.09-3.21,3.8,3.8,0,0,0-.78-1.56c-0.6-.67-1.71-0.92-2.09-0.06a8.51,8.51,0,0,0-1,1.8,2.79,2.79,0,0,0,1.19,3.18h0Zm0.51-1.57c-1.66-.38,0-2.58.4-2.21,0.86,0.94.74,2.47-.4,2.21h0Zm3,0.21a6.13,6.13,0,0,0,.06,2,0.63,0.63,0,0,0,1.11,0c0.63-1.07.74-2.29,1.54-3.17,0.27,1.29.13,2.56,0.33,3.9,0.06,0.41.67,0.25,1.08,0.14a0.7,0.7,0,0,0,.21-0.81c-0.08-1.61,0-3.36-.87-4.77-1.14-.33-1.62.67-2.14,1.54a0.43,0.43,0,0,1-.14-0.19,4.58,4.58,0,0,0,.14-1.21,0.71,0.71,0,0,0-1.25-.08,8.46,8.46,0,0,0-.06,2.62h0ZM17.3,40a1.53,1.53,0,0,0,1.6-.14A3.36,3.36,0,0,0,20,36.66a3.8,3.8,0,0,0-.78-1.56c-0.6-.67-1.71-0.92-2.09-0.06a8.51,8.51,0,0,0-1,1.8A2.79,2.79,0,0,0,17.3,40h0Zm0.51-1.57c-1.66-.38,0-2.58.4-2.21,0.86,0.94.74,2.47-.4,2.21h0Zm3,0.21a6.13,6.13,0,0,0,.06,2,0.63,0.63,0,0,0,1.11,0c0.63-1.07.74-2.29,1.54-3.17,0.27,1.29.13,2.56,0.33,3.9,0.06,0.41.67,0.25,1.08,0.14a0.7,0.7,0,0,0,.21-0.81c-0.08-1.61,0-3.36-.87-4.77-1.14-.33-1.62.67-2.14,1.54A0.43,0.43,0,0,1,22,37.31a4.58,4.58,0,0,0,.14-1.21A0.71,0.71,0,0,0,20.85,36a8.46,8.46,0,0,0-.06,2.62h0Zm8.56-2.85c0.08,0.87.24,1.65,0.32,2.53s0.81,1.5.63,2.35C30,42,30.18,42.3,29.07,43.16a0.76,0.76,0,0,0-1-.62A1.1,1.1,0,0,0,28,44c0.4,0.78,1.79.7,2.36,0A9.06,9.06,0,0,0,32,40.12c0.14-1.88,1.3-3.39,2.11-4.95,0.38-.73-0.62-0.86-1-0.64-0.93.56-1.25,1.73-1.73,2.75-0.08.08-.24,0.32-0.32,0.08-0.16-.94.14-1.88-0.24-2.67a0.84,0.84,0,0,0-1.41,0,1.49,1.49,0,0,0-.08,1.1h0ZM35.89,40a1.53,1.53,0,0,0,1.6-.14,3.36,3.36,0,0,0,1.09-3.21,3.8,3.8,0,0,0-.78-1.56c-0.6-.67-1.71-0.92-2.09-0.06a8.51,8.51,0,0,0-1,1.8A2.79,2.79,0,0,0,35.89,40h0Zm0.51-1.57c-1.66-.38,0-2.58.4-2.21,0.86,0.94.74,2.47-.4,2.21h0Zm2.69-2c-0.16,2.16.54,6.11,3.25,4.95,1.73-.75,2.25-3.1,2.14-5,0-1-.87-2.37-2-1.91-0.4.17-.16,0.81,0.08,1.19a3.53,3.53,0,0,1-.79,4.63c-0.62.41-.79-1.11-1-1.75a20.48,20.48,0,0,1,0-3.12c0-.56-0.79-0.72-1.35-0.48a1.75,1.75,0,0,0-.4,1.51h0Zm6.12,0.76a23,23,0,0,1,.24,3.9,0.7,0.7,0,0,0,.24.72A0.86,0.86,0,0,0,47,41.7a1.33,1.33,0,0,0,.16-1.59,0.88,0.88,0,0,1-.16-1A7,7,0,0,1,47.26,38c0.65-1,1.6-1.35,2.23-2.24,0.33-.46-0.16-0.64-0.55-0.8-1.12-.32-1.36,1-2.31,1.19,0.16-1-.79-2-1.58-1.27s0.06,1.53.16,2.32h0Zm7.91,0.22a32.67,32.67,0,0,0-.19,3.52,0.69,0.69,0,0,0,.52.25,1,1,0,0,0,.86-0.33A8.84,8.84,0,0,1,56,38.25c0.65,1.26-.14,2.78.71,3.83a0.78,0.78,0,0,0,1.12-.32,15.4,15.4,0,0,0-.67-5c-1.17-.52-2.11.6-2.63,1.53a9.38,9.38,0,0,1,0-3.58,0.71,0.71,0,0,0-.21-0.65,0.85,0.85,0,0,0-1.11.32c-0.48.87,0,2-.14,3h0ZM59.57,40a1.53,1.53,0,0,0,1.6-.14,3.36,3.36,0,0,0,1.09-3.21,3.8,3.8,0,0,0-.78-1.56c-0.6-.67-1.71-0.92-2.09-0.06a8.51,8.51,0,0,0-1,1.8A2.79,2.79,0,0,0,59.57,40h0Zm0.51-1.57c-1.66-.38,0-2.58.4-2.21,0.86,0.94.74,2.47-.4,2.21h0Zm2.58-1c0.16,1.26-.21,2.67.24,3.79a0.9,0.9,0,0,0,1.43,0c0.7-1,1-2.21,1.65-3.31,0.4,1.1-.4,2.35.08,3.31,0.4,0.64,1.41.16,1.65-.32a18,18,0,0,1,1.49-3.23c0.08-.16.4-0.4,0.4-0.16a9.62,9.62,0,0,1-.32,4.74,0.53,0.53,0,0,0,.08.54,1,1,0,0,0,1.51-.3,11.26,11.26,0,0,0,.4-5.62,1.47,1.47,0,0,0-.32-1.19c-1.35-.54-2.2.87-3,1.75a12.55,12.55,0,0,1-.32-1.83c-0.08-.06-0.24-0.22-0.32-0.3-1.65-.64-1.81,1.5-2.76,2.37-0.46-.64.49-1.86-0.46-2.13-1.25-.37-1.55.86-1.43,1.89h0Zm9.65,0.22c0,1.53.38,3.32,2,4a3.88,3.88,0,0,0,2.25,0,0.84,0.84,0,0,0,.38-1.46c-0.89.46-1.9,0.89-2.46-.08-0.1-.16.19-0.32,0.25-0.33,0.6-.57,2.38-1.22,2.63-2A2.82,2.82,0,0,0,75,35.11a2.31,2.31,0,0,0-2.68,2.5h0ZM74,38.42c-0.38,0-.59-1.51.11-1.88s1.95,0.08,1.6.87a1.64,1.64,0,0,1-1.71,1h0ZM80.66,35c-1-.46-3.55,1.07-2.93,2.34,0.51,1.07,1.73,1.34,2.79,1.81a1.26,1.26,0,0,1,.73.7c0,0.91-1.3,1.3-2,.92C78.9,40.62,78.86,40,78.48,40a0.78,0.78,0,0,0-.74,1c1,2,3.87,1.21,4.69-.17a1.61,1.61,0,0,0,0-1.86A6.9,6.9,0,0,0,80,37.59c-0.32-.11-1-0.84-0.59-1.15,1.2-.76,2.31,1.15,3.12.64a0.8,0.8,0,0,0,.25-0.81c-0.38-.76-1.32-1-2.09-1.29h0ZM83,38a3,3,0,0,0,2,3.48c1.22,0.35,2.69.52,3.49-.7,0.16-.25.6-1.26-0.1-1.21s-1.25,1.18-2.09.86a2.46,2.46,0,0,1-1.46-.8,2.51,2.51,0,0,1-.33-1.48,2.78,2.78,0,0,1,1.24-1.91c0.76-.56,1.65-0.49,2-1.46a0.45,0.45,0,0,0-.21-0.62c-1.2-.54-2.33.6-3.2,1.38A4,4,0,0,0,83,38h0Zm6.48-.8a23,23,0,0,1,.24,3.9,0.7,0.7,0,0,0,.24.72,0.86,0.86,0,0,0,1.35-.08,1.33,1.33,0,0,0,.16-1.59,0.88,0.88,0,0,1-.16-1A7,7,0,0,1,91.56,38c0.65-1,1.6-1.35,2.23-2.24,0.33-.46-0.16-0.64-0.55-0.8-1.12-.32-1.36,1-2.31,1.19,0.16-1-.79-2-1.58-1.27s0.06,1.53.16,2.32h0Zm4.75,0.45c0,1.53.38,3.32,2,4a3.88,3.88,0,0,0,2.25,0,0.84,0.84,0,0,0,.38-1.46c-0.89.46-1.9,0.89-2.46-.08-0.1-.16.19-0.32,0.25-0.33,0.6-.57,2.38-1.22,2.63-2a2.82,2.82,0,0,0-2.34-2.7,2.31,2.31,0,0,0-2.68,2.5h0ZM96,38.42c-0.38,0-.59-1.51.11-1.88s1.95,0.08,1.6.87a1.64,1.64,0,0,1-1.71,1h0Zm3.64-.81c0,1.53.38,3.32,2,4a3.88,3.88,0,0,0,2.25,0,0.84,0.84,0,0,0,.38-1.46c-0.89.46-1.9,0.89-2.46-.08-0.1-.16.19-0.32,0.25-0.33,0.6-.57,2.38-1.22,2.63-2a2.82,2.82,0,0,0-2.34-2.7,2.31,2.31,0,0,0-2.68,2.5h0Zm1.73,0.81c-0.38,0-.59-1.51.11-1.88s1.95,0.08,1.6.87a1.64,1.64,0,0,1-1.71,1h0Zm4,0.22a6.13,6.13,0,0,0,.06,2,0.63,0.63,0,0,0,1.11,0c0.63-1.07.74-2.29,1.54-3.17,0.27,1.29.13,2.56,0.33,3.9,0.06,0.41.67,0.25,1.08,0.14a0.7,0.7,0,0,0,.21-0.81c-0.08-1.61,0-3.36-.87-4.77-1.14-.33-1.62.67-2.14,1.54a0.43,0.43,0,0,1-.14-0.19,4.58,4.58,0,0,0,.14-1.21,0.71,0.71,0,0,0-1.25-.08,8.46,8.46,0,0,0-.06,2.62h0ZM112,40.19a0.86,0.86,0,0,0-1.36.64c0.16,0.73.57,1.64,1.44,1.13,0.65-.38.16-1,0.24-1.69a0.62,0.62,0,0,1-.32-0.08h0ZM84.74,78.1a2.41,2.41,0,0,0-1.26.36A36,36,0,0,1,68.19,70.8c-3.25-2.9-7-5.67-7.45-12.41,0.91-2.75,1.06-4.43.4-5.06A1.16,1.16,0,0,0,60.42,53a0.66,0.66,0,0,0-.37.07c-0.84.33-1.06,1.61-1.13,2.6-0.44,7,2.34,11.42,8.07,16.48a37.57,37.57,0,0,0,17.5,8.37L83.56,81c-0.8.22-3,.77-3.18,1.83a1,1,0,0,0,.37,1,1.83,1.83,0,0,0,1.93-.26c0.51-.29,1.06-0.55,1.53-0.81a0.13,0.13,0,0,0,.11,0,15,15,0,0,1,6.21-1.76h0.07a0.9,0.9,0,0,0,.95-0.81,1,1,0,0,0-.8-1,8.34,8.34,0,0,1-1.1-.29,15.36,15.36,0,0,1-5-3.12c-1.86-3-2.56-3.26-3-3.26H81.63a0.92,0.92,0,0,0-.84.55c-0.15.29-.26,0.81,0.51,1.83A18.5,18.5,0,0,0,84.74,78.1Zm1.79,1.21a1.24,1.24,0,0,1,0,.47l0.54-.15Zm25.23-39.85c0.4,0.16.82,0.27,0.82-.13,0.33-2.34,1.22-4.63,1.41-6.89,0.06-.56-1.11-0.8-1.36-0.08a27.75,27.75,0,0,0-1.16,5.54C111.41,38.47,111.07,39.18,111.76,39.46Z"
    }));
  }
  /***/

},
/* 228 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PrevIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function PrevIcon() {
    return _react2.default.createElement("svg", {
      className: "verticalAlign-middle fill-silver marginLeftRight-xs",
      height: "16",
      viewBox: "0 0 4 16",
      width: "4"
    }, _react2.default.createElement("circle", {
      cx: "2",
      cy: "2",
      r: "2"
    }), _react2.default.createElement("circle", {
      cx: "2",
      cy: "8",
      r: "2"
    }), _react2.default.createElement("circle", {
      cx: "2",
      cy: "14",
      r: "2"
    }));
  }
  /***/

},
/* 229 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ShareIOS;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function ShareIOS() {
    return _react2.default.createElement('svg', {
      className: 'verticalAlign-middle marginLeftRight-xxs',
      style: {
        fill: '#007aff',
        marginTop: '-8px'
      },
      width: '19',
      height: '27',
      viewBox: '0 0 19 27'
    }, _react2.default.createElement('path', {
      d: 'M12 8v1h6v17h-17v-17h6v-1h-7v19h19v-19zM5.6 5.1c.1.1.2.1.3 0l3.1-3.2v15.1h1v-15.1l3.1 3.2c.1.1.2.1.3 0l.4-.4c.1-.1.1-.2 0-.3l-4-4.2-.1-.1c-.1-.1-.1-.1-.2-.1 0 0-.1 0-.1.1l-.1.1-4.1 4.1c-.1.1-.1.2 0 .3l.4.5z'
    }));
  }
  /***/

},
/* 230 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Tap;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function Tap() {
    return _react2.default.createElement("svg", {
      className: "display-block centered",
      width: "40",
      height: "60",
      viewBox: "0 0 40 60"
    }, _react2.default.createElement("path", {
      d: "M24.35,20.24a1.58,1.58,0,0,0,2-1,10.21,10.21,0,0,0,.46-3,10.45,10.45,0,0,0-20.89,0A10.27,10.27,0,0,0,7.12,21a1.59,1.59,0,0,0,2.14.64,1.56,1.56,0,0,0,.65-2.12A7.16,7.16,0,0,1,9,16.17a7.29,7.29,0,0,1,14.57,0,7.13,7.13,0,0,1-.32,2.12,1.56,1.56,0,0,0,1,2M3.16,16.17a13.17,13.17,0,0,1,26.34,0,12.89,12.89,0,0,1-.38,3.13,1.56,1.56,0,0,0,1.16,1.89A1.58,1.58,0,0,0,32.19,20a16,16,0,0,0,.47-3.88A16.33,16.33,0,0,0,0,16.17a16,16,0,0,0,2.55,8.68,1.59,1.59,0,0,0,2.18.48,1.56,1.56,0,0,0,.48-2.16,12.89,12.89,0,0,1-2.05-7M39.9,34.78a4.92,4.92,0,0,0-4.72-5,4.36,4.36,0,0,0-1.58.31,4.67,4.67,0,0,0-4.7-4.45,4.75,4.75,0,0,0-2.18.54,4.68,4.68,0,0,0-5.66-2.09V16.94a4.72,4.72,0,0,0-9.44,0v19A5.5,5.5,0,0,0,6.2,40,19,19,0,0,0,7,50.62c1,2.93,3.25,5.87,7,9a1.59,1.59,0,0,0,2.23-.17A1.55,1.55,0,0,0,16,57.25c-3.21-2.71-5.23-5.27-6-7.61a15.8,15.8,0,0,1-.7-8.92,2.38,2.38,0,0,1,2.34-1.66v2.81a1.58,1.58,0,0,0,3.16,0V16.94a1.56,1.56,0,0,1,3.12,0v17.7a1.58,1.58,0,0,0,3.16,0V28.39a1.56,1.56,0,0,1,3.12,0V35.5a1.58,1.58,0,0,0,3.16,0V30.22a1.56,1.56,0,0,1,3.12,0v6.69a1.58,1.58,0,0,0,3.16,0V34.84a1.82,1.82,0,0,1,1.56-2,1.82,1.82,0,0,1,1.56,2s0,.08,0,.11.93,13.44-3.41,22.83a1.56,1.56,0,0,0,.78,2.07,1.59,1.59,0,0,0,2.1-.77c4.58-9.92,3.77-23.2,3.69-24.31"
    }));
  }
  /***/

},
/* 231 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = BrokenImageIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function BrokenImageIcon() {
    return _react2.default.createElement("svg", {
      className: "fill-silver",
      width: "44",
      height: "50",
      viewBox: "0 0 44 50"
    }, _react2.default.createElement("g", {
      transform: "translate(-570 -80)"
    }, _react2.default.createElement("ellipse", {
      cx: "581",
      cy: "98.652",
      rx: "3.667",
      ry: "3.627"
    }), _react2.default.createElement("path", {
      d: "M602.831 87.77l-1.087 3.627h8.589v27.206h-16.736l-1.087 3.627h21.49v-34.46zM594.139 116.789h14.361v-5.182c-3.661-5.035-5.416-12.074-8.952-12.874l-5.409 18.056zM597.575 80l-2.328 7.77h-25.247v34.46h14.929l-2.02 6.74 3.516 1.03 14.667-48.97-3.517-1.03zm-8.673 28.957c-1.225-1.562-2.457-2.532-3.777-2.532-3.584 0-4.902 7.54-9.625 9.067v1.297h11.057l-.543 1.814h-12.347v-27.206h20.497l-5.262 17.56z"
    })));
  }
  /***/

},
/* 232 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = UpsellLogo;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function UpsellLogo() {
    return _react2.default.createElement("svg", {
      width: "35",
      height: "15",
      className: "display-block",
      viewBox: "0 0 60 26"
    }, _react2.default.createElement("path", {
      d: "M50.925 16.73c-21.825-1.728-39.899 3.607-43.949 5.561-2.25 1.052-2.4 2.33-2.1 3.081.225.601 1.35.902 2.55.301 8.7-4.659 26.249-8.341 43.499-7.289.825-.075 1.2-1.503 0-1.653zm5.4-6.538c-.975 1.052-2.25 1.804-2.7 1.428-.45-.376 0-1.578 0-1.578 2.175-1.353 6.375-4.96 6.375-7.665 0-2.555-2.25-3.306-4.65-.977-1.65 1.578-3.225 4.509-4.05 7.44-1.2 1.202-3.15 2.78-4.95 2.78-.975 0-1.2-.676-1.05-1.503 1.5-.075 5.625-1.202 5.625-4.734-.075-1.503-1.2-2.029-2.325-2.029-1.875 0-4.275 1.954-5.475 4.659-.3-.075-.675-.15-.975-.376.375-.827.675-1.578.675-2.029.225-1.428-.375-2.33-1.5-2.254-.75.075-1.65.676-1.8 2.254-.15 1.052.375 2.254.375 2.254-.375 1.578-2.4 3.607-3.15 3.532-.675 0 .15-2.931.825-5.035.375-.451.75-.977.975-1.428.15-.676-.075-.977-.375-1.202-.45-.376-1.95-.225-2.775 1.202-.225.376-.45.977-.75 1.653-.6.676-1.5 1.653-1.8 1.503-.375-.225.9-2.029.675-3.006-.15-.902-.9-1.353-1.65-1.278-1.125.15-2.625 2.48-2.625 2.48s.3-.676.3-1.278c-.075-.827-1.65-1.202-2.4.376-.3.601-.75 2.63-1.2 4.584-.375.676-1.65 2.78-2.625 2.856-.825.075.15-3.682.3-3.908.45-.676 1.05-2.179.975-2.856-.075-.902-.675-1.052-1.2-.977-.825.15-1.2.977-1.2.977s-.45-.676-1.575-.601c-3.45.376-5.7 6.388-5.4 9.243.15 1.503.975 2.48 2.25 2.33 1.5-.15 2.775-2.405 2.775-2.405s.375 1.804 1.95 1.578c1.05-.15 2.175-1.127 3.075-2.104-.075.15-.075.376-.075.376-.225 1.503 2.325 1.353 2.475.15.75-5.786 2.625-8.191 3.225-8.191.45 0-1.2 2.705-.225 3.757.75.902 2.025.15 3.15-.751-.15.751-.3 1.503-.3 2.254-.075 1.653.525 2.931 2.1 2.856 2.1-.075 4.275-2.63 5.775-5.11.375.225.75.376 1.2.526-.15.601-.15 1.202-.15 1.804.15 1.879 1.425 2.63 2.925 2.555 1.8-.075 3.825-1.428 5.325-2.63 0 .075 0 .15-.075.15-.15.902.075 2.63 1.35 2.63 1.5.15 4.125-1.428 5.4-3.081.825-1.052-.225-2.104-1.05-1.202zm1.425-7.815c.15 0 .225.15.225.376 0 1.578-4.05 5.035-4.05 5.035s2.7-5.411 3.825-5.411zm-9.75 3.382c.375 0 .45.15.45.526 0 .902-1.2 1.578-2.625 1.653.75-1.127 1.575-2.179 2.175-2.179zm-27.074 2.555c-.15.977-1.8 5.335-2.775 5.335-1.2.075.6-6.162 2.475-6.162.45.075.45.301.3.827zm-14.7 1.202c1.125 0-.9 5.786-.675 8.341.225 2.555 3.075 1.804 2.85.376-.3-2.48 1.35-10.295 3.075-10.295 1.2 0-1.35 5.335-.825 8.792.375 2.254 3.375 1.503 3 .15-.975-4.434 2.175-8.717 1.8-11.798-.15-1.278-.975-2.029-1.8-2.029-2.85 0-5.025 5.711-5.025 5.711s.225-3.231-2.025-3.382c-3.3-.225-6.675 8.041-6.6 15.555.075 2.405 3.075 2.029 2.85.075-.225-3.532 1.725-11.498 3.375-11.498z"
    }));
  }
  /***/

},
/* 233 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = TextIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function TextIcon() {
    return _react2.default.createElement("svg", {
      width: "14",
      height: "14",
      className: "fill-smoke--xd",
      viewBox: "0 0 30 30"
    }, _react2.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.76 25.271l10.748-25.271h1.123l10.052 24.881c.751 1.863 2.319 3.327 4.276 3.783l.041.009v1.327h-12.27v-1.327c.42-.06.858-.118 1.322-.177.463-.06.88-.128 1.254-.222 1.61-.406 1.007-2.124 1.007-2.124l-2.016-5.443c-.328-.767-1.237-1.149-2.729-1.149h-6.672c-1.135 0-1.823.381-2.06 1.145-.675 2.188-1.287 3.354-1.689 5.624-.235 1.33 1.299 2.125 3.927 2.125v1.548h-10.074v-1.549s2.299-.137 3.76-3.18zm10.075-19.034l-3.939 9.293c-.328.71-.492 1.21-.492 1.505 0 .442.551.664 1.656.664h5.642c.896 0 1.344-.177 1.344-.531 0-.147-.167-.634-.493-1.461l-3.718-9.47z"
    }));
  }
  /***/

},
/* 234 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = GroupIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function GroupIcon() {
    return _react2.default.createElement("svg", {
      width: "14",
      height: "14",
      className: "fill-smoke--xd",
      viewBox: "-3 4 30 30"
    }, _react2.default.createElement("path", {
      d: "M27 10.2v20.7c0 1-.7 2.1-1.8 2.2-4.6.6-9 .9-13.3.9-4.3 0-8.6-.3-13.2-.9-1-.1-1.7-1.2-1.7-2.2v-24.8c0-1.2.9-2.1 2-2.1h7c.7 0 1.4.5 1.8 1.1l1.5 3h15.7c1.1 0 2 1 2 2.1z"
    }));
  }
  /***/

},
/* 235 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ShapeIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function ShapeIcon() {
    return _react2.default.createElement("svg", {
      width: "14",
      height: "14",
      className: "fill-smoke--xd",
      viewBox: "0 0 14 14"
    }, _react2.default.createElement("path", {
      d: "M14 4v-4h-4v1h-6v-1h-4v4h1v6h-1v4h4v-1h6v1h4v-4h-1v-6h1zm-4 6v1h-6v-1h-1v-6h1v-1h6v1h1v6h-1z"
    }));
  }
  /***/

},
/* 236 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = GearIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function GearIcon() {
    return _react2.default.createElement("svg", {
      width: "12",
      height: "12",
      className: "fill-smoke--xd display-inlineBlock marginRight-xxs",
      viewBox: "0 0 12 12"
    }, _react2.default.createElement("path", {
      d: "M12.972962,5.8770583 C13.013587,6.2833097 13.013587,6.7031029 12.972962,7.122896 C12.932337,7.4208137 12.702128,7.6645646 12.40421,7.7051897 C12.038584,7.7458149 11.29379,7.8406069 11.29379,7.8406069 C10.968789,7.9083154 10.725038,8.2062331 10.725038,8.544776 C10.725038,8.6937349 10.765663,8.829152 10.846913,8.9374857 C10.846913,8.9510274 11.29379,9.5333211 11.523999,9.8312389 C11.713583,10.061448 11.700041,10.3999909 11.510457,10.6302 C11.253165,10.9552011 10.955247,11.2531189 10.630246,11.5104114 C10.50837,11.6187451 10.372953,11.6593703 10.223994,11.6593703 C10.088577,11.6593703 9.939618,11.6187451 9.831285,11.5239531 L8.951073,10.8468674 C8.842739,10.7656171 8.693781,10.724992 8.544822,10.724992 C8.192737,10.724992 7.908361,10.9822846 7.840653,11.3208274 L7.705235,12.4041646 C7.66461,12.7020823 7.420859,12.9322914 7.122942,12.9729166 C6.919816,12.9864583 6.703149,13 6.500023,13 C6.296897,13 6.08023,12.9864583 5.877104,12.9729166 C5.579186,12.9322914 5.335435,12.7020823 5.29481,12.4041646 C5.29481,12.4041646 5.159393,11.3343691 5.159393,11.3208274 C5.105226,10.9822846 4.807309,10.724992 4.455224,10.724992 C4.292723,10.724992 4.143765,10.7791589 4.021889,10.8604091 L3.168761,11.5239531 C3.060427,11.6187451 2.911469,11.6593703 2.776051,11.6593703 C2.627093,11.6593703 2.491675,11.6052034 2.3698,11.5104114 C2.044799,11.2531189 1.7468811,10.9552011 1.4895886,10.6302 C1.3000046,10.3999909 1.2864629,10.061448 1.4760469,9.8312389 L2.126049,8.9781109 C2.220841,8.8562354 2.275008,8.7072766 2.275008,8.544776 C2.275008,8.1791497 2.004174,7.881232 1.6520891,7.8406069 L0.5958354,7.7051897 C0.2979177,7.6645646 0.0677086,7.4208137 0.0270834,7.122896 C-0.0135417,6.7166446 -0.0135417,6.2968514 0.0270834,5.8770583 C0.0541669,5.5791406 0.2979177,5.3353897 0.5958354,5.2947646 L1.6520891,5.1593474 C2.004174,5.1051806 2.275008,4.8072629 2.275008,4.4416366 C2.275008,4.2926777 2.220841,4.1437189 2.126049,4.0218434 L1.4760469,3.1687154 C1.2864629,2.93850628 1.2864629,2.59996343 1.4895886,2.36975428 C1.7468811,2.04475314 2.044799,1.74683543 2.3698,1.48954285 C2.600009,1.29995885 2.938552,1.28641714 3.168761,1.47600114 L4.021889,2.13954514 C4.143765,2.22079543 4.292723,2.27496228 4.455224,2.27496228 C4.807309,2.27496228 5.105226,2.01766971 5.159393,1.67912685 L5.29481,0.59578971 C5.335435,0.297872 5.579186,0.06766285 5.877104,0.02703771 C6.283355,-0.01358743 6.703149,-0.01358743 7.122942,0.02703771 C7.420859,0.06766285 7.66461,0.297872 7.705235,0.59578971 L7.840653,1.67912685 C7.908361,2.01766971 8.192737,2.27496228 8.544822,2.27496228 C8.693781,2.27496228 8.829198,2.22079543 8.951073,2.15308686 C8.951073,2.15308686 9.533367,1.70621028 9.831285,1.47600114 C10.061494,1.28641714 10.400037,1.29995885 10.630246,1.48954285 C10.955247,1.74683543 11.253165,2.04475314 11.510457,2.36975428 C11.700041,2.59996343 11.713583,2.93850628 11.523999,3.1687154 C11.523999,3.1687154 10.846913,4.0489269 10.846913,4.0624686 C10.765663,4.1708023 10.725038,4.3062194 10.725038,4.4416366 C10.725038,4.7937211 10.968789,5.0780971 11.29379,5.1593474 C11.29379,5.1593474 12.038584,5.2541394 12.40421,5.2947646 C12.702128,5.3353897 12.932337,5.5791406 12.972962,5.8770583 L12.972962,5.8770583 Z M6.500023,8.7072766 C7.718777,8.7072766 8.707322,7.7187314 8.707322,6.4999771 C8.707322,5.2812229 7.718777,4.2926777 6.500023,4.2926777 C5.281269,4.2926777 4.292723,5.2812229 4.292723,6.4999771 C4.292723,7.7187314 5.281269,8.7072766 6.500023,8.7072766 L6.500023,8.7072766 Z"
    }));
  }
  /***/

},
/* 237 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ImageIcon;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function ImageIcon() {
    return _react2.default.createElement("svg", {
      width: "14",
      height: "14",
      className: "fill-smoke--xd",
      viewBox: "0 0 14 14"
    }, _react2.default.createElement("path", {
      d: "M0 0v14h14v-14h-14zm12 2v4.806l-2.5 1.527-4-4-3.5 3.5v-5.833h10z "
    }));
  }
  /***/

},
/* 238 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "close": "Close__close___V_vBz borderRadius-circle cursor-pointer link position-absolute transitionDuration-l transitionTimingFunction-cv-easeInOutBack",
    "hidden": "Close__hidden___vOFxN",
    "icon": "Close__icon___35RL- position-absolute pinCenter",
    "close--negative": "Close__close--negative___29bGW bg-negative bg-red--d--hover boxShadow-close fill-white",
    "close--light": "Close__close--light___1RMFx bg-marvel--hover bg-smoke fill-silver fill-white--hover"
  };
  /***/
},
/* 239 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "wrapper": "Banner__wrapper___2cLk8 marginBottom-xs marginRight-xs pinBR position-fixed zi-100",
    "upsell": "Banner__upsell___20Muo bg-blue--d--hover bg-blue borderRadius-s paddingLeftRight-xs paddingTopBottom-xxs position-relative transitionDuration-l transitionTimingFunction-cv-easeInOutBack",
    "click": "Banner__click___1vmth cursor-pointer userSelect-none",
    "logo": "Banner__logo___1EnDG display-inlineBlock fill-white marginRight-xxs verticalAlign-middle",
    "copy": "Banner__copy___1O-6n c-white cursor-pointer display-inlineBlock fontSize-s lineHeight-m verticalAlign-middle",
    "popoverPadding": "Banner__popoverPadding___TScx- paddingBottom-s paddingLeftRight-s paddingTop-xs",
    "popoverCopy": "Banner__popoverCopy___8r3R- c-silver fontSize-s fontWeight-3 lineHeight-m textAlign-center",
    "buttonWrap": "Banner__buttonWrap___3iH5h marginTop-xs textAlign-center",
    "button": "Banner__button___2vB2- bg-green button--flat button--s button",
    "arrow": "Banner__arrow___24jZw cursor-pointer fill-silver--hover fill-smoke--d paddingLeftRight-xs paddingTopBottom-s pinTR position-absolute transitionDuration-l"
  };
  /***/
},
/* 240 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _NavigationGrid = __webpack_require__(241);

  var _NavigationGrid2 = babelHelpers.interopRequireDefault(_NavigationGrid);

  var _actionCreators = __webpack_require__(4);

  var _project = __webpack_require__(11);

  function mapStateToProps(state) {
    return {
      projectName: state.project.config.name,
      projectFrame: (0, _project.getFrame)(state),
      screens: state.screen.screenSequence,
      currentScreenID: state.screen.currentScreen && state.screen.currentScreen.id
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      onSelect: function onSelect(screenID) {
        dispatch((0, _actionCreators.showScreen)(screenID));
      },
      onClose: function onClose() {
        dispatch((0, _actionCreators.hideGrid)());
      }
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_NavigationGrid2.default);
  /***/
},
/* 241 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _NavigationGridItem = __webpack_require__(242);

  var _NavigationGridItem2 = babelHelpers.interopRequireDefault(_NavigationGridItem);

  var _NavigationSearchInput = __webpack_require__(247);

  var _NavigationSearchInput2 = babelHelpers.interopRequireDefault(_NavigationSearchInput);

  var _NavigationGrid = __webpack_require__(249);

  var _NavigationGrid2 = babelHelpers.interopRequireDefault(_NavigationGrid);

  var NavigationGrid = function (_Component) {
    babelHelpers.inherits(NavigationGrid, _Component);

    function NavigationGrid() {
      var _ref;

      var _temp, _this, _ret;

      babelHelpers.classCallCheck(this, NavigationGrid);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = NavigationGrid.__proto__ || Object.getPrototypeOf(NavigationGrid)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        searchQuery: ''
      }, _this.handleSearch = function (event) {
        _this.setState({
          searchQuery: event.target.value
        });
      }, _this.clearSearch = function () {
        _this.setState({
          searchQuery: ''
        });
      }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
    }

    babelHelpers.createClass(NavigationGrid, [{
      key: 'getVisibleScreens',
      value: function getVisibleScreens() {
        var _this2 = this;

        return this.props.screens.filter(function (screen) {
          return screen.name.toLowerCase().indexOf(_this2.state.searchQuery.toLowerCase()) !== -1;
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            projectName = _props.projectName,
            projectFrame = _props.projectFrame,
            currentScreenID = _props.currentScreenID,
            onSelect = _props.onSelect,
            onClose = _props.onClose;
        var searchQuery = this.state.searchQuery;
        var screens = this.getVisibleScreens();
        var showEmptyState = screens.length === 0;
        return _react2.default.createElement('div', {
          className: _NavigationGrid2.default.modalContainer
        }, _react2.default.createElement('div', {
          className: _NavigationGrid2.default.header
        }, _react2.default.createElement('div', {
          className: 'position-absolute pinAll bg-black opacity-90'
        }), _react2.default.createElement('div', {
          className: _NavigationGrid2.default.pageWrap
        }, _react2.default.createElement('div', {
          className: 'width-50 paddingTopBottom-xs'
        }, _react2.default.createElement('h1', {
          className: _NavigationGrid2.default.heading
        }, projectName), _react2.default.createElement('h2', {
          className: _NavigationGrid2.default.subheading
        }, screens.length, ' ', screens.length === 1 ? 'screen' : 'screens')), _react2.default.createElement('div', {
          className: _NavigationGrid2.default.searchInputWrapper
        }, _react2.default.createElement(_NavigationSearchInput2.default, {
          value: searchQuery,
          onChange: this.handleSearch,
          onCloseButton: this.clearSearch
        })))), _react2.default.createElement('div', {
          className: _NavigationGrid2.default.scroll
        }, !showEmptyState ? _react2.default.createElement('div', {
          className: _NavigationGrid2.default.pageWrap
        }, _react2.default.createElement('div', {
          className: _NavigationGrid2.default.gridContainer
        }, _react2.default.createElement('div', {
          className: _NavigationGrid2.default.grid
        }, screens.map(function (s) {
          return _react2.default.createElement(_NavigationGridItem2.default, {
            key: s.id,
            screenID: s.id,
            frame: projectFrame,
            name: s.name,
            previewImageURL: s.img.previewURL,
            isActive: s.id === currentScreenID,
            searchQuery: searchQuery,
            onClick: function onClick() {
              return onSelect(s.id);
            }
          });
        })))) : _react2.default.createElement('div', {
          className: _NavigationGrid2.default.noSearchResultsContainer
        }, _react2.default.createElement('div', {
          className: _NavigationGrid2.default.noSearchResults
        }, 'No search results found.'))), _react2.default.createElement('div', {
          className: _NavigationGrid2.default.iconClose,
          onClick: onClose
        }));
      }
    }]);
    return NavigationGrid;
  }(_react.Component);

  exports.default = NavigationGrid;
  NavigationGrid.propTypes = {
    projectName: _propTypes2.default.string.isRequired,
    projectFrame: _propTypes2.default.string.isRequired,
    screens: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    currentScreenID: _propTypes2.default.number.isRequired,
    onSelect: _propTypes2.default.func.isRequired,
    onClose: _propTypes2.default.func.isRequired
  };
  /***/
},
/* 242 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _NavigationGridItem = __webpack_require__(243);

  var _NavigationGridItem2 = babelHelpers.interopRequireDefault(_NavigationGridItem);

  var _grid = __webpack_require__(82);

  function mapStateToProps(state, _ref) {
    var screenID = _ref.screenID;
    return {
      status: (0, _grid.getThumbStatus)(state, screenID)
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_NavigationGridItem2.default);
  /***/
},
/* 243 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _reactHighlightWords = __webpack_require__(244);

  var _reactHighlightWords2 = babelHelpers.interopRequireDefault(_reactHighlightWords);

  var _UploadFailed = __webpack_require__(124);

  var _UploadFailed2 = babelHelpers.interopRequireDefault(_UploadFailed);

  var _UploadPending = __webpack_require__(125);

  var _UploadPending2 = babelHelpers.interopRequireDefault(_UploadPending);

  var _DownloadFailed = __webpack_require__(126);

  var _DownloadFailed2 = babelHelpers.interopRequireDefault(_DownloadFailed);

  var _NavigationGridItem = __webpack_require__(246);

  var _NavigationGridItem2 = babelHelpers.interopRequireDefault(_NavigationGridItem);

  var _icons = __webpack_require__(14);

  function NavigationGridItem(_ref) {
    var frame = _ref.frame,
        name = _ref.name,
        previewImageURL = _ref.previewImageURL,
        isActive = _ref.isActive,
        status = _ref.status,
        _onClick = _ref.onClick,
        searchQuery = _ref.searchQuery;
    var hoverClass = (0, _classnames2.default)(_NavigationGridItem2.default.hover, isActive ? 'bg-positive opacity-80' : 'bg-black opacity-0 opacity-10--hover cursor-pointer');
    var imageNameClass = (0, _classnames2.default)(_NavigationGridItem2.default.imageName, isActive ? 'paddingBottom-s' : null);
    var imageNameBackgroundClass = (0, _classnames2.default)(_NavigationGridItem2.default.imageNameBackground, isActive ? null : 'bg-black');
    var style = void 0;

    if (status.isLoaded) {
      style = {
        backgroundImage: 'url(' + previewImageURL + ')'
      };
    }

    var ErrorComponent = void 0;

    if (status.uploadError) {
      ErrorComponent = _UploadFailed2.default;
    } else if (status.uploadPending) {
      ErrorComponent = _UploadPending2.default;
    } else if (status.downloadError) {
      ErrorComponent = _DownloadFailed2.default;
    }

    if (ErrorComponent) {
      return _react2.default.createElement(ErrorWrapper, {
        frame: frame
      }, _react2.default.createElement(ErrorComponent, {
        isThumb: true
      }));
    }

    var className = (0, _classnames2.default)(_NavigationGridItem2.default.image, _NavigationGridItem2.default[frame], babelHelpers.defineProperty({}, _NavigationGridItem2.default.isLoading, !status.isLoaded && !isActive));
    return _react2.default.createElement('div', null, _react2.default.createElement('div', {
      className: className,
      style: style
    }, _react2.default.createElement('div', {
      className: hoverClass,
      onClick: function onClick() {
        return _onClick();
      }
    }), isActive ? _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_NavigationGridItem2.default.check)
    }, _react2.default.createElement(_icons.CheckIcon, null)) : null, _react2.default.createElement('div', {
      className: imageNameClass
    }, isActive ? null : _react2.default.createElement('div', {
      className: imageNameBackgroundClass
    }), _react2.default.createElement('div', {
      className: _NavigationGridItem2.default.name
    }, _react2.default.createElement(_reactHighlightWords2.default, {
      highlightClassName: _NavigationGridItem2.default.highlight,
      searchWords: [searchQuery],
      textToHighlight: name
    })))));
  }

  exports.default = NavigationGridItem;
  NavigationGridItem.propTypes = {
    frame: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    previewImageURL: _propTypes2.default.string.isRequired,
    isActive: _propTypes2.default.bool.isRequired,
    status: _propTypes2.default.object.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    searchQuery: _propTypes2.default.string
  };

  function ErrorWrapper(_ref2) {
    var frame = _ref2.frame,
        children = _ref2.children;
    return _react2.default.createElement('div', null, _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_NavigationGridItem2.default.image, _NavigationGridItem2.default[frame])
    }, _react2.default.createElement('div', {
      className: _NavigationGridItem2.default.error
    }, children)));
  }

  ErrorWrapper.propTypes = {
    frame: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.node.isRequired
  };
  /***/
},
/* 244 */

/***/
function (module, exports) {
  module.exports = require("react-highlight-words");
  /***/
},
/* 245 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "screenPadding": "ImageError__screenPadding___Rwklv paddingLeftRight-l textAlign-center",
    "thumbnailPadding": "ImageError__thumbnailPadding___2gQdj paddingLeftRight-s breakPointM-paddingLeftRight-m breakPointL-paddingLeftRight-l textAlign-center",
    "screenText": "ImageError__screenText___1vXpD c-silver lineHeight-l",
    "wrapper": "ImageError__wrapper___3agcb position-absolute pinFill display-table bg-white",
    "thumbWrapper": "ImageError__thumbWrapper___3Xln9 borderRadius-s",
    "thumbnailText": "ImageError__thumbnailText___3ybGl c-silver lineHeight-s breadkPointM-lineHeight-m breakPointL-lineHeight-l fontSize-xs breakPointM-fontSize-s breakPointL-fontSize-m",
    "cell": "ImageError__cell___2K-OP display-tableCell verticalAlign-middle",
    "loader": "ImageError__loader___3l3iY is-loading is-loading--xl centered position-relative marginBottom-s",
    "errorIcon": "ImageError__errorIcon___1CNaw fill-negative centered display-block marginBottom-s"
  };
  /***/
},
/* 246 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "image": "NavigationGridItem__image___33_-m backgroundSize-cover borderRadius-m position-relative",
    "htc-one-frame": "NavigationGridItem__htc-one-frame___1onRd",
    "iphone4s-frame": "NavigationGridItem__iphone4s-frame___1sx2o",
    "iphone5c-frame": "NavigationGridItem__iphone5c-frame___3qMfe",
    "iphone5-frame": "NavigationGridItem__iphone5-frame___4uISP",
    "iphone6-frame": "NavigationGridItem__iphone6-frame___PM9M8",
    "iphone6plus-frame": "NavigationGridItem__iphone6plus-frame___13opA",
    "lumia920-frame": "NavigationGridItem__lumia920-frame___1Ef57",
    "nexus5-frame": "NavigationGridItem__nexus5-frame___a-Bk2",
    "s5-frame": "NavigationGridItem__s5-frame___N8fBx",
    "apple-watch-38-frame": "NavigationGridItem__apple-watch-38-frame___3kxv6",
    "apple-watch-42-frame": "NavigationGridItem__apple-watch-42-frame___1FDJP",
    "hover": "NavigationGridItem__hover___2Cyuz borderRadius-m position-absolute pinAll transitionDuration-m transitionTimingFunction-ease-in-out",
    "check": "NavigationGridItem__check___3OA_t position-absolute pinCenter fill-white",
    "imageName": "NavigationGridItem__imageName___2747f c-white fontSize-s lineHeight-s paddingLeftRight-s paddingTopBottom-xxs position-absolute pinBL textAlign-center width-100",
    "imageNameBackground": "NavigationGridItem__imageNameBackground___2bhLV borderRadiusBottom-m opacity-70 position-absolute pinAll",
    "isLoading": "NavigationGridItem__isLoading___uCtrq bg-smoke is-loading is-loading--xl",
    "error": "NavigationGridItem__error___Zd772 position-absolute pinFill borderRadius-s overflow-hidden",
    "name": "NavigationGridItem__name___1PV0P position-relative truncateText",
    "highlight": "NavigationGridItem__highlight___2S0NZ borderRadius-s"
  };
  /***/
},
/* 247 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = NavigationSearchInput;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _NavigationSearchInput = __webpack_require__(248);

  var _NavigationSearchInput2 = babelHelpers.interopRequireDefault(_NavigationSearchInput);

  var _icons = __webpack_require__(14);

  function NavigationSearchInput(_ref) {
    var value = _ref.value,
        onCloseButton = _ref.onCloseButton,
        onChange = _ref.onChange;
    var hasContent = value !== '';
    var wrapperClass = (0, _classnames2.default)(_NavigationSearchInput2.default.wrapper, babelHelpers.defineProperty({}, _NavigationSearchInput2.default.hasContent, hasContent));
    return _react2.default.createElement('div', {
      className: wrapperClass
    }, _react2.default.createElement('div', {
      className: 'uiIcon uiIcon--m '
    }, _react2.default.createElement('input', {
      type: 'text',
      className: _NavigationSearchInput2.default.input,
      placeholder: 'Search screens',
      value: value,
      onChange: onChange
    }), _react2.default.createElement(_icons.SearchIcon, null)), hasContent ? _react2.default.createElement('div', {
      className: _NavigationSearchInput2.default.closeButton,
      onClick: onCloseButton
    }, _react2.default.createElement('div', {
      className: 'pinCenter position-absolute'
    }, _react2.default.createElement(_icons.SearchCloseIcon, null))) : null);
  }

  NavigationSearchInput.propTypes = {
    value: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    onCloseButton: _propTypes2.default.func.isRequired
  };
  /***/
},
/* 248 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "wrapper": "NavigationSearchInput__wrapper___W_9Lx position-relative display-inlineBlock",
    "input": "NavigationSearchInput__input___11Q2s input input--m input--invisible",
    "hasContent": "NavigationSearchInput__hasContent___2KwAe",
    "closeButton": "NavigationSearchInput__closeButton___1r_o0 bg-marvel--hover bg-slate borderRadius-circle cursor-pointer fill-silver fill-white--hover position-absolute searchInputClose transitionDuration-s transitionProperty-all transitionTimingFunction-linear"
  };
  /***/
},
/* 249 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "modalContainer": "NavigationGrid__modalContainer___3pNiQ modal-container bg-black zi-chrome position-fixed overflow-hidden",
    "iconClose": "NavigationGrid__iconClose___vpSzW modal-icon--universal modal-icon modal-iconClose--outside modal-iconClose zi-chrome",
    "pageWrap": "NavigationGrid__pageWrap___XxTqi position-relative pageWrap--m pageWrap",
    "scroll": "NavigationGrid__scroll___3EgpP overflow-auto height-100",
    "header": "NavigationGrid__header___x4Haj paddingTopBottom-m position-fixed pinTL width-100 zi-chrome",
    "heading": "NavigationGrid__heading___22edp c-white fontSize-xl fontWeight-4 marginBottom-xs",
    "subheading": "NavigationGrid__subheading___1ugFw c-silver fontSize-m fontWeight-3",
    "gridContainer": "NavigationGrid__gridContainer___2XG3Y paddingBottom-m breakPointM-paddingBottom-l",
    "grid": "NavigationGrid__grid___3bvqf breakPointL-grid--5 breakPointM-grid--4 breakPointM-grid--l breakPointS-grid--3 grid--2 grid--m grid",
    "searchInputWrapper": "NavigationGrid__searchInputWrapper___1YQOS position-absolute",
    "noSearchResultsContainer": "NavigationGrid__noSearchResultsContainer___2MwEX display-table position-absolute pinAll",
    "noSearchResults": "NavigationGrid__noSearchResults___3CeUY display-tableCell verticalAlign-middle textAlign-center c-white fontSize-l"
  };
  /***/
},
/* 250 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ENTER_ANNOTATION_MODE = exports.ENTER_ANNOTATION_MODE = 'ENTER_ANNOTATION_MODE';
  var LEAVE_ANNOTATION_MODE = exports.LEAVE_ANNOTATION_MODE = 'LEAVE_ANNOTATION_MODE';
  var ADD_NEW_ANNOTATION = exports.ADD_NEW_ANNOTATION = 'ADD_NEW_ANNOTATION';
  var ADD_ANNOTATION = exports.ADD_ANNOTATION = 'ADD_ANNOTATION';
  var REMOVE_ANNOTATION = exports.REMOVE_ANNOTATION = 'REMOVE_ANNOTATION';
  var POSITION_ANNOTATION = exports.POSITION_ANNOTATION = 'POSITION_ANNOTATION';
  var SCROLL_TO_ANNOTATION = exports.SCROLL_TO_ANNOTATION = 'SCROLL_TO_ANNOTATION';
  var HIGHLIGHT_ANNOTATION = exports.HIGHLIGHT_ANNOTATION = 'HIGHLIGHT_ANNOTATION';
  var UNHIGHLIGHT_ANNOTATION = exports.UNHIGHLIGHT_ANNOTATION = 'UNHIGHLIGHT_ANNOTATION';
  var PULSE_ANNOTATION = exports.PULSE_ANNOTATION = 'PULSE_ANNOTATION';
  var CLEAR_ANNOTATIONS = exports.CLEAR_ANNOTATIONS = 'CLEAR_ANNOTATIONS';
  var MAKE_ANNOTATION_MOVEABLE = exports.MAKE_ANNOTATION_MOVEABLE = 'MAKE_ANNOTATION_MOVEABLE';
  var CANCEL_ANNOTATION = exports.CANCEL_ANNOTATION = 'CANCEL_ANNOTATION';
  var MARK_ANNOTATION_SAVED = exports.MARK_ANNOTATION_SAVED = 'MARK_ANNOTATION_SAVED';
  var ANNOTATION_COMMENT_UPDATED = exports.ANNOTATION_COMMENT_UPDATED = 'ANNOTATION_COMMENT_UPDATED';
  var UPDATE_ANNOTATION = exports.UPDATE_ANNOTATION = 'UPDATE_ANNOTATION';
  /***/
},
/* 251 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SHOW_COPYING = exports.SHOW_COPYING = 'SHOW_COPYING';
  var SHOW_COPYING_DONE = exports.SHOW_COPYING_DONE = 'SHOW_COPYING_DONE';
  /***/
},
/* 252 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var LOAD_CODE_START = exports.LOAD_CODE_START = 'LOAD_CODE_START';
  var LOAD_CODE_DONE = exports.LOAD_CODE_DONE = 'LOAD_CODE_DONE';
  var LOAD_CODE_FAILED = exports.LOAD_CODE_FAILED = 'LOAD_CODE_FAILED';
  var SET_CURRENT_LANG = exports.SET_CURRENT_LANG = 'SET_CURRENT_LANG';
  var SET_DEFAULT_PROJECT_LANG = exports.SET_DEFAULT_PROJECT_LANG = 'SET_DEFAULT_PROJECT_LANG';
  /***/
},
/* 253 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SET_COMMENT_COUNT = exports.SET_COMMENT_COUNT = 'SET_COMMENT_COUNT';
  var SHOW_COMMENTS = exports.SHOW_COMMENTS = 'SHOW_COMMENTS';
  var HIDE_COMMENTS = exports.HIDE_COMMENTS = 'HIDE_COMMENTS';
  var HIGHLIGHT_COMMENT = exports.HIGHLIGHT_COMMENT = 'HIGHLIGHT_COMMENT';
  var UNHIGHLIGHT_COMMENT = exports.UNHIGHLIGHT_COMMENT = 'UNHIGHLIGHT_COMMENT';
  var SHOW_COMMENT_NOTIFICATION = exports.SHOW_COMMENT_NOTIFICATION = 'SHOW_COMMENT_NOTIFICATION';
  var HIDE_COMMENT_NOTIFICATION = exports.HIDE_COMMENT_NOTIFICATION = 'HIDE_COMMENT_NOTIFICATION';
  var GET_LEAVE_COMMENT_POPOVER_COOKIE = exports.GET_LEAVE_COMMENT_POPOVER_COOKIE = 'GET_LEAVE_COMMENT_POPOVER_COOKIE';
  var SET_LEAVE_COMMENT_POPOVER_COOKIE = exports.SET_LEAVE_COMMENT_POPOVER_COOKIE = 'SET_LEAVE_COMMENT_POPOVER_COOKIE';
  var RECEIVE_LEAVE_COMMENT_POPOVER_COOKIE = exports.RECEIVE_LEAVE_COMMENT_POPOVER_COOKIE = 'RECEIVE_LEAVE_COMMENT_POPOVER_COOKIE';
  /***/
},
/* 254 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ORIENTATION_CHANGED = exports.ORIENTATION_CHANGED = 'ORIENTATION_CHANGED';
  /***/
},
/* 255 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var CHANGE_PROJECT_DEVICE_FRAME = exports.CHANGE_PROJECT_DEVICE_FRAME = 'CHANGE_DEVICE_FRAME';
  var CHANGE_PROJECT_DEVICE_COLOR = exports.CHANGE_PROJECT_DEVICE_COLOR = 'CHANGE_DEVICE_COLOR';
  var CHANGE_PROJECT_DEVICE_ORIENTATION = exports.CHANGE_PROJECT_DEVICE_ORIENTATION = 'CHANGE_PROJECT_DEVICE_ORIENTATION';
  var CHANGE_DEVICE_ORIENTATION = exports.CHANGE_DEVICE_ORIENTATION = 'CHANGE_DEVICE_ORIENTATION';
  var CHANGE_DEVICE_DETECTION = exports.CHANGE_DEVICE_DETECTION = 'CHANGE_DEVICE_DETECTION';
  /***/
},
/* 256 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var DOWNLOAD_ASSETS = exports.DOWNLOAD_ASSETS = 'DOWNLOAD_ASSETS';
  var DOWNLOAD_ASSETS_START = exports.DOWNLOAD_ASSETS_START = 'DOWNLOAD_ASSETS_START';
  var ASSETS_ZIP_CREATED = exports.ASSETS_ZIP_CREATED = 'ASSETS_ZIP_CREATED';
  var ASSETS_ZIP_DOWNLOADED = exports.ASSETS_ZIP_DOWNLOADED = 'ASSETS_ZIP_DOWNLOADED';
  /***/
},
/* 257 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SET_CONTAINER_HEIGHT = exports.SET_CONTAINER_HEIGHT = 'SET_CONTAINER_HEIGHT';
  /***/
},
/* 258 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SHOW_GRID = exports.SHOW_GRID = 'SHOW_GRID';
  var HIDE_GRID = exports.HIDE_GRID = 'HIDE_GRID';
  var IMAGE_THUMB_LOADED = exports.IMAGE_THUMB_LOADED = 'IMAGE_THUMB_LOADED';
  var IMAGE_THUMB_FAILED = exports.IMAGE_THUMB_FAILED = 'IMAGE_THUMB_FAILED';
  /***/
},
/* 259 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SHOW_HANDOFF = exports.SHOW_HANDOFF = 'SHOW_HANDOFF';
  var HIDE_HANDOFF = exports.HIDE_HANDOFF = 'HIDE_HANDOFF';
  var CHANGE_HANDOFF_SELECTED_ITEM = exports.CHANGE_HANDOFF_SELECTED_ITEM = 'CHANGE_HANDOFF_SELECTED_ITEM';
  var INCREMENT_ZOOM = exports.INCREMENT_ZOOM = 'INCREMENT_ZOOM';
  var DECREMENT_ZOOM = exports.DECREMENT_ZOOM = 'DECREMENT_ZOOM';
  var DESELECT_HANDOFF_ITEM = exports.DESELECT_HANDOFF_ITEM = 'DESELECT_HANDOFF_ITEM';
  var CHANGE_HANDOFF_HOVERED_ITEM = exports.CHANGE_HANDOFF_HOVERED_ITEM = 'CHANGE_HANDOFF_HOVERED_ITEM';
  var SET_CANVAS = exports.SET_CANVAS = 'SET_CANVAS';
  var LOAD_CANVAS_STARTING = exports.LOAD_CANVAS_STARTING = 'LOAD_CANVAS_STARTING';
  var LOAD_CANVAS_FAILED = exports.LOAD_CANVAS_FAILED = 'LOAD_CANVAS_FAILED';
  var LOAD_CANVAS_DONE = exports.LOAD_CANVAS_DONE = 'LOAD_CANVAS_DONE';
  var SET_CANVAS_EASEL_URLS = exports.SET_CANVAS_EASEL_URLS = 'SET_CANVAS_EASEL_URLS';
  var TOGGLE_COLUMN_OVERLAY = exports.TOGGLE_COLUMN_OVERLAY = 'TOGGLE_COLUMN_OVERLAY';
  var TOGGLE_ROW_OVERLAY = exports.TOGGLE_ROW_OVERLAY = 'TOGGLE_ROW_OVERLAY';
  var SET_UNIT = exports.SET_UNIT = 'SET_UNIT';
  var UPDATE_ZOOM_POSITION = exports.UPDATE_ZOOM_POSITION = 'UPDATE_ZOOM_POSITION';
  /***/
},
/* 260 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SHOW_ADD_TO_HOME_SCREEN = exports.SHOW_ADD_TO_HOME_SCREEN = 'SHOW_ADD_TO_HOME_SCREEN';
  var HIDE_ADD_TO_HOME_SCREEN = exports.HIDE_ADD_TO_HOME_SCREEN = 'HIDE_ADD_TO_HOME_SCREEN';
  var GET_ADD_TO_HOME_SCREEN_COOKIE = exports.GET_ADD_TO_HOME_SCREEN_COOKIE = 'GET_ADD_TO_HOME_SCREEN_COOKIE';
  var RECEIVE_ADD_TO_HOME_SCREEN_COOKIE = exports.RECEIVE_ADD_TO_HOME_SCREEN_COOKIE = 'RECEIVE_ADD_TO_HOME_SCREEN_COOKIE';
  var SET_ADD_TO_HOME_SCREEN_COOKIE = exports.SET_ADD_TO_HOME_SCREEN_COOKIE = 'SET_ADD_TO_HOME_SCREEN_COOKIE';
  /***/
},
/* 261 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SHOW_HOTSPOTS = exports.SHOW_HOTSPOTS = 'SHOW_HOTSPOTS';
  var HIDE_HOTSPOTS = exports.HIDE_HOTSPOTS = 'HIDE_HOTSPOTS';
  var FLASH_HOTSPOTS = exports.FLASH_HOTSPOTS = 'FLASH_HOTSPOTS';
  var LOAD_HOTSPOTS_STARTING = exports.LOAD_HOTSPOTS_STARTING = 'LOAD_HOTSPOTS_STARTING';
  var LOAD_HOTSPOTS_DONE = exports.LOAD_HOTSPOTS_DONE = 'LOAD_HOTSPOTS_DONE';
  var LOAD_HOTSPOTS_FAILED = exports.LOAD_HOTSPOTS_FAILED = 'LOAD_HOTSPOTS_FAILED';
  var ADD_TO_HOVER_STACK = exports.ADD_TO_HOVER_STACK = 'ADD_TO_HOVER_STACK';
  var REMOVE_FROM_HOVER_STACK = exports.REMOVE_FROM_HOVER_STACK = 'REMOVE_FROM_HOVER_STACK';
  var HOVER_OUT = exports.HOVER_OUT = 'HOVER_OUT';
  /***/
},
/* 262 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var IMAGE_LOADING_COMPLETE = exports.IMAGE_LOADING_COMPLETE = 'IMAGE_LOADING_COMPLETE';
  var RELOAD_IMAGES = exports.RELOAD_IMAGES = 'RELOAD_IMAGES';
  var IMAGE_LOADING_START = exports.IMAGE_LOADING_START = 'IMAGE_LOADING_START';
  /***/
},
/* 263 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var LOCATION_CHANGED = exports.LOCATION_CHANGED = 'LOCATION_CHANGED';
  /***/
},
/* 264 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SHOW_OVERLAY = exports.SHOW_OVERLAY = 'SHOW_OVERLAY';
  var HIDE_OVERLAY = exports.HIDE_OVERLAY = 'HIDE_OVERLAY';
  var SHOW_HOVER_OVERLAY = exports.SHOW_HOVER_OVERLAY = 'SHOW_HOVER_OVERLAY';
  var SET_OVERLAY_SCROLL_POS = exports.SET_OVERLAY_SCROLL_POS = 'SET_OVERLAY_SCROLL_POS';
  var UNSET_OVERLAY_SCROLL_POS = exports.UNSET_OVERLAY_SCROLL_POS = 'UNSET_OVERLAY_SCROLL_POS';
  /***/
},
/* 265 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var PASSWORD_REQUIRED = exports.PASSWORD_REQUIRED = 'PASSWORD_REQUIRED';
  var VERIFY_PASSWORD = exports.VERIFY_PASSWORD = 'VERIFY_PASSWORD';
  var VERIFY_PASSWORD_FAIL = exports.VERIFY_PASSWORD_FAIL = 'VERIFY_PASSWORD_FAIL'; // Success can be PASSWORD_VALID or PASSWORD_INVALID

  var PASSWORD_VALID = exports.PASSWORD_VALID = 'PASSWORD_VALID';
  var PASSWORD_INVALID = exports.PASSWORD_INVALID = 'PASSWORD_INVALID';
  /***/
},
/* 266 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var PLAY = exports.PLAY = 'PLAY';
  var HISTORY_BACK = exports.HISTORY_BACK = 'HISTORY_BACK';
  /***/
},
/* 267 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SET_PROJECT = exports.SET_PROJECT = 'SET_PROJECT';
  var LOAD_PROJECT = exports.LOAD_PROJECT = 'LOAD_PROJECT';
  var LOAD_PROJECT_PREVIEW = exports.LOAD_PROJECT_PREVIEW = 'LOAD_PROJECT_PREVIEW';
  var LOAD_PROJECT_PREVIEW_STARTING = exports.LOAD_PROJECT_PREVIEW_STARTING = 'LOAD_PROJECT_PREVIEW_STARTING';
  var LOAD_PROJECT_PREVIEW_DONE = exports.LOAD_PROJECT_PREVIEW_DONE = 'LOAD_PROJECT_PREVIEW_DONE';
  var LOAD_PROJECT_PREVIEW_FAILED = exports.LOAD_PROJECT_PREVIEW_FAILED = 'LOAD_PROJECT_PREVIEW_FAILED';
  var LOAD_FULL_PROJECT = exports.LOAD_FULL_PROJECT = 'LOAD_FULL_PROJECT';
  var LOAD_FULL_PROJECT_STARTING = exports.LOAD_FULL_PROJECT_STARTING = 'LOAD_FULL_PROJECT_STARTING';
  var LOAD_FULL_PROJECT_DONE = exports.LOAD_FULL_PROJECT_DONE = 'LOAD_FULL_PROJECT_DONE';
  var LOAD_FULL_PROJECT_FAILED = exports.LOAD_FULL_PROJECT_FAILED = 'LOAD_FULL_PROJECT_FAILED';
  var NOT_FOUND = exports.NOT_FOUND = 'NOT_FOUND';
  var SET_IS_DOWNLOADED = exports.SET_IS_DOWNLOADED = 'SET_IS_DOWNLOADED';
  var SET_PROJECT_PLAN = exports.SET_PROJECT_PLAN = 'SET_PROJECT_PLAN';
  var SET_FRAMELESS = exports.SET_FRAMELESS = 'SET_FRAMELESS';
  /***/
},
/* 268 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var CLICK = exports.CLICK = 'CLICK';
  var MISSED_CLICK = exports.MISSED_CLICK = 'MISSED_CLICK';
  /***/
},
/* 269 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SET_INITIAL_SCREEN = exports.SET_INITIAL_SCREEN = 'SET_INITIAL_SCREEN';
  var SHOW_NEXT = exports.SHOW_NEXT = 'SHOW_NEXT';
  var SHOW_PREVIOUS = exports.SHOW_PREVIOUS = 'SHOW_PREVIOUS';
  var SHOW_HOME = exports.SHOW_HOME = 'SHOW_HOME';
  var SHOW_SCREEN = exports.SHOW_SCREEN = 'SHOW_SCREEN';
  var SET_SCREEN_TRANSITION = exports.SET_SCREEN_TRANSITION = 'SET_SCREEN_TRANSITION';
  var SCREEN_RESIZED = exports.SCREEN_RESIZED = 'SCREEN_RESIZED';
  var IMAGE_LOADED = exports.IMAGE_LOADED = 'IMAGE_LOADED';
  var IMAGE_LOAD_FAILED = exports.IMAGE_LOAD_FAILED = 'IMAGE_LOAD_FAILED';
  var SCROLL_TO = exports.SCROLL_TO = 'SCROLL_TO';
  var UNSET_SCROLL_POS = exports.UNSET_SCROLL_POS = 'UNSET_SCROLL_POS';
  var SCREEN_TIMER = exports.SCREEN_TIMER = 'SCREEN_TIMER';
  var SCREEN_TRANSITION_COMPLETED = exports.SCREEN_TRANSITION_COMPLETED = 'SCREEN_TRANSITION_COMPLETED';
  var SHOW_SCREEN_INFO = exports.SHOW_SCREEN_INFO = 'SHOW_SCREEN_INFO';
  var HIDE_SCREEN_INFO = exports.HIDE_SCREEN_INFO = 'HIDE_SCREEN_INFO';
  var GIF_RESET_DONE = exports.GIF_RESET_DONE = 'GIF_RESET_DONE';
  var SHOW_HOVER_SCREEN = exports.SHOW_HOVER_SCREEN = 'SHOW_HOVER_SCREEN';
  /***/
},
/* 270 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SET_USER_PROP = exports.SET_USER_PROP = 'SET_USER_PROP';
  /***/
},
/* 271 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.showCopying = showCopying;
  exports.showCopyingDone = showCopyingDone;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function showCopying(target) {
    return {
      type: actionTypes.SHOW_COPYING,
      target: target
    };
  }

  function showCopyingDone(target) {
    return {
      type: actionTypes.SHOW_COPYING_DONE,
      target: target
    };
  }
  /***/

},
/* 272 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.loadCodeStart = loadCodeStart;
  exports.loadCodeDone = loadCodeDone;
  exports.loadCodeFailed = loadCodeFailed;
  exports.setCurrentLang = setCurrentLang;
  exports.setDefaultProjectLang = setDefaultProjectLang;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function loadCodeStart(lang) {
    return {
      type: actionTypes.LOAD_CODE_START,
      lang: lang
    };
  }

  function loadCodeDone(lang, code) {
    return {
      type: actionTypes.LOAD_CODE_DONE,
      lang: lang,
      code: code
    };
  }

  function loadCodeFailed(lang, error) {
    return {
      type: actionTypes.LOAD_CODE_FAILED,
      lang: lang,
      error: error
    };
  }

  function setCurrentLang(lang) {
    return {
      type: actionTypes.SET_CURRENT_LANG,
      lang: lang
    };
  }

  function setDefaultProjectLang(lang) {
    return {
      type: actionTypes.SET_DEFAULT_PROJECT_LANG,
      lang: lang
    };
  }
  /***/

},
/* 273 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setCommentCount = setCommentCount;
  exports.showComments = showComments;
  exports.hideComments = hideComments;
  exports.highlightComment = highlightComment;
  exports.unHighlightComment = unHighlightComment;
  exports.getLeaveCommentPopoverCookie = getLeaveCommentPopoverCookie;
  exports.receiveLeaveCommentPopoverCookie = receiveLeaveCommentPopoverCookie;
  exports.setLeaveCommentPopoverCookie = setLeaveCommentPopoverCookie;
  exports.showCommentNotification = showCommentNotification;
  exports.hideCommentNotification = hideCommentNotification;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function setCommentCount(count) {
    return {
      type: actionTypes.SET_COMMENT_COUNT,
      count: count
    };
  }

  function showComments() {
    return {
      type: actionTypes.SHOW_COMMENTS
    };
  }

  function hideComments() {
    return {
      type: actionTypes.HIDE_COMMENTS
    };
  }

  function highlightComment(id) {
    return {
      type: actionTypes.HIGHLIGHT_COMMENT,
      id: id
    };
  }

  function unHighlightComment() {
    return {
      type: actionTypes.UNHIGHLIGHT_COMMENT
    };
  }

  function getLeaveCommentPopoverCookie() {
    return {
      type: actionTypes.GET_LEAVE_COMMENT_POPOVER_COOKIE
    };
  }

  function receiveLeaveCommentPopoverCookie(value) {
    return {
      type: actionTypes.RECEIVE_LEAVE_COMMENT_POPOVER_COOKIE,
      value: value
    };
  }

  function setLeaveCommentPopoverCookie() {
    return {
      type: actionTypes.SET_LEAVE_COMMENT_POPOVER_COOKIE
    };
  }

  function showCommentNotification(notification) {
    return {
      type: actionTypes.SHOW_COMMENT_NOTIFICATION,
      notification: notification
    };
  }

  function hideCommentNotification() {
    return {
      type: actionTypes.HIDE_COMMENT_NOTIFICATION
    };
  }
  /***/

},
/* 274 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.orientationChanged = orientationChanged;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function orientationChanged(orientation) {
    return {
      type: actionTypes.ORIENTATION_CHANGED,
      orientation: orientation
    };
  }
  /***/

},
/* 275 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.changeProjectDeviceFrame = changeProjectDeviceFrame;
  exports.changeProjectDeviceOrientation = changeProjectDeviceOrientation;
  exports.changeDeviceOrientation = changeDeviceOrientation;
  exports.changeDeviceDetection = changeDeviceDetection;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function changeProjectDeviceFrame(frame) {
    return {
      type: actionTypes.CHANGE_PROJECT_DEVICE_FRAME,
      frame: frame
    };
  }

  function changeProjectDeviceOrientation(orientation) {
    return {
      type: actionTypes.CHANGE_PROJECT_DEVICE_ORIENTATION,
      orientation: orientation
    };
  }

  function changeDeviceOrientation(orientation) {
    return {
      type: actionTypes.CHANGE_DEVICE_ORIENTATION,
      orientation: orientation
    };
  }

  function changeDeviceDetection(deviceDetection) {
    return {
      type: actionTypes.CHANGE_DEVICE_DETECTION,
      deviceDetection: deviceDetection
    };
  }
  /***/

},
/* 276 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setContainerHeight = setContainerHeight;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function setContainerHeight(height) {
    return {
      type: actionTypes.SET_CONTAINER_HEIGHT,
      height: height
    };
  }
  /***/

},
/* 277 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.showGrid = showGrid;
  exports.hideGrid = hideGrid;
  exports.imageThumbLoaded = imageThumbLoaded;
  exports.imageThumbFailed = imageThumbFailed;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function showGrid() {
    return {
      type: actionTypes.SHOW_GRID
    };
  }

  function hideGrid() {
    return {
      type: actionTypes.HIDE_GRID
    };
  }

  function imageThumbLoaded(id) {
    return {
      type: actionTypes.IMAGE_THUMB_LOADED,
      id: id
    };
  }

  function imageThumbFailed(id) {
    return {
      type: actionTypes.IMAGE_THUMB_FAILED,
      id: id
    };
  }
  /***/

},
/* 278 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.showAddToHomeScreen = showAddToHomeScreen;
  exports.hideAddToHomeScreen = hideAddToHomeScreen;
  exports.getAddToHomeScreenCookie = getAddToHomeScreenCookie;
  exports.receiveAddToHomeScreenCookie = receiveAddToHomeScreenCookie;
  exports.setAddToHomeScreenCookie = setAddToHomeScreenCookie;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function showAddToHomeScreen(payload) {
    return {
      type: actionTypes.SHOW_ADD_TO_HOME_SCREEN,
      payload: payload
    };
  }

  function hideAddToHomeScreen() {
    return {
      type: actionTypes.HIDE_ADD_TO_HOME_SCREEN
    };
  }

  function getAddToHomeScreenCookie() {
    return {
      type: actionTypes.GET_ADD_TO_HOME_SCREEN_COOKIE
    };
  }

  function receiveAddToHomeScreenCookie(value) {
    return {
      type: actionTypes.RECEIVE_ADD_TO_HOME_SCREEN_COOKIE,
      value: value
    };
  }

  function setAddToHomeScreenCookie() {
    return {
      type: actionTypes.SET_ADD_TO_HOME_SCREEN_COOKIE
    };
  }
  /***/

},
/* 279 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.flashHotspots = flashHotspots;
  exports.showHotspots = showHotspots;
  exports.hideHotspots = hideHotspots;
  exports.loadHotspotsStarting = loadHotspotsStarting;
  exports.loadHotspotsFailed = loadHotspotsFailed;
  exports.loadHotspotsDone = loadHotspotsDone;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function flashHotspots() {
    return {
      type: actionTypes.FLASH_HOTSPOTS
    };
  }

  function showHotspots() {
    return {
      type: actionTypes.SHOW_HOTSPOTS
    };
  }

  function hideHotspots() {
    return {
      type: actionTypes.HIDE_HOTSPOTS
    };
  }

  function loadHotspotsStarting() {
    return {
      type: actionTypes.LOAD_HOTSPOTS_STARTING
    };
  }

  function loadHotspotsFailed() {
    return {
      type: actionTypes.LOAD_HOTSPOTS_FAILED
    };
  }

  function loadHotspotsDone() {
    return {
      type: actionTypes.LOAD_HOTSPOTS_DONE
    };
  }
  /***/

},
/* 280 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.addToHoverStack = addToHoverStack;
  exports.removeFromHoverStack = removeFromHoverStack;
  exports.hoverOut = hoverOut;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function addToHoverStack(_ref) {
    var screenID = _ref.screenID,
        layerID = _ref.layerID,
        scrollPos = _ref.scrollPos,
        maintainScroll = _ref.maintainScroll,
        coordinates = _ref.coordinates;
    return {
      type: actionTypes.ADD_TO_HOVER_STACK,
      hoverOutInfo: {
        screenID: screenID,
        layerID: layerID,
        scrollPos: scrollPos,
        maintainScroll: maintainScroll,
        coordinates: coordinates
      }
    };
  }

  function removeFromHoverStack(numberOfLevels) {
    return {
      type: actionTypes.REMOVE_FROM_HOVER_STACK,
      numberOfLevels: numberOfLevels
    };
  }

  function hoverOut(numberOfLevels, scrollPos) {
    return {
      type: actionTypes.HOVER_OUT,
      numberOfLevels: numberOfLevels,
      scrollPos: scrollPos
    };
  }
  /***/

},
/* 281 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.reloadImages = reloadImages;
  exports.imageLoadingStart = imageLoadingStart;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function reloadImages(currentScreenID) {
    return {
      type: actionTypes.RELOAD_IMAGES,
      currentScreenID: currentScreenID
    };
  }

  function imageLoadingStart(id) {
    return {
      type: actionTypes.IMAGE_LOADING_START,
      id: id
    };
  }
  /***/

},
/* 282 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.locationChanged = locationChanged;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes); // locationState is a shape with the following attributes:
  // { projectID, screenID, highlightedComment, inHandoff, isEmbedded,
  //   hotspotID, hideAddToHomeScreen, isFrameless, isInTheExploreView }
  // currentLocation is the location object

  function locationChanged(locationState, currentLocation) {
    return babelHelpers.extends({
      type: actionTypes.LOCATION_CHANGED
    }, locationState, {
      currentLocation: currentLocation
    });
  }
  /***/

},
/* 283 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.showOverlay = showOverlay;
  exports.hideOverlay = hideOverlay;
  exports.showHoverOverlay = showHoverOverlay;
  exports.setOverlayScrollPos = setOverlayScrollPos;
  exports.unsetOverlayScrollPos = unsetOverlayScrollPos;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function showOverlay(hotspotID, scrollPos) {
    return {
      type: actionTypes.SHOW_OVERLAY,
      hotspotID: hotspotID,
      scrollPos: scrollPos
    };
  }

  function hideOverlay(transition) {
    return {
      type: actionTypes.HIDE_OVERLAY,
      transition: transition
    };
  }

  function showHoverOverlay(hotspotID, scrollPos) {
    return {
      type: actionTypes.SHOW_HOVER_OVERLAY,
      hotspotID: hotspotID,
      scrollPos: scrollPos
    };
  }

  function setOverlayScrollPos(scrollPos, smoothScroll) {
    return {
      type: actionTypes.SET_OVERLAY_SCROLL_POS,
      scrollPos: scrollPos,
      smoothScroll: smoothScroll
    };
  }

  function unsetOverlayScrollPos() {
    return {
      type: actionTypes.UNSET_OVERLAY_SCROLL_POS
    };
  }
  /***/

},
/* 284 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.historyBack = historyBack;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function historyBack() {
    return {
      type: actionTypes.HISTORY_BACK
    };
  }
  /***/

},
/* 285 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setProject = setProject;
  exports.setPartialProject = setPartialProject;
  exports.loadProject = loadProject;
  exports.loadFullProject = loadFullProject;
  exports.loadFullProjectStarting = loadFullProjectStarting;
  exports.loadFullProjectDone = loadFullProjectDone;
  exports.loadFullProjectFailed = loadFullProjectFailed;
  exports.loadProjectPreview = loadProjectPreview;
  exports.loadProjectPreviewStarting = loadProjectPreviewStarting;
  exports.loadProjectPreviewDone = loadProjectPreviewDone;
  exports.loadProjectPreviewFailed = loadProjectPreviewFailed;
  exports.play = play;
  exports.notFound = notFound;
  exports.passwordRequired = passwordRequired;
  exports.verifyPassword = verifyPassword;
  exports.setIsDownloaded = setIsDownloaded;
  exports.setCanvasEaselURLs = setCanvasEaselURLs;
  exports.setProjectPlan = setProjectPlan;
  exports.setFrameless = setFrameless;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _createProjectConfig = __webpack_require__(127);

  function setProject(data) {
    return {
      type: actionTypes.SET_PROJECT,
      project: (0, _createProjectConfig.createProjectConfig)(data)
    };
  }

  function setPartialProject(data) {
    return {
      type: actionTypes.SET_PROJECT,
      project: (0, _createProjectConfig.createPartialProjectConfig)(data)
    };
  }

  function loadProject(projectID, token) {
    return loadFullProject(projectID, token);
  }

  function loadFullProject(id, token) {
    return {
      type: actionTypes.LOAD_FULL_PROJECT,
      id: id,
      token: token
    };
  }

  function loadFullProjectStarting(id) {
    return {
      type: actionTypes.LOAD_FULL_PROJECT_STARTING,
      id: id
    };
  }

  function loadFullProjectDone(project, token) {
    return {
      type: actionTypes.LOAD_FULL_PROJECT_DONE,
      project: project,
      token: token
    };
  }

  function loadFullProjectFailed(id, err) {
    return {
      type: actionTypes.LOAD_FULL_PROJECT_FAILED,
      id: id,
      err: err
    };
  }

  function loadProjectPreview(id, screenID, token) {
    return {
      type: actionTypes.LOAD_PROJECT_PREVIEW,
      id: id,
      screenID: screenID,
      token: token
    };
  }

  function loadProjectPreviewStarting(id) {
    return {
      type: actionTypes.LOAD_PROJECT_PREVIEW_STARTING,
      id: id
    };
  }

  function loadProjectPreviewDone(project) {
    return {
      type: actionTypes.LOAD_PROJECT_PREVIEW_DONE,
      project: project
    };
  }

  function loadProjectPreviewFailed(id, err) {
    return {
      type: actionTypes.LOAD_PROJECT_PREVIEW_FAILED,
      id: id,
      err: err
    };
  }

  function play(projectID) {
    return function (dispatch) {
      dispatch(loadFullProject(projectID));
      dispatch({
        type: actionTypes.PLAY
      });
    };
  }

  function notFound(id) {
    return {
      type: actionTypes.NOT_FOUND,
      id: id
    };
  }

  function passwordRequired(id) {
    return {
      type: actionTypes.PASSWORD_REQUIRED,
      id: id
    };
  }

  function verifyPassword(projectID, password) {
    var url = '/api/project/verify/' + projectID + '/';
    var data = new FormData();
    data.append('password', password);
    return function (dispatch) {
      dispatch(verifyPasswordInProgress());
      return fetch(url, {
        method: 'POST',
        body: data,
        credentials: 'same-origin'
      }).then(function (response) {
        if (response.ok) {
          dispatch(passwordValid());
          return response.json();
        }

        if (response.status === 403) {
          dispatch(passwordInvalid());
        } // TODO dispatch action for other errors


        throw new Error('Password verification error: ' + response.statusText);
      }).then(function (responseData) {
        var token = responseData.token;
        dispatch(loadProject(projectID, token));
      }, function () {});
    };
  }

  function verifyPasswordInProgress() {
    return {
      type: actionTypes.VERIFY_PASSWORD
    };
  }

  function passwordInvalid() {
    return {
      type: actionTypes.PASSWORD_INVALID
    };
  }

  function passwordValid() {
    return {
      type: actionTypes.PASSWORD_VALID
    };
  }

  function setIsDownloaded(isDownloaded) {
    return {
      type: actionTypes.SET_IS_DOWNLOADED,
      isDownloaded: isDownloaded
    };
  }

  function setCanvasEaselURLs(canvasEaselHost) {
    return {
      type: actionTypes.SET_CANVAS_EASEL_URLS,
      canvasEaselHost: canvasEaselHost
    };
  }

  function setProjectPlan(plan) {
    return {
      type: actionTypes.SET_PROJECT_PLAN,
      plan: plan
    };
  }

  function setFrameless(isFrameless) {
    return {
      type: actionTypes.SET_FRAMELESS,
      isFrameless: isFrameless
    };
  }
  /***/

},
/* 286 */

/***/
function (module, exports) {
  module.exports = require("lodash/transform");
  /***/
},
/* 287 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  }); // TODO: Move to marvel-core?

  var STATUS_BAR_TYPE_PROPERTY = exports.STATUS_BAR_TYPE_PROPERTY = 'ui-prj-status-bar';
  var TRIM_STATUS_BAR_PROPERTY = exports.TRIM_STATUS_BAR_PROPERTY = 'ui-prj-remove-status';
  var DEVICE_ORIENTATION = exports.DEVICE_ORIENTATION = 'ui-prj-orientation';
  var DEVICE_FRAME = exports.DEVICE_FRAME = 'ui-prj-frame';
  var DEVICE_COLOR = exports.DEVICE_COLOR = 'ui-prj-frame-colour';
  var DISABLE_SWIPE_THROUGH_SCREENS = exports.DISABLE_SWIPE_THROUGH_SCREENS = 'ui-prj-disable-swipe';
  var DISABLE_HOTSPOT_HINTS = exports.DISABLE_HOTSPOT_HINTS = 'ui-prj-show-hints';
  var SCALE_RETINA_IMAGES = exports.SCALE_RETINA_IMAGES = 'ui-prj-retina-scale';
  /***/
},
/* 288 */

/***/
function (module, exports) {
  module.exports = require("mobile-detect");
  /***/
},
/* 289 */

/***/
function (module, exports) {
  module.exports = require("lodash/keyBy");
  /***/
},
/* 290 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isEmail;
  var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // TODO: We shouldn't use a regular expression to validate email addresses
  // because there is no good regular expression to validate RFC822.
  // We could use a BNF parser like https://github.com/hapijs/isemail,
  // but this is over complicated, the server should simply append `mailto:`
  // to `external_url` when necessary

  function isEmail(pattern) {
    return emailRegex.test(pattern);
  }
  /***/

},
/* 291 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getEmbedUrl;

  var _unescape = __webpack_require__(292);

  var _unescape2 = babelHelpers.interopRequireDefault(_unescape);

  var iframeSrcRegex = /<iframe.*?src="(.*?)"/;

  function getEmbedUrl(embed) {
    var match = iframeSrcRegex.exec(embed);

    if (match) {
      return (0, _unescape2.default)(match[1]);
    }

    return undefined;
  }
  /***/

},
/* 292 */

/***/
function (module, exports) {
  module.exports = require("lodash/unescape");
  /***/
},
/* 293 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.missedClick = missedClick;
  exports.click = click;

  var _actionTypes = __webpack_require__(3);

  function missedClick(position) {
    return {
      type: _actionTypes.MISSED_CLICK,
      position: position
    };
  }

  function click(position) {
    return {
      type: _actionTypes.CLICK,
      // TODO add metadata for different types of click (change screen, show
      // overlay etc.) ?
      position: position
    };
  }
  /***/

},
/* 294 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setIsUserAuthenticated = setIsUserAuthenticated;
  exports.setUserRole = setUserRole;
  exports.setUserCompanyId = setUserCompanyId;
  exports.setIsSuperUser = setIsSuperUser;
  exports.setIsUserInHandoffTestGroup = setIsUserInHandoffTestGroup;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function setIsUserAuthenticated(isAuthenticated) {
    return {
      type: actionTypes.SET_USER_PROP,
      key: 'isAuthenticated',
      value: isAuthenticated
    };
  }

  function setUserRole(role) {
    return {
      type: actionTypes.SET_USER_PROP,
      key: 'role',
      value: role
    };
  }

  function setUserCompanyId(companyId) {
    return {
      type: actionTypes.SET_USER_PROP,
      key: 'companyId',
      value: companyId
    };
  }

  function setIsSuperUser(isSuperUser) {
    return {
      type: actionTypes.SET_USER_PROP,
      key: 'isSuperUser',
      value: isSuperUser
    };
  }

  function setIsUserInHandoffTestGroup(isInHandoffTestGroup) {
    return {
      type: actionTypes.SET_USER_PROP,
      key: 'isInHandoffTestGroup',
      value: isInHandoffTestGroup
    };
  }
  /***/

},
/* 295 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _compose = __webpack_require__(24);

  var _compose2 = babelHelpers.interopRequireDefault(_compose);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _AddToHomeScreen = __webpack_require__(296);

  var _AddToHomeScreen2 = babelHelpers.interopRequireDefault(_AddToHomeScreen);

  var _homeScreen = __webpack_require__(133);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapDispatchToProps(dispatch) {
    return {
      onClose: function onClose() {
        dispatch(actionCreators.setAddToHomeScreenCookie());
      },
      onComponentDidMount: function onComponentDidMount() {
        dispatch(actionCreators.getAddToHomeScreenCookie());
      }
    };
  }

  exports.default = (0, _compose2.default)((0, _reactRedux.connect)(_homeScreen.getAddToHomeScreenProps, mapDispatchToProps), (0, _onlyIf2.default)(function (props) {
    return props.isVisible;
  }))(_AddToHomeScreen2.default);
  /***/
},
/* 296 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.AddToHomeScreenIPhone = AddToHomeScreenIPhone;
  exports.AddToHomeScreenIPad = AddToHomeScreenIPad;
  exports.AddToHomeScreenAndroid = AddToHomeScreenAndroid;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _icons = __webpack_require__(14);

  var _AppIcon = __webpack_require__(297);

  var _AppIcon2 = babelHelpers.interopRequireDefault(_AppIcon);

  var _AddToHomeScreen = __webpack_require__(299);

  var _AddToHomeScreen2 = babelHelpers.interopRequireDefault(_AddToHomeScreen);

  var devices = {
    android: AddToHomeScreenAndroid,
    ipad: AddToHomeScreenIPad,
    iphone: AddToHomeScreenIPhone
  };
  /* eslint-disable react/no-unused-prop-types */

  var AddToHomeScreen = function (_Component) {
    babelHelpers.inherits(AddToHomeScreen, _Component);

    function AddToHomeScreen() {
      babelHelpers.classCallCheck(this, AddToHomeScreen);
      return babelHelpers.possibleConstructorReturn(this, (AddToHomeScreen.__proto__ || Object.getPrototypeOf(AddToHomeScreen)).apply(this, arguments));
    }

    babelHelpers.createClass(AddToHomeScreen, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.props.onComponentDidMount();
      }
    }, {
      key: 'render',
      value: function render() {
        var SubComponent = devices[this.props.device];
        return _react2.default.createElement(SubComponent, this.props);
      }
    }]);
    return AddToHomeScreen;
  }(_react.Component);
  /* eslint-disable react/prop-types */


  AddToHomeScreen.propTypes = {
    device: _propTypes2.default.oneOf(Object.keys(devices)),
    appIconUrl: _propTypes2.default.string.isRequired,
    onClose: _propTypes2.default.func.isRequired,
    onComponentDidMount: _propTypes2.default.func.isRequired
  };
  AddToHomeScreen.defaultProps = {
    onClose: _noop2.default,
    onComponentDidMount: _noop2.default
  };
  exports.default = AddToHomeScreen;

  function AddToHomeScreenIPhone(_ref) {
    var appIconUrl = _ref.appIconUrl,
        onClose = _ref.onClose;
    return _react2.default.createElement(ModalBackground, null, _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.table
    }, _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.cell
    }, _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_AddToHomeScreen2.default.modal)
    }, _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_AddToHomeScreen2.default.modalInner)
    }, _react2.default.createElement(ModalContent, {
      appIconUrl: appIconUrl
    }), _react2.default.createElement(IOSAdd, null)), _react2.default.createElement(IOSClose, {
      onClose: onClose
    })))));
  }

  function AddToHomeScreenIPad(_ref2) {
    var appIconUrl = _ref2.appIconUrl,
        onClose = _ref2.onClose;
    return _react2.default.createElement(ModalBackground, null, _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_AddToHomeScreen2.default.modal, _AddToHomeScreen2.default.modalTablet)
    }, _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_AddToHomeScreen2.default.modalInner)
    }, _react2.default.createElement(IOSAdd, null), _react2.default.createElement(ModalContent, {
      appIconUrl: appIconUrl
    })), _react2.default.createElement(IOSClose, {
      onClose: onClose
    })));
  }

  function AddToHomeScreenAndroid(_ref3) {
    var appIconUrl = _ref3.appIconUrl,
        onClose = _ref3.onClose;
    return _react2.default.createElement(ModalBackground, null, _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.table
    }, _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.cell
    }, _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_AddToHomeScreen2.default.modal)
    }, _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_AddToHomeScreen2.default.modalInner)
    }, _react2.default.createElement(AndroidAdd, null), _react2.default.createElement(ModalContent, {
      appIconUrl: appIconUrl
    }), _react2.default.createElement(AndroidClose, {
      onClose: onClose
    }))))));
  }

  function ModalBackground(_ref4) {
    var children = _ref4.children;
    return _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.modalBackground
    }, children);
  }

  function ModalContent(_ref5) {
    var appIconUrl = _ref5.appIconUrl;
    return _react2.default.createElement('div', null, _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.appIcon
    }, _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.seeAppIcon
    }, _react2.default.createElement(_icons.SeeAppIcon, null)), _react2.default.createElement('div', {
      className: 'marginTop-s'
    }, _react2.default.createElement(_AppIcon2.default, {
      image: appIconUrl,
      radius: 13,
      size: 60
    }))), _react2.default.createElement('h1', {
      className: _AddToHomeScreen2.default.title
    }, 'Install this prototype!'), _react2.default.createElement('p', {
      className: _AddToHomeScreen2.default.content
    }, 'You can install this prototype on your homescreen to make it look and feel like a real app. Give it a spin!'));
  }

  function IOSAdd() {
    return _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.modalHeaderFooter
    }, 'Just tap ', _react2.default.createElement(_icons.ShareIOSIcon, null), ' then \'Add to Home Screen\'');
  }

  function AndroidAdd() {
    return _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.modalHeaderFooter
    }, 'Just tap ', _react2.default.createElement(_icons.SettingsAndroidIcon, null), ' then \'Add to Home Screen\'');
  }

  function AndroidClose(_ref6) {
    var onClose = _ref6.onClose;
    return _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.modalHeaderFooter
    }, _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.closeAndroid,
      onClick: onClose
    }, 'Close'));
  }

  function IOSClose(_ref7) {
    var onClose = _ref7.onClose;
    return _react2.default.createElement('div', {
      className: _AddToHomeScreen2.default.closeIOS,
      onClick: onClose
    });
  }
  /***/

},
/* 297 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = AppIcon;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _AppIcon = __webpack_require__(298);

  var _AppIcon2 = babelHelpers.interopRequireDefault(_AppIcon);

  function AppIcon(_ref) {
    var image = _ref.image,
        size = _ref.size,
        radius = _ref.radius;
    return _react2.default.createElement('div', {
      className: _AppIcon2.default.icon,
      style: {
        backgroundImage: 'url(' + image + ')',
        width: size,
        height: size,
        borderRadius: radius
      }
    });
  }

  AppIcon.propTypes = {
    image: _propTypes2.default.string.isRequired,
    size: _propTypes2.default.number.isRequired,
    radius: _propTypes2.default.number.isRequired
  };
  /***/
},
/* 298 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "icon": "AppIcon__icon___1-zOi backgroundPosition-centerCenter backgroundRepeat-noRepeat backgroundSize-cover boxShadow-close display-inlineBlock"
  };
  /***/
},
/* 299 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "modalBackground": "AddToHomeScreen__modalBackground___2PvnX c-silver fontWeight-3 height-100 overflow-auto paddingTopBottom-m pinTL position-fixed width-100 zi-800",
    "table": "AddToHomeScreen__table___3uHRc display-table height-100 textAlign-center width-100",
    "cell": "AddToHomeScreen__cell___2Qc5q display-tableCell verticalAlign-middle width-100",
    "modal": "AddToHomeScreen__modal___3LCNa bg-white borderRadius-l boxShadow-raise display-inlineBlock textAlign-center width-80",
    "modalInner": "AddToHomeScreen__modalInner___2rE7G borderRadius-l overflow-hidden",
    "modalTablet": "AddToHomeScreen__modalTablet___8COzt position-fixed",
    "closeIOS": "AddToHomeScreen__closeIOS___2L0ln cursor-pointer modal-icon--s modal-icon--universal modal-icon modal-iconClose--outside modal-iconClose",
    "closeAndroid": "AddToHomeScreen__closeAndroid___2VyOW c-blue fontSize-m",
    "appIcon": "AddToHomeScreen__appIcon___2fjaJ paddingTop-l marginBottom-m position-relative",
    "seeAppIcon": "AddToHomeScreen__seeAppIcon___2f41r fill-silver padding-xxs position-absolute pinTL textAlign-left width-100",
    "title": "AddToHomeScreen__title___3tRHu c-slate fontSize-l fontWeight-4 lineHeight-l marginBottom-xxs",
    "content": "AddToHomeScreen__content___3-9ZY fontSize-m lineHeight-m marginBottom-m paddingBottom-xs paddingLeftRight-s",
    "modalHeaderFooter": "AddToHomeScreen__modalHeaderFooter___13k80 bg-snow fontSize-s padding-s"
  };
  /***/
},
/* 300 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _redux = __webpack_require__(7);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _Sidebar = __webpack_require__(301);

  var _Sidebar2 = babelHelpers.interopRequireDefault(_Sidebar);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _handoff = __webpack_require__(5);

  var _track = __webpack_require__(80);

  var _track2 = babelHelpers.interopRequireDefault(_track);

  function mapStateToProps(state) {
    return {
      commentCount: state.comment.count,
      screenCount: state.screen.screenSequence.length,
      isCommentingEnabled: state.project.config.isCommentingEnabled,
      isNavigationEnabled: state.project.config.isNavigationEnabled,
      isDownloadedProject: state.project.isDownloaded,
      isHandoffEnabled: (0, _handoff.isHandoffEnabled)(state),
      isHandoffOpen: (0, _handoff.isInHandoffMode)(state),
      isHandoffButtonVisible: (0, _handoff.isHandoffButtonVisible)(state),
      screenHasHandoffData: (0, _handoff.hasHandoffData)(state),
      initialHandoffZoom: (0, _handoff.isHandoffEnabled)(state) && (0, _handoff.getInitialZoom)(state)
    };
  }

  function mergeProps(stateProps, _ref, ownProps) {
    var dispatch = _ref.dispatch;
    var props = {
      showPrevious: function showPrevious() {
        dispatch(actionCreators.showPrevious());
      },
      showNext: function showNext() {
        dispatch(actionCreators.showNext());
      },
      showHome: function showHome() {
        dispatch(actionCreators.showHome());
      },
      showGrid: function showGrid() {
        dispatch(actionCreators.showGrid());
      },
      showHandoff: function showHandoff() {
        (0, _track2.default)('opened-handoff');

        if (stateProps.isHandoffEnabled) {
          dispatch(actionCreators.showHandoff());
        }
      }
    };
    return babelHelpers.extends({}, ownProps, stateProps, props);
  }

  var IsNavigationEnabled = function IsNavigationEnabled(props) {
    return props.isNavigationEnabled;
  };

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, null, mergeProps), (0, _onlyIf2.default)(IsNavigationEnabled))(_Sidebar2.default);
  /***/
},
/* 301 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Sidebar;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _grid = __webpack_require__(302);

  var _Comments = __webpack_require__(303);

  var _Comments2 = babelHelpers.interopRequireDefault(_Comments);

  var _ScreenInfo = __webpack_require__(312);

  var _ScreenInfo2 = babelHelpers.interopRequireDefault(_ScreenInfo);

  var _SidebarHandoffButton = __webpack_require__(315);

  var _SidebarHandoffButton2 = babelHelpers.interopRequireDefault(_SidebarHandoffButton);

  var _SidebarNavigation = __webpack_require__(319);

  var _SidebarNavigation2 = babelHelpers.interopRequireDefault(_SidebarNavigation);

  var _SidebarGrid = __webpack_require__(321);

  var _SidebarGrid2 = babelHelpers.interopRequireDefault(_SidebarGrid);

  var _Sidebar = __webpack_require__(324);

  var _Sidebar2 = babelHelpers.interopRequireDefault(_Sidebar);

  function Sidebar(_ref) {
    var isDownloadedProject = _ref.isDownloadedProject,
        isCommentingEnabled = _ref.isCommentingEnabled,
        screenCount = _ref.screenCount,
        showNext = _ref.showNext,
        showPrevious = _ref.showPrevious,
        showGrid = _ref.showGrid,
        isHandoffOpen = _ref.isHandoffOpen,
        showHandoff = _ref.showHandoff,
        isHandoffEnabled = _ref.isHandoffEnabled,
        isHandoffButtonVisible = _ref.isHandoffButtonVisible;
    var showNavigationButtons = screenCount > 1;
    return _react2.default.createElement('div', null, !isHandoffOpen && _react2.default.createElement('div', {
      className: _Sidebar2.default.sidebar
    }, _react2.default.createElement(_grid.InlineGrid, {
      size: 'xs'
    }, _react2.default.createElement(_SidebarGrid2.default, {
      onClick: showGrid
    }), isHandoffButtonVisible && _react2.default.createElement(_SidebarHandoffButton2.default, {
      isDisabled: !isHandoffEnabled,
      isEnabled: isHandoffButtonVisible && isHandoffEnabled,
      onClick: showHandoff
    }), !isDownloadedProject && isCommentingEnabled ? _react2.default.createElement(_Comments2.default, null) : null, _react2.default.createElement(_ScreenInfo2.default, null))), showNavigationButtons && _react2.default.createElement(_SidebarNavigation2.default, {
      isHandoffOpen: isHandoffOpen,
      showNext: showNext,
      showPrevious: showPrevious
    }));
  }

  Sidebar.propTypes = {
    isDownloadedProject: _propTypes2.default.bool,
    isCommentingEnabled: _propTypes2.default.bool,
    screenCount: _propTypes2.default.number.isRequired,
    showNext: _propTypes2.default.func.isRequired,
    showPrevious: _propTypes2.default.func.isRequired,
    showGrid: _propTypes2.default.func.isRequired,
    isHandoffOpen: _propTypes2.default.bool,
    showHandoff: _propTypes2.default.func.isRequired,
    isHandoffEnabled: _propTypes2.default.bool.isRequired,
    isHandoffButtonVisible: _propTypes2.default.bool.isRequired
  };
  Sidebar.defaultProps = {
    showNext: _noop2.default,
    showPrevious: _noop2.default,
    showGrid: _noop2.default,
    showHandoff: _noop2.default
  };
  /***/
},
/* 302 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/marvel-ui/grid");
  /***/
},
/* 303 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _Comments = __webpack_require__(304);

  var _Comments2 = babelHelpers.interopRequireDefault(_Comments);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _project = __webpack_require__(11);

  function mapStateToProps(state) {
    return {
      commentCount: state.comment.count,
      notification: state.comment.notification,
      isCommentingEnabled: (0, _project.getIsCommentingEnabled)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      onNotificationClick: function onNotificationClick() {
        dispatch(actionCreators.hideCommentNotification());
        dispatch(actionCreators.showComments());
        dispatch(actionCreators.setLeaveCommentPopoverCookie());
      },
      onCommentButtonClick: function onCommentButtonClick() {
        dispatch(actionCreators.hideCommentNotification());
        dispatch(actionCreators.showComments());
        dispatch(actionCreators.setLeaveCommentPopoverCookie());
      }
    };
  }

  var IsCommentingEnabled = function IsCommentingEnabled(props) {
    return props.isCommentingEnabled;
  };

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _onlyIf2.default)(IsCommentingEnabled))(_Comments2.default);
  /***/
},
/* 304 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Comments;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _toolbar = __webpack_require__(88);

  var _icons = __webpack_require__(14);

  var _LeaveComment = __webpack_require__(305);

  var _LeaveComment2 = babelHelpers.interopRequireDefault(_LeaveComment);

  var _CommentNotification = __webpack_require__(308);

  var _CommentNotification2 = babelHelpers.interopRequireDefault(_CommentNotification);

  var _Comments = __webpack_require__(311);

  var _Comments2 = babelHelpers.interopRequireDefault(_Comments);

  function Comments(_ref) {
    var commentCount = _ref.commentCount,
        notification = _ref.notification,
        onNotificationClick = _ref.onNotificationClick,
        onCommentButtonClick = _ref.onCommentButtonClick;
    var comments = commentCount === 1 ? 'comment' : 'comments';
    var count = commentCount === 0 ? 'No' : commentCount;
    var toolbarButtonProps = {
      icon: !notification && _react2.default.createElement(_icons.CommentIcon, null),
      onClick: onCommentButtonClick
    };
    var commentsButtonStyle = notification && {
      marginLeft: '50px'
    };
    return _react2.default.createElement(_toolbar.ToolbarButton, toolbarButtonProps, _react2.default.createElement('div', {
      className: 'comments-count',
      style: commentsButtonStyle
    }, count + ' ' + comments), _react2.default.createElement(_LeaveComment2.default, null), notification && _react2.default.createElement('div', {
      className: _Comments2.default.notificationWrap
    }, _react2.default.createElement(_CommentNotification2.default, babelHelpers.extends({}, notification, {
      onClick: onNotificationClick
    }))));
  }

  Comments.propTypes = {
    onCommentButtonClick: _propTypes2.default.func.isRequired,
    onNotificationClick: _propTypes2.default.func.isRequired,
    commentCount: _propTypes2.default.number.isRequired,
    notification: _propTypes2.default.object // TODO: validation

  };
  Comments.defaultProps = {
    commentCount: 0,
    onNotificationClick: _noop2.default,
    onCommentButtonClick: _noop2.default
  };
  /***/
},
/* 305 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _assign = __webpack_require__(21);

  var _assign2 = babelHelpers.interopRequireDefault(_assign);

  var _redux = __webpack_require__(7);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _popover = __webpack_require__(77);

  var _popover2 = babelHelpers.interopRequireDefault(_popover);

  var _LeaveComment = __webpack_require__(306);

  var _LeaveComment2 = babelHelpers.interopRequireDefault(_LeaveComment);

  function mapStateToProps(state) {
    return {
      isVisible: state.comment.leaveCommentPopoverVisible
    };
  }

  function mergeProps(stateProps, _ref, ownProps) {
    var dispatch = _ref.dispatch;
    var newProps = {
      isPopoverOpen: stateProps.isVisible && ownProps.isPopoverOpen,
      togglePopover: function togglePopover() {
        ownProps.togglePopover();
        dispatch(actionCreators.setLeaveCommentPopoverCookie());
      },
      onComponentDidMount: function onComponentDidMount() {
        dispatch(actionCreators.getLeaveCommentPopoverCookie());
      },
      onLeaveCommentClick: function onLeaveCommentClick() {
        dispatch(actionCreators.showComments());
        dispatch(actionCreators.setLeaveCommentPopoverCookie());
      }
    };
    return (0, _assign2.default)({}, ownProps, stateProps, newProps);
  }

  exports.default = (0, _redux.compose)((0, _popover2.default)(true), (0, _reactRedux.connect)(mapStateToProps, null, mergeProps))(_LeaveComment2.default);
  /***/
},
/* 306 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _popover = __webpack_require__(43);

  var _popover2 = babelHelpers.interopRequireDefault(_popover);

  var _Close = __webpack_require__(123);

  var _Close2 = babelHelpers.interopRequireDefault(_Close);

  var _LeaveComment = __webpack_require__(307);

  var _LeaveComment2 = babelHelpers.interopRequireDefault(_LeaveComment);

  var LeaveComment = function (_Component) {
    babelHelpers.inherits(LeaveComment, _Component);

    function LeaveComment() {
      var _ref;

      var _temp, _this, _ret;

      babelHelpers.classCallCheck(this, LeaveComment);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = LeaveComment.__proto__ || Object.getPrototypeOf(LeaveComment)).call.apply(_ref, [this].concat(args))), _this), _this._onClose = function (e) {
        e.stopPropagation();

        _this.props.togglePopover();
      }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
    }

    babelHelpers.createClass(LeaveComment, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.props.onComponentDidMount();
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            isPopoverOpen = _props.isPopoverOpen,
            onLeaveCommentClick = _props.onLeaveCommentClick;
        return _react2.default.createElement(_popover2.default, {
          isActive: isPopoverOpen,
          position: 'top',
          size: 'small',
          width: 133
        }, _react2.default.createElement('div', {
          className: _LeaveComment2.default.popoverInner,
          onClick: onLeaveCommentClick
        }, 'Leave a comment on this design!'), _react2.default.createElement(_Close2.default, {
          style: 'light',
          onClick: this._onClose
        }));
      }
    }]);
    return LeaveComment;
  }(_react.Component);

  LeaveComment.propTypes = {
    isPopoverOpen: _propTypes2.default.bool.isRequired,
    togglePopover: _propTypes2.default.func.isRequired,
    onComponentDidMount: _propTypes2.default.func.isRequired,
    onLeaveCommentClick: _propTypes2.default.func.isRequired
  };
  exports.default = LeaveComment;
  /***/
},
/* 307 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "popoverInner": "LeaveComment__popoverInner___1Un2A padding-xs textAlign-center lineHeight-s c-silver"
  };
  /***/
},
/* 308 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = CommentNotification;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Avatar = __webpack_require__(309);

  var _Avatar2 = babelHelpers.interopRequireDefault(_Avatar);

  var _CommentNotification = __webpack_require__(310);

  var _CommentNotification2 = babelHelpers.interopRequireDefault(_CommentNotification);
  /* eslint-disable react/no-danger */


  function CommentNotification(_ref) {
    var commentCount = _ref.commentCount,
        user = _ref.user,
        textMarkup = _ref.textMarkup,
        onClick = _ref.onClick;
    return _react2.default.createElement('div', {
      className: 'cursor-pointer',
      onClick: onClick
    }, _react2.default.createElement('div', {
      className: _CommentNotification2.default.avatarWrap
    }, _react2.default.createElement(_Avatar2.default, babelHelpers.extends({}, user, {
      size: 'small',
      noBorder: true
    })), _react2.default.createElement('div', {
      className: _CommentNotification2.default.commentCount
    }, commentCount + ' new')), _react2.default.createElement('div', {
      className: _CommentNotification2.default.popover
    }, _react2.default.createElement('div', {
      className: _CommentNotification2.default.popoverCopy,
      dangerouslySetInnerHTML: {
        __html: '<span class="c-slate">' + user.name + '</span>: ' + textMarkup
      }
    })));
  }

  CommentNotification.propTypes = {
    user: _propTypes2.default.object.isRequired,
    commentCount: _propTypes2.default.number.isRequired,
    textMarkup: _propTypes2.default.node.isRequired,
    onClick: _propTypes2.default.func.isRequired
  };
  /***/
},
/* 309 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Avatar;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var sizeMap = {
    extraSmall: 'avatar--xs',
    small: 'avatar--s',
    medium: 'avatar--m',
    large: 'avatar--l',
    extraLarge: 'avatar--xl'
  };

  function Avatar(_ref) {
    var initials = _ref.initials,
        size = _ref.size,
        picture = _ref.picture,
        backgroundColor = _ref.backgroundColor,
        foregroundColor = _ref.foregroundColor,
        noBorder = _ref.noBorder;
    var avatarImageStyle = {
      backgroundImage: 'url(' + picture + ')'
    };

    if (noBorder) {
      avatarImageStyle.border = 'none';
    }

    return _react2.default.createElement('div', {
      className: (0, _classnames2.default)('avatar', sizeMap[size]),
      style: {
        backgroundColor: backgroundColor
      }
    }, picture && _react2.default.createElement('div', {
      className: 'avatar-img',
      style: avatarImageStyle
    }), _react2.default.createElement('div', {
      className: 'avatar-initials',
      style: {
        foregroundColor: foregroundColor
      }
    }, initials));
  }

  Avatar.propTypes = {
    initials: _propTypes2.default.string.isRequired,
    size: _propTypes2.default.oneOf(Object.keys(sizeMap)).isRequired,
    backgroundColor: _propTypes2.default.string.isRequired,
    foregroundColor: _propTypes2.default.string.isRequired,
    picture: _propTypes2.default.string,
    noBorder: _propTypes2.default.bool
  };
  Avatar.defaultProps = {
    foregroundColor: '#fff',
    size: 'medium'
  };
  /***/
},
/* 310 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "popover": "CommentNotification__popover___2NnmO bg-white--translucent boxShadow-outside--black--pellucid has-animation has-caret is-visible popover--leftAligned popover--s popover--top popover",
    "popoverCopy": "CommentNotification__popoverCopy___Aq9zh c-silver display-inlineBlock fontSize-s lineHeight-m paddingLeftRight-s paddingTopBottom-xs verticalAlign-top",
    "avatarWrap": "CommentNotification__avatarWrap___nWNqe paddingLeft-xs position-relative",
    "commentCount": "CommentNotification__commentCount___3xx4Q bg-negative borderRadius-s c-white fontSize-xxs fontWeight-4 marginLeft-l pinTL position-absolute textTransform-uppercase zi-100"
  };
  /***/
},
/* 311 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "notificationWrap": "Comments__notificationWrap___lVviR position-absolute pinAll"
  };
  /***/
},
/* 312 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _ScreenInfo = __webpack_require__(313);

  var _ScreenInfo2 = babelHelpers.interopRequireDefault(_ScreenInfo);

  var _screen = __webpack_require__(9);

  function mapStateToProps(state) {
    if (state.project.isLoading) {
      return {
        isVisible: false
      };
    }

    var currentScreen = (0, _screen.getCurrentScreen)(state);
    return {
      screenName: currentScreen.name,
      screenNumber: currentScreen.order,
      screenCount: state.screen.screenSequence.length,
      isVisible: state.screen.showScreenInfo
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, null, null, {
    pure: true
  })(_ScreenInfo2.default);
  /***/
},
/* 313 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ScreenInfo;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _velocityReact = __webpack_require__(23);

  var _ScreenInfo = __webpack_require__(314);

  var _ScreenInfo2 = babelHelpers.interopRequireDefault(_ScreenInfo);

  var enterAnimation = {
    animation: {
      opacity: 1
    },
    duration: 300
  };
  var leaveAnimation = {
    animation: {
      opacity: 0
    },
    duration: 300
  };

  function ScreenInfo(_ref) {
    var screenName = _ref.screenName,
        screenNumber = _ref.screenNumber,
        screenCount = _ref.screenCount,
        isVisible = _ref.isVisible;
    return _react2.default.createElement(_velocityReact.VelocityTransitionGroup, {
      enter: enterAnimation,
      leave: leaveAnimation
    }, isVisible && _react2.default.createElement('div', {
      className: _ScreenInfo2.default.screenInfo
    }, screenNumber, ' / ', screenCount, " \u2014 ", screenName));
  }

  ScreenInfo.propTypes = {
    screenName: _propTypes2.default.string,
    screenNumber: _propTypes2.default.number,
    screenCount: _propTypes2.default.number,
    isVisible: _propTypes2.default.bool.isRequired
  };
  /***/
},
/* 314 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "screenInfo": "ScreenInfo__screenInfo___1sdZd bg-black--translucent borderRadius-m boxShadow-outside--black--pellucid c-white fontSize-s padding-xs verticalAlign-middle whiteSpace-nowrap"
  };
  /***/
},
/* 315 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = SidebarHandoff;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _popover = __webpack_require__(43);

  var _popover2 = babelHelpers.interopRequireDefault(_popover);

  var _toolbar = __webpack_require__(88);

  var _icons = __webpack_require__(14);

  var _HandoffPopoverContent = __webpack_require__(316);

  var _HandoffPopoverContent2 = babelHelpers.interopRequireDefault(_HandoffPopoverContent);

  function SidebarHandoff(_ref) {
    var isDisabled = _ref.isDisabled,
        isEnabled = _ref.isEnabled,
        onClick = _ref.onClick;
    var toolbarProps = {
      icon: _react2.default.createElement(_icons.HandoffIcon, null),
      isDisabled: isDisabled,
      isOpaque: isDisabled,
      onClick: onClick
    };
    var popoverProps = {
      align: 'left',
      showOnHover: true,
      size: 'small',
      width: 300
    };

    if (isEnabled) {
      return _react2.default.createElement(_toolbar.ToolbarButton, toolbarProps, 'Handoff');
    }

    return _react2.default.createElement(_popover2.default, popoverProps, _react2.default.createElement(_popover2.default.Trigger, null, _react2.default.createElement(_toolbar.ToolbarButton, toolbarProps, 'Handoff')), _react2.default.createElement(_popover2.default.Content, null, _react2.default.createElement(_HandoffPopoverContent2.default, null)));
  }

  SidebarHandoff.propTypes = {
    isDisabled: _propTypes2.default.bool.isRequired,
    isEnabled: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
  };
  /***/
},
/* 316 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _handoff = __webpack_require__(5);

  var _HandoffPopoverContent = __webpack_require__(317);

  var _HandoffPopoverContent2 = babelHelpers.interopRequireDefault(_HandoffPopoverContent);

  function mapStateToProps(state) {
    return {
      projectPlan: state.project.config.plan,
      isUserAuthenticated: state.user.isAuthenticated,
      hasHandoffData: (0, _handoff.hasHandoffData)(state)
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_HandoffPopoverContent2.default);
  /***/
},
/* 317 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = HandoffPopoverContent;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _plans = __webpack_require__(131);

  var plans = babelHelpers.interopRequireWildcard(_plans);

  var _marvelURL = __webpack_require__(38);

  var marvelURL = babelHelpers.interopRequireWildcard(_marvelURL);

  var _HandoffPopoverContent = __webpack_require__(318);

  var _HandoffPopoverContent2 = babelHelpers.interopRequireDefault(_HandoffPopoverContent);

  function HandoffPopoverContent(props) {
    var _getPopoverProps = getPopoverProps(props),
        headline = _getPopoverProps.headline,
        body = _getPopoverProps.body,
        button = _getPopoverProps.button,
        href = _getPopoverProps.href;

    return _react2.default.createElement('div', null, _react2.default.createElement('div', {
      className: _HandoffPopoverContent2.default.popoverHeader
    }, _react2.default.createElement('div', {
      className: _HandoffPopoverContent2.default.popoverHeaderGraphic
    })), _react2.default.createElement('div', {
      className: _HandoffPopoverContent2.default.popoverInner
    }, _react2.default.createElement('div', {
      className: _HandoffPopoverContent2.default.headline
    }, headline), _react2.default.createElement('div', {
      className: _HandoffPopoverContent2.default.body
    }, body), _react2.default.createElement('a', {
      className: _HandoffPopoverContent2.default.button,
      target: '_blank',
      rel: 'noopener noreferrer',
      href: href
    }, button)));
  }
  /* eslint-disable react/no-unused-prop-types */


  HandoffPopoverContent.propTypes = {
    projectPlan: _propTypes2.default.string,
    hasHandoffData: _propTypes2.default.bool.isRequired
  };

  function getPopoverProps(_ref) {
    var projectPlan = _ref.projectPlan,
        hasHandoffData = _ref.hasHandoffData;

    if (projectPlan === plans.FREE) {
      return {
        headline: 'Code, specs and assets have not been generated',
        body: 'Find out how to use Handoff and save hours for your developers',
        button: 'How to use Handoff',
        href: marvelURL.DOWNLOAD_ASSETS_USING_HANDOFF
      };
    }

    if (projectPlan === plans.COMPANY && !hasHandoffData) {
      return {
        headline: 'Handoff unavaiable for this screen',
        body: 'Learn how to  turn designs into code, specs and assets for developers',
        button: 'How to use Handoff',
        href: marvelURL.HANDOFF
      };
    }

    return {};
  }
  /***/

},
/* 318 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "popoverInner": "HandoffPopoverContent__popoverInner___19uVf padding-m c-silver lineHeight-s textAlign-center fontSize-s cursor-default",
    "popoverHeader": "HandoffPopoverContent__popoverHeader___2UFce bg-blue--l borderRadiusTop-m width-100 position-relative",
    "popoverHeaderGraphic": "HandoffPopoverContent__popoverHeaderGraphic___1Vd7X position-absolute pinCenter",
    "headline": "HandoffPopoverContent__headline___BijSm c-slate fontSize-l",
    "body": "HandoffPopoverContent__body___KyXAn c-silver fontWeight-3 marginBottom-s marginTop-xs",
    "button": "HandoffPopoverContent__button___28qtX button button--s button--flat bg-blue"
  };
  /***/
},
/* 319 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = SidebarNavigation;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _icons = __webpack_require__(14);

  var _SidebarNavigation = __webpack_require__(320);

  var _SidebarNavigation2 = babelHelpers.interopRequireDefault(_SidebarNavigation);

  function SidebarNavigation(_ref) {
    var _cx;

    var isHandoffOpen = _ref.isHandoffOpen,
        showNext = _ref.showNext,
        showPrevious = _ref.showPrevious;
    var rightButtonClasses = (0, _classnames2.default)(_SidebarNavigation2.default.wrapper, (_cx = {}, babelHelpers.defineProperty(_cx, _SidebarNavigation2.default.wrapperRight, !isHandoffOpen), babelHelpers.defineProperty(_cx, _SidebarNavigation2.default.wrapperRightHandoffOpen, isHandoffOpen), _cx));
    return _react2.default.createElement('div', null, _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_SidebarNavigation2.default.wrapper, _SidebarNavigation2.default.wrapperLeft)
    }, _react2.default.createElement('div', {
      className: _SidebarNavigation2.default.previousButton,
      onClick: showPrevious
    }, _react2.default.createElement(_icons.PrevIcon, null))), _react2.default.createElement('div', {
      className: rightButtonClasses
    }, _react2.default.createElement('div', {
      className: _SidebarNavigation2.default.nextButton,
      onClick: showNext
    }, _react2.default.createElement(_icons.NextIcon, null))));
  }

  SidebarNavigation.propTypes = {
    isHandoffOpen: _propTypes2.default.bool,
    showNext: _propTypes2.default.func.isRequired,
    showPrevious: _propTypes2.default.func.isRequired
  };
  SidebarNavigation.propTypes = {
    isHandoffOpen: _propTypes2.default.bool
  };
  /***/
},
/* 320 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "navButton": "SidebarNavigation__navButton___k3ckH cursor-pointer transitionProperty-all transitionDuration-l transitionTimingFunction-cb--scaleOut position-absolute display-inlineBlock",
    "previousButton": "SidebarNavigation__previousButton___258Lz SidebarNavigation__navButton___k3ckH cursor-pointer transitionProperty-all transitionDuration-l transitionTimingFunction-cb--scaleOut position-absolute display-inlineBlock previous-button",
    "nextButton": "SidebarNavigation__nextButton___2ZjgQ SidebarNavigation__navButton___k3ckH cursor-pointer transitionProperty-all transitionDuration-l transitionTimingFunction-cb--scaleOut position-absolute display-inlineBlock next-button",
    "wrapper": "SidebarNavigation__wrapper___2LSXh position-fixed overflow-hidden verticallyCenter-absolute",
    "wrapperLeft": "SidebarNavigation__wrapperLeft___2khzV",
    "wrapperRight": "SidebarNavigation__wrapperRight___1T8Y7",
    "wrapperRightHandoffOpen": "SidebarNavigation__wrapperRightHandoffOpen___3UBMk"
  };
  /***/
},
/* 321 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = SidebarGrid;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _popover = __webpack_require__(43);

  var _popover2 = babelHelpers.interopRequireDefault(_popover);

  var _toolbar = __webpack_require__(88);

  var _icons = __webpack_require__(14);

  var _ShortcutText = __webpack_require__(322);

  var _ShortcutText2 = babelHelpers.interopRequireDefault(_ShortcutText);

  function SidebarGrid(_ref) {
    var onClick = _ref.onClick;
    var popoverProps = {
      align: 'left',
      maxWidth: 300,
      showOnHover: true,
      size: 'small',
      style: 'dark'
    };
    return _react2.default.createElement(_popover2.default, popoverProps, _react2.default.createElement(_popover2.default.Trigger, null, _react2.default.createElement(_toolbar.ToolbarButton, {
      icon: _react2.default.createElement(_icons.GridIcon, null),
      onClick: onClick
    })), _react2.default.createElement(_popover2.default.Content, null, _react2.default.createElement(_ShortcutText2.default, {
      text: 'Show Grid View',
      shortcut: 'G'
    })));
  }

  SidebarGrid.propTypes = {
    onClick: _propTypes2.default.func.isRequired
  };
  /***/
},
/* 322 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ShortcutText;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _ShortcutText = __webpack_require__(323);

  var _ShortcutText2 = babelHelpers.interopRequireDefault(_ShortcutText);

  function ShortcutText(_ref) {
    var shortcut = _ref.shortcut,
        text = _ref.text;
    return _react2.default.createElement('div', {
      className: _ShortcutText2.default.wrap
    }, text, _react2.default.createElement('div', {
      className: _ShortcutText2.default.key
    }, shortcut));
  }

  ShortcutText.propTypes = {
    shortcut: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired
  };
  /***/
},
/* 323 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "wrap": "ShortcutText__wrap___2R_vi fontSize-s padding-xs whiteSpace-nowrap",
    "key": "ShortcutText__key___1hh35 c-silver borderRadius-s borderColor-silver borderStyle-solid borderWidth-1 display-inlineBlock fontSize-xs verticalAlign-top marginLeft-xxs"
  };
  /***/
},
/* 324 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "sidebar": "Sidebar__sidebar___3jZX3 position-fixed userSelect-none zi-300"
  };
  /***/
},
/* 325 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _SidebarHandoff = __webpack_require__(326);

  var _SidebarHandoff2 = babelHelpers.interopRequireDefault(_SidebarHandoff);

  var _actionCreators = __webpack_require__(4);

  var _handoff = __webpack_require__(5);

  function mapStateToProps(state) {
    return {
      isOpen: (0, _handoff.isInHandoffMode)(state),
      selectedElementType: (0, _handoff.getSelectedElementType)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      onClose: function onClose() {
        dispatch((0, _actionCreators.hideHandoff)());
      }
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SidebarHandoff2.default);
  /***/
},
/* 326 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = SidebarHandoff;

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _handoffItems = __webpack_require__(118);

  var handoffItems = babelHelpers.interopRequireWildcard(_handoffItems);

  var _SidebarHandoff = __webpack_require__(134);

  var _SidebarHandoff2 = babelHelpers.interopRequireDefault(_SidebarHandoff);

  var _handoffSidebar = __webpack_require__(89);

  var _ArtboardHandoff = __webpack_require__(327);

  var _ArtboardHandoff2 = babelHelpers.interopRequireDefault(_ArtboardHandoff);

  var _ElementHandoff = __webpack_require__(369);

  var _ElementHandoff2 = babelHelpers.interopRequireDefault(_ElementHandoff);

  function SidebarHandoff(_ref) {
    var isOpen = _ref.isOpen,
        onClose = _ref.onClose,
        selectedElementType = _ref.selectedElementType;
    var className = (0, _classnames2.default)(_SidebarHandoff2.default.handoffSidebar, babelHelpers.defineProperty({}, _SidebarHandoff2.default.handoffMode, isOpen));
    var iconClass = selectedElementType === 'default' ? _SidebarHandoff2.default.iconClose : _SidebarHandoff2.default.iconBack;
    return _react2.default.createElement('div', {
      className: className,
      style: {
        width: _handoffSidebar.WIDTH
      }
    }, _react2.default.createElement('div', {
      className: iconClass,
      onClick: onClose
    }), isOpen && (selectedElementType === 'default' ? _react2.default.createElement(_ArtboardHandoff2.default, null) : _react2.default.createElement(_ElementHandoff2.default, {
      selectedElementType: selectedElementType
    })));
  }

  SidebarHandoff.propTypes = {
    onClose: _propTypes2.default.func.isRequired,
    isOpen: _propTypes2.default.bool.isRequired,
    selectedElementType: _propTypes2.default.string
  };
  SidebarHandoff.defaultProps = {
    isOpen: false,
    selectedElementType: handoffItems.DEFAULT
  };
  /***/
},
/* 327 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _ArtboardHandoff = __webpack_require__(328);

  var _ArtboardHandoff2 = babelHelpers.interopRequireDefault(_ArtboardHandoff);

  var _handoff = __webpack_require__(5);

  function mapStateToProps(state) {
    return {
      title: (0, _handoff.hasHandoffData)(state) && (0, _handoff.getArtboardTitle)(state),
      isAvaible: (0, _handoff.isHandoffAvaible)(state)
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_ArtboardHandoff2.default);
  /***/
},
/* 328 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Artboard;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _tabs = __webpack_require__(329);

  var _HandoffDefault = __webpack_require__(330);

  var _HandoffDefault2 = babelHelpers.interopRequireDefault(_HandoffDefault);

  var _ScreenAssets = __webpack_require__(360);

  var _ScreenAssets2 = babelHelpers.interopRequireDefault(_ScreenAssets);

  var _SidebarHandoff = __webpack_require__(134);

  var _SidebarHandoff2 = babelHelpers.interopRequireDefault(_SidebarHandoff);

  var _Header = __webpack_require__(152);

  var _Header2 = babelHelpers.interopRequireDefault(_Header);

  var _Panel = __webpack_require__(45);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  function Artboard(_ref) {
    var title = _ref.title,
        isAvaible = _ref.isAvaible;
    return isAvaible ? _react2.default.createElement('div', null, _react2.default.createElement('div', {
      className: _Header2.default.header
    }, _react2.default.createElement('div', {
      className: _Header2.default.subheading
    }, 'Overview'), _react2.default.createElement('h1', {
      className: (0, _classnames2.default)(_Header2.default.heading, _Header2.default.largeHeading)
    }, title)), _react2.default.createElement('div', {
      className: _SidebarHandoff2.default.sidebarSwitcher
    }, _react2.default.createElement(_tabs.Tabs, {
      size: 'extraSmall',
      justified: true
    }, _react2.default.createElement(_tabs.TabLink, {
      to: 'artboard'
    }, _react2.default.createElement('div', {
      className: _Panel2.default.title
    }, 'Artboard')), _react2.default.createElement(_tabs.TabLink, {
      to: 'assets'
    }, _react2.default.createElement('div', {
      className: _Panel2.default.title
    }, 'Assets')), _react2.default.createElement(_tabs.TabPane, {
      'for': 'artboard'
    }, _react2.default.createElement(_HandoffDefault2.default, null)), _react2.default.createElement(_tabs.TabPane, {
      'for': 'assets'
    }, _react2.default.createElement(_ScreenAssets2.default, null))))) : _react2.default.createElement(_HandoffDefault2.default, null);
  }

  Artboard.propTypes = {
    isAvaible: _propTypes2.default.bool,
    title: _propTypes2.default.string.isRequired
  };
  /***/
},
/* 329 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/marvel-ui/tabs");
  /***/
},
/* 330 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _HandoffDefault = __webpack_require__(331);

  var _HandoffDefault2 = babelHelpers.interopRequireDefault(_HandoffDefault);

  var _actionCreators = __webpack_require__(4);

  var _project = __webpack_require__(11);

  var _getCanvasFonts = __webpack_require__(359);

  var _getCanvasFonts2 = babelHelpers.interopRequireDefault(_getCanvasFonts);

  var _handoff = __webpack_require__(5);

  var _userRole = __webpack_require__(78);

  var userRoles = babelHelpers.interopRequireWildcard(_userRole);

  function mapStateToProps(state) {
    var props = void 0;

    if (!(0, _handoff.isHandoffAvaible)(state)) {
      props = {
        screenHasHandoffData: false
      };
    } else if (state.handoff.canvas) {
      props = {
        isWeb: (0, _project.isWeb)(state),
        screenHasHandoffData: true,
        artboard: (0, _handoff.getArtboard)(state),
        fonts: (0, _getCanvasFonts2.default)(state.handoff.flatCanvas)
      };
    } else {
      props = {
        screenHasHandoffData: true
      };
    }

    return babelHelpers.extends({
      handoffState: (0, _handoff.getHandoffState)(state),
      requestStatus: state.handoff.requestStatus,
      isUserOwner: userRoles.isOwner(state.user.role)
    }, props);
  }

  function mapDispatchToProps(dispatch) {
    return {
      onClose: function onClose() {
        dispatch((0, _actionCreators.hideHandoff)());
      }
    };
  }

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_HandoffDefault2.default);
  /***/
},
/* 331 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = HandoffDefault;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _PanelArtboard = __webpack_require__(332);

  var _PanelArtboard2 = babelHelpers.interopRequireDefault(_PanelArtboard);

  var _PanelColours = __webpack_require__(346);

  var _PanelColours2 = babelHelpers.interopRequireDefault(_PanelColours);

  var _PanelFonts = __webpack_require__(349);

  var _PanelFonts2 = babelHelpers.interopRequireDefault(_PanelFonts);

  var _RowSettings = __webpack_require__(352);

  var _RowSettings2 = babelHelpers.interopRequireDefault(_RowSettings);

  var _ColumnSettings = __webpack_require__(354);

  var _ColumnSettings2 = babelHelpers.interopRequireDefault(_ColumnSettings);

  var _HandoffDefault = __webpack_require__(356);

  var _HandoffDefault2 = babelHelpers.interopRequireDefault(_HandoffDefault);

  var _SidebarState = __webpack_require__(146);

  var _SidebarState2 = babelHelpers.interopRequireDefault(_SidebarState);

  var _requestStatus = __webpack_require__(31);

  var _handoffState = __webpack_require__(120);

  var handoffState = babelHelpers.interopRequireWildcard(_handoffState);

  function HandoffDefault(_ref) {
    var requestStatus = _ref.requestStatus,
        artboard = _ref.artboard,
        fonts = _ref.fonts,
        state = _ref.handoffState,
        isUserOwner = _ref.isUserOwner;
    var content = void 0;

    if (state !== handoffState.AVAILABLE) {
      var _getSidebarProps = getSidebarProps({
        state: state,
        isUserOwner: isUserOwner
      }),
          children = _getSidebarProps.children,
          sidebarProps = babelHelpers.objectWithoutProperties(_getSidebarProps, ['children']);

      content = _react2.default.createElement(_SidebarState2.default, sidebarProps, children);
    } else if (requestStatus === _requestStatus.PENDING) {
      content = _react2.default.createElement('div', {
        className: _HandoffDefault2.default.loading
      });
    } else if (requestStatus === _requestStatus.SUCCESS) {
      content = _react2.default.createElement('div', null, _react2.default.createElement(_PanelArtboard2.default, babelHelpers.extends({
        key: 'artboard'
      }, artboard)), _react2.default.createElement(_PanelColours2.default, null), fonts.length > 0 && _react2.default.createElement(_PanelFonts2.default, {
        key: 'fonts',
        fonts: fonts
      }), _react2.default.createElement(_ColumnSettings2.default, null), _react2.default.createElement(_RowSettings2.default, null));
    }

    return _react2.default.createElement('div', {
      className: _HandoffDefault2.default.background
    }, content);
  }

  function getSidebarProps(_ref2) {
    var state = _ref2.state;

    switch (state) {
      case handoffState.UNAVAILABLE:
        return {
          heading: 'Handoff access unavailable',
          message: 'Handoff is only available to users on the company account. Request access from the owner to get started.',
          image: 'handoff'
        };

      case handoffState.UNAUTHORIZED:
        return {
          heading: 'Sign in to view Handoff',
          message: 'Access code, specs and assets when you sign in to your company account',
          children: _react2.default.createElement(_SidebarState.SignInButton, null),
          image: 'handoff'
        };

      case handoffState.NO_HANDOFF_DATA:
        return {
          heading: 'Code, specs and assets have not been generated',
          message: 'Find out how to use Handoff and save hours for your developers',
          image: 'handoff',
          children: _react2.default.createElement(_SidebarState.FindOutMoreButtton, null)
        };

      case handoffState.REQUEST_ERROR:
        return {
          heading: 'Oops, something went wrong',
          message: 'Please try uploading your screen again or contact support',
          image: 'error',
          children: _react2.default.createElement(_SidebarState.ContactButton, null)
        };

      default:
        return {};
    }
  }

  HandoffDefault.propTypes = {
    artboard: _propTypes2.default.object,
    fonts: _propTypes2.default.array,
    isUserOwner: _propTypes2.default.bool.isRequired,
    requestStatus: _propTypes2.default.string.isRequired,
    handoffState: _propTypes2.default.string.isRequired
  };
  HandoffDefault.defaultProps = {
    isOpen: false
  };
  /***/
},
/* 332 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PanelArtboard;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _PanelGrid = __webpack_require__(46);

  var _PanelGrid2 = babelHelpers.interopRequireDefault(_PanelGrid);

  var _PanelProperty = __webpack_require__(136);

  var _PanelProperty2 = babelHelpers.interopRequireDefault(_PanelProperty);

  var _Measurement = __webpack_require__(39);

  var _Measurement2 = babelHelpers.interopRequireDefault(_Measurement);

  var _Fills = __webpack_require__(138);

  var _Fills2 = babelHelpers.interopRequireDefault(_Fills);

  function PanelArtboard(_ref) {
    var width = _ref.width,
        height = _ref.height,
        fills = _ref.fills;
    return _react2.default.createElement('div', null, _react2.default.createElement(_Panel2.default, null, _react2.default.createElement(_PanelGrid2.default, {
      columns: 2
    }, _react2.default.createElement(_PanelProperty2.default, {
      label: 'Width'
    }, _react2.default.createElement(_Measurement2.default, {
      value: width
    })), _react2.default.createElement(_PanelProperty2.default, {
      label: 'Height'
    }, _react2.default.createElement(_Measurement2.default, {
      value: height
    })))), _react2.default.createElement(_Fills2.default, {
      fills: fills
    }));
  }

  PanelArtboard.propTypes = {
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    fills: _propTypes2.default.array.isRequired
  };
  /***/
},
/* 333 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _unitMap;

  exports.default = Measurement;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _round = __webpack_require__(90);

  var _round2 = babelHelpers.interopRequireDefault(_round);

  var _measurementUnits = __webpack_require__(137);

  var measurementUnits = babelHelpers.interopRequireWildcard(_measurementUnits);

  var _platform = __webpack_require__(69);

  var platforms = babelHelpers.interopRequireWildcard(_platform);
  var unitMap = (_unitMap = {}, babelHelpers.defineProperty(_unitMap, platforms.IOS, measurementUnits.POINT), babelHelpers.defineProperty(_unitMap, platforms.WATCHOS, measurementUnits.POINT), babelHelpers.defineProperty(_unitMap, platforms.ANDROID, measurementUnits.DENSITY_INDEPENDENT_PIXEL), babelHelpers.defineProperty(_unitMap, platforms.WEB, measurementUnits.PIXEL), _unitMap);

  function Measurement(_ref) {
    var value = _ref.value,
        platform = _ref.platform,
        _ref$includeUnitIfZer = _ref.includeUnitIfZero,
        includeUnitIfZero = _ref$includeUnitIfZer === undefined ? false : _ref$includeUnitIfZer,
        isText = _ref.isText;
    var unit = unitMap[platform];

    if (platform === platforms.ANDROID && isText) {
      unit = measurementUnits.SCALE_INDEPENDENT_PIXEL;
    }

    var displayUnit = unit;

    if (value === 0 && !includeUnitIfZero) {
      displayUnit = '';
    }

    return _react2.default.createElement('span', null, (0, _round2.default)(value, 2), displayUnit);
  }

  Measurement.propTypes = {
    value: _propTypes2.default.number,
    platform: _propTypes2.default.string.isRequired,
    includeUnitIfZero: _propTypes2.default.bool,
    isText: _propTypes2.default.bool
  };
  /***/
},
/* 334 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/marvel-ui/tooltip");
  /***/
},
/* 335 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "swatchWrapper": "Swatch__swatchWrapper___Pctgo display-inlineBlock verticalAlign-top position-relative",
    "swatch": "Swatch__swatch___dRDf6 display-inlineBlock verticalAlign-top position-relative overflow-hidden zi-100",
    "top": "Swatch__top___J2-1x borderRadiusTop-m",
    "bottom": "Swatch__bottom___3XHZh borderRadiusBottom-m",
    "alone": "Swatch__alone___FVXdv borderRadius-m",
    "swatchAnimation": "Swatch__swatchAnimation___1n1Rk position-absolute bg-smoke borderRadius-m",
    "isAnimating": "Swatch__isAnimating___1VED8",
    "pulse": "Swatch__pulse___2XMvC",
    "copiedLabel": "Swatch__copiedLabel___2yr1v position-absolute c-silver fontSize-s pointerEvents-none fontWeight-5 textAlign-center",
    "labelAnimating": "Swatch__labelAnimating___1Jf8z",
    "label": "Swatch__label___3ZdVc",
    "colour": "Swatch__colour___coznS position-absolute pinFill",
    "border": "Swatch__border___2Owm8 position-absolute pinAll borderStyle-solid borderWidth-1 borderColor-black--pellucid pointerEvents-none",
    "transparentWrapper": "Swatch__transparentWrapper___2GzYl borderRadius-m overflow-hidden",
    "transparent": "Swatch__transparent___1xVOQ position-absolute pinAll",
    "gradientStop": "Swatch__gradientStop___IJBiL bg-white position-absolute borderRadius-circle",
    "gradientLine": "Swatch__gradientLine___z6Zx8 bg-white position-absolute",
    "topLine": "Swatch__topLine___1tKOA",
    "middleLine": "Swatch__middleLine___2UBjW",
    "bottomLine": "Swatch__bottomLine___EGpWH",
    "aloneLine": "Swatch__aloneLine___zF5oo"
  };
  /***/
},
/* 336 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactClipboard = __webpack_require__(337);

  var _reactClipboard2 = babelHelpers.interopRequireDefault(_reactClipboard);

  var _uniqueId = __webpack_require__(338);

  var _uniqueId2 = babelHelpers.interopRequireDefault(_uniqueId);

  var _CopyToClipboard = __webpack_require__(339);

  var _CopyToClipboard2 = babelHelpers.interopRequireDefault(_CopyToClipboard);

  var CopyToClipboard = function (_Component) {
    babelHelpers.inherits(CopyToClipboard, _Component);

    function CopyToClipboard(props) {
      babelHelpers.classCallCheck(this, CopyToClipboard);

      var _this = babelHelpers.possibleConstructorReturn(this, (CopyToClipboard.__proto__ || Object.getPrototypeOf(CopyToClipboard)).call(this, props));

      _this.id = (0, _uniqueId2.default)();
      return _this;
    }

    babelHelpers.createClass(CopyToClipboard, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            target = _props.target,
            text = _props.text,
            onCopy = _props.onCopy,
            isCopying = _props.isCopying,
            children = _props.children;
        var dataClipboard = {
          'data-clipboard-text': text,
          'data-clipboard-target': target && '#' + target
        };
        return _react2.default.createElement(_reactClipboard2.default, babelHelpers.extends({
          onSuccess: function onSuccess(e) {
            return e.clearSelection();
          }
        }, dataClipboard, {
          className: _CopyToClipboard2.default.button
        }), _react2.default.createElement('div', {
          onClick: function onClick() {
            return onCopy(_this2.id);
          }
        }, children && children(isCopying(this.id))));
      }
    }]);
    return CopyToClipboard;
  }(_react.Component);

  CopyToClipboard.propTypes = {
    target: _propTypes2.default.string,
    text: _propTypes2.default.string,
    isCopying: _propTypes2.default.func,
    onCopy: _propTypes2.default.func.isRequired,
    children: _propTypes2.default.func
  };
  exports.default = CopyToClipboard;
  /***/
},
/* 337 */

/***/
function (module, exports) {
  module.exports = require("react-clipboard.js");
  /***/
},
/* 338 */

/***/
function (module, exports) {
  module.exports = require("lodash/uniqueId");
  /***/
},
/* 339 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "button": "CopyToClipboard__button___1d39F userSelect-none borderWidth-0 verticalAlign-top"
  };
  /***/
},
/* 340 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "section": "PanelColorSection__section___2DT4N display-flex justifyContent-between textAlign-right",
    "swatchLabel": "PanelColorSection__swatchLabel___2IpCI marginRight-xs",
    "labelWrapper": "PanelColorSection__labelWrapper___BuB7W width-35 textAlign-left",
    "swatchWrapper": "PanelColorSection__swatchWrapper___2WTws width-65"
  };
  /***/
},
/* 341 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ImageFill;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _button = __webpack_require__(49);

  var _button2 = babelHelpers.interopRequireDefault(_button);

  var _Box = __webpack_require__(33);

  var _Box2 = babelHelpers.interopRequireDefault(_Box);

  var _BoxSection = __webpack_require__(40);

  var _BoxSection2 = babelHelpers.interopRequireDefault(_BoxSection);

  var _ImageFill = __webpack_require__(345);

  var _ImageFill2 = babelHelpers.interopRequireDefault(_ImageFill);

  var _Label = __webpack_require__(32);

  var _Label2 = babelHelpers.interopRequireDefault(_Label);

  var _AssetPreview = __webpack_require__(144);

  var _AssetPreview2 = babelHelpers.interopRequireDefault(_AssetPreview);

  function ImageFill(_ref) {
    var url = _ref.url;
    return _react2.default.createElement(_Box2.default, {
      withoutPadding: true
    }, _react2.default.createElement(_BoxSection2.default, null, _react2.default.createElement('div', {
      className: _ImageFill2.default.label
    }, _react2.default.createElement(_Label2.default, null, 'Image Fill')), _react2.default.createElement('div', {
      className: _ImageFill2.default.download
    }, _react2.default.createElement('a', {
      href: url,
      download: true
    }, _react2.default.createElement(_button2.default, {
      size: 'extraSmall',
      style: 'ghost',
      hover: 'blue'
    }, 'Download')))), _react2.default.createElement(_AssetPreview2.default, {
      url: url,
      bottom: true,
      centered: false
    }));
  }

  ImageFill.propTypes = {
    url: _propTypes2.default.string.isRequired
  };
  /***/
},
/* 342 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "box": "Box__box___3j_cU cf borderColor-smoke borderStyle-solid borderWidth-1 boxShadow-raise position-relative marginBottom-s c-slate"
  };
  /***/
},
/* 343 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "boxSection": "BoxSection__boxSection___2FO-m cf borderColor-smoke borderStyle-solid borderWidth-0 borderTopWidth-1 c-slate"
  };
  /***/
},
/* 344 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "snow": "BoxSectionBackground__snow___F5GEn bg-snow",
    "white": "BoxSectionBackground__white___15vsH bg-white",
    "transparent": "BoxSectionBackground__transparent___21Az-"
  };
  /***/
},
/* 345 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "label": "ImageFill__label___VJBuN float-left",
    "download": "ImageFill__download___gJr6T float-right textAlign-right"
  };
  /***/
},
/* 346 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _PanelColours = __webpack_require__(347);

  var _PanelColours2 = babelHelpers.interopRequireDefault(_PanelColours);

  var _handoff = __webpack_require__(5);

  function mapStateToProps(state) {
    return (0, _handoff.getDocumentColors)(state);
  }

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(function (props) {
    return props.opacityCols.length || props.solidCols.length;
  }))(_PanelColours2.default);
  /***/
},
/* 347 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _convertColours = __webpack_require__(27);

  var convert = babelHelpers.interopRequireWildcard(_convertColours);

  var _CopyToClipboard = __webpack_require__(58);

  var _CopyToClipboard2 = babelHelpers.interopRequireDefault(_CopyToClipboard);

  var _PanelColours = __webpack_require__(348);

  var _PanelColours2 = babelHelpers.interopRequireDefault(_PanelColours);

  var _Swatch = __webpack_require__(91);

  var _Swatch2 = babelHelpers.interopRequireDefault(_Swatch);

  var PanelColours = function PanelColours(_ref) {
    var solidCols = _ref.solidCols,
        opacityCols = _ref.opacityCols;
    return _react2.default.createElement(_Panel2.default, {
      header: 'Document Colours'
    }, _react2.default.createElement('div', {
      className: _PanelColours2.default.wrapper
    }, solidCols.map(function (color) {
      var hex = convert.rgbArray2css(color);
      return _react2.default.createElement('div', {
        key: hex
      }, _react2.default.createElement(_CopyToClipboard2.default, {
        text: hex
      }, function (isCopying) {
        return _react2.default.createElement(_Swatch2.default, {
          color: color,
          isCopying: isCopying,
          width: 25,
          height: 25,
          isRectangular: true
        });
      }));
    }), opacityCols.map(function (color) {
      var rgba = convert.rgbaArray2rgba(color);
      return _react2.default.createElement('div', {
        key: rgba
      }, _react2.default.createElement(_CopyToClipboard2.default, {
        text: rgba
      }, function (isCopying) {
        return _react2.default.createElement(_Swatch2.default, {
          color: color,
          isCopying: isCopying,
          width: 25,
          height: 25,
          isRectangular: true
        });
      }));
    })));
  };

  exports.default = PanelColours;
  PanelColours.propTypes = {
    solidCols: _propTypes2.default.array,
    opacityCols: _propTypes2.default.array
  };
  /***/
},
/* 348 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "wrapper": "PanelColours__wrapper___32LJd cf"
  };
  /***/
},
/* 349 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PanelFonts;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _PanelLine = __webpack_require__(350);

  var _PanelLine2 = babelHelpers.interopRequireDefault(_PanelLine);

  function PanelFonts(_ref) {
    var fonts = _ref.fonts;
    return _react2.default.createElement(_Panel2.default, {
      header: 'Fonts'
    }, fonts.map(function (font) {
      return _react2.default.createElement(_PanelLine2.default, {
        key: font
      }, font);
    }));
  }

  PanelFonts.propTypes = {
    fonts: _propTypes2.default.array.isRequired
  };
  /***/
},
/* 350 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PanelLine;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _PanelLine = __webpack_require__(351);

  var _PanelLine2 = babelHelpers.interopRequireDefault(_PanelLine);

  function PanelLine(_ref) {
    var children = _ref.children;
    return _react2.default.createElement('div', {
      className: _PanelLine2.default.line
    }, children);
  }

  PanelLine.propTypes = {
    children: _propTypes2.default.node.isRequired
  };
  /***/
},
/* 351 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "line": "PanelLine__line___3YbIH cf"
  };
  /***/
},
/* 352 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _layoutOverlay = __webpack_require__(41);

  var _RowSettings = __webpack_require__(353);

  var _RowSettings2 = babelHelpers.interopRequireDefault(_RowSettings);

  var _handoff = __webpack_require__(85);

  var actionCreators = babelHelpers.interopRequireWildcard(_handoff);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state) {
    try {
      // TODO remove when using easel api v2
      return babelHelpers.extends({}, (0, _layoutOverlay.getRowSettings)(state), {
        isOverlayOn: (0, _layoutOverlay.getIsRowOverlayOn)(state),
        isOverlayEnabled: (0, _layoutOverlay.getRowsEnabled)(state)
      });
    } catch (e) {
      return {
        isOverlayEnabled: false
      };
    }
  }

  function mapDispatchToProps(dispatch) {
    return {
      toggleOverlay: function toggleOverlay() {
        dispatch(actionCreators.toggleRowOverlay());
      }
    };
  }

  var isOverlayEnabled = function isOverlayEnabled(props) {
    return props.isOverlayEnabled;
  };

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _onlyIf2.default)(isOverlayEnabled))(_RowSettings2.default);
  /***/
},
/* 353 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = RowSettings;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _checkbox = __webpack_require__(145);

  var _checkbox2 = babelHelpers.interopRequireDefault(_checkbox);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _PanelGrid = __webpack_require__(46);

  var _PanelGrid2 = babelHelpers.interopRequireDefault(_PanelGrid);

  var _PanelGridItem = __webpack_require__(57);

  var _PanelGridItem2 = babelHelpers.interopRequireDefault(_PanelGridItem);

  var _Label = __webpack_require__(32);

  var _Label2 = babelHelpers.interopRequireDefault(_Label);

  var _Value = __webpack_require__(47);

  var _Value2 = babelHelpers.interopRequireDefault(_Value);

  var _Box = __webpack_require__(33);

  var _Box2 = babelHelpers.interopRequireDefault(_Box);

  var _BoxSection = __webpack_require__(40);

  var _BoxSection2 = babelHelpers.interopRequireDefault(_BoxSection);

  function RowSettings(_ref) {
    var heightAsGutterMultiple = _ref.heightAsGutterMultiple,
        gutterHeight = _ref.gutterHeight,
        isOverlayOn = _ref.isOverlayOn,
        toggleOverlay = _ref.toggleOverlay;
    return _react2.default.createElement(_Panel2.default, {
      header: 'Rows'
    }, _react2.default.createElement(_Box2.default, null, _react2.default.createElement(_BoxSection2.default, null, _react2.default.createElement(_checkbox2.default, {
      label: 'Show row overlay',
      checked: isOverlayOn,
      onChange: toggleOverlay,
      size: 'small'
    }))), _react2.default.createElement(_PanelGrid2.default, {
      columns: 2
    }, _react2.default.createElement(_PanelGridItem2.default, null, _react2.default.createElement(_Label2.default, null, 'Gutter'), _react2.default.createElement(_Value2.default, null, gutterHeight, 'px')), _react2.default.createElement(_PanelGridItem2.default, null, _react2.default.createElement(_Label2.default, null, 'Row Height'), _react2.default.createElement(_Value2.default, null, heightAsGutterMultiple, ' x Gutter'))));
  }

  RowSettings.propTypes = {
    heightAsGutterMultiple: _propTypes2.default.number.isRequired,
    gutterHeight: _propTypes2.default.number.isRequired,
    isOverlayOn: _propTypes2.default.bool.isRequired,
    toggleOverlay: _propTypes2.default.func.isRequired
  };
  /***/
},
/* 354 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _layoutOverlay = __webpack_require__(41);

  var _ColumnSettings = __webpack_require__(355);

  var _ColumnSettings2 = babelHelpers.interopRequireDefault(_ColumnSettings);

  var _handoff = __webpack_require__(85);

  var actionCreators = babelHelpers.interopRequireWildcard(_handoff);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state) {
    try {
      // TODO remove when using easel api v2
      return babelHelpers.extends({}, (0, _layoutOverlay.getColumnSettings)(state), {
        isOverlayOn: (0, _layoutOverlay.getIsColumnOverlayOn)(state),
        isOverlayEnabled: (0, _layoutOverlay.getColumnsEnabled)(state)
      });
    } catch (e) {
      return {
        isOverlayEnabled: false
      };
    }
  }

  function mapDispatchToProps(dispatch) {
    return {
      toggleOverlay: function toggleOverlay() {
        dispatch(actionCreators.toggleColumnOverlay());
      }
    };
  }

  var isOverlayEnabled = function isOverlayEnabled(props) {
    return props.isOverlayEnabled;
  };

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _onlyIf2.default)(isOverlayEnabled))(_ColumnSettings2.default);
  /***/
},
/* 355 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ColumnSettings;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _checkbox = __webpack_require__(145);

  var _checkbox2 = babelHelpers.interopRequireDefault(_checkbox);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _PanelGrid = __webpack_require__(46);

  var _PanelGrid2 = babelHelpers.interopRequireDefault(_PanelGrid);

  var _PanelGridItem = __webpack_require__(57);

  var _PanelGridItem2 = babelHelpers.interopRequireDefault(_PanelGridItem);

  var _Label = __webpack_require__(32);

  var _Label2 = babelHelpers.interopRequireDefault(_Label);

  var _Value = __webpack_require__(47);

  var _Value2 = babelHelpers.interopRequireDefault(_Value);

  var _Box = __webpack_require__(33);

  var _Box2 = babelHelpers.interopRequireDefault(_Box);

  var _BoxSection = __webpack_require__(40);

  var _BoxSection2 = babelHelpers.interopRequireDefault(_BoxSection);

  function ColumnSettings(_ref) {
    var totalWidth = _ref.totalWidth,
        columnWidth = _ref.columnWidth,
        offset = _ref.offset,
        gutterWidth = _ref.gutterWidth,
        count = _ref.count,
        isGutterOnOutside = _ref.isGutterOnOutside,
        isOverlayOn = _ref.isOverlayOn,
        toggleOverlay = _ref.toggleOverlay;
    return _react2.default.createElement(_Panel2.default, {
      header: 'Columns'
    }, _react2.default.createElement(_Box2.default, null, _react2.default.createElement(_BoxSection2.default, null, _react2.default.createElement(_checkbox2.default, {
      label: 'Show column overlay',
      checked: isOverlayOn,
      onChange: toggleOverlay,
      size: 'small'
    }))), _react2.default.createElement(_PanelGrid2.default, {
      columns: 2
    }, _react2.default.createElement(_PanelGridItem2.default, null, _react2.default.createElement(_Label2.default, null, 'Width'), _react2.default.createElement(_Value2.default, null, totalWidth, 'px')), _react2.default.createElement(_PanelGridItem2.default, null, _react2.default.createElement(_Label2.default, null, 'Offset'), _react2.default.createElement(_Value2.default, null, offset, 'px')), _react2.default.createElement(_PanelGridItem2.default, null, _react2.default.createElement(_Label2.default, null, 'Columns'), _react2.default.createElement(_Value2.default, null, count)), _react2.default.createElement(_PanelGridItem2.default, null, _react2.default.createElement(_Label2.default, null, 'Gutter'), _react2.default.createElement(_Value2.default, null, gutterWidth, 'px')), _react2.default.createElement(_PanelGridItem2.default, null, _react2.default.createElement(_Label2.default, null, 'Column Width'), _react2.default.createElement(_Value2.default, null, columnWidth, 'px')), _react2.default.createElement(_PanelGridItem2.default, null, _react2.default.createElement(_Label2.default, null, 'Outside Gutter'), _react2.default.createElement(_Value2.default, null, isGutterOnOutside ? 'Yes' : 'No'))));
  }

  ColumnSettings.propTypes = {
    count: _propTypes2.default.number.isRequired,
    offset: _propTypes2.default.number.isRequired,
    columnWidth: _propTypes2.default.number.isRequired,
    totalWidth: _propTypes2.default.number.isRequired,
    gutterWidth: _propTypes2.default.number.isRequired,
    isGutterOnOutside: _propTypes2.default.bool.isRequired,
    isOverlayOn: _propTypes2.default.bool.isRequired,
    toggleOverlay: _propTypes2.default.func.isRequired
  };
  /***/
},
/* 356 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "loading": "HandoffDefault__loading___276zZ is-loading is-loading--xl",
    "background": "HandoffDefault__background___7xJTB bg-white"
  };
  /***/
},
/* 357 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "wrap": "SidebarState__wrap___31jRK position-absolute pinAll",
    "table": "SidebarState__table___1ADA4 position-absolute display-table pinFill",
    "cell": "SidebarState__cell___2qOKz display-tableCell verticalAlign-middle paddingLeftRight-m textAlign-center",
    "heading": "SidebarState__heading___mtKG2 fontSize-m c-slate marginBottom-xxs lineHeight-m",
    "message": "SidebarState__message___35qlk fontSize-s c-silver lineHeight-s fontweight-3",
    "contact": "SidebarState__contact___3P_Ge display-block marginTop-xs",
    "asset": "SidebarState__asset___6aKOI display-block marginTop-xs"
  };
  /***/
},
/* 358 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "noAsset": "SidebarImages__noAsset___lTaww display-block centered marginBottom-m",
    "error": "SidebarImages__error___F7vPw display-block centered marginBottom-m",
    "handoff": "SidebarImages__handoff___2J_L1 display-block centered marginBottom-m"
  };
  /***/
},
/* 359 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getCanvasFonts;

  var _uniqBy = __webpack_require__(147);

  var _uniqBy2 = babelHelpers.interopRequireDefault(_uniqBy);

  function getCanvasFonts(flatCanvas) {
    var fonts = (0, _uniqBy2.default)(flatCanvas.filter(function (item) {
      return item.className === 'Text';
    }).map(function (item) {
      return item.style.fontFamily;
    }));
    fonts.sort();
    return fonts;
  }
  /***/

},
/* 360 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _assign = __webpack_require__(21);

  var _assign2 = babelHelpers.interopRequireDefault(_assign);

  var _downloadAssets = __webpack_require__(84);

  var _ScreenAssets = __webpack_require__(361);

  var _ScreenAssets2 = babelHelpers.interopRequireDefault(_ScreenAssets);

  var _screen = __webpack_require__(9);

  var _handoff = __webpack_require__(5);

  var _downloadAssets2 = __webpack_require__(93);

  var _element = __webpack_require__(16);

  function mapStateToProps(state) {
    var currentScreen = (0, _screen.getCurrentScreen)(state);
    var elements = (0, _handoff.getElements)(state).filter(_element.hasAssets);
    return {
      screenID: currentScreen.id,
      sourcePlatform: currentScreen.sourcePlatform,
      elements: elements,
      areDownloading: (0, _downloadAssets2.isDownloading)(state, {
        screenID: currentScreen.id
      }),
      hasDownloaded: (0, _downloadAssets2.hasDownloaded)(state, {
        screenID: currentScreen.id
      })
    };
  }

  function mergeProps(stateProps, _ref, ownProps) {
    var dispatch = _ref.dispatch;
    var newProps = {
      download: function download() {
        dispatch((0, _downloadAssets.downloadAssets)({
          screenID: stateProps.screenID
        }));
      }
    };
    return (0, _assign2.default)({}, ownProps, stateProps, newProps);
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, null, mergeProps)(_ScreenAssets2.default);
  /***/
},
/* 361 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ScreenAssets;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _button = __webpack_require__(49);

  var _button2 = babelHelpers.interopRequireDefault(_button);

  var _element = __webpack_require__(16);

  var _ElementAssets = __webpack_require__(148);

  var _ElementAssets2 = babelHelpers.interopRequireDefault(_ElementAssets);

  var _Box = __webpack_require__(33);

  var _Box2 = babelHelpers.interopRequireDefault(_Box);

  var _ScreenAssets = __webpack_require__(368);

  var _ScreenAssets2 = babelHelpers.interopRequireDefault(_ScreenAssets);

  var _SidebarState = __webpack_require__(146);

  var _SidebarState2 = babelHelpers.interopRequireDefault(_SidebarState);

  var _sourcePlatform = __webpack_require__(94);

  var screenLocation = babelHelpers.interopRequireWildcard(_sourcePlatform);

  function ScreenAssets(_ref) {
    var areDownloading = _ref.areDownloading,
        hasDownloaded = _ref.hasDownloaded,
        download = _ref.download,
        elements = _ref.elements,
        sourcePlatform = _ref.sourcePlatform;
    return _react2.default.createElement('div', {
      className: _ScreenAssets2.default.wrapper
    }, elements.length > 0 && _react2.default.createElement('div', {
      className: _ScreenAssets2.default.buttonWrapper
    }, _react2.default.createElement('a', {
      onClick: download
    }, _react2.default.createElement(_button2.default, {
      size: 'small',
      isLoading: areDownloading,
      hasSucceeded: hasDownloaded,
      fullWidth: true
    }, 'Download all screen assets'))), _react2.default.createElement('div', {
      className: _ScreenAssets2.default.assetsWrapper
    }, elements.map(function (element) {
      return _react2.default.createElement('div', {
        key: element.id,
        className: _ScreenAssets2.default.assetWrapper
      }, _react2.default.createElement('p', {
        className: _ScreenAssets2.default.elementName
      }, (0, _element.getLayerName)(element)), _react2.default.createElement(_Box2.default, {
        withoutPadding: true
      }, _react2.default.createElement(_ElementAssets2.default, {
        element: element,
        previewOnTop: true
      })));
    }), elements.length === 0 && _react2.default.createElement(_SidebarState2.default, {
      heading: 'No assets yet!',
      message: getSidebarStateMsg(sourcePlatform),
      image: 'noAssets'
    }, sourcePlatform === screenLocation.SKETCH && _react2.default.createElement(_SidebarState.FindHowToDownloadAssetsButton, null))));
  }

  function getSidebarStateMsg(sourcePlatform) {
    if (sourcePlatform === screenLocation.SKETCH) {
      return 'Set layers as exportable in Sketch and we will list them here.';
    }

    return 'Insert an image or icon from our Design tool to see it here.';
  }

  ScreenAssets.propTypes = {
    areDownloading: _propTypes2.default.bool,
    sourcePlatform: _propTypes2.default.number,
    hasDownloaded: _propTypes2.default.bool,
    download: _propTypes2.default.func.isRequired,
    elements: _propTypes2.default.array.isRequired
  };
  /***/
},
/* 362 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ElementAssets;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _size = __webpack_require__(107);

  var _size2 = babelHelpers.interopRequireDefault(_size);

  var _map = __webpack_require__(129);

  var _map2 = babelHelpers.interopRequireDefault(_map);

  var _button = __webpack_require__(49);

  var _button2 = babelHelpers.interopRequireDefault(_button);

  var _badge = __webpack_require__(150);

  var _badge2 = babelHelpers.interopRequireDefault(_badge);

  var _AssetPreview = __webpack_require__(144);

  var _AssetPreview2 = babelHelpers.interopRequireDefault(_AssetPreview);

  var _ElementAssets = __webpack_require__(363);

  var _ElementAssets2 = babelHelpers.interopRequireDefault(_ElementAssets);

  var formatToType = {
    svg: {
      label: 'vector',
      color: 'yellow'
    },
    png: {
      label: 'image',
      color: 'purple'
    },
    jpg: {
      label: 'image',
      color: 'green'
    },
    pdf: {
      label: 'document',
      color: 'red'
    },
    tiff: {
      label: 'image',
      color: 'orange'
    },
    webp: {
      label: 'image',
      color: 'orange'
    },
    eps: {
      label: 'vector',
      color: 'yellow'
    }
  };

  function ElementAssets(_ref) {
    var assets = _ref.assets,
        bestAssetUrl = _ref.bestAssetUrl,
        downloadType = _ref.downloadType,
        downloadAll = _ref.downloadAll,
        isDownloadingType = _ref.isDownloadingType,
        hasDownloadedType = _ref.hasDownloadedType,
        isDownloadingAll = _ref.isDownloadingAll,
        hasDownloadedAll = _ref.hasDownloadedAll,
        previewOnTop = _ref.previewOnTop;
    var hasMoreThanOneAsset = (0, _size2.default)(assets) > 1;
    var wrapperClass = previewOnTop ? 'padding-xs' : 'paddingTop-xs paddingBottom-s paddingLeftRight-s';
    return _react2.default.createElement('div', null, _react2.default.createElement(_AssetPreview2.default, {
      url: bestAssetUrl,
      centered: !previewOnTop,
      top: previewOnTop
    }), _react2.default.createElement('div', {
      className: wrapperClass
    }, (0, _map2.default)(assets, function (groupedAssets, format) {
      return format === 'UNKNOWN' ? _react2.default.createElement('div', {
        className: 'inline'
      }, _react2.default.createElement('a', downloadLinkProps(downloadType, groupedAssets, format), _react2.default.createElement(_button2.default, {
        fullWidth: true,
        size: 'extraSmall',
        style: 'outlined',
        background: 'white',
        hover: 'blue',
        isLoading: isDownloadingType(format)
      }, 'Download'))) : formatToType[format] && _react2.default.createElement('div', {
        key: format,
        className: (0, _classnames2.default)(_ElementAssets2.default.section, {
          'marginBottom-xs': hasMoreThanOneAsset
        })
      }, _react2.default.createElement('div', {
        className: _ElementAssets2.default.left
      }, _react2.default.createElement('div', {
        className: _ElementAssets2.default.inline
      }, _react2.default.createElement('div', {
        className: _ElementAssets2.default.middle,
        style: {
          height: 16
        }
      }, _react2.default.createElement(_badge2.default, {
        size: 'small',
        text: format.toUpperCase(),
        color: formatToType[format].color
      })), _react2.default.createElement('div', {
        className: _ElementAssets2.default.assetLabel
      }, groupedAssets.length, ' ', formatToType[format].label, groupedAssets.length > 1 ? 's' : ''))), _react2.default.createElement('div', {
        className: _ElementAssets2.default.right
      }, _react2.default.createElement('div', {
        className: 'inline'
      }, _react2.default.createElement('a', downloadLinkProps(downloadType, groupedAssets, format), _react2.default.createElement(_button2.default, {
        isStateful: true,
        size: 'extraSmall',
        style: 'outlined',
        background: 'white',
        hover: 'blue',
        isLoading: isDownloadingType(format),
        hasSucceeded: hasDownloadedType(format)
      }, 'Download')))));
    }), hasMoreThanOneAsset && _react2.default.createElement('a', {
      onClick: downloadAll,
      className: _ElementAssets2.default.downloadAllButton
    }, _react2.default.createElement(_button2.default, {
      fullWidth: true,
      style: 'outlined',
      background: 'white',
      size: 'small',
      hover: 'blue',
      isLoading: isDownloadingAll(),
      hasSucceeded: hasDownloadedAll()
    }, 'Download all'))));
  }

  ElementAssets.propTypes = {
    isDownloadingType: _propTypes2.default.func.isRequired,
    isDownloadingAll: _propTypes2.default.func.isRequired,
    hasDownloadedType: _propTypes2.default.func.isRequired,
    hasDownloadedAll: _propTypes2.default.func.isRequired,
    assets: _propTypes2.default.object.isRequired,
    bestAssetUrl: _propTypes2.default.string,
    downloadType: _propTypes2.default.func.isRequired,
    downloadAll: _propTypes2.default.func.isRequired,
    previewOnTop: _propTypes2.default.bool
  };

  function downloadLinkProps(downloadType, assets, format) {
    if (assets.length > 1) {
      return {
        onClick: function onClick() {
          downloadType(format);
        }
      };
    }

    return {
      download: true,
      href: assets[0].url
    };
  }
  /***/

},
/* 363 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "section": "ElementAssets__section___1GkFI fontSize-s cf inline",
    "inline": "ElementAssets__inline___2U7uA inline",
    "type": "ElementAssets__type___2_ZVK textTransform-uppercase fontWeight-4 paddingBottom-s",
    "sizes": "ElementAssets__sizes___3MayR c-silver fontWeight-3",
    "left": "ElementAssets__left___RFyea float-left",
    "right": "ElementAssets__right___3D5Lz float-right",
    "clear": "ElementAssets__clear___2wTkE clear-both",
    "assetLabel": "ElementAssets__assetLabel___2hwPF fontSize-s fontWeight-3 c-silver marginLeft-xxs verticalAlign-middle",
    "middle": "ElementAssets__middle___2CffW verticalAlign-middle",
    "downloadAllButton": "ElementAssets__downloadAllButton___377r0 display-inlineBlock width-100"
  };
  /***/
},
/* 364 */

/***/
function (module, exports) {
  module.exports = require("lodash/toPairs");
  /***/
},
/* 365 */

/***/
function (module, exports) {
  module.exports = require("lodash/maxBy");
  /***/
},
/* 366 */

/***/
function (module, exports) {
  module.exports = require("lodash/isEqual");
  /***/
},
/* 367 */

/***/
function (module, exports) {
  module.exports = require("lodash/pick");
  /***/
},
/* 368 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "wrapper": "ScreenAssets__wrapper___2KO2U bg-white",
    "buttonWrapper": "ScreenAssets__buttonWrapper___1hTCr padding-s borderWidth-0 borderStyle-solid borderBottomWidth-1 borderColor-snow--xd",
    "assetsWrapper": "ScreenAssets__assetsWrapper___t1Pf7 padding-s",
    "elementName": "ScreenAssets__elementName___1Q3Je marginBottom-xs",
    "assetWrapper": "ScreenAssets__assetWrapper___3xK4r marginBottom-l"
  };
  /***/
},
/* 369 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ElementHandoff;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _HandoffImage = __webpack_require__(370);

  var _HandoffImage2 = babelHelpers.interopRequireDefault(_HandoffImage);

  var _HandoffText = __webpack_require__(391);

  var _HandoffText2 = babelHelpers.interopRequireDefault(_HandoffText);

  var _HandoffShape = __webpack_require__(399);

  var _HandoffShape2 = babelHelpers.interopRequireDefault(_HandoffShape);

  var _HandoffGroup = __webpack_require__(401);

  var _HandoffGroup2 = babelHelpers.interopRequireDefault(_HandoffGroup);

  var _Header = __webpack_require__(402);

  var _Header2 = babelHelpers.interopRequireDefault(_Header);

  var _SelectedElementAssets = __webpack_require__(404);

  var _SelectedElementAssets2 = babelHelpers.interopRequireDefault(_SelectedElementAssets);

  var specs = {
    raster: _react2.default.createElement(_HandoffImage2.default, null),
    text: _react2.default.createElement(_HandoffText2.default, null),
    shape: _react2.default.createElement(_HandoffShape2.default, null),
    group: _react2.default.createElement(_HandoffGroup2.default, null),
    mask: _react2.default.createElement(_HandoffGroup2.default, null)
  };

  function ElementHandoff(_ref) {
    var selectedElementType = _ref.selectedElementType;
    return _react2.default.createElement('div', null, _react2.default.createElement(_Header2.default, null), _react2.default.createElement(_SelectedElementAssets2.default, null), specs[selectedElementType]);
  }

  ElementHandoff.propTypes = {
    selectedElementType: _propTypes2.default.string.isRequired
  };
  /***/
},
/* 370 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _HandoffImage = __webpack_require__(371);

  var _HandoffImage2 = babelHelpers.interopRequireDefault(_HandoffImage);

  var _element = __webpack_require__(16);

  var handoff = babelHelpers.interopRequireWildcard(_element);

  var _handoff = __webpack_require__(5);

  function mapStateToProps(state) {
    var element = (0, _handoff.getSelectedElement)(state);
    return {
      type: element.className,
      url: handoff.getElementThumbURL(element)
    };
  }

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps))(_HandoffImage2.default);
  /***/
},
/* 371 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = HandoffImage;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _PanelProperties = __webpack_require__(59);

  var _PanelProperties2 = babelHelpers.interopRequireDefault(_PanelProperties);

  var _PanelBorder = __webpack_require__(60);

  var _PanelBorder2 = babelHelpers.interopRequireDefault(_PanelBorder);

  var _PanelCode = __webpack_require__(61);

  var _PanelCode2 = babelHelpers.interopRequireDefault(_PanelCode);

  var _PanelShadows = __webpack_require__(62);

  var _PanelShadows2 = babelHelpers.interopRequireDefault(_PanelShadows);

  function HandoffImage() {
    return _react2.default.createElement('div', null, _react2.default.createElement(_PanelProperties2.default, null), _react2.default.createElement(_PanelBorder2.default, null), _react2.default.createElement(_PanelShadows2.default, null), _react2.default.createElement(_PanelCode2.default, null));
  }
  /***/

},
/* 372 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _startCase = __webpack_require__(373);

  var _startCase2 = babelHelpers.interopRequireDefault(_startCase);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _PanelProperty = __webpack_require__(136);

  var _PanelProperty2 = babelHelpers.interopRequireDefault(_PanelProperty);

  var _PanelGrid = __webpack_require__(46);

  var _PanelGrid2 = babelHelpers.interopRequireDefault(_PanelGrid);

  var _Measurement = __webpack_require__(39);

  var _Measurement2 = babelHelpers.interopRequireDefault(_Measurement);

  var _blendMode = __webpack_require__(153);

  function allEqual(array) {
    var first = array[0];
    return array.every(function (el) {
      return el === first;
    });
  }

  var getBorderRadius = function getBorderRadius(radii) {
    if (allEqual(radii)) {
      var elementHasRadius = radii[0] !== 0;

      if (elementHasRadius) {
        return _react2.default.createElement(_PanelProperty2.default, {
          label: 'Border Radius'
        }, _react2.default.createElement(_Measurement2.default, {
          value: radii[0]
        }));
      }

      return null;
    }

    return _react2.default.createElement(_PanelProperty2.default, {
      label: 'Border Radius'
    }, radii.map(function (radius, index) {
      return (// eslint-disable-next-line react/no-array-index-key
        _react2.default.createElement(_Measurement2.default, {
          value: radius,
          key: index
        })
      );
    }).reduce(function (prev, curr) {
      return [prev, ' ', curr];
    }));
  };

  var PanelProperties = function PanelProperties(_ref) {
    var blendMode = _ref.blendMode,
        blur = _ref.blur,
        layout = _ref.layout,
        opacity = _ref.opacity,
        radius = _ref.radius;
    return _react2.default.createElement(_Panel2.default, {
      header: 'Properties'
    }, _react2.default.createElement(_PanelGrid2.default, {
      columns: 2
    }, _react2.default.createElement(_PanelProperty2.default, {
      label: 'Width'
    }, _react2.default.createElement(_Measurement2.default, {
      value: layout.width
    })), _react2.default.createElement(_PanelProperty2.default, {
      label: 'Height'
    }, _react2.default.createElement(_Measurement2.default, {
      value: layout.height
    })), _react2.default.createElement(_PanelProperty2.default, {
      label: 'X Position'
    }, _react2.default.createElement(_Measurement2.default, {
      value: layout.x
    })), _react2.default.createElement(_PanelProperty2.default, {
      label: 'Y Position'
    }, _react2.default.createElement(_Measurement2.default, {
      value: layout.y
    })), opacity < 1 && _react2.default.createElement(_PanelProperty2.default, {
      label: 'Opacity'
    }, Math.round(opacity * 100) + '%'), radius && getBorderRadius(radius), blendMode !== _blendMode.NORMAL && _react2.default.createElement(_PanelProperty2.default, {
      label: 'Blending Mode'
    }, (0, _startCase2.default)(blendMode)), blur && _react2.default.createElement(_PanelProperty2.default, {
      label: 'Blur'
    }, _react2.default.createElement(_Measurement2.default, {
      value: blur
    }))));
  };

  exports.default = PanelProperties;
  PanelProperties.propTypes = {
    blendMode: _propTypes2.default.string.isRequired,
    blur: _propTypes2.default.number.isRequired,
    layout: _propTypes2.default.shape({
      width: _propTypes2.default.number.isRequired,
      height: _propTypes2.default.number.isRequired,
      x: _propTypes2.default.number.isRequired,
      y: _propTypes2.default.number.isRequired
    }).isRequired,
    opacity: _propTypes2.default.number.isRequired,
    radius: _propTypes2.default.array
  };
  PanelProperties.defaultProps = {
    blendMode: _blendMode.NORMAL,
    blur: 0,
    opacity: 1
  };
  /***/
},
/* 373 */

/***/
function (module, exports) {
  module.exports = require("lodash/startCase");
  /***/
},
/* 374 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getOpacity = getOpacity;
  exports.getBlendMode = getBlendMode;
  exports.hasNoShadow = hasNoShadow;

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _every = __webpack_require__(375);

  var _every2 = babelHelpers.interopRequireDefault(_every);

  var _round = __webpack_require__(90);

  var _round2 = babelHelpers.interopRequireDefault(_round);

  var _blendMode = __webpack_require__(153);

  function getOpacity(element) {
    var opacity = 1;
    var parent = element;

    while (parent) {
      opacity *= parent.itemProps.opacity;
      parent = parent.positionParent;
    }

    if (opacity < 1) {
      return (0, _round2.default)(opacity, 2);
    }

    return undefined;
  }

  function getBlendMode(element) {
    var blendMode = void 0;
    var parent = element;

    while (parent) {
      blendMode = parent.itemProps.blendMode;

      if (blendMode !== _blendMode.NORMAL) {
        return blendMode;
      }

      parent = parent.positionParent;
    }

    return blendMode;
  }

  function hasNoShadow(element) {
    var shadowValues = [].concat(babelHelpers.toConsumableArray((0, _get2.default)(element, 'shadowStyle.shadowOffset', [0, 0])), [(0, _get2.default)(element, 'shadowStyle.shadowBlur', 0)]);
    var hasNoShadowVals = (0, _every2.default)(shadowValues, function (v) {
      return v === 0;
    });
    return hasNoShadowVals;
  }
  /***/

},
/* 375 */

/***/
function (module, exports) {
  module.exports = require("lodash/every");
  /***/
},
/* 376 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PanelBorder;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Box = __webpack_require__(33);

  var _Box2 = babelHelpers.interopRequireDefault(_Box);

  var _BoxSection = __webpack_require__(40);

  var _BoxSection2 = babelHelpers.interopRequireDefault(_BoxSection);

  var _ColorFill = __webpack_require__(92);

  var _ColorFill2 = babelHelpers.interopRequireDefault(_ColorFill);

  var _GradientFill = __webpack_require__(139);

  var _GradientFill2 = babelHelpers.interopRequireDefault(_GradientFill);

  var _Measurement = __webpack_require__(39);

  var _Measurement2 = babelHelpers.interopRequireDefault(_Measurement);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _PanelInlineProperty = __webpack_require__(154);

  var _PanelInlineProperty2 = babelHelpers.interopRequireDefault(_PanelInlineProperty);

  function PanelBorder(_ref) {
    var borders = _ref.borders;
    var header = 'Border';

    if (borders.length > 1) {
      header += 's';
    }

    return _react2.default.createElement(_Panel2.default, {
      header: header
    }, borders.map(function (border, index) {
      return (// eslint-disable-next-line react/no-array-index-key
        _react2.default.createElement(_Box2.default, {
          key: index
        }, _react2.default.createElement(_BoxSection2.default, null, border.type === 'color' ? _react2.default.createElement(_ColorFill2.default, border) : _react2.default.createElement(_GradientFill2.default, border)), _react2.default.createElement(_BoxSection2.default, {
          background: 'snow'
        }, _react2.default.createElement(_PanelInlineProperty2.default, {
          label: 'Position'
        }, border.position), _react2.default.createElement(_PanelInlineProperty2.default, {
          label: 'Weight'
        }, _react2.default.createElement(_Measurement2.default, {
          value: border.width,
          includeUnitIfZero: true
        }))))
      );
    }));
  }

  PanelBorder.propTypes = {
    borders: _propTypes2.default.array.isRequired
  };
  /***/
},
/* 377 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "inlinePanel": "PanelInlineProperty__inlinePanel___1UH-H marginRight-xs display-inlineBlock verticalAlign-top"
  };
  /***/
},
/* 378 */

/***/
function (module, exports) {
  module.exports = require("lodash/isEmpty");
  /***/
},
/* 379 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _light = __webpack_require__(380);

  var _light2 = babelHelpers.interopRequireDefault(_light);

  var _css = __webpack_require__(381);

  var _css2 = babelHelpers.interopRequireDefault(_css);

  var _swift = __webpack_require__(382);

  var _swift2 = babelHelpers.interopRequireDefault(_swift);

  var _xml = __webpack_require__(383);

  var _xml2 = babelHelpers.interopRequireDefault(_xml);

  var _objectivec = __webpack_require__(384);

  var _objectivec2 = babelHelpers.interopRequireDefault(_objectivec);

  var _popover = __webpack_require__(43);

  var _popover2 = babelHelpers.interopRequireDefault(_popover);

  var _link = __webpack_require__(385);

  var _link2 = babelHelpers.interopRequireDefault(_link);

  var _badge = __webpack_require__(150);

  var _badge2 = babelHelpers.interopRequireDefault(_badge);

  var _popover3 = __webpack_require__(77);

  var _popover4 = babelHelpers.interopRequireDefault(_popover3);

  var _highlighterStyle = __webpack_require__(386);

  var _highlighterStyle2 = babelHelpers.interopRequireDefault(_highlighterStyle);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _CopyToClipboardButton = __webpack_require__(155);

  var _CopyToClipboardButton2 = babelHelpers.interopRequireDefault(_CopyToClipboardButton);

  var _Code = __webpack_require__(156);

  var _Code2 = babelHelpers.interopRequireDefault(_Code);

  var _CodeError = __webpack_require__(388);

  var _CodeError2 = babelHelpers.interopRequireDefault(_CodeError);

  var _requestStatus = __webpack_require__(31);

  var APIRequestStatus = babelHelpers.interopRequireWildcard(_requestStatus);

  var _code = __webpack_require__(143);

  var codeConstants = babelHelpers.interopRequireWildcard(_code);

  var _icons = __webpack_require__(14);

  (0, _light.registerLanguage)('css', _css2.default);
  (0, _light.registerLanguage)('objectivec', _objectivec2.default);
  (0, _light.registerLanguage)('swift', _swift2.default);
  (0, _light.registerLanguage)('xml', _xml2.default);

  var PanelCode = function (_Component) {
    babelHelpers.inherits(PanelCode, _Component);

    function PanelCode() {
      var _ref;

      var _temp, _this, _ret;

      babelHelpers.classCallCheck(this, PanelCode);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = PanelCode.__proto__ || Object.getPrototypeOf(PanelCode)).call.apply(_ref, [this].concat(args))), _this), _this.selectLang = function (lang) {
        _this.props.togglePopover();

        _this.props.setCurrentLang(lang);
      }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
    }

    babelHelpers.createClass(PanelCode, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            code = _props.code,
            requestStatus = _props.requestStatus,
            currentLang = _props.currentLang;
        var _props2 = this.props,
            togglePopover = _props2.togglePopover,
            isPopoverOpen = _props2.isPopoverOpen;
        var copyTarget = 'css-content';
        var hasError = requestStatus[currentLang] === APIRequestStatus.ERROR;

        var badge = _react2.default.createElement(_badge2.default, {
          size: 'small',
          text: 'SOON'
        });

        var header = _react2.default.createElement('div', null, _react2.default.createElement('div', {
          className: 'position-relative display-inlineBlock'
        }, _react2.default.createElement(_link2.default, {
          onClick: togglePopover
        }, _react2.default.createElement(_icons.GearIcon, null)), _react2.default.createElement(_popover2.default, {
          position: 'right',
          align: 'center',
          isActive: isPopoverOpen,
          size: 'small'
        }, _react2.default.createElement(_popover.PopoverOption, {
          size: 'small',
          block: true,
          isActive: currentLang === codeConstants.CSS,
          onClick: function onClick() {
            return _this2.selectLang(codeConstants.CSS);
          }
        }, _react2.default.createElement('div', {
          className: _Code2.default.inline
        }, _react2.default.createElement('div', {
          className: _Code2.default.label
        }, codeConstants.LANGUAGES[codeConstants.CSS].label))), _react2.default.createElement(_popover.PopoverOption, {
          size: 'small',
          block: true,
          isActive: currentLang === codeConstants.ANDROID,
          onClick: function onClick() {
            return _this2.selectLang(codeConstants.ANDROID);
          }
        }, _react2.default.createElement('div', {
          className: _Code2.default.inline
        }, _react2.default.createElement('div', {
          className: _Code2.default.label
        }, codeConstants.LANGUAGES[codeConstants.ANDROID].label))), _react2.default.createElement(_popover.PopoverOption, {
          size: 'small',
          block: true,
          isActive: currentLang === codeConstants.SWIFT,
          onClick: function onClick() {
            return _this2.selectLang(codeConstants.SWIFT);
          }
        }, _react2.default.createElement('div', {
          className: _Code2.default.inline
        }, _react2.default.createElement('div', {
          className: _Code2.default.label
        }, codeConstants.LANGUAGES[codeConstants.SWIFT].label))), _react2.default.createElement(_popover.PopoverOption, {
          size: 'small',
          block: true,
          isActive: currentLang === codeConstants.OBJECTIVE_C,
          onClick: function onClick() {
            return _this2.selectLang(codeConstants.OBJECTIVE_C);
          }
        }, _react2.default.createElement('div', {
          className: _Code2.default.inline
        }, _react2.default.createElement('div', {
          className: _Code2.default.label
        }, codeConstants.LANGUAGES[codeConstants.OBJECTIVE_C].label))), _react2.default.createElement(_popover.PopoverOption, {
          size: 'small',
          block: true,
          isDisabled: true
        }, _react2.default.createElement('div', {
          className: _Code2.default.inline
        }, _react2.default.createElement('div', {
          className: _Code2.default.label
        }, codeConstants.LANGUAGES[codeConstants.REACT_NATIVE].label), _react2.default.createElement('div', {
          className: _Code2.default.badge
        }, badge))))));

        var action = !hasError ? _react2.default.createElement(_CopyToClipboardButton2.default, {
          target: copyTarget
        }) : null;
        var label = !isPopoverOpen ? codeConstants.LANGUAGES[currentLang].label : ' ';
        return _react2.default.createElement(_Panel2.default, {
          header: label,
          customHeader: header,
          action: action
        }, !hasError ? _react2.default.createElement('div', {
          className: (0, _classnames2.default)(_Code2.default.codeBlock),
          id: 'css-content'
        }, _react2.default.createElement(_light2.default, {
          language: currentLang === 'android' ? 'xml' : currentLang,
          PreTag: 'span',
          style: _highlighterStyle2.default,
          wrapLines: true,
          lineStyle: {
            whiteSpace: 'pre'
          },
          codeTagProps: {
            className: 'codeBlock'
          }
        }, code[currentLang])) : _react2.default.createElement(_CodeError2.default, {
          lang: currentLang
        }));
      }
    }]);
    return PanelCode;
  }(_react.Component);

  PanelCode.propTypes = {
    code: _propTypes2.default.string,
    requestStatus: _propTypes2.default.object,
    currentLang: _propTypes2.default.string,
    setCurrentLang: _propTypes2.default.func.isRequired,
    isPopoverOpen: _propTypes2.default.bool,
    togglePopover: _propTypes2.default.func
  };
  exports.default = (0, _popover4.default)(false)(PanelCode);
  /***/
},
/* 380 */

/***/
function (module, exports) {
  module.exports = require("react-syntax-highlighter/dist/light");
  /***/
},
/* 381 */

/***/
function (module, exports) {
  module.exports = require("react-syntax-highlighter/dist/languages/hljs/css");
  /***/
},
/* 382 */

/***/
function (module, exports) {
  module.exports = require("react-syntax-highlighter/dist/languages/hljs/swift");
  /***/
},
/* 383 */

/***/
function (module, exports) {
  module.exports = require("react-syntax-highlighter/dist/languages/hljs/xml");
  /***/
},
/* 384 */

/***/
function (module, exports) {
  module.exports = require("react-syntax-highlighter/dist/languages/hljs/objectivec");
  /***/
},
/* 385 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/marvel-ui/link");
  /***/
},
/* 386 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    hljs: {
      display: 'block',
      overflowX: 'auto',
      color: '#586e75'
    },
    'hljs-comment': {
      color: '#408080',
      fontStyle: 'italic'
    },
    'hljs-quote': {
      color: '#408080',
      fontStyle: 'italic'
    },
    'hljs-keyword': {
      color: '#954121'
    },
    'hljs-selector-tag': {
      color: '#954121'
    },
    'hljs-literal': {
      color: '#954121'
    },
    'hljs-subst': {
      color: '#954121'
    },
    'hljs-number': {
      color: '#2aa198'
    },
    'hljs-string': {
      color: '#219161'
    },
    'hljs-doctag': {
      color: '#219161'
    },
    'hljs-selector-id': {
      color: '#6c71c4'
    },
    'hljs-selector-class': {
      color: '#6c71c4'
    },
    'hljs-section': {
      color: '#6c71c4'
    },
    'hljs-type': {
      color: '#6c71c4'
    },
    'hljs-params': {
      color: '#00f'
    },
    'hljs-title': {
      color: '#458',
      fontWeight: 'bold'
    },
    'hljs-tag': {
      color: '#073642',
      fontWeight: 'normal'
    },
    'hljs-name': {
      color: '#073642',
      fontWeight: 'normal'
    },
    'hljs-attribute': {
      color: '#073642',
      fontWeight: 'normal'
    },
    'hljs-variable': {
      color: '#008080'
    },
    'hljs-template-variable': {
      color: '#008080'
    },
    'hljs-regexp': {
      color: '#b68'
    },
    'hljs-link': {
      color: '#b68'
    },
    'hljs-symbol': {
      color: '#990073'
    },
    'hljs-bullet': {
      color: '#990073'
    },
    'hljs-built_in': {
      color: '#d33682'
    },
    'hljs-builtin-name': {
      color: '#d33682'
    },
    'hljs-meta': {
      color: '#999',
      fontWeight: 'bold'
    },
    'hljs-deletion': {
      background: '#fdd'
    },
    'hljs-addition': {
      background: '#dfd'
    },
    'hljs-emphasis': {
      fontStyle: 'italic'
    },
    'hljs-strong': {
      fontWeight: 'bold'
    }
  };
  /***/
},
/* 387 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "link": "CopyToClipboardButton__link___3Z5UB link link--blue"
  };
  /***/
},
/* 388 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = CodeError;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _button = __webpack_require__(49);

  var _button2 = babelHelpers.interopRequireDefault(_button);

  var _CodeError = __webpack_require__(389);

  var _CodeError2 = babelHelpers.interopRequireDefault(_CodeError);

  var _marvelURL = __webpack_require__(38);

  var marvelURL = babelHelpers.interopRequireWildcard(_marvelURL);

  function CodeError(_ref) {
    var lang = _ref.lang;
    return _react2.default.createElement('div', {
      className: _CodeError2.default.error
    }, 'Oops! Looks like there was an error loading the ', lang, '. Please try uploading your screen again or contact support.', _react2.default.createElement('a', {
      href: marvelURL.CONTACT_SUPPORT,
      target: '_blank',
      rel: 'noopener noreferrer',
      className: _CodeError2.default.contactButton
    }, _react2.default.createElement(_button2.default, {
      size: 'small',
      style: 'ghost',
      hover: 'slate',
      isReversed: true
    }, 'Contact support')));
  }

  CodeError.propTypes = {
    lang: _propTypes2.default.string.isRequired
  };
  /***/
},
/* 389 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "error": "CodeError__error___wixLn padding-s textAlign-center bg-red c-white lineHeight-s",
    "contactButton": "CodeError__contactButton___bld24 marginTop-xs display-block"
  };
  /***/
},
/* 390 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PanelShadows;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Box = __webpack_require__(33);

  var _Box2 = babelHelpers.interopRequireDefault(_Box);

  var _BoxSection = __webpack_require__(40);

  var _BoxSection2 = babelHelpers.interopRequireDefault(_BoxSection);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _PanelInlineProperty = __webpack_require__(154);

  var _PanelInlineProperty2 = babelHelpers.interopRequireDefault(_PanelInlineProperty);

  var _ColorFill = __webpack_require__(92);

  var _ColorFill2 = babelHelpers.interopRequireDefault(_ColorFill);

  var _Measurement = __webpack_require__(39);

  var _Measurement2 = babelHelpers.interopRequireDefault(_Measurement);

  function PanelShadows(_ref) {
    var shadows = _ref.shadows,
        innerShadows = _ref.innerShadows;
    return _react2.default.createElement('div', null, shadows.length ? _react2.default.createElement(_Panel2.default, {
      header: 'Shadows'
    }, shadows.map(function (shadow, index) {
      return getShadowBox(shadow, index);
    })) : null, innerShadows.length ? _react2.default.createElement(_Panel2.default, {
      header: 'Inner Shadows'
    }, innerShadows.map(function (shadow, index) {
      return getShadowBox(shadow, index);
    })) : null);
  }

  function getShadowBox(shadow, index) {
    return _react2.default.createElement(_Box2.default, {
      key: index
    }, _react2.default.createElement(_BoxSection2.default, null, _react2.default.createElement(_ColorFill2.default, {
      color: shadow.color.rgbaValues
    })), _react2.default.createElement(_BoxSection2.default, {
      background: 'snow'
    }, _react2.default.createElement(_PanelInlineProperty2.default, {
      label: 'X'
    }, _react2.default.createElement(_Measurement2.default, {
      value: shadow.offset[0],
      includeUnitIfZero: true
    })), _react2.default.createElement(_PanelInlineProperty2.default, {
      label: 'Y'
    }, _react2.default.createElement(_Measurement2.default, {
      value: shadow.offset[1],
      includeUnitIfZero: true
    })), _react2.default.createElement(_PanelInlineProperty2.default, {
      label: 'Blur'
    }, _react2.default.createElement(_Measurement2.default, {
      value: shadow.blur,
      includeUnitIfZero: true
    })), _react2.default.createElement(_PanelInlineProperty2.default, {
      label: 'Spread'
    }, _react2.default.createElement(_Measurement2.default, {
      value: shadow.shadowSpread,
      includeUnitIfZero: true
    }))));
  }

  PanelShadows.propTypes = {
    shadows: _propTypes2.default.array.isRequired,
    innerShadows: _propTypes2.default.array.isRequired
  };
  /***/
},
/* 391 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _HandoffText = __webpack_require__(392);

  var _HandoffText2 = babelHelpers.interopRequireDefault(_HandoffText);

  var _handoff = __webpack_require__(5);

  var _element = __webpack_require__(16);

  var handoff = babelHelpers.interopRequireWildcard(_element);

  function mapStateToProps(state) {
    var element = (0, _handoff.getSelectedElement)(state);
    return {
      content: handoff.getContent(element),
      style: element.style
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_HandoffText2.default);
  /***/
},
/* 392 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = HandoffText;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _PanelProperties = __webpack_require__(59);

  var _PanelProperties2 = babelHelpers.interopRequireDefault(_PanelProperties);

  var _PanelBorder = __webpack_require__(60);

  var _PanelBorder2 = babelHelpers.interopRequireDefault(_PanelBorder);

  var _PanelCode = __webpack_require__(61);

  var _PanelCode2 = babelHelpers.interopRequireDefault(_PanelCode);

  var _PanelContent = __webpack_require__(393);

  var _PanelContent2 = babelHelpers.interopRequireDefault(_PanelContent);

  var _PanelShadows = __webpack_require__(62);

  var _PanelShadows2 = babelHelpers.interopRequireDefault(_PanelShadows);

  var _PanelAppearance = __webpack_require__(395);

  var _PanelAppearance2 = babelHelpers.interopRequireDefault(_PanelAppearance);

  var _PanelTypography = __webpack_require__(398);

  var _PanelTypography2 = babelHelpers.interopRequireDefault(_PanelTypography);

  function HandoffText(_ref) {
    var content = _ref.content,
        onCopy = _ref.onCopy,
        copyBtnActive = _ref.copyBtnActive,
        style = _ref.style;
    return _react2.default.createElement('div', null, _react2.default.createElement(_PanelProperties2.default, null), _react2.default.createElement(_PanelAppearance2.default, null), _react2.default.createElement(_PanelTypography2.default, style), _react2.default.createElement(_PanelContent2.default, {
      content: content,
      onCopy: onCopy,
      copyBtnActive: copyBtnActive
    }), _react2.default.createElement(_PanelBorder2.default, null), _react2.default.createElement(_PanelShadows2.default, null), _react2.default.createElement(_PanelCode2.default, null));
  }

  HandoffText.propTypes = {
    content: _propTypes2.default.string,
    onCopy: _propTypes2.default.func,
    copyBtnActive: _propTypes2.default.bool,
    style: _propTypes2.default.object.isRequired
  };
  /***/
},
/* 393 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PanelContent;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _CopyToClipboardButton = __webpack_require__(155);

  var _CopyToClipboardButton2 = babelHelpers.interopRequireDefault(_CopyToClipboardButton);

  var _PanelContent = __webpack_require__(394);

  var _PanelContent2 = babelHelpers.interopRequireDefault(_PanelContent);

  var _Code = __webpack_require__(156);

  var _Code2 = babelHelpers.interopRequireDefault(_Code);

  function PanelContent(_ref) {
    var content = _ref.content;
    var copyTarget = 'text-content';

    var action = _react2.default.createElement(_CopyToClipboardButton2.default, {
      target: copyTarget
    });

    return _react2.default.createElement(_Panel2.default, {
      header: 'Content',
      action: action
    }, _react2.default.createElement('div', {
      className: _PanelContent2.default.wrapper
    }, _react2.default.createElement('div', {
      id: copyTarget,
      className: (0, _classnames2.default)(_PanelContent2.default.content, _Code2.default.codeBlock, _Code2.default.font)
    }, content)));
  }

  PanelContent.propTypes = {
    content: _propTypes2.default.string
  };
  /***/
},
/* 394 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "wrapper": "PanelContent__wrapper___3_1GM",
    "content": "PanelContent__content___2uhVy width-100 overflow-scroll textOverflow-clip resize-none"
  };
  /***/
},
/* 395 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _PanelAppearance = __webpack_require__(396);

  var _PanelAppearance2 = babelHelpers.interopRequireDefault(_PanelAppearance);

  var _handoff = __webpack_require__(5);

  var _element = __webpack_require__(16);

  var handoff = babelHelpers.interopRequireWildcard(_element);

  function mapStateToProps(state) {
    var element = (0, _handoff.getSelectedElement)(state);
    return {
      color: handoff.getTextColor(element)
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_PanelAppearance2.default);
  /***/
},
/* 396 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _Swatch = __webpack_require__(91);

  var _Swatch2 = babelHelpers.interopRequireDefault(_Swatch);

  var _CopyToClipboard = __webpack_require__(58);

  var _CopyToClipboard2 = babelHelpers.interopRequireDefault(_CopyToClipboard);

  var _convertColours = __webpack_require__(27);

  var convert = babelHelpers.interopRequireWildcard(_convertColours);

  var _PanelAppearance = __webpack_require__(397);

  var _PanelAppearance2 = babelHelpers.interopRequireDefault(_PanelAppearance);

  var _Panel3 = __webpack_require__(45);

  var _Panel4 = babelHelpers.interopRequireDefault(_Panel3);

  function PanelAppearance(_ref) {
    var color = _ref.color;
    var css = convert.rgbArray2hybridCSS(color);
    return _react2.default.createElement(_Panel2.default, {
      header: 'Appearance'
    }, _react2.default.createElement('div', {
      className: _PanelAppearance2.default.wrapper
    }, _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_PanelAppearance2.default.label, _Panel4.default.property)
    }, 'Colour'), _react2.default.createElement('div', {
      className: _PanelAppearance2.default.colour
    }, _react2.default.createElement('div', {
      className: _PanelAppearance2.default.colourLabel
    }, css), _react2.default.createElement(_CopyToClipboard2.default, {
      text: convert.rgbArray2css(color)
    }, function (isCopying) {
      return _react2.default.createElement(_Swatch2.default, {
        color: color,
        isCopying: isCopying,
        width: 20,
        height: 20
      });
    }))));
  }

  exports.default = PanelAppearance;
  PanelAppearance.propTypes = {
    color: _propTypes2.default.object
  };
  /***/
},
/* 397 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "wrapper": "PanelAppearance__wrapper___zz_yK marginBottom-m",
    "grid": "PanelAppearance__grid___D8tWS grid grid--m grid--3",
    "label": "PanelAppearance__label___3Zfj1 width-30 display-inlineBlock verticalAlign-top",
    "colour": "PanelAppearance__colour___1fyRW width-70 display-inlineBlock verticalAlign-top textAlign-right",
    "colourLabel": "PanelAppearance__colourLabel___14r8Z marginRight-xs display-inlineBlock verticalAlign-top"
  };
  /***/
},
/* 398 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PanelTypography;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _capitalize = __webpack_require__(73);

  var _capitalize2 = babelHelpers.interopRequireDefault(_capitalize);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  var _PanelGrid = __webpack_require__(46);

  var _PanelGrid2 = babelHelpers.interopRequireDefault(_PanelGrid);

  var _Label = __webpack_require__(32);

  var _Label2 = babelHelpers.interopRequireDefault(_Label);

  var _Value = __webpack_require__(47);

  var _Value2 = babelHelpers.interopRequireDefault(_Value);

  var _PanelGridItem = __webpack_require__(57);

  var _PanelGridItem2 = babelHelpers.interopRequireDefault(_PanelGridItem);

  var _Measurement = __webpack_require__(39);

  var _Measurement2 = babelHelpers.interopRequireDefault(_Measurement);

  function PanelTypography(props) {
    var panelItems = getPanelItems(props);
    return _react2.default.createElement(_Panel2.default, {
      header: 'Typography'
    }, _react2.default.createElement(_PanelGrid2.default, {
      columns: 2
    }, panelItems.map(function (_ref) {
      var label = _ref.label,
          value = _ref.value,
          itemProps = _ref.itemProps;
      return _react2.default.createElement(_PanelGridItem2.default, babelHelpers.extends({
        key: label
      }, itemProps), _react2.default.createElement(_Label2.default, null, label), _react2.default.createElement(_Value2.default, null, value));
    })));
  }

  function getPanelItems(_ref2) {
    var align = _ref2.align,
        fontFamily = _ref2.fontFamily,
        fontSize = _ref2.fontSize,
        fontWeight = _ref2.fontWeight,
        italic = _ref2.italic,
        letterSpacing = _ref2.letterSpacing,
        lineHeight = _ref2.lineHeight,
        strikethrough = _ref2.strikethrough,
        underline = _ref2.underline;
    var panelItems = [{
      label: 'Typeface',
      value: fontFamily,
      itemProps: {
        fullWidth: true
      }
    }, {
      label: 'Size',
      value: _react2.default.createElement(_Measurement2.default, {
        isText: true,
        value: fontSize
      })
    }, {
      label: 'Align',
      value: (0, _capitalize2.default)(align)
    }, {
      label: 'Font Weight',
      value: fontWeight
    }];

    if (letterSpacing !== 0) {
      panelItems.push({
        label: 'Letter Spacing',
        value: _react2.default.createElement(_Measurement2.default, {
          isText: true,
          value: letterSpacing
        })
      });
    }

    if (lineHeight) {
      panelItems.push({
        label: 'Line Spacing',
        value: _react2.default.createElement(_Measurement2.default, {
          isText: true,
          value: lineHeight
        })
      });
    }

    if (underline) {
      panelItems.push({
        label: 'Text Decoration',
        value: 'Underline'
      });
    } else if (strikethrough) {
      panelItems.push({
        label: 'Text Decoration',
        value: 'Strikethrough'
      });
    }

    if (italic) {
      panelItems.push({
        label: 'Font Style',
        value: 'Italic'
      });
    }

    return panelItems;
  }
  /* eslint-disable react/no-unused-prop-types */


  PanelTypography.propTypes = {
    align: _propTypes2.default.string.isRequired,
    fontFamily: _propTypes2.default.string.isRequired,
    fontSize: _propTypes2.default.number.isRequired,
    fontWeight: _propTypes2.default.number.isRequired,
    italic: _propTypes2.default.bool.isRequired,
    letterSpacing: _propTypes2.default.number,
    lineHeight: _propTypes2.default.number,
    strikethrough: _propTypes2.default.bool.isRequired,
    underline: _propTypes2.default.bool.isRequired
  };
  /***/
},
/* 399 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = HandoffShape;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _PanelProperties = __webpack_require__(59);

  var _PanelProperties2 = babelHelpers.interopRequireDefault(_PanelProperties);

  var _PanelCode = __webpack_require__(61);

  var _PanelCode2 = babelHelpers.interopRequireDefault(_PanelCode);

  var _Fills = __webpack_require__(400);

  var _Fills2 = babelHelpers.interopRequireDefault(_Fills);

  var _PanelBorder = __webpack_require__(60);

  var _PanelBorder2 = babelHelpers.interopRequireDefault(_PanelBorder);

  var _PanelShadows = __webpack_require__(62);

  var _PanelShadows2 = babelHelpers.interopRequireDefault(_PanelShadows);

  function HandoffShape() {
    return _react2.default.createElement('div', null, _react2.default.createElement(_PanelProperties2.default, null), _react2.default.createElement(_Fills2.default, null), _react2.default.createElement(_PanelBorder2.default, null), _react2.default.createElement(_PanelShadows2.default, null), _react2.default.createElement(_PanelCode2.default, null));
  }
  /***/

},
/* 400 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _Fills = __webpack_require__(138);

  var _Fills2 = babelHelpers.interopRequireDefault(_Fills);

  var _handoff = __webpack_require__(5);

  var _element = __webpack_require__(16);

  var elementUtils = babelHelpers.interopRequireWildcard(_element);

  function mapStateToProps(state) {
    var element = (0, _handoff.getSelectedElement)(state);

    if (!element) {
      return {};
    }

    var fills = elementUtils.getFills(element);

    if (!fills.length) {
      return {};
    }

    return {
      fills: fills
    };
  }

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(function (props) {
    return props.fills;
  }))(_Fills2.default);
  /***/
},
/* 401 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = HandoffGroup;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _PanelProperties = __webpack_require__(59);

  var _PanelProperties2 = babelHelpers.interopRequireDefault(_PanelProperties);

  var _PanelBorder = __webpack_require__(60);

  var _PanelBorder2 = babelHelpers.interopRequireDefault(_PanelBorder);

  var _PanelCode = __webpack_require__(61);

  var _PanelCode2 = babelHelpers.interopRequireDefault(_PanelCode);

  var _PanelShadows = __webpack_require__(62);

  var _PanelShadows2 = babelHelpers.interopRequireDefault(_PanelShadows);

  function HandoffGroup() {
    return _react2.default.createElement('div', null, _react2.default.createElement(_PanelProperties2.default, null), _react2.default.createElement(_PanelBorder2.default, null), _react2.default.createElement(_PanelShadows2.default, null), _react2.default.createElement(_PanelCode2.default, null));
  }
  /***/

},
/* 402 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _compose = __webpack_require__(24);

  var _compose2 = babelHelpers.interopRequireDefault(_compose);

  var _Header = __webpack_require__(403);

  var _Header2 = babelHelpers.interopRequireDefault(_Header);

  var _handoff = __webpack_require__(5);

  var specSelectors = babelHelpers.interopRequireWildcard(_handoff);

  var _element = __webpack_require__(16);

  var elementUtils = babelHelpers.interopRequireWildcard(_element);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state) {
    var element = specSelectors.getSelectedElement(state);

    if (!element) {
      return {};
    }

    return {
      isDownloadable: elementUtils.hasAssets(element),
      layerName: elementUtils.getLayerName(element),
      layerType: specSelectors.getSelectedElementType(state)
    };
  }

  exports.default = (0, _compose2.default)((0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(function (props) {
    return props.layerType;
  }))(_Header2.default);
  /***/
},
/* 403 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Header;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Header = __webpack_require__(152);

  var _Header2 = babelHelpers.interopRequireDefault(_Header);

  var _icons = __webpack_require__(14);

  function Header(_ref) {
    var layerName = _ref.layerName,
        layerType = _ref.layerType;
    var icon = void 0;

    if (layerType === 'group') {
      icon = _react2.default.createElement(_icons.GroupIcon, null);
    } else if (layerType === 'text') {
      icon = _react2.default.createElement(_icons.TextIcon, null);
    } else if (layerType === 'shape') {
      icon = _react2.default.createElement(_icons.ShapeIcon, null);
    } else if (layerType === 'raster') {
      icon = _react2.default.createElement(_icons.ImageIcon, null);
    }

    return _react2.default.createElement('div', {
      className: _Header2.default.header
    }, icon && _react2.default.createElement('div', {
      className: _Header2.default.icon
    }, _react2.default.createElement('div', {
      className: _Header2.default.iconContainer
    }, icon)), _react2.default.createElement('div', {
      className: _Header2.default.heading,
      style: {
        paddingLeft: 40
      }
    }, layerName));
  }

  Header.propTypes = {
    layerName: _propTypes2.default.string.isRequired,
    layerType: _propTypes2.default.string.isRequired
  };
  /***/
},
/* 404 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _compose = __webpack_require__(24);

  var _compose2 = babelHelpers.interopRequireDefault(_compose);

  var _SelectedElementAssets = __webpack_require__(405);

  var _SelectedElementAssets2 = babelHelpers.interopRequireDefault(_SelectedElementAssets);

  var _handoff = __webpack_require__(5);

  var handoff = babelHelpers.interopRequireWildcard(_handoff);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _element = __webpack_require__(16);

  function mapStateToProps(state) {
    var element = handoff.getSelectedElement(state);

    if (!element) {
      return {};
    }

    if (!(0, _element.hasAssets)(element)) {
      return {};
    }

    return {
      element: element
    };
  }

  exports.default = (0, _compose2.default)((0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(function (props) {
    return props.element;
  }))(_SelectedElementAssets2.default);
  /***/
},
/* 405 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = SelectedElementAssets;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _ElementAssets = __webpack_require__(148);

  var _ElementAssets2 = babelHelpers.interopRequireDefault(_ElementAssets);

  var _Panel = __webpack_require__(17);

  var _Panel2 = babelHelpers.interopRequireDefault(_Panel);

  function SelectedElementAssets(_ref) {
    var element = _ref.element;
    return _react2.default.createElement(_Panel2.default, {
      header: 'Assets',
      withoutPadding: true
    }, _react2.default.createElement(_ElementAssets2.default, {
      element: element
    }));
  }

  SelectedElementAssets.propTypes = {
    element: _propTypes2.default.object.isRequired
  };
  /***/
},
/* 406 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _Player = __webpack_require__(407);

  var _Player2 = babelHelpers.interopRequireDefault(_Player);

  var _player = __webpack_require__(164);

  var _screen = __webpack_require__(9);

  var _hotspot = __webpack_require__(28);

  var _handoff = __webpack_require__(5);

  var mapStateToProps = function mapStateToProps(state) {
    return {
      isInHandoffMode: (0, _handoff.isInHandoffMode)(state),
      isPlaying: (0, _player.isPlaying)(state),
      areInitialScreensPreloaded: (0, _screen.areInitialScreensPreloaded)(state),
      areHotspotsLoaded: (0, _hotspot.areHotspotsLoaded)(state),
      transition: state.screen.transition,
      backgroundColor: state.project.config.screenBackgroundColour,
      isEmpty: (0, _get2.default)(state, 'project.config.screens.length') === 0
    };
  };

  exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(_Player2.default);
  /***/
},
/* 407 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Player;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _LoadingScreen = __webpack_require__(408);

  var _LoadingScreen2 = babelHelpers.interopRequireDefault(_LoadingScreen);

  var _Device = __webpack_require__(418);

  var _Device2 = babelHelpers.interopRequireDefault(_Device);

  var _PreviewScreen = __webpack_require__(422);

  var _PreviewScreen2 = babelHelpers.interopRequireDefault(_PreviewScreen);

  var _CurrentScreen = __webpack_require__(428);

  var _CurrentScreen2 = babelHelpers.interopRequireDefault(_CurrentScreen);

  var _PreviousScreen = __webpack_require__(501);

  var _PreviousScreen2 = babelHelpers.interopRequireDefault(_PreviousScreen);

  var _StatusBarUnderlay = __webpack_require__(502);

  var _StatusBarUnderlay2 = babelHelpers.interopRequireDefault(_StatusBarUnderlay);

  var _EmptyProject = __webpack_require__(504);

  var _EmptyProject2 = babelHelpers.interopRequireDefault(_EmptyProject);

  var _Player = __webpack_require__(506);

  var _Player2 = babelHelpers.interopRequireDefault(_Player);

  function Player(_ref) {
    var isPlaying = _ref.isPlaying,
        isInHandoffMode = _ref.isInHandoffMode,
        areInitialScreensPreloaded = _ref.areInitialScreensPreloaded,
        areHotspotsLoaded = _ref.areHotspotsLoaded,
        transition = _ref.transition,
        backgroundColor = _ref.backgroundColor,
        isEmpty = _ref.isEmpty;

    if (isEmpty) {
      return _react2.default.createElement(_Device2.default, null, _react2.default.createElement(_EmptyProject2.default, null));
    }

    var className = (0, _classnames2.default)(_Player2.default.player, _Player2.default[transition], babelHelpers.defineProperty({}, _Player2.default.handoffMode, isInHandoffMode));
    var style = isInHandoffMode ? undefined : {
      backgroundColor: '#' + backgroundColor
    };
    return _react2.default.createElement(_Device2.default, null, _react2.default.createElement('div', null, _react2.default.createElement('div', {
      className: className,
      style: style
    }, !isInHandoffMode && _react2.default.createElement(_StatusBarUnderlay2.default, null), isPlaying && areInitialScreensPreloaded && areHotspotsLoaded ? _react2.default.createElement('div', null, _react2.default.createElement(_PreviousScreen2.default, {
      key: 'previous'
    }), _react2.default.createElement(_CurrentScreen2.default, {
      key: 'current'
    })) : _react2.default.createElement(_PreviewScreen2.default, null)), _react2.default.createElement(_LoadingScreen2.default, null)));
  }

  Player.propTypes = {
    isPlaying: _propTypes2.default.bool.isRequired,
    isInHandoffMode: _propTypes2.default.bool.isRequired,
    areInitialScreensPreloaded: _propTypes2.default.bool.isRequired,
    areHotspotsLoaded: _propTypes2.default.bool.isRequired,
    transition: _propTypes2.default.string,
    backgroundColor: _propTypes2.default.string.isRequired,
    isEmpty: _propTypes2.default.bool.isRequired
  };
  /***/
},
/* 408 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _LoadingScreen = __webpack_require__(409);

  var _LoadingScreen2 = babelHelpers.interopRequireDefault(_LoadingScreen);

  var _screen = __webpack_require__(9);

  var _hotspot = __webpack_require__(28);

  var _project = __webpack_require__(11);

  function mapStateToProps(state) {
    return babelHelpers.extends({
      isPro: (0, _project.isPro)(state),
      areHotspotsLoaded: (0, _hotspot.areHotspotsLoaded)(state),
      isEmbedded: (0, _project.isEmbedded)(state)
    }, (0, _screen.getPendingAndLoadedScreenCounts)(state), (0, _project.getCompanyColourAndLogo)(state));
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_LoadingScreen2.default);
  /***/
},
/* 409 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = LoadingScreen;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _LoadingLogo = __webpack_require__(410);

  var _LoadingLogo2 = babelHelpers.interopRequireDefault(_LoadingLogo);

  var _InitialLoadProgress = __webpack_require__(414);

  var _InitialLoadProgress2 = babelHelpers.interopRequireDefault(_InitialLoadProgress);

  var _LoadingScreen = __webpack_require__(417);

  var _LoadingScreen2 = babelHelpers.interopRequireDefault(_LoadingScreen);

  function LoadingScreen(_ref) {
    var noOfPendingImages = _ref.noOfPendingImages,
        noOfLoadedImages = _ref.noOfLoadedImages,
        isPro = _ref.isPro,
        isEmbedded = _ref.isEmbedded,
        areHotspotsLoaded = _ref.areHotspotsLoaded,
        companyIcon = _ref.companyIcon,
        companyColour = _ref.companyColour;

    if (isEmbedded) {
      return null;
    }

    if (noOfPendingImages === 0 && areHotspotsLoaded) {
      return null;
    }

    var noOfSteps = noOfPendingImages + noOfLoadedImages;
    var completedStep = noOfLoadedImages;
    var backgroundStyle = (0, _classnames2.default)(_LoadingScreen2.default.loader, !companyColour && {
      'bg-white': isPro,
      'bg-blue': !isPro
    });
    return _react2.default.createElement('div', {
      className: backgroundStyle,
      style: companyColour ? {
        backgroundColor: '#' + companyColour
      } : undefined
    }, _react2.default.createElement('div', {
      className: (0, _classnames2.default)('position-absolute', 'pinAll')
    }, _react2.default.createElement('div', {
      className: (0, _classnames2.default)('display-table', 'width-100', 'height-100')
    }, _react2.default.createElement('div', {
      className: (0, _classnames2.default)('display-tableCell', 'verticalAlign-middle')
    }, _react2.default.createElement('div', {
      className: (0, _classnames2.default)('marginBottom-l')
    }, _react2.default.createElement(_LoadingLogo2.default, {
      companyIcon: companyIcon,
      isPro: isPro
    })), _react2.default.createElement(_InitialLoadProgress2.default, {
      isPro: isPro,
      companyColour: companyColour,
      noOfImagesToPreload: noOfSteps,
      noOfImagesLoaded: completedStep
    })))));
  }

  LoadingScreen.propTypes = {
    isPro: _propTypes2.default.bool.isRequired,
    isEmbedded: _propTypes2.default.bool.isRequired,
    areHotspotsLoaded: _propTypes2.default.bool,
    noOfPendingImages: _propTypes2.default.number.isRequired,
    noOfLoadedImages: _propTypes2.default.number.isRequired,
    companyIcon: _propTypes2.default.string,
    companyColour: _propTypes2.default.string
  };
  LoadingScreen.defaultProps = {
    isEmbedded: false,
    noOfPendingImages: 0,
    noOfLoadedImages: 0
  };
  /***/
},
/* 410 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = LoadingLogo;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _Logo = __webpack_require__(411);

  var _Logo2 = babelHelpers.interopRequireDefault(_Logo);

  var _LoadingLogo = __webpack_require__(413);

  var _LoadingLogo2 = babelHelpers.interopRequireDefault(_LoadingLogo);

  function LoadingLogo(_ref) {
    var companyIcon = _ref.companyIcon,
        isPro = _ref.isPro;

    if (isPro) {
      if (companyIcon) {
        return _react2.default.createElement('img', {
          src: companyIcon,
          className: _LoadingLogo2.default.image
        });
      }

      return null;
    }

    return _react2.default.createElement(_Logo2.default, null);
  }

  LoadingLogo.propTypes = {
    companyIcon: _propTypes2.default.string,
    isPro: _propTypes2.default.bool.isRequired
  };
  /***/
},
/* 411 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Logo;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _marvelURL = __webpack_require__(38);

  var marvelURL = babelHelpers.interopRequireWildcard(_marvelURL);

  var _Logo = __webpack_require__(412);

  var _Logo2 = babelHelpers.interopRequireDefault(_Logo);
  /* eslint-disable max-len */


  function Logo() {
    return _react2.default.createElement('a', {
      href: marvelURL.HOMEPAGE,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, _react2.default.createElement('svg', {
      className: (0, _classnames2.default)(_Logo2.default.logo, 'fill-white'),
      width: '80',
      height: '34.6',
      viewBox: '0 19.8 80 34.6',
      enableBackground: 'new 0 19.8 80 34.6'
    }, _react2.default.createElement('path', {
      d: 'M67.9 42.1c-29.1-2.3-53.2 4.8-58.6 7.4-3 1.4-3.2 3.1-2.8 4.1.3.8 1.8 1.2 3.4.4 11.6-6.2 35-11.1 58-9.7 1.1-.1 1.6-2 0-2.2zm7.2-8.7c-1.3 1.4-3 2.4-3.6 1.9-.6-.5 0-2.1 0-2.1 2.9-1.8 8.5-6.6 8.5-10.2 0-3.4-3-4.4-6.2-1.3-2.2 2.1-4.3 6-5.4 9.9-1.6 1.6-4.2 3.7-6.6 3.7-1.3 0-1.6-.9-1.4-2 2-.1 7.5-1.6 7.5-6.3-.1-2-1.6-2.7-3.1-2.7-2.5 0-5.7 2.6-7.3 6.2-.4-.1-.9-.2-1.3-.5.5-1.1.9-2.1.9-2.7.3-1.9-.5-3.1-2-3-1 .1-2.2.9-2.4 3-.2 1.4.5 3 .5 3-.5 2.1-3.2 4.8-4.2 4.7-.9 0 .2-3.9 1.1-6.7.5-.6 1-1.3 1.3-1.9.2-.9-.1-1.3-.5-1.6-.6-.5-2.6-.3-3.7 1.6-.3.5-.6 1.3-1 2.2-.8.9-2 2.2-2.4 2-.5-.3 1.2-2.7.9-4-.2-1.2-1.2-1.8-2.2-1.7-1.5.2-3.5 3.3-3.5 3.3s.4-.9.4-1.7c-.1-1.1-2.2-1.6-3.2.5-.4.8-1 3.5-1.6 6.1-.5.9-2.2 3.7-3.5 3.8-1.1.1.2-4.9.4-5.2.6-.9 1.4-2.9 1.3-3.8-.1-1.2-.9-1.4-1.6-1.3-1.1.2-1.6 1.3-1.6 1.3s-.6-.9-2.1-.8c-4.6.5-7.6 8.5-7.2 12.3.2 2 1.3 3.3 3 3.1 2-.2 3.7-3.2 3.7-3.2s.5 2.4 2.6 2.1c1.4-.2 2.9-1.5 4.1-2.8-.1.2-.1.5-.1.5-.3 2 3.1 1.8 3.3.2 1-7.7 3.5-10.9 4.3-10.9.6 0-1.6 3.6-.3 5 1 1.2 2.7.2 4.2-1-.2 1-.4 2-.4 3-.1 2.2.7 3.9 2.8 3.8 2.8-.1 5.7-3.5 7.7-6.8.5.3 1 .5 1.6.7-.2.8-.2 1.6-.2 2.4.2 2.5 1.9 3.5 3.9 3.4 2.4-.1 5.1-1.9 7.1-3.5 0 .1 0 .2-.1.2-.2 1.2.1 3.5 1.8 3.5 2 .2 5.5-1.9 7.2-4.1 1.1-1.4-.3-2.8-1.4-1.6zm1.9-10.4c.2 0 .3.2.3.5 0 2.1-5.4 6.7-5.4 6.7s3.6-7.2 5.1-7.2zm-13 4.5c.5 0 .6.2.6.7 0 1.2-1.6 2.1-3.5 2.2 1-1.5 2.1-2.9 2.9-2.9zm-36.1 3.4c-.2 1.3-2.4 7.1-3.7 7.1-1.6.1.8-8.2 3.3-8.2.6.1.6.4.4 1.1zm-19.6 1.6c1.5 0-1.2 7.7-.9 11.1.3 3.4 4.1 2.4 3.8.5-.4-3.3 1.8-13.7 4.1-13.7 1.6 0-1.8 7.1-1.1 11.7.5 3 4.5 2 4 .2-1.3-5.9 2.9-11.6 2.4-15.7-.2-1.7-1.3-2.7-2.4-2.7-3.8 0-6.7 7.6-6.7 7.6s.3-4.3-2.7-4.5c-4.4-.3-8.9 10.7-8.8 20.7.1 3.2 4.1 2.7 3.8.1-.3-4.7 2.3-15.3 4.5-15.3z'
    })));
  }
  /***/

},
/* 412 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "logo": "Logo__logo___2Ogce",
    "breathing": "Logo__breathing___s9URU"
  };
  /***/
},
/* 413 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "image": "LoadingLogo__image___1E5kz display-block centered width-60"
  };
  /***/
},
/* 414 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = InitialLoadProgress;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _ProgressBar = __webpack_require__(415);

  var _ProgressBar2 = babelHelpers.interopRequireDefault(_ProgressBar);

  var _InitialLoadProgress = __webpack_require__(416);

  var _InitialLoadProgress2 = babelHelpers.interopRequireDefault(_InitialLoadProgress);

  var API_LOADED_PROGRESS = 1 / 3;

  function InitialLoadProgress(_ref) {
    var isPro = _ref.isPro,
        companyColour = _ref.companyColour,
        noOfImagesToPreload = _ref.noOfImagesToPreload,
        noOfImagesLoaded = _ref.noOfImagesLoaded;
    var backgroundStyle = (0, _classnames2.default)(_InitialLoadProgress2.default.background, {
      'bg-smoke': isPro,
      'bg-white': !isPro
    });
    var foregroundStyle = (0, _classnames2.default)(_InitialLoadProgress2.default.foreground, !companyColour && {
      'bg-green--l': isPro,
      'bg-blue--l': !isPro
    }, companyColour && _InitialLoadProgress2.default.companyColor);
    return _react2.default.createElement('div', {
      className: backgroundStyle
    }, _react2.default.createElement(_ProgressBar2.default, {
      noOfSteps: noOfImagesToPreload,
      completedStep: noOfImagesLoaded,
      initialProgress: API_LOADED_PROGRESS
    }, _react2.default.createElement('div', {
      style: companyColour ? {
        backgroundColor: '#' + companyColour
      } : undefined,
      className: foregroundStyle
    })));
  }

  InitialLoadProgress.propTypes = {
    isPro: _propTypes2.default.bool.isRequired,
    companyColour: _propTypes2.default.string,
    noOfImagesToPreload: _propTypes2.default.number.isRequired,
    noOfImagesLoaded: _propTypes2.default.number.isRequired
  };
  /***/
},
/* 415 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ProgressBar;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _velocityReact = __webpack_require__(23);

  function ProgressBar(_ref) {
    var noOfSteps = _ref.noOfSteps,
        completedStep = _ref.completedStep,
        _ref$initialProgress = _ref.initialProgress,
        initialProgress = _ref$initialProgress === undefined ? 0 : _ref$initialProgress,
        children = _ref.children,
        _ref$duration = _ref.duration,
        duration = _ref$duration === undefined ? 300 : _ref$duration,
        onAnimationComplete = _ref.onAnimationComplete;
    var animation = getAnimation(initialProgress, noOfSteps, completedStep);
    return _react2.default.createElement(_velocityReact.VelocityComponent, {
      animation: animation,
      duration: duration,
      complete: onAnimationComplete,
      runOnMount: true
    }, children);
  }

  ProgressBar.propTypes = {
    noOfSteps: _propTypes2.default.number.isRequired,
    completedStep: _propTypes2.default.number.isRequired,
    initialProgress: _propTypes2.default.number,
    children: _propTypes2.default.node.isRequired,
    duration: _propTypes2.default.number,
    onAnimationComplete: _propTypes2.default.func
  };

  function getAnimation(initialProgress, noOfSteps, completedStep) {
    var currentProgress = getProgressForCompletedStep(noOfSteps, initialProgress, completedStep);
    var previousProgress = void 0;

    if (completedStep === 0) {
      previousProgress = 0;
    } else {
      previousProgress = getProgressForCompletedStep(noOfSteps, initialProgress, completedStep - 1);
    }

    var animation = {
      width: [toPct(currentProgress), 'ease-in-out', toPct(previousProgress)]
    };

    if (completedStep === noOfSteps) {
      animation.opacity = [0, 'ease-in-out', 1];
    }

    return animation;
  }

  function getProgressForCompletedStep(noOfSteps, initialProgress, completedStep) {
    return completedStep * ((1 - initialProgress) / noOfSteps) + initialProgress;
  }

  function toPct(value) {
    return Math.round(value * 100) + '%';
  }
  /***/

},
/* 416 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "background": "InitialLoadProgress__background___3zrAQ",
    "foreground": "InitialLoadProgress__foreground___cekTc",
    "companyColor": "InitialLoadProgress__companyColor___Z7JeE"
  };
  /***/
},
/* 417 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "loader": "LoadingScreen__loader___25Rve"
  };
  /***/
},
/* 418 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _Device = __webpack_require__(419);

  var _Device2 = babelHelpers.interopRequireDefault(_Device);

  var _actionCreators = __webpack_require__(4);

  var _annotation = __webpack_require__(20);

  var _project = __webpack_require__(11);

  var _device = __webpack_require__(96);

  var _handoff = __webpack_require__(5);

  var mapStateToProps = function mapStateToProps(state) {
    return babelHelpers.extends({
      statusBar: state.project.config.statusBar,
      orientation: (0, _project.getOrientation)(state),
      dimensions: (0, _device.getDimensions)(state),
      isShowingHotspots: state.hotspots,
      backgroundColour: state.project.config.backgroundColour,
      hotspot: null,
      // getHotspot(state, hotspotID)
      isMobile: state.deviceDetection.isMobile,
      isWeb: state.project.config.isWeb,
      isEmbedded: state.project.isEmbedded,
      isFrameless: state.project.isFrameless,
      isInAnnotationMode: (0, _annotation.isInAnnotationMode)(state),
      isInHandoffMode: (0, _handoff.isInHandoffMode)(state)
    }, state.project.config.device);
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      onScreenResize: function onScreenResize(renderedScreenDimensions) {
        return dispatch((0, _actionCreators.screenResized)(renderedScreenDimensions));
      }
    };
  };

  exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Device2.default);
  /***/
},
/* 419 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  __webpack_require__(420);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _values = __webpack_require__(95);

  var _values2 = babelHelpers.interopRequireDefault(_values);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _orientation = __webpack_require__(44);

  var deviceOrientation = babelHelpers.interopRequireWildcard(_orientation);

  var _resizeRootId = __webpack_require__(157);

  var _resizeRootId2 = babelHelpers.interopRequireDefault(_resizeRootId);

  var _Device = __webpack_require__(421);

  var _Device2 = babelHelpers.interopRequireDefault(_Device);

  var Device = function (_Component) {
    babelHelpers.inherits(Device, _Component);

    function Device() {
      var _ref;

      var _temp, _this, _ret;

      babelHelpers.classCallCheck(this, Device);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = Device.__proto__ || Object.getPrototypeOf(Device)).call.apply(_ref, [this].concat(args))), _this), _this.updateDeviceDimensions = function () {
        var MARGIN_PCT = 0.02;
        var _this$props = _this.props,
            onScreenResize = _this$props.onScreenResize,
            dimensions = _this$props.dimensions;
        var width = dimensions.width,
            height = dimensions.height,
            padding = dimensions.padding,
            borderRadius = dimensions.borderRadius;
        var rootWidth = _this._root.offsetWidth;
        var rootHeight = _this._root.offsetHeight;
        var deviceOuterWidth = width + padding[1] + padding[3];
        var deviceOuterHeight = height + padding[0] + padding[2];
        var scaleRatio = 1;

        if (_this.isFullScreen()) {
          // Full screen mode
          width = rootWidth;
          height = rootHeight;
          padding = [0, 0, 0, 0];
        } else if (rootHeight < deviceOuterHeight || rootWidth < deviceOuterWidth) {
          // Responsive mode
          scaleRatio = Math.min(rootWidth / deviceOuterWidth, rootHeight / deviceOuterHeight) - MARGIN_PCT;
          width *= scaleRatio;
          height *= scaleRatio;
          padding = padding.map(function (p) {
            return p * scaleRatio;
          });
        }

        if (borderRadius) {
          borderRadius *= scaleRatio;
        }

        onScreenResize({
          width: width,
          height: height,
          padding: padding
        });

        _this.setState({
          width: width,
          height: height,
          padding: padding,
          borderRadius: borderRadius
        });
      }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
    }

    babelHelpers.createClass(Device, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this._root = document.getElementById(_resizeRootId2.default);

        if (!this._root) {
          if (false) {
            // This might happen in karma when using shallow rendering
            this._root = document.body;
          } else {
            throw new Error('Cannot find Prototype root node');
          }
        }

        this.updateDeviceDimensions();
        window.addResizeListener(this._root, this.updateDeviceDimensions);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;

        var keys = ['orientation', 'frame', 'isMobile', 'isWeb', 'isInHandoffMode'];
        var updateDimensions = keys.some(function (key) {
          return _this2.props[key] !== prevProps[key];
        });

        if (updateDimensions) {
          this.updateDeviceDimensions();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeResizeListener(this._root, this.updateDeviceDimensions);
      }
    }, {
      key: 'isFullScreen',
      value: function isFullScreen() {
        return this.props.isMobile && !this.props.isEmbedded || this.props.isWeb || this.props.isInHandoffMode || this.props.isFrameless;
      }
    }, {
      key: 'render',
      value: function render() {
        if (!this.state) {
          // First render
          return null;
        }

        var _props = this.props,
            frame = _props.frame,
            orientation = _props.orientation,
            backgroundColour = _props.backgroundColour,
            isEmbedded = _props.isEmbedded,
            isInAnnotationMode = _props.isInAnnotationMode,
            children = _props.children;

        if (this.isFullScreen()) {
          return children;
        }

        var _state = this.state,
            width = _state.width,
            height = _state.height,
            padding = _state.padding,
            borderRadius = _state.borderRadius;
        var deviceClass = (0, _classnames2.default)(_Device2.default.device, _Device2.default[frame], _Device2.default[[frame, orientation].join('-')]);
        var deviceStyle = {
          width: width,
          height: height,
          padding: padding.map(function (p) {
            return p + 'px';
          }).join(' ')
        }; // TODO need to sort out setting the presentation background on
        // Project instead. For now ignoring the background colour so the
        // annotation mode background shows through.

        var wrapperStyle = {
          backgroundColor: isEmbedded || isInAnnotationMode ? 'transparent' : '#' + backgroundColour
        };
        return _react2.default.createElement('div', {
          className: _Device2.default.deviceWrapper,
          style: wrapperStyle
        }, _react2.default.createElement('div', {
          className: deviceClass,
          style: deviceStyle
        }, _react2.default.createElement('div', {
          className: _Device2.default.deviceScreenBorder,
          style: {
            width: width,
            height: height,
            borderRadius: borderRadius
          }
        }, children)));
      }
    }]);
    return Device;
  }(_react.Component);

  Device.propTypes = {
    orientation: _propTypes2.default.oneOf((0, _values2.default)(deviceOrientation)).isRequired,
    frame: _propTypes2.default.string.isRequired,
    dimensions: _propTypes2.default.object.isRequired,
    isMobile: _propTypes2.default.bool.isRequired,
    isEmbedded: _propTypes2.default.bool.isRequired,
    isInAnnotationMode: _propTypes2.default.bool.isRequired,
    isInHandoffMode: _propTypes2.default.bool.isRequired,
    isFrameless: _propTypes2.default.bool.isRequired,
    isWeb: _propTypes2.default.bool.isRequired,
    onScreenResize: _propTypes2.default.func.isRequired,
    backgroundColour: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.node.isRequired
  };
  Device.defaultProps = {
    onScreenResize: _noop2.default,
    isEmbedded: false,
    isFrameless: false,
    backgroundColour: 'transparent'
  };
  exports.default = Device;
  /***/
},
/* 420 */

/***/
function (module, exports) {
  module.exports = require("javascript-detect-element-resize");
  /***/
},
/* 421 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "deviceWrapper": "Device__deviceWrapper___2oPKn",
    "device": "Device__device___10K_k",
    "deviceScreenBorder": "Device__deviceScreenBorder___QgTTP",
    "nexus5-frame": "Device__nexus5-frame___20Shg",
    "iphonex-frame": "Device__iphonex-frame___3AtIa",
    "iphone5c-frame": "Device__iphone5c-frame___2rs3L",
    "iphone5-frame": "Device__iphone5-frame___1LUbT",
    "iphone6-frame": "Device__iphone6-frame___dALg2",
    "iphone6plus-frame": "Device__iphone6plus-frame___3bClA",
    "ipad-frame": "Device__ipad-frame___3Cb6D",
    "iphonex-frame-portrait": "Device__iphonex-frame-portrait___3X88f",
    "iphonex-frame-landscape": "Device__iphonex-frame-landscape___1NtFf",
    "apple-watch-42-frame-portrait": "Device__apple-watch-42-frame-portrait___215n4",
    "ipad-frame-portrait": "Device__ipad-frame-portrait___2RZzD",
    "ipad-frame-landscape": "Device__ipad-frame-landscape___3LIut",
    "iphone4s-frame-portrait": "Device__iphone4s-frame-portrait___2whAF",
    "iphone4s-frame-landscape": "Device__iphone4s-frame-landscape___5fcol",
    "iphone5c-frame-portrait": "Device__iphone5c-frame-portrait___2ACw6",
    "iphone5c-frame-landscape": "Device__iphone5c-frame-landscape___2pyGI",
    "iphone5-frame-portrait": "Device__iphone5-frame-portrait___FvhN5",
    "iphone5-frame-landscape": "Device__iphone5-frame-landscape___29inQ",
    "iphone6-frame-portrait": "Device__iphone6-frame-portrait___U3Ydb",
    "iphone6-frame-landscape": "Device__iphone6-frame-landscape___1OHwY",
    "iphone6plus-frame-portrait": "Device__iphone6plus-frame-portrait___3BVhM",
    "iphone6plus-frame-landscape": "Device__iphone6plus-frame-landscape___4rn7q",
    "nexus5-frame-portrait": "Device__nexus5-frame-portrait___JggD-",
    "nexus5-frame-landscape": "Device__nexus5-frame-landscape___d1voJ",
    "lumia920-frame-portrait": "Device__lumia920-frame-portrait___2ad1D",
    "lumia920-frame-landscape": "Device__lumia920-frame-landscape___23CdP"
  };
  /***/
},
/* 422 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _PreviewScreen = __webpack_require__(423);

  var _PreviewScreen2 = babelHelpers.interopRequireDefault(_PreviewScreen);

  var _screen = __webpack_require__(9);

  var _layout = __webpack_require__(15);

  function mapStateToProps(state) {
    var _getScreenStyles = (0, _layout.getScreenStyles)(state, true),
        imageWidth = _getScreenStyles.imageWidth,
        imageHeight = _getScreenStyles.imageHeight;

    var imageURL = (0, _screen.getPreviewScreenImgURL)(state);
    return {
      imageWidth: imageWidth,
      imageHeight: imageHeight,
      imageURL: imageURL
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_PreviewScreen2.default);
  /***/
},
/* 423 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PreviewScreen;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _PlayButton = __webpack_require__(424);

  var _PlayButton2 = babelHelpers.interopRequireDefault(_PlayButton);

  var _PreviewScreen = __webpack_require__(427);

  var _PreviewScreen2 = babelHelpers.interopRequireDefault(_PreviewScreen);

  function PreviewScreen(_ref) {
    var imageURL = _ref.imageURL,
        imageWidth = _ref.imageWidth,
        imageHeight = _ref.imageHeight;
    var stretchedImageWidth = Math.ceil(imageWidth);
    var stretchedImageHeight = Math.ceil(imageHeight);
    return _react2.default.createElement('div', {
      className: (0, _classnames2.default)(_PreviewScreen2.default.preview, 'position-absolute pinAll'),
      style: {
        backgroundImage: 'url(' + imageURL + ')',
        backgroundSize: stretchedImageWidth + 'px ' + stretchedImageHeight + 'px',
        backgroundPosition: '50% 0'
      }
    }, _react2.default.createElement(_PlayButton2.default, null));
  }

  PreviewScreen.propTypes = {
    imageURL: _propTypes2.default.string.isRequired,
    imageWidth: _propTypes2.default.number.isRequired,
    imageHeight: _propTypes2.default.number.isRequired
  };
  /***/
},
/* 424 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _assign = __webpack_require__(21);

  var _assign2 = babelHelpers.interopRequireDefault(_assign);

  var _PlayButton = __webpack_require__(425);

  var _PlayButton2 = babelHelpers.interopRequireDefault(_PlayButton);

  var _actionCreators = __webpack_require__(4);

  var _screen = __webpack_require__(9);

  var _project = __webpack_require__(11);

  function mapStateToProps(state) {
    return {
      hasTouch: state.deviceDetection.hasTouch,
      isAppleWatch: (0, _project.isAppleWatch)(state),
      isLoading: state.player.isAboutToPlay || !(0, _screen.areInitialScreensPreloaded)(state),
      projectID: state.project.config.id
    };
  }

  function mergeProps(stateProps, _ref, ownProps) {
    var dispatch = _ref.dispatch;
    var newProps = {
      onClick: function onClick() {
        if (!stateProps.isLoading) {
          dispatch((0, _actionCreators.play)(stateProps.projectID));
        }
      }
    };
    return (0, _assign2.default)({}, ownProps, stateProps, newProps);
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, null, mergeProps)(_PlayButton2.default);
  /***/
},
/* 425 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PlayButton;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _icons = __webpack_require__(14);

  var _PlayButton = __webpack_require__(426);

  var _PlayButton2 = babelHelpers.interopRequireDefault(_PlayButton);

  function PlayButton(_ref) {
    var _cx;

    var hasTouch = _ref.hasTouch,
        isAppleWatch = _ref.isAppleWatch,
        isLoading = _ref.isLoading,
        onClick = _ref.onClick;
    var icon = hasTouch ? _react2.default.createElement(_icons.TapIcon, null) : _react2.default.createElement(_icons.ClickIcon, null);
    var action = hasTouch ? 'Tap' : 'Click';
    var message = action + ' anywhere to interact with this prototype';
    var size = hasTouch ? 60 : 52;
    var boxClasses = (0, _classnames2.default)(_PlayButton2.default.box, (_cx = {}, babelHelpers.defineProperty(_cx, _PlayButton2.default.fontBig, !isAppleWatch), babelHelpers.defineProperty(_cx, _PlayButton2.default.fontSmall, isAppleWatch), babelHelpers.defineProperty(_cx, _PlayButton2.default.loading, isLoading && isAppleWatch), _cx));
    var loadingProps = {
      className: _PlayButton2.default.loading,
      style: {
        width: size,
        height: size
      }
    };
    var messageStyle = {
      opacity: isLoading && isAppleWatch ? 0 : 1
    };
    return _react2.default.createElement('div', {
      className: _PlayButton2.default.position,
      onClick: onClick
    }, _react2.default.createElement('div', {
      className: _PlayButton2.default.table
    }, _react2.default.createElement('div', {
      className: _PlayButton2.default.cell
    }, _react2.default.createElement('div', {
      className: boxClasses
    }, !isAppleWatch && _react2.default.createElement('div', {
      className: _PlayButton2.default.icon
    }, isLoading ? _react2.default.createElement('div', loadingProps) : icon), _react2.default.createElement('div', {
      style: messageStyle
    }, message)))));
  }

  PlayButton.propTypes = {
    hasTouch: _propTypes2.default.bool.isRequired,
    isAppleWatch: _propTypes2.default.bool.isRequired,
    isLoading: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
  };
  PlayButton.defaultProps = {
    hasTouch: false,
    isAppleWatch: false,
    isLoading: false
  };
  /***/
},
/* 426 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "position": "PlayButton__position___2zDiu cursor-pointer padding-m pinAll position-absolute textAlign-center",
    "table": "PlayButton__table___1om7F display-table height-100 width-100",
    "cell": "PlayButton__cell___2xxIR display-tableCell verticalAlign-middle",
    "box": "PlayButton__box___2Fw_6 borderRadius-l c-white centered transitionDuration-m transitionTimingFunction-ease-in-out",
    "fontBig": "PlayButton__fontBig___2o16f fontSize-xl lineHeight-l padding-m",
    "fontSmall": "PlayButton__fontSmall____plLQ fontSize-m lineHeight-m padding-s",
    "icon": "PlayButton__icon___2kTCw fill-white paddingBottom-s paddingTop-xs",
    "loading": "PlayButton__loading___2X996 centered is-loading--white is-loading--xl is-loading position-relative"
  };
  /***/
},
/* 427 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "preview": "PreviewScreen__preview___2nEm5"
  };
  /***/
},
/* 428 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _assign = __webpack_require__(21);

  var _assign2 = babelHelpers.interopRequireDefault(_assign);

  var _partial = __webpack_require__(22);

  var _partial2 = babelHelpers.interopRequireDefault(_partial);

  var _Screen = __webpack_require__(158);

  var _Screen2 = babelHelpers.interopRequireDefault(_Screen);

  var _screen = __webpack_require__(9);

  var _layout = __webpack_require__(15);

  var _actionCreators = __webpack_require__(4);

  var _imagePreloading = __webpack_require__(75);

  var _handoff = __webpack_require__(5);

  var _controlScroll = __webpack_require__(102);

  var _controlScroll2 = babelHelpers.interopRequireDefault(_controlScroll);

  var _tracking = __webpack_require__(98);

  function mapStateToProps(state) {
    var props = (0, _screen.getCurrentScreenProps)(state);
    var screenStyles = (0, _layout.getScreenStyles)(state, true);
    return babelHelpers.extends({}, props, {
      scrollTop: screenStyles.scrollTop,
      smoothScroll: state.screen.smoothScroll,
      isLoading: (0, _imagePreloading.isImageLoading)(state, props.id),
      fixBounce: state.deviceDetection.isIOS && screenStyles.isScrollableAreaScrollable,
      isInHandoffMode: (0, _handoff.isInHandoffMode)(state),
      getMissedClickPosition: (0, _partial2.default)(_tracking.getMissedClickPosition, state)
    });
  }

  function mergeProps(stateProps, _ref, ownProps) {
    var dispatch = _ref.dispatch;
    var newProps = {
      onAnimationComplete: function onAnimationComplete() {
        dispatch((0, _actionCreators.screenTransitionCompleted)({
          isCurrent: true
        }));
        dispatch((0, _actionCreators.screenTimer)(stateProps.timer));
      },
      onClick: function onClick(id, clickArea, event) {
        if (stateProps.isInHandoffMode) {
          dispatch((0, _actionCreators.deselectHandoffItem)());
        } else {
          event.stopPropagation();
          dispatch((0, _actionCreators.missedClick)(stateProps.getMissedClickPosition(id, clickArea, event)));
          dispatch((0, _actionCreators.flashHotspots)());
        }
      },
      onSetScrollEnd: function onSetScrollEnd() {
        dispatch((0, _actionCreators.unsetScrollPos)());
      }
    };
    return (0, _assign2.default)({}, ownProps, stateProps, newProps);
  }

  var CurrentScreen = (0, _reactRedux.connect)(mapStateToProps, null, mergeProps)((0, _controlScroll2.default)(_Screen2.default));
  exports.default = CurrentScreen;
  /***/
},
/* 429 */

/***/
function (module, exports) {
  module.exports = require("lodash/includes");
  /***/
},
/* 430 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _HoverOutLayer = __webpack_require__(431);

  var _HoverOutLayer2 = babelHelpers.interopRequireDefault(_HoverOutLayer);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _hover = __webpack_require__(433);

  var mapStateToProps = function mapStateToProps(state) {
    return {
      hoverStack: state.hoverStack
    };
  };

  function mergeProps(stateProps, _ref, ownProps) {
    var dispatch = _ref.dispatch;
    var hoverStack = stateProps.hoverStack;
    return babelHelpers.extends({}, stateProps, ownProps, {
      onMouseMove: function onMouseMove(event) {
        var scrollPos = ownProps.getScreenScrollPos();
        var numberOfLevels = (0, _hover.getNumberOfHoverOutLevels)(event, hoverStack, scrollPos);

        if (numberOfLevels > 0) {
          dispatch(actionCreators.hoverOut(numberOfLevels, scrollPos));
        }
      }
    });
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, null, mergeProps)(_HoverOutLayer2.default);
  /***/
},
/* 431 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = HoverOutLayer;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _HoverOutLayer = __webpack_require__(432);

  var _HoverOutLayer2 = babelHelpers.interopRequireDefault(_HoverOutLayer);

  function HoverOutLayer(_ref) {
    var children = _ref.children,
        hoverStack = _ref.hoverStack,
        onMouseMove = _ref.onMouseMove;
    return _react2.default.createElement('div', {
      className: _HoverOutLayer2.default.screenArea,
      onMouseMove: hoverStack.length ? onMouseMove : null
    }, children);
  }

  HoverOutLayer.propTypes = {
    onMouseMove: _propTypes2.default.func,
    children: _propTypes2.default.node.isRequired,
    hoverStack: _propTypes2.default.array.isRequired
  };
  /***/
},
/* 432 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "screenArea": "HoverOutLayer__screenArea___3oZ-2 height-100 position-absolute width-100"
  };
  /***/
},
/* 433 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getNumberOfHoverOutLevels = getNumberOfHoverOutLevels;

  var _hotspot = __webpack_require__(87);

  function getNumberOfHoverOutLevels(event, hoverStack, scrollPos) {
    var numberOfLevels = 0;

    for (var i = hoverStack.length - 1; i >= 0; i -= 1) {
      if ((0, _hotspot.isMouseOutsideHotspot)(event, hoverStack[i], scrollPos)) {
        numberOfLevels += 1;
      } else {
        break;
      }
    }

    return numberOfLevels;
  }
  /***/

},
/* 434 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _redux = __webpack_require__(7);

  var _getContext = __webpack_require__(29);

  var _getContext2 = babelHelpers.interopRequireDefault(_getContext);

  var _Image = __webpack_require__(50);

  var _Image2 = babelHelpers.interopRequireDefault(_Image);

  var _fixedArea = __webpack_require__(66);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state, _ref) {
    var isCurrentScreen = _ref.isCurrentScreen;
    return (0, _fixedArea.getHeaderProps)(state, isCurrentScreen);
  }

  var exists = function exists(_ref2) {
    var header = _ref2.header;
    return !!header;
  };

  exports.default = (0, _redux.compose)((0, _getContext2.default)({
    isCurrentScreen: _propTypes2.default.bool.isRequired
  }), (0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(exists))(_Image2.default);
  /***/
},
/* 435 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactDom = __webpack_require__(63);

  var _values = __webpack_require__(95);

  var _values2 = babelHelpers.interopRequireDefault(_values);

  var _reactDnd = __webpack_require__(52);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _velocityReact = __webpack_require__(23);

  var _Hotspot = __webpack_require__(436);

  var _Hotspot2 = babelHelpers.interopRequireDefault(_Hotspot);

  var _Annotation = __webpack_require__(449);

  var _Annotation2 = babelHelpers.interopRequireDefault(_Annotation);

  var _Element = __webpack_require__(451);

  var _Element2 = babelHelpers.interopRequireDefault(_Element);

  var _RelativeGuides = __webpack_require__(459);

  var _RelativeGuides2 = babelHelpers.interopRequireDefault(_RelativeGuides);

  var _Columns = __webpack_require__(464);

  var _Columns2 = babelHelpers.interopRequireDefault(_Columns);

  var _Rows = __webpack_require__(466);

  var _Rows2 = babelHelpers.interopRequireDefault(_Rows);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);

  var _HotspotLayer = __webpack_require__(468);

  var _HotspotLayer2 = babelHelpers.interopRequireDefault(_HotspotLayer);

  var annotationTransitionProps = {
    leave: {
      animation: {
        scale: [0, 1]
      },
      duration: 300,
      easing: [0.175, 0.885, 0.32, 1.275]
    }
  };

  var HotspotLayer = function (_Component) {
    babelHelpers.inherits(HotspotLayer, _Component);

    function HotspotLayer() {
      var _ref;

      var _temp, _this, _ret;

      babelHelpers.classCallCheck(this, HotspotLayer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = HotspotLayer.__proto__ || Object.getPrototypeOf(HotspotLayer)).call.apply(_ref, [this].concat(args))), _this), _this.renderHotspot = function (_ref2) {
        var id = _ref2.id;
        var _this$props = _this.props,
            getScreenScrollPos = _this$props.getScreenScrollPos,
            getOverlayScrollPos = _this$props.getOverlayScrollPos,
            location = _this$props.location,
            screenID = _this$props.screenID;
        return _react2.default.createElement(_Hotspot2.default, {
          id: id,
          key: id,
          location: location,
          screenID: screenID,
          getScreenScrollPos: getScreenScrollPos,
          getOverlayScrollPos: getOverlayScrollPos
        });
      }, _this.renderAnnotation = function (annotation) {
        var _this$props2 = _this.props,
            location = _this$props2.location,
            screenID = _this$props2.screenID;
        var commentUUID = annotation.commentUUID,
            reference = annotation.reference;
        return _react2.default.createElement(_Annotation2.default, babelHelpers.extends({
          key: commentUUID,
          id: reference,
          screenID: screenID,
          location: location
        }, annotation));
      }, _this._onClick = function (e) {
        if (_this.props.isInAnnotationMode) {
          // TODO are these cross browser??
          var offsetX = e.nativeEvent.offsetX;
          var offsetY = e.nativeEvent.offsetY; // ////////////////////////////////////////////////

          _this.props.onClick(_this.props.location, {
            x: offsetX,
            y: offsetY
          });
        }
      }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
    }

    babelHelpers.createClass(HotspotLayer, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            height = _props.height,
            hotspots = _props.hotspots,
            annotations = _props.annotations,
            elements = _props.elements,
            isInAnnotationMode = _props.isInAnnotationMode,
            isInHandoffMode = _props.isInHandoffMode,
            areLayoutRowsEnabled = _props.areLayoutRowsEnabled,
            areLayoutColumnsEnabled = _props.areLayoutColumnsEnabled,
            connectDropTarget = _props.connectDropTarget;
        var className = (0, _classnames2.default)(_HotspotLayer2.default.hotspotLayer, babelHelpers.defineProperty({}, _HotspotLayer2.default.annotationMode, isInAnnotationMode));

        var layer = _react2.default.createElement('div', {
          className: className,
          onClick: this._onClick,
          style: {
            height: height
          }
        }, !isInAnnotationMode && !isInHandoffMode && hotspots.map(this.renderHotspot), _react2.default.createElement(_velocityReact.VelocityTransitionGroup, annotationTransitionProps, annotations.map(this.renderAnnotation)), elements.map(function (element) {
          return _react2.default.createElement(_Element2.default, babelHelpers.extends({
            key: element.id
          }, element));
        }), _react2.default.createElement(_RelativeGuides2.default, null), areLayoutColumnsEnabled && _react2.default.createElement(_Columns2.default, null), areLayoutRowsEnabled && _react2.default.createElement(_Rows2.default, null));

        return connectDropTarget(layer);
      }
    }]);
    return HotspotLayer;
  }(_react.Component);

  var hotspotLayerTarget = {
    drop: function drop(props, monitor, component) {
      var annotation = monitor.getItem();
      var layerPosition = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();
      var annotationPosition = monitor.getClientOffset();
      props.positionAnnotation(annotation.commentUUID, props.location, {
        x: annotationPosition.x - layerPosition.left,
        y: annotationPosition.y - layerPosition.top
      });
    }
  };

  function collect(connect) {
    return {
      // Call this function inside render()
      // to let React DnD handle the drag events:
      connectDropTarget: connect.dropTarget()
    };
  }

  HotspotLayer.propTypes = {
    height: _propTypes2.default.number.isRequired,
    onClick: _propTypes2.default.func,
    location: _propTypes2.default.oneOf((0, _values2.default)(screenLocation)),
    hotspots: _propTypes2.default.array,
    elements: _propTypes2.default.array.isRequired,
    getScreenScrollPos: _propTypes2.default.func,
    annotations: _propTypes2.default.array.isRequired,
    isInAnnotationMode: _propTypes2.default.bool,
    isInHandoffMode: _propTypes2.default.bool,
    connectDropTarget: _propTypes2.default.func.isRequired,
    areLayoutRowsEnabled: _propTypes2.default.bool,
    areLayoutColumnsEnabled: _propTypes2.default.bool,
    getOverlayScrollPos: _propTypes2.default.func,
    screenID: _propTypes2.default.number.isRequired
  };
  HotspotLayer.defaultProps = {
    hotspots: [],
    elements: [],
    annotations: []
  };
  exports.default = (0, _reactDnd.DropTarget)('annotation', hotspotLayerTarget, collect)(HotspotLayer);
  /***/
},
/* 436 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactRedux = __webpack_require__(2);

  var _marvelCore = __webpack_require__(25);

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _assign = __webpack_require__(21);

  var _assign2 = babelHelpers.interopRequireDefault(_assign);

  var _partial = __webpack_require__(22);

  var _partial2 = babelHelpers.interopRequireDefault(_partial);

  var _hotspotAction = __webpack_require__(130);

  var hotspotAction = babelHelpers.interopRequireWildcard(_hotspotAction);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);

  var _Hotspot = __webpack_require__(97);

  var _Hotspot2 = babelHelpers.interopRequireDefault(_Hotspot);

  var _EmbeddedHotspot = __webpack_require__(437);

  var _EmbeddedHotspot2 = babelHelpers.interopRequireDefault(_EmbeddedHotspot);

  var _TouchableHotspot = __webpack_require__(439);

  var _TouchableHotspot2 = babelHelpers.interopRequireDefault(_TouchableHotspot);

  var _HoverHotspot = __webpack_require__(441);

  var _HoverHotspot2 = babelHelpers.interopRequireDefault(_HoverHotspot);

  var _ExternalLinkHotspot = __webpack_require__(442);

  var _ExternalLinkHotspot2 = babelHelpers.interopRequireDefault(_ExternalLinkHotspot);

  var _VideoHotspot = __webpack_require__(443);

  var _VideoHotspot2 = babelHelpers.interopRequireDefault(_VideoHotspot);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _layout = __webpack_require__(15);

  var _hotspot = __webpack_require__(28);

  var _tracking = __webpack_require__(98);

  function mapStateToProps(state, _ref) {
    var id = _ref.id,
        location = _ref.location,
        screenID = _ref.screenID;
    var hotspot = (0, _hotspot.getHotspotByID)(state, id);
    return babelHelpers.extends({}, hotspot, (0, _layout.getHotspotStyle)({
      state: state,
      hotspot: hotspot,
      location: location,
      screenID: screenID
    }), {
      isVisible: (0, _hotspot.areHotspotsVisible)(state),
      hasTouch: state.deviceDetection.hasTouch,
      currentScreenID: (0, _get2.default)(state, 'screen.currentScreen.id'),
      previousScreenID: (0, _get2.default)(state, 'screen.previousScreen.id'),
      currentOverlayID: (0, _get2.default)(state, 'screen.currentOverlayHotspot.id'),
      getClickPosition: (0, _partial2.default)(_tracking.getClickPosition, state)
    });
  }

  function mergeProps(stateProps, _ref2, ownProps) {
    var dispatch = _ref2.dispatch;

    var boundHandleHotspotAction = function boundHandleHotspotAction() {
      handleHotspotAction(dispatch, ownProps, stateProps);
    };

    var boundHandleHoverAction = function boundHandleHoverAction(coordinates) {
      handleHoverAction(dispatch, ownProps, stateProps, coordinates);
    };

    var newProps = {
      onClick: function onClick(e) {
        e.stopPropagation();
        dispatch(actionCreators.click(stateProps.getClickPosition(stateProps.id, e)));
        boundHandleHotspotAction();
      },
      onTouch: boundHandleHotspotAction,
      hover: function hover(e, coordinates) {
        e.stopPropagation();
        boundHandleHoverAction(coordinates);
      }
    };
    return (0, _assign2.default)({}, ownProps, stateProps, newProps);
  }

  function handleHoverAction(dispatch, ownProps, stateProps, coordinates) {
    var currentOverlayID = stateProps.currentOverlayID,
        currentScreenID = stateProps.currentScreenID,
        destinationScreenID = stateProps.destinationScreenID,
        id = stateProps.id,
        isOverlay = stateProps.isOverlay,
        maintainScroll = stateProps.maintainScroll,
        stayOnTarget = stateProps.stayOnTarget,
        transition = stateProps.transition;
    var screenScrollPos = getScreenScrollPos(ownProps, stateProps);

    if (isOverlay) {
      var overlayScrollPos = getOverlayScrollPos(ownProps, stateProps);

      if (!stayOnTarget) {
        dispatch(actionCreators.showHoverOverlay(id, overlayScrollPos));
      } else {
        dispatch(actionCreators.showOverlay(id, overlayScrollPos));
      }
    } else if (!stayOnTarget) {
      dispatch(actionCreators.showHoverScreen(destinationScreenID, screenScrollPos));
    } else {
      dispatch(actionCreators.showScreen(destinationScreenID, transition, screenScrollPos));
    }

    if (!stayOnTarget) {
      dispatch(actionCreators.addToHoverStack({
        screenID: currentScreenID,
        layerID: currentOverlayID,
        scrollPos: screenScrollPos,
        maintainScroll: maintainScroll,
        coordinates: coordinates
      }));
    }
  }

  function handleHotspotAction(dispatch, ownProps, stateProps) {
    var id = stateProps.id,
        type = stateProps.type,
        isOverlay = stateProps.isOverlay,
        transition = stateProps.transition,
        destinationScreenID = stateProps.destinationScreenID,
        anchorYPos = stateProps.anchorYPos,
        smoothScroll = stateProps.smoothScroll,
        currentOverlayID = stateProps.currentOverlayID,
        currentScreenID = stateProps.currentScreenID,
        maintainScroll = stateProps.maintainScroll;

    switch (type) {
      case _marvelCore.constants.TYPE_STANDARD:
        {
          if (isOverlay) {
            var overlayScrollPos = getOverlayScrollPos(ownProps, stateProps);
            dispatch(actionCreators.showOverlay(id, overlayScrollPos));
          } else if (destinationScreenID !== currentScreenID) {
            var screenScrollPos = getScreenScrollPos(ownProps, stateProps);
            dispatch(actionCreators.showScreen(destinationScreenID, transition, screenScrollPos));
          } else {
            dispatch(actionCreators.hideOverlay(transition));
          }

          break;
        }

      case _marvelCore.constants.TYPE_BACK:
        dispatch(actionCreators.historyBack());

        if (!maintainScroll) {
          dispatch(actionCreators.scrollTo(0));
        }

        break;

      case _marvelCore.constants.TYPE_ANCHOR:
        if (currentOverlayID) {
          dispatch(actionCreators.setOverlayScrollPos(anchorYPos, smoothScroll));
        } else {
          dispatch(actionCreators.scrollTo(anchorYPos, smoothScroll));
        }

        break;

      default:
        break;
    }
  }

  function getOverlayScrollPos(ownProps, stateProps) {
    if ((stateProps.maintainScroll || stateProps.overlayPosition === _marvelCore.constants.OVERLAY_CUSTOM) && stateProps.location === screenLocation.BODY) {
      if (ownProps.getOverlayScrollPos) {
        // Hotspot is on a layer so we need the _layer_ scroll position
        // to set the next layer's scroll
        return ownProps.getOverlayScrollPos();
      } // Hotspot is on a screen so we need the _screen_ scroll position
      // to set the layer's scroll


      return ownProps.getScreenScrollPos();
    }

    return 0;
  }

  function getScreenScrollPos(ownProps, stateProps) {
    var previousScreenPos = ownProps.getScreenScrollPos();
    var scrollPos = {
      previous: previousScreenPos,
      current: 0
    };

    if (stateProps.maintainScroll) {
      scrollPos.current = scrollPos.previous;
    }

    return scrollPos;
  }

  function SmartHotspot(props) {
    var action = props.action,
        type = props.type,
        hasTouch = props.hasTouch;

    if (type === _marvelCore.constants.TYPE_EMBED) {
      return _react2.default.createElement(_EmbeddedHotspot2.default, props);
    }

    if (type === _marvelCore.constants.TYPE_VIDEO) {
      return _react2.default.createElement(_VideoHotspot2.default, props);
    }

    if (hasTouch) {
      if (action === hotspotAction.HOVER) {
        return null;
      }

      if (hotspotAction.isTouchAction(action)) {
        return _react2.default.createElement(_TouchableHotspot2.default, props);
      }
    }

    if (action === hotspotAction.HOVER) {
      return _react2.default.createElement(_HoverHotspot2.default, props);
    }

    if (type === _marvelCore.constants.TYPE_URL) {
      return _react2.default.createElement(_ExternalLinkHotspot2.default, props);
    }

    return _react2.default.createElement(_Hotspot2.default, props);
  }

  SmartHotspot.propTypes = {
    type: _propTypes2.default.number.isRequired,
    hasTouch: _propTypes2.default.bool.isRequired,
    action: _propTypes2.default.string.isRequired
  };
  exports.default = (0, _reactRedux.connect)(mapStateToProps, null, mergeProps)(SmartHotspot);
  /***/
},
/* 437 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = EmbeddedHotspot;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _EmbeddedHotspot = __webpack_require__(438);

  var _EmbeddedHotspot2 = babelHelpers.interopRequireDefault(_EmbeddedHotspot);

  function EmbeddedHotspot(_ref) {
    var left = _ref.left,
        top = _ref.top,
        width = _ref.width,
        height = _ref.height,
        externalUrl = _ref.externalUrl;
    var style = {
      left: left,
      top: top,
      width: width,
      height: height
    };
    return _react2.default.createElement('iframe', {
      className: (0, _classnames2.default)(_EmbeddedHotspot2.default.embeddedHotspot),
      src: externalUrl,
      allowFullScreen: true,
      allowTransparency: true,
      frameBorder: 0,
      style: style
    });
  }

  EmbeddedHotspot.propTypes = {
    left: _propTypes2.default.number.isRequired,
    top: _propTypes2.default.number.isRequired,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    externalUrl: _propTypes2.default.string.isRequired
  };
  /***/
},
/* 438 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "embeddedHotspot": "EmbeddedHotspot__embeddedHotspot___2eXL1"
  };
  /***/
},
/* 439 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = TouchableHotspot;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _TouchGesture = __webpack_require__(162);

  var _TouchGesture2 = babelHelpers.interopRequireDefault(_TouchGesture);

  var _Hotspot = __webpack_require__(97);

  var _Hotspot2 = babelHelpers.interopRequireDefault(_Hotspot);

  function TouchableHotspot(props) {
    var action = props.action,
        onTouch = props.onTouch;
    return _react2.default.createElement(_TouchGesture2.default, {
      action: action,
      eventHandler: onTouch
    }, _react2.default.createElement(_Hotspot2.default, babelHelpers.extends({}, props, {
      onClick: onClick
    })));
  }

  function onClick(e) {
    // This is for preventing the hotspots from flashing when the user taps
    // on them.
    // We need to prevent the event from bubbling up the DOM tree immediately,
    // it would be too late on TouchGesture.eventHandler
    e.stopPropagation();
  }

  TouchableHotspot.propTypes = {
    action: _propTypes2.default.string.isRequired,
    onTouch: _propTypes2.default.func.isRequired
  };
  TouchableHotspot.defaultProps = {
    onTouch: _noop2.default
  };
  /***/
},
/* 440 */

/***/
function (module, exports) {
  module.exports = require("react-hammerjs");
  /***/
},
/* 441 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _Hotspot = __webpack_require__(161);

  var _Hotspot2 = babelHelpers.interopRequireDefault(_Hotspot);

  var HoverHotspot = function (_React$Component) {
    babelHelpers.inherits(HoverHotspot, _React$Component);

    function HoverHotspot() {
      babelHelpers.classCallCheck(this, HoverHotspot);
      return babelHelpers.possibleConstructorReturn(this, (HoverHotspot.__proto__ || Object.getPrototypeOf(HoverHotspot)).apply(this, arguments));
    }

    babelHelpers.createClass(HoverHotspot, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            isVisible = _props.isVisible,
            left = _props.left,
            top = _props.top,
            width = _props.width,
            height = _props.height,
            hover = _props.hover;
        var style = {
          left: left,
          top: top,
          width: width,
          height: height
        };
        return _react2.default.createElement('div', {
          className: (0, _classnames2.default)(_Hotspot2.default.hotspot, babelHelpers.defineProperty({}, _Hotspot2.default.visibleHotspot, isVisible)),
          style: style,
          ref: function ref(node) {
            _this2.hotspot = node;
          },
          onMouseOver: function onMouseOver(e) {
            var position = _this2.hotspot.getBoundingClientRect();

            hover(e, {
              top: position.top,
              left: position.left,
              right: position.right,
              bottom: position.bottom
            });
          }
        });
      }
    }]);
    return HoverHotspot;
  }(_react2.default.Component);

  exports.default = HoverHotspot;
  HoverHotspot.propTypes = {
    left: _propTypes2.default.number.isRequired,
    top: _propTypes2.default.number.isRequired,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    isVisible: _propTypes2.default.bool.isRequired,
    hover: _propTypes2.default.func.isRequired
  };
  HoverHotspot.defaultProps = {
    hover: _noop2.default
  };
  /***/
},
/* 442 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ExternalLinkHotspot;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _Hotspot = __webpack_require__(97);

  var _Hotspot2 = babelHelpers.interopRequireDefault(_Hotspot);

  function ExternalLinkHotspot(_ref) {
    var externalUrl = _ref.externalUrl,
        newWindow = _ref.newWindow,
        props = babelHelpers.objectWithoutProperties(_ref, ['externalUrl', 'newWindow']);
    var linkProps = {
      href: externalUrl
    };

    if (newWindow) {
      linkProps.target = '_blank';
      linkProps.rel = 'noopener noreferrer';
    }

    return _react2.default.createElement('a', babelHelpers.extends({
      id: props.id
    }, linkProps), _react2.default.createElement(_Hotspot2.default, babelHelpers.extends({
      onClick: _noop2.default
    }, props)));
  }

  ExternalLinkHotspot.propTypes = {
    id: _propTypes2.default.number.isRequired,
    externalUrl: _propTypes2.default.string.isRequired,
    newWindow: _propTypes2.default.bool.isRequired
  };
  /***/
},
/* 443 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = VideoHotspot;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _VideoHotspot = __webpack_require__(444);

  var _VideoHotspot2 = babelHelpers.interopRequireDefault(_VideoHotspot);

  function VideoHotspot(_ref) {
    var left = _ref.left,
        top = _ref.top,
        width = _ref.width,
        height = _ref.height,
        externalUrl = _ref.externalUrl;
    var style = {
      left: left,
      top: top,
      width: width,
      height: height
    };
    return _react2.default.createElement('video', {
      controls: true,
      controlsList: 'nodownload',
      style: style,
      className: _VideoHotspot2.default.video
    }, _react2.default.createElement('source', {
      src: externalUrl
    }));
  }

  VideoHotspot.propTypes = {
    left: _propTypes2.default.number.isRequired,
    top: _propTypes2.default.number.isRequired,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    externalUrl: _propTypes2.default.string.isRequired
  };
  /***/
},
/* 444 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "video": "VideoHotspot__video___2E9G4"
  };
  /***/
},
/* 445 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getProject = getProject;

  function getProject(state) {
    return state.project.config;
  }
  /***/

},
/* 446 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getPathnameFromState = getPathnameFromState;
  exports.getLocationState = getLocationState;

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _location = __webpack_require__(65);

  var location = babelHelpers.interopRequireWildcard(_location);

  function getPathnameFromState(state) {
    var _getLocationState = getLocationState(state),
        projectID = _getLocationState.projectID,
        screenID = _getLocationState.screenID,
        hotspotID = _getLocationState.hotspotID,
        isHandoff = _getLocationState.isHandoff;

    return location.getPathName(projectID, screenID, hotspotID, false, isHandoff);
  }

  function getLocationState(state) {
    var projectID = (0, _get2.default)(state, 'project.config.id');
    var screenID = (0, _get2.default)(state, 'screen.currentScreen.id');
    var hotspotID = (0, _get2.default)(state, 'screen.currentOverlayHotspot.id', null);
    var isHandoff = (0, _get2.default)(state, 'handoff.isOpen');
    return {
      projectID: projectID,
      screenID: screenID,
      hotspotID: hotspotID,
      isHandoff: isHandoff
    };
  }
  /***/

},
/* 447 */

/***/
function (module, exports) {
  module.exports = require("querystring");
  /***/
},
/* 448 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isUserPartOfThisCompany = isUserPartOfThisCompany;

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  function isUserPartOfThisCompany(state) {
    /* eslint-disable eqeqeq */
    var companyId = (0, _get2.default)(state, 'project.config.companyData.id');

    if (!companyId) {
      // Can't be part of a company if there isn't one!
      return false;
    }

    return state.user.companyId == companyId;
  }
  /***/

},
/* 449 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _Annotation = __webpack_require__(166);

  var _Annotation2 = babelHelpers.interopRequireDefault(_Annotation);

  var _annotation = __webpack_require__(83);

  var _actionCreators = __webpack_require__(4);

  var _layout = __webpack_require__(15);

  var _annotation2 = __webpack_require__(20);

  function mapStateToProps(state, _ref) {
    var location = _ref.location,
        screenID = _ref.screenID,
        annotation = babelHelpers.objectWithoutProperties(_ref, ['location', 'screenID']);

    var _getHotspotStyle = (0, _layout.getHotspotStyle)({
      hotspot: annotation,
      state: state,
      location: location,
      screenID: screenID
    }),
        top = _getHotspotStyle.top,
        left = _getHotspotStyle.left;

    var commentUUID = annotation.commentUUID;
    return babelHelpers.extends({}, annotation, {
      position: {
        top: top,
        left: left
      },
      isHighlighted: (0, _annotation2.isHighlighted)(state, commentUUID),
      isDehighlighted: (0, _annotation2.isDehighlighted)(state, commentUUID),
      isPulsing: (0, _annotation2.isPulsing)(state, commentUUID),
      isMoveable: (0, _annotation2.isMoveable)(state, annotation)
    });
  }

  function mapDispatchToProps(dispatch, ownProps) {
    return {
      onDrop: function onDrop(dropPosition) {
        dispatch((0, _annotation.positionAnnotation)(ownProps.commentUUID, ownProps.screenArea, dropPosition));
      },
      onMouseEnter: function onMouseEnter() {
        dispatch((0, _actionCreators.highlightComment)(ownProps.commentUUID));
      },
      onMouseLeave: function onMouseLeave() {
        dispatch((0, _actionCreators.unHighlightComment)(ownProps.commentUUID));
      }
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Annotation2.default);
  /***/
},
/* 450 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "annotation": "Annotation__annotation___3OHBd borderColor-white borderRadius-circle borderStyle-solid c-white cursor-grab fontSize-s lineHeight-l position-absolute textAlign-center",
    "highlight": "Annotation__highlight___Nh2RI",
    "dragging": "Annotation__dragging___2ME_a",
    "completed": "Annotation__completed___2Jz1V borderRadius-circle display-block fill-white position-absolute pinAll",
    "annotationNumber": "Annotation__annotationNumber___1oH-3 borderRadius-circle display-block fill-white position-absolute pinAll",
    "completedIcon": "Annotation__completedIcon___2WnsM display-block position-absolute pinCenter",
    "annotationTick": "Annotation__annotationTick___HDBsV position-absolute pinAll bg-positive",
    "notification": "Annotation__notification___1gwHW bg-purple--l borderColor-purple opacity-0 pointerEvents-none borderRadius-circle borderStyle-solid position-absolute pinCenter",
    "done": "Annotation__done___1MzxZ opacity-80 bg-silver bg-green--hover opacity-100--hover",
    "draggingDone": "Annotation__draggingDone___1R6Us bg-green opacity-100",
    "highlightDone": "Annotation__highlightDone___3VkOd bg-green opacity-100",
    "normal": "Annotation__normal___GkHMQ bg-purple",
    "dehighlight": "Annotation__dehighlight___1yP_y bg-silver",
    "moveable": "Annotation__moveable___uFUhm cursor-move",
    "hiddenForDrag": "Annotation__hiddenForDrag___1QBwt display-none",
    "new": "Annotation__new___L3HvZ",
    "bounce": "Annotation__bounce___3i5da"
  };
  /***/
},
/* 451 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _Element = __webpack_require__(452);

  var _Element2 = babelHelpers.interopRequireDefault(_Element);

  var _actionCreators = __webpack_require__(4);

  var _handoff = __webpack_require__(5);

  function mapStateToProps(state, _ref) {
    var id = _ref.id;
    var artboardSize = (0, _handoff.getArtboardSize)(state);
    return {
      artboardWidth: artboardSize[0],
      artboardHeight: artboardSize[1],
      isSelected: (0, _handoff.isElementSelected)(state, id),
      isHovered: (0, _handoff.isElementHovered)(state, id),
      isSelectable: (0, _handoff.isElementSelectable)(state, id),
      isHoverable: (0, _handoff.isElementHoverable)(state, id),
      showGuides: (0, _handoff.showGuides)(state, id),
      zoomScale: (0, _handoff.getZoomScale)(state),
      pixelRatio: (0, _handoff.getPixelRatio)(state)
    };
  }

  function mergeProps(stateProps, _ref2, ownProps) {
    var dispatch = _ref2.dispatch;
    var id = ownProps.id;
    var isHoverable = stateProps.isHoverable;
    var actions = {
      onClick: function onClick(e) {
        // stop this propagating up and deselecting thr element we just clicked!
        e.stopPropagation();
        dispatch((0, _actionCreators.changeHandoffSelectedItem)(id));
      },
      onMouseOver: function onMouseOver() {
        if (isHoverable) {
          dispatch((0, _actionCreators.changeHandoffHoveredItem)(id));
        }
      },
      onMouseOut: function onMouseOut() {
        dispatch((0, _actionCreators.changeHandoffHoveredItem)(null));
      }
    };
    return babelHelpers.extends({}, ownProps, actions, stateProps);
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, null, mergeProps)(_Element2.default);
  /***/
},
/* 452 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Element;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _mapValues = __webpack_require__(26);

  var _mapValues2 = babelHelpers.interopRequireDefault(_mapValues);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _Guide = __webpack_require__(167);

  var _Guide2 = babelHelpers.interopRequireDefault(_Guide);

  var _Element = __webpack_require__(458);

  var _Element2 = babelHelpers.interopRequireDefault(_Element);

  function Element(_ref) {
    var _cx;

    var showGuides = _ref.showGuides,
        isSelected = _ref.isSelected,
        isHovered = _ref.isHovered,
        left = _ref.left,
        top = _ref.top,
        width = _ref.width,
        height = _ref.height,
        artboardWidth = _ref.artboardWidth,
        artboardHeight = _ref.artboardHeight,
        zoomScale = _ref.zoomScale,
        pixelRatio = _ref.pixelRatio,
        onClick = _ref.onClick,
        onMouseOver = _ref.onMouseOver,
        onMouseOut = _ref.onMouseOut;
    var style = (0, _mapValues2.default)({
      left: left,
      top: top,
      width: width,
      height: height
    }, function (v) {
      return v * zoomScale * pixelRatio;
    });
    var className = (0, _classnames2.default)(_Element2.default.element, (_cx = {}, babelHelpers.defineProperty(_cx, _Element2.default.selected, isSelected), babelHelpers.defineProperty(_cx, _Element2.default.hovered, isHovered), _cx));
    return _react2.default.createElement('div', null, showGuides && renderGuides({
      left: left,
      top: top,
      width: width,
      height: height,
      artboardWidth: artboardWidth,
      artboardHeight: artboardHeight,
      pixelRatio: pixelRatio
    }), _react2.default.createElement('div', {
      onClick: onClick,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      className: className,
      style: style
    }, isSelected && _react2.default.createElement('div', null, _react2.default.createElement('div', {
      className: _Element2.default.handle,
      style: {
        top: -2,
        left: -2
      }
    }), _react2.default.createElement('div', {
      className: _Element2.default.handle,
      style: {
        bottom: -2,
        left: -2
      }
    }), _react2.default.createElement('div', {
      className: _Element2.default.handle,
      style: {
        top: -2,
        right: -2
      }
    }), _react2.default.createElement('div', {
      className: _Element2.default.handle,
      style: {
        bottom: -2,
        right: -2
      }
    }))));
  }

  Element.propTypes = {
    left: _propTypes2.default.number.isRequired,
    top: _propTypes2.default.number.isRequired,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    artboardWidth: _propTypes2.default.number.isRequired,
    artboardHeight: _propTypes2.default.number.isRequired,
    showGuides: _propTypes2.default.bool.isRequired,
    isSelected: _propTypes2.default.bool.isRequired,
    isHovered: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired,
    zoomScale: _propTypes2.default.number.isRequired,
    pixelRatio: _propTypes2.default.number.isRequired,
    onMouseOver: _propTypes2.default.func,
    onMouseOut: _propTypes2.default.func
  };
  Element.defaultProps = {
    onClick: _noop2.default,
    onMouseOver: _noop2.default,
    onMouseOut: _noop2.default
  };

  function renderGuides(_ref2) {
    var pixelRatio = _ref2.pixelRatio,
        elementPositionAndSize = babelHelpers.objectWithoutProperties(_ref2, ['pixelRatio']);
    return [_react2.default.createElement(_Guide2.default, babelHelpers.extends({}, northGuide(elementPositionAndSize, pixelRatio), {
      isVertical: true
    })), _react2.default.createElement(_Guide2.default, babelHelpers.extends({}, southGuide(elementPositionAndSize, pixelRatio), {
      isVertical: true
    })), _react2.default.createElement(_Guide2.default, westGuide(elementPositionAndSize, pixelRatio)), _react2.default.createElement(_Guide2.default, eastGuide(elementPositionAndSize, pixelRatio))];
  }

  function northGuide(_ref3, pixelRatio) {
    var left = _ref3.left,
        width = _ref3.width,
        top = _ref3.top;
    var ruleLeft = left + width / 2;
    var ruleHeight = top;
    return {
      left: ruleLeft * pixelRatio,
      top: 0,
      height: ruleHeight * pixelRatio,
      value: ruleHeight
    };
  }

  function southGuide(_ref4, pixelRatio) {
    var left = _ref4.left,
        width = _ref4.width,
        top = _ref4.top,
        height = _ref4.height,
        artboardHeight = _ref4.artboardHeight;
    var ruleLeft = left + width / 2;
    var ruleTop = top + height;
    var ruleHeight = artboardHeight - ruleTop;
    return {
      left: ruleLeft * pixelRatio,
      top: ruleTop * pixelRatio,
      height: ruleHeight * pixelRatio,
      value: artboardHeight - ruleTop
    };
  }

  function westGuide(_ref5, pixelRatio) {
    var top = _ref5.top,
        height = _ref5.height,
        left = _ref5.left;
    var ruleTop = top + height / 2;
    var ruleWidth = left;
    return {
      left: 0,
      top: ruleTop * pixelRatio,
      width: ruleWidth * pixelRatio,
      value: ruleWidth
    };
  }

  function eastGuide(_ref6, pixelRatio) {
    var top = _ref6.top,
        height = _ref6.height,
        left = _ref6.left,
        width = _ref6.width,
        artboardWidth = _ref6.artboardWidth;
    var ruleTop = top + height / 2;
    var ruleLeft = left + width;
    var ruleWidth = artboardWidth - ruleLeft;
    return {
      left: ruleLeft * pixelRatio,
      top: ruleTop * pixelRatio,
      width: ruleWidth * pixelRatio,
      value: artboardWidth - ruleLeft
    };
  }
  /***/

},
/* 453 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Guide;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _mapValues = __webpack_require__(26);

  var _mapValues2 = babelHelpers.interopRequireDefault(_mapValues);

  var _Guide = __webpack_require__(168);

  var _Guide2 = babelHelpers.interopRequireDefault(_Guide);

  var _Label = __webpack_require__(454);

  var _Label2 = babelHelpers.interopRequireDefault(_Label);

  function Guide(_ref) {
    var isVertical = _ref.isVertical,
        zoomScale = _ref.zoomScale,
        value = _ref.value,
        layout = babelHelpers.objectWithoutProperties(_ref, ['isVertical', 'zoomScale', 'value']);
    var className = (0, _classnames2.default)(_Guide2.default.guide, 'borderWidth-0', {
      'borderLeftWidth-1': isVertical,
      'borderTopWidth-1': !isVertical
    });
    var style = (0, _mapValues2.default)(layout, function (v) {
      return zoomScale * v;
    });

    if (!isVertical) {
      style.top -= 1;
    }

    return _react2.default.createElement('div', {
      style: style,
      className: className
    }, _react2.default.createElement(_Label2.default, {
      isGuideVertical: isVertical,
      guide: style,
      value: value
    }));
  }

  Guide.propTypes = {
    isVertical: _propTypes2.default.bool,
    value: _propTypes2.default.number.isRequired,
    zoomScale: _propTypes2.default.number.isRequired
  };
  /***/
},
/* 454 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _Label = __webpack_require__(455);

  var _Label2 = babelHelpers.interopRequireDefault(_Label);

  var _handoff = __webpack_require__(5);

  function mapStateToProps(state) {
    var scale = (0, _handoff.getZoomScale)(state);
    var img = state.screen.currentScreen.img;
    var renderedImageDimensions = {
      width: img.width * scale,
      height: img.height * scale
    };
    return {
      renderedImageDimensions: renderedImageDimensions
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_Label2.default);
  /***/
},
/* 455 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _Label = __webpack_require__(456);

  var _Label2 = babelHelpers.interopRequireDefault(_Label);

  var _measureSize = __webpack_require__(457);

  var _measureSize2 = babelHelpers.interopRequireDefault(_measureSize);

  var _Measurement = __webpack_require__(39);

  var _Measurement2 = babelHelpers.interopRequireDefault(_Measurement);

  var MARGIN = 5;
  /* eslint-disable react/no-unused-prop-types */

  function Label(_ref) {
    var _cx;

    var sizeRef = _ref.sizeRef,
        size = _ref.size,
        renderedImageDimensions = _ref.renderedImageDimensions,
        guide = _ref.guide,
        value = _ref.value,
        isGuideVertical = _ref.isGuideVertical;
    var position = void 0;

    if (isLabelOffTopOfScreen(size, guide, isGuideVertical)) {
      position = {
        top: MARGIN
      };
    } else if (isLabelOffRightOfScreen(size, guide, isGuideVertical, renderedImageDimensions.width)) {
      position = {
        right: MARGIN
      };
    } else if (isLabelOffBottomOfScreen(size, guide, isGuideVertical, renderedImageDimensions.height)) {
      position = {
        bottom: MARGIN
      };
    } else if (isLabelOffLeftOfScreen(size, guide, isGuideVertical)) {
      position = {
        left: MARGIN
      };
    }

    var className = (0, _classnames2.default)(_Label2.default.label, (_cx = {}, babelHelpers.defineProperty(_cx, _Label2.default.centre, !position), babelHelpers.defineProperty(_cx, _Label2.default.centreHorizontal, position && !isGuideVertical), babelHelpers.defineProperty(_cx, _Label2.default.centreVertical, position && isGuideVertical), _cx));
    return _react2.default.createElement('span', {
      ref: sizeRef,
      className: className,
      style: position
    }, value && _react2.default.createElement(_Measurement2.default, {
      value: value
    }));
  }

  Label.propTypes = {
    sizeRef: _propTypes2.default.func,
    size: _propTypes2.default.shape({
      width: _propTypes2.default.number,
      height: _propTypes2.default.number
    }),
    renderedImageDimensions: _propTypes2.default.shape({
      width: _propTypes2.default.number.isRequired,
      height: _propTypes2.default.number.isRequired
    }),
    value: _propTypes2.default.number,
    screenWidth: _propTypes2.default.number,
    screenHeight: _propTypes2.default.number,
    guide: _propTypes2.default.object.isRequired,
    isGuideVertical: _propTypes2.default.bool
  };

  function isLabelOffTopOfScreen(_ref2, guide, isGuideVertical) {
    var height = _ref2.height;
    return !isGuideVertical && guide.top < (height + MARGIN) / 2 || isGuideVertical && guide.top === 0 && guide.height < height + MARGIN;
  }

  function isLabelOffRightOfScreen(_ref3, guide, isGuideVertical, screenWidth) {
    var width = _ref3.width;
    return !isGuideVertical && screenWidth === guide.left + guide.width && guide.width < width + MARGIN || isGuideVertical && screenWidth - guide.left < (width + MARGIN) / 2;
  }

  function isLabelOffBottomOfScreen(_ref4, guide, isGuideVertical, screenHeight) {
    var height = _ref4.height;
    return !isGuideVertical && screenHeight - guide.top < (height + MARGIN) / 2 || isGuideVertical && screenHeight - guide.top < height + MARGIN;
  }

  function isLabelOffLeftOfScreen(_ref5, guide, isGuideVertical) {
    var width = _ref5.width;
    return !isGuideVertical && guide.left === 0 && guide.width < width + MARGIN || isGuideVertical && guide.left < (width + MARGIN) / 2;
  }

  exports.default = (0, _measureSize2.default)(Label);
  /***/
},
/* 456 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "label": "Label__label___2SnJC position-absolute borderRadius-s c-white fontSize-xs fontWeight-5 lineHeight-xs pointerEvents-none",
    "centre": "Label__centre___2S32y pinCenter",
    "centreVertical": "Label__centreVertical___1-P1j",
    "centreHorizontal": "Label__centreHorizontal___1vVc4"
  };
  /***/
},
/* 457 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = measureSize;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function measureSize(Component) {
    var Measure = function (_React$Component) {
      babelHelpers.inherits(Measure, _React$Component);

      function Measure(props) {
        babelHelpers.classCallCheck(this, Measure);

        var _this = babelHelpers.possibleConstructorReturn(this, (Measure.__proto__ || Object.getPrototypeOf(Measure)).call(this, props));

        _this.state = {};
        return _this;
      }

      babelHelpers.createClass(Measure, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.measureSize();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          this.measureSize();
        }
      }, {
        key: 'measureSize',
        value: function measureSize() {
          var node = this.rendered;
          var size = {
            width: node.offsetWidth,
            height: node.offsetHeight
          };

          if (size.width !== this.state.width || size.height !== this.state.height) {
            this.setState(size);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          return _react2.default.createElement(Component, babelHelpers.extends({
            sizeRef: function sizeRef(node) {
              _this2.rendered = node;
            },
            size: this.state
          }, this.props));
        }
      }]);
      return Measure;
    }(_react2.default.Component);

    return Measure;
  }
  /***/

},
/* 458 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "element": "Element__element___iJ63E borderStyle-solid borderWidth-1 position-absolute",
    "handle": "Element__handle___2qodJ position-absolute",
    "hovered": "Element__hovered___3GLiA",
    "selected": "Element__selected___3GXJf"
  };
  /***/
},
/* 459 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _recompose = __webpack_require__(160);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _RelativeGuides = __webpack_require__(460);

  var _RelativeGuides2 = babelHelpers.interopRequireDefault(_RelativeGuides);

  var _handoff = __webpack_require__(5);

  function mapStateToProps(state) {
    if (!(0, _handoff.isInHandoffMode)(state) || !(0, _handoff.showRelativeGuides)(state)) {
      return {};
    }

    return {
      selectedElement: (0, _handoff.getSelectedElementLayout)(state),
      hoveredElement: (0, _handoff.getHoveredElementLayout)(state),
      pixelRatio: (0, _handoff.getPixelRatio)(state)
    };
  }

  exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, null), (0, _onlyIf2.default)(function (props) {
    return props.hoveredElement;
  }))(_RelativeGuides2.default);
  /***/
},
/* 460 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = RelativeGuides;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _set = __webpack_require__(461);

  var _set2 = babelHelpers.interopRequireDefault(_set);

  var _mapValues = __webpack_require__(26);

  var _mapValues2 = babelHelpers.interopRequireDefault(_mapValues);

  var _Guide = __webpack_require__(167);

  var _Guide2 = babelHelpers.interopRequireDefault(_Guide);

  var _Extension = __webpack_require__(462);

  var _Extension2 = babelHelpers.interopRequireDefault(_Extension);

  var measurements = [{
    hoveredSide: 'top',
    selectedSide: 'top',
    shouldRender: function shouldRender(guides) {
      return !guides.top.bottom.guide && !guides.bottom.top.guide;
    }
  }, {
    hoveredSide: 'top',
    selectedSide: 'bottom'
  }, {
    hoveredSide: 'bottom',
    selectedSide: 'top'
  }, {
    hoveredSide: 'bottom',
    selectedSide: 'bottom',
    shouldRender: function shouldRender(guides) {
      return !guides.top.bottom.guide && !guides.bottom.top.guide;
    }
  }, {
    hoveredSide: 'right',
    selectedSide: 'right',
    shouldRender: function shouldRender(guides) {
      return !guides.right.left.guide && !guides.left.right.guide;
    }
  }, {
    hoveredSide: 'right',
    selectedSide: 'left'
  }, {
    hoveredSide: 'left',
    selectedSide: 'right'
  }, {
    hoveredSide: 'left',
    selectedSide: 'left',
    shouldRender: function shouldRender(guides) {
      return !guides.right.left.guide && !guides.left.right.guide;
    }
  }];

  function RelativeGuides(_ref) {
    var selectedElement = _ref.selectedElement,
        hoveredElement = _ref.hoveredElement,
        pixelRatio = _ref.pixelRatio;
    var allGuides = {};
    measurements.forEach(function (_ref2) {
      var hoveredSide = _ref2.hoveredSide,
          selectedSide = _ref2.selectedSide;
      var measurement = getMeasurement({
        selected: selectedElement,
        hovered: hoveredElement,
        selectedElementSide: selectedSide,
        hoveredElementSide: hoveredSide
      });
      var guide = attachGuide({
        selected: selectedElement,
        hovered: hoveredElement,
        measurement: measurement
      });
      var extension = void 0;

      if (guide) {
        if (guide.attachedTo === 'selected') {
          extension = getExtension(hoveredElement, hoveredSide, guide);
        } else {
          extension = getExtension(selectedElement, selectedSide, guide);
        }
      }

      (0, _set2.default)(allGuides, [hoveredSide, selectedSide], {
        guide: guide,
        extension: extension
      });
    });
    var renderedGuides = [];
    measurements.forEach(function (_ref3) {
      var hoveredSide = _ref3.hoveredSide,
          selectedSide = _ref3.selectedSide,
          shouldRender = _ref3.shouldRender;
      var guide = allGuides[hoveredSide][selectedSide];

      if (guide.guide) {
        if (!shouldRender || shouldRender(allGuides)) {
          renderedGuides.push(_react2.default.createElement(_Guide2.default, babelHelpers.extends({
            key: hoveredSide + '-' + selectedSide
          }, (0, _mapValues2.default)(guide.guide, function (v) {
            return v ? v * pixelRatio : v;
          }), {
            value: guide.guide.value
          })));

          if (guide.extension) {
            renderedGuides.push(_react2.default.createElement(_Extension2.default, babelHelpers.extends({
              side: guide.extension.side
            }, (0, _mapValues2.default)(guide.extension.layout, function (v) {
              return v ? v * pixelRatio : v;
            }))));
          }
        }
      }
    });
    return _react2.default.createElement('div', null, renderedGuides);
  }

  RelativeGuides.propTypes = {
    selectedElement: _propTypes2.default.object.isRequired,
    hoveredElement: _propTypes2.default.object.isRequired,
    pixelRatio: _propTypes2.default.number.isRequired
  };

  function attachGuide(_ref4) {
    var selected = _ref4.selected,
        hovered = _ref4.hovered,
        measurement = _ref4.measurement;
    var guideAttachedToSelectedElement = attachGuideTo({
      element: selected,
      measurement: measurement
    });

    if (!isLineThroughBoundingBox({
      isVertical: measurement.isVertical,
      start: guideAttachedToSelectedElement,
      length: measurement.length,
      bbox: selected
    })) {
      return babelHelpers.extends({}, guideAttachedToSelectedElement, {
        attachedTo: 'selected',
        isVertical: measurement.isVertical
      });
    }

    var guideAttachedToHoveredElement = attachGuideTo({
      element: hovered,
      measurement: measurement
    });

    if (!isLineThroughBoundingBox({
      isVertical: measurement.isVertical,
      start: guideAttachedToHoveredElement,
      length: measurement.length,
      bbox: hovered
    })) {
      return babelHelpers.extends({}, guideAttachedToHoveredElement, {
        attachedTo: 'hovered',
        isVertical: measurement.isVertical
      });
    }

    return null;
  }

  function attachGuideTo(_ref5) {
    var element = _ref5.element,
        measurement = _ref5.measurement;

    if (measurement.isVertical) {
      return {
        left: element.left + element.width / 2,
        top: measurement.start,
        height: measurement.length,
        value: measurement.length
      };
    }

    return {
      left: measurement.start,
      width: measurement.length,
      top: element.top + element.height / 2,
      value: measurement.length
    };
  }

  function getMeasurement(_ref6) {
    var selected = _ref6.selected,
        hovered = _ref6.hovered,
        selectedElementSide = _ref6.selectedElementSide,
        hoveredElementSide = _ref6.hoveredElementSide;
    var hoveredCoord = hovered[hoveredElementSide];
    var selectedCoord = selected[selectedElementSide];
    var distance = hoveredCoord - selectedCoord;
    var absDistance = Math.abs(distance);
    var base = void 0;

    if (distance < 0) {
      base = hoveredCoord;
    } else {
      base = selectedCoord;
    }

    return {
      start: base,
      length: absDistance,
      isVertical: isVerticalMeasurement(selectedElementSide)
    };
  }

  function getExtension(selectedElement, selectedElementSide, guide) {
    var _props;

    var overDraw = 50;
    var adjacentSide = void 0;
    var fixedProp = void 0;
    var sizeProp = void 0;
    var position = void 0;
    var size = void 0;

    if (guide.isVertical) {
      adjacentSide = 'left';
      fixedProp = 'top';
      sizeProp = 'width';
    } else {
      adjacentSide = 'top';
      fixedProp = 'left';
      sizeProp = 'height';
    }

    if (guide[adjacentSide] < selectedElement[adjacentSide]) {
      position = Math.max(0, guide[adjacentSide] - overDraw);
      size = selectedElement[adjacentSide] - position;
    } else if (guide[adjacentSide] > selectedElement[getOppositeSide(adjacentSide)]) {
      position = selectedElement[getOppositeSide(adjacentSide)];
      size = guide[adjacentSide] - selectedElement[getOppositeSide(adjacentSide)] + overDraw;
    }

    var props = (_props = {}, babelHelpers.defineProperty(_props, fixedProp, selectedElement[selectedElementSide]), babelHelpers.defineProperty(_props, adjacentSide, position), babelHelpers.defineProperty(_props, sizeProp, size), babelHelpers.defineProperty(_props, 'isVertical', !guide.isVertical), _props);
    return {
      side: selectedElementSide,
      layout: props
    };
  }

  function getOppositeSide(side) {
    return {
      left: 'right',
      right: 'left',
      top: 'bottom',
      bottom: 'top'
    }[side];
  }

  function isVerticalMeasurement(side) {
    return side === 'top' || side === 'bottom';
  }

  function isLineThroughBoundingBox(_ref7) {
    var isVertical = _ref7.isVertical,
        start = _ref7.start,
        length = _ref7.length,
        bbox = _ref7.bbox;

    if (isVertical) {
      if (start.left >= bbox.left && start.left <= bbox.right) {
        return isOverlapping([start.top, start.top + length], [bbox.top, bbox.bottom]);
      }
    } else if (start.top >= bbox.top && start.top <= bbox.bottom) {
      return isOverlapping([start.left, start.left + length], [bbox.left, bbox.right]);
    }

    return false;
  }

  function isOverlapping(range1, range2) {
    var isOutside = range1[1] <= range2[0] || range1[0] >= range2[1];
    return !isOutside;
  }
  /***/

},
/* 461 */

/***/
function (module, exports) {
  module.exports = require("lodash/set");
  /***/
},
/* 462 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _Extension = __webpack_require__(463);

  var _Extension2 = babelHelpers.interopRequireDefault(_Extension);

  var _handoff = __webpack_require__(5);

  function mapStateToProps(state) {
    return {
      zoomScale: (0, _handoff.getZoomScale)(state),
      pixelRatio: (0, _handoff.getPixelRatio)(state)
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(_Extension2.default);
  /***/
},
/* 463 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Extension;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _mapValues = __webpack_require__(26);

  var _mapValues2 = babelHelpers.interopRequireDefault(_mapValues);

  var _Guide = __webpack_require__(168);

  var _Guide2 = babelHelpers.interopRequireDefault(_Guide);

  function Extension(_ref) {
    var side = _ref.side,
        zoomScale = _ref.zoomScale,
        layout = babelHelpers.objectWithoutProperties(_ref, ['side', 'zoomScale']);
    var isVertical = side === 'left' || side === 'right';
    var className = (0, _classnames2.default)(_Guide2.default.guide, 'borderWidth-0', {
      'borderLeftWidth-1': isVertical,
      'borderTopWidth-1': !isVertical
    });
    var style = (0, _mapValues2.default)(layout, function (v) {
      return zoomScale * v;
    });

    if (side === 'right') {
      style.left -= 1;
    } else if (side === 'bottom') {
      style.top -= 1;
    }

    return _react2.default.createElement('div', {
      style: style,
      className: className
    });
  }

  Extension.propTypes = {
    side: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
    zoomScale: _propTypes2.default.number.isRequired
  };
  /***/
},
/* 464 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _layoutOverlay = __webpack_require__(41);

  var _Columns = __webpack_require__(465);

  var _Columns2 = babelHelpers.interopRequireDefault(_Columns);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state) {
    return babelHelpers.extends({}, (0, _layoutOverlay.getColumnConfig)(state), {
      isOverlayOn: (0, _layoutOverlay.getIsColumnOverlayOn)(state)
    });
  }

  var isOverlayOn = function isOverlayOn(props) {
    return props.isOverlayOn;
  };

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(isOverlayOn))(_Columns2.default);
  /***/
},
/* 465 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Columns;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _bind = __webpack_require__(79);

  var _bind2 = babelHelpers.interopRequireDefault(_bind);

  var _Container = __webpack_require__(169);

  var _Container2 = babelHelpers.interopRequireDefault(_Container);

  var _Layout = __webpack_require__(101);

  var _Layout2 = babelHelpers.interopRequireDefault(_Layout);

  var _convertColours = __webpack_require__(27);

  var cx = _bind2.default.bind(_Layout2.default);

  function Columns(_ref) {
    var count = _ref.count,
        offset = _ref.offset,
        totalWidth = _ref.totalWidth,
        columnWidth = _ref.columnWidth,
        gutterWidth = _ref.gutterWidth,
        isGutterOnOutside = _ref.isGutterOnOutside,
        fillColor = _ref.fillColor,
        strokeColor = _ref.strokeColor;
    var left = offset;

    if (isGutterOnOutside) {
      left += (totalWidth - (count * columnWidth + (count - 1) * gutterWidth)) / 2;
    }

    var columns = [];
    var colorStyle = fillColor ? {
      backgroundColor: (0, _convertColours.rgbaArray2rgba)(fillColor)
    } : {
      border: '1px solid ' + (0, _convertColours.rgbaArray2rgba)(strokeColor)
    };

    for (var i = 0; i < count; i += 1) {
      columns.push(_react2.default.createElement('div', {
        key: i,
        className: cx('overlay', 'column'),
        style: babelHelpers.extends({
          top: 0,
          left: left,
          width: columnWidth
        }, colorStyle)
      }));
      left += columnWidth + gutterWidth;
    }

    return _react2.default.createElement(_Container2.default, null, columns);
  }

  Columns.propTypes = {
    count: _propTypes2.default.number.isRequired,
    offset: _propTypes2.default.number.isRequired,
    columnWidth: _propTypes2.default.number.isRequired,
    totalWidth: _propTypes2.default.number.isRequired,
    gutterWidth: _propTypes2.default.number.isRequired,
    isGutterOnOutside: _propTypes2.default.bool.isRequired,
    fillColor: _propTypes2.default.arrayOf(_propTypes2.default.number),
    strokeColor: _propTypes2.default.arrayOf(_propTypes2.default.number)
  };
  /***/
},
/* 466 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _layoutOverlay = __webpack_require__(41);

  var _Rows = __webpack_require__(467);

  var _Rows2 = babelHelpers.interopRequireDefault(_Rows);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state) {
    return babelHelpers.extends({}, (0, _layoutOverlay.getRowConfig)(state), {
      isOverlayOn: (0, _layoutOverlay.getIsRowOverlayOn)(state)
    });
  }

  var isOverlayOn = function isOverlayOn(props) {
    return props.isOverlayOn;
  };

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(isOverlayOn))(_Rows2.default);
  /***/
},
/* 467 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Rows;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _bind = __webpack_require__(79);

  var _bind2 = babelHelpers.interopRequireDefault(_bind);

  var _Container = __webpack_require__(169);

  var _Container2 = babelHelpers.interopRequireDefault(_Container);

  var _Layout = __webpack_require__(101);

  var _Layout2 = babelHelpers.interopRequireDefault(_Layout);

  var _convertColours = __webpack_require__(27);

  var cx = _bind2.default.bind(_Layout2.default);

  function Rows(_ref) {
    var gutterHeight = _ref.gutterHeight,
        heightAsGutterMultiple = _ref.heightAsGutterMultiple,
        fillColor = _ref.fillColor,
        strokeColor = _ref.strokeColor,
        count = _ref.count;
    var top = 0;
    var rows = [];
    var colorStyle = fillColor ? {
      backgroundColor: (0, _convertColours.rgbaArray2rgba)(fillColor)
    } : {
      borderColor: (0, _convertColours.rgbaArray2rgba)(strokeColor)
    };

    for (var i = 0; i < count; i += 1) {
      var height = heightAsGutterMultiple * gutterHeight;
      rows.push(_react2.default.createElement('div', {
        key: i,
        className: cx('overlay', 'row', {
          strokeRow: strokeColor
        }),
        style: babelHelpers.extends({
          left: 0,
          top: top,
          height: height
        }, colorStyle)
      }));
      top += height + gutterHeight;
    }

    return _react2.default.createElement(_Container2.default, null, rows);
  }

  Rows.propTypes = {
    gutterHeight: _propTypes2.default.number.isRequired,
    heightAsGutterMultiple: _propTypes2.default.number.isRequired,
    fillColor: _propTypes2.default.arrayOf(_propTypes2.default.number),
    strokeColor: _propTypes2.default.arrayOf(_propTypes2.default.number),
    count: _propTypes2.default.number.isRequired
  };
  /***/
},
/* 468 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "hotspotLayer": "HotspotLayer__hotspotLayer___3l6ct width-100 position-relative",
    "annotationMode": "HotspotLayer__annotationMode___8oDnp cusror-crosshair"
  };
  /***/
},
/* 469 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "image": "Image__image___1yZY2",
    "hiddenImage": "Image__hiddenImage___1OKDP",
    "annotating": "Image__annotating___2b1Uh"
  };
  /***/
},
/* 470 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _redux = __webpack_require__(7);

  var _getContext = __webpack_require__(29);

  var _getContext2 = babelHelpers.interopRequireDefault(_getContext);

  var _Image = __webpack_require__(50);

  var _Image2 = babelHelpers.interopRequireDefault(_Image);

  var _fixedArea = __webpack_require__(66);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state, _ref) {
    var isCurrentScreen = _ref.isCurrentScreen;
    return (0, _fixedArea.getFooterProps)(state, isCurrentScreen);
  }

  var exists = function exists(_ref2) {
    var footer = _ref2.footer;
    return !!footer;
  };

  exports.default = (0, _redux.compose)((0, _getContext2.default)({
    isCurrentScreen: _propTypes2.default.bool.isRequired
  }), (0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(exists))(_Image2.default);
  /***/
},
/* 471 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _reactRedux = __webpack_require__(2);

  var _redux = __webpack_require__(7);

  var _getContext = __webpack_require__(29);

  var _getContext2 = babelHelpers.interopRequireDefault(_getContext);

  var _ScreenImage = __webpack_require__(472);

  var _ScreenImage2 = babelHelpers.interopRequireDefault(_ScreenImage);

  var _layout = __webpack_require__(15);

  var _screen = __webpack_require__(9);

  var _annotation = __webpack_require__(20);

  var _hotspot = __webpack_require__(28);

  var _handoff = __webpack_require__(5);

  var _project = __webpack_require__(11);

  var _screen2 = __webpack_require__(132);

  function mapStateToProps(state, _ref) {
    var isCurrentScreen = _ref.isCurrentScreen;
    var screenStyles = (0, _layout.getScreenStyles)(state, isCurrentScreen);
    var currentScreen = (0, _screen.getScreen)(state, isCurrentScreen);
    return {
      src: screenStyles.imgURL,
      resetGIF: (0, _screen.isGIFResetRequired)(state),
      imageMargin: screenStyles.imageMargin,
      imageWidth: screenStyles.imageWidth,
      imageHeight: screenStyles.imageHeight,
      naturalWidth: currentScreen.img.width,
      hotspots: (0, _hotspot.getBodyHotspots)(state),
      annotations: (0, _annotation.getBodyAnnotations)(state),
      elements: (0, _handoff.getElementHotspots)(state),
      isCentredWebPrototype: (0, _project.isCentredWebPrototype)(state),
      isInHandoffMode: (0, _handoff.isInHandoffMode)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      gifResetDone: function gifResetDone() {
        dispatch((0, _screen2.gifResetDone)());
      }
    };
  }

  exports.default = (0, _redux.compose)((0, _getContext2.default)({
    isCurrentScreen: _propTypes2.default.bool.isRequired
  }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_ScreenImage2.default);
  /***/
},
/* 472 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _HotspotLayer = __webpack_require__(159);

  var _HotspotLayer2 = babelHelpers.interopRequireDefault(_HotspotLayer);

  var _handoffScrollableArea = __webpack_require__(473);

  var _ScreenImage = __webpack_require__(474);

  var _ScreenImage2 = babelHelpers.interopRequireDefault(_ScreenImage);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);

  var ScreenImage = function (_Component) {
    babelHelpers.inherits(ScreenImage, _Component);

    function ScreenImage() {
      babelHelpers.classCallCheck(this, ScreenImage);
      return babelHelpers.possibleConstructorReturn(this, (ScreenImage.__proto__ || Object.getPrototypeOf(ScreenImage)).apply(this, arguments));
    }

    babelHelpers.createClass(ScreenImage, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.resetGifAnimation();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.resetGifAnimation();
      }
    }, {
      key: 'resetGifAnimation',
      value: function resetGifAnimation() {
        if (this.props.resetGIF) {
          var img = this.refs.img;
          img.src = img.src; // Note for reasons unknown we need setTimeout here (so the
          // state is changed in the next React update cycle. Or something)

          setTimeout(this.props.gifResetDone, 0);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            hotspots = _props.hotspots,
            annotations = _props.annotations,
            elements = _props.elements,
            getScreenScrollPos = _props.getScreenScrollPos,
            imageMargin = _props.imageMargin,
            imageWidth = _props.imageWidth,
            imageHeight = _props.imageHeight,
            src = _props.src,
            isCurrentScreen = _props.isCurrentScreen,
            screenID = _props.screenID,
            isCentredWebPrototype = _props.isCentredWebPrototype,
            isInHandoffMode = _props.isInHandoffMode;
        var stretchedImageWidth = Math.ceil(imageWidth);
        var stretchedImageHeight = Math.ceil(imageHeight);
        var outerStyle = {
          marginLeft: imageMargin.marginLeft
        };

        if (isCentredWebPrototype) {
          outerStyle.overflowX = 'hidden';
        } else {
          outerStyle.width = imageWidth;
        }

        var imgWrapperStyle = (0, _classnames2.default)(_ScreenImage2.default.imgWrapper, babelHelpers.defineProperty({}, _ScreenImage2.default.handoffMode, isInHandoffMode));
        var appliedOuterStyle = getHandoffImageOuterStyle(isInHandoffMode, outerStyle);
        return _react2.default.createElement('div', {
          style: appliedOuterStyle
        }, _react2.default.createElement('div', {
          className: imgWrapperStyle
        }, _react2.default.createElement('div', {
          className: 'overflow-hidden',
          style: {
            height: stretchedImageHeight + imageMargin.marginBottom,
            marginTop: imageMargin.marginTop,
            marginBottom: -imageMargin.marginBottom,
            backgroundColor: isInHandoffMode && 'white'
          }
        }, _react2.default.createElement('img', {
          ref: 'img',
          alt: '',
          src: src,
          className: _ScreenImage2.default.img,
          style: {
            width: stretchedImageWidth,
            height: stretchedImageHeight
          }
        })), isCurrentScreen && _react2.default.createElement('div', {
          className: _ScreenImage2.default.hotspotLayerWrapper
        }, _react2.default.createElement(_HotspotLayer2.default, {
          screenID: screenID,
          height: imageHeight,
          getScreenScrollPos: getScreenScrollPos,
          location: screenLocation.BODY,
          hotspots: hotspots,
          annotations: annotations,
          elements: elements
        }))));
      }
    }]);
    return ScreenImage;
  }(_react.Component);

  exports.default = ScreenImage;

  function getHandoffImageOuterStyle(isInHandoffMode, outerStyle) {
    if (isInHandoffMode) {
      var width = outerStyle.width,
          marginLeft = outerStyle.marginLeft;
      var marginBottom = _handoffScrollableArea.SIDE_PADDING;

      if (marginLeft < _handoffScrollableArea.SIDE_PADDING) {
        var newWidth = width + _handoffScrollableArea.SIDE_PADDING * 2;
        var padding = '0 ' + _handoffScrollableArea.SIDE_PADDING + 'px';
        return {
          width: newWidth,
          padding: padding,
          marginBottom: marginBottom
        };
      }

      return {
        width: width,
        marginLeft: marginLeft,
        marginBottom: marginBottom
      };
    }

    return outerStyle;
  }

  ScreenImage.propTypes = {
    imageMargin: _propTypes2.default.shape({
      marginTop: _propTypes2.default.number.isRequired,
      marginBottom: _propTypes2.default.number.isRequired
    }),
    imageWidth: _propTypes2.default.number.isRequired,
    imageHeight: _propTypes2.default.number.isRequired,
    src: _propTypes2.default.string.isRequired,
    hotspots: _propTypes2.default.array,
    getScreenScrollPos: _propTypes2.default.func,
    annotations: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      left: _propTypes2.default.number,
      top: _propTypes2.default.number
    })),
    elements: _propTypes2.default.array,
    resetGIF: _propTypes2.default.bool,
    gifResetDone: _propTypes2.default.func.isRequired,
    isCurrentScreen: _propTypes2.default.bool.isRequired,
    isCentredWebPrototype: _propTypes2.default.bool.isRequired,
    isInHandoffMode: _propTypes2.default.bool,
    screenID: _propTypes2.default.number.isRequired
  };
  /***/
},
/* 473 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SIDE_PADDING = exports.SIDE_PADDING = 30;
  /***/
},
/* 474 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "imgWrapper": "ScreenImage__imgWrapper___lROGZ",
    "img": "ScreenImage__img___1DNfD",
    "hotspotLayerWrapper": "ScreenImage__hotspotLayerWrapper___1AI3H",
    "handoffMode": "ScreenImage__handoffMode___DqCJc boxShadow-distant marginTop-xl"
  };
  /***/
},
/* 475 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _reactRedux = __webpack_require__(2);

  var _compose = __webpack_require__(24);

  var _compose2 = babelHelpers.interopRequireDefault(_compose);

  var _getContext = __webpack_require__(29);

  var _getContext2 = babelHelpers.interopRequireDefault(_getContext);

  var _toClass = __webpack_require__(42);

  var _toClass2 = babelHelpers.interopRequireDefault(_toClass);

  var _ScrollableArea = __webpack_require__(170);

  var _ScrollableArea2 = babelHelpers.interopRequireDefault(_ScrollableArea);

  var _layout = __webpack_require__(15);

  function mapStateToProps(state, _ref) {
    var isCurrentScreen = _ref.isCurrentScreen;
    var screenStyles = (0, _layout.getScreenStyles)(state, isCurrentScreen);
    return {
      height: screenStyles.scrollableAreaHeight,
      width: screenStyles.scrollableAreaWidth,
      padding: screenStyles.scrollableAreaPadding,
      isScrollable: screenStyles.isScrollableAreaScrollable,
      isMobile: state.deviceDetection.isMobile,
      isIOS: state.deviceDetection.isIPad || state.deviceDetection.isIPhone
    };
  }

  exports.default = (0, _compose2.default)(_toClass2.default, (0, _getContext2.default)({
    isCurrentScreen: _propTypes2.default.bool.isRequired
  }), (0, _reactRedux.connect)(mapStateToProps))(_ScrollableArea2.default);
  /***/
},
/* 476 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = fixMobileSafariScrollBounce;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactDom = __webpack_require__(63);

  var _reactDom2 = babelHelpers.interopRequireDefault(_reactDom);

  var _assign = __webpack_require__(21);

  var _assign2 = babelHelpers.interopRequireDefault(_assign);

  function fixMobileSafariScrollBounce(Component) {
    // Note: to attach event handlers we have to *extend* rather than
    // wrap Component.
    // See: https://medium.com/@franleplant/react-higher-order-components-in-depth-cf9032ee6c3e#.2ah28ksdp
    // TODO support function components
    var MobileSafariBounceFix = function (_Component) {
      babelHelpers.inherits(MobileSafariBounceFix, _Component);

      function MobileSafariBounceFix() {
        var _ref;

        var _temp, _this, _ret;

        babelHelpers.classCallCheck(this, MobileSafariBounceFix);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = MobileSafariBounceFix.__proto__ || Object.getPrototypeOf(MobileSafariBounceFix)).call.apply(_ref, [this].concat(args))), _this), _this.onTouchStart = function () {
          if (_this.props.isScrollable) {
            if (_this.isScrolledToTop()) {
              _this.hackilyMakeContentStillScrollableAtTop();
            } else if (_this.isScrolledToBottom()) {
              _this.hackilyMakeContentStillScrollableAtBottom();
            }
          }
        }, _this.onTouchMove = function (e) {
          if (!_this.props.isScrollable) {
            e.preventDefault();
          }
        }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
      }

      babelHelpers.createClass(MobileSafariBounceFix, [{
        key: 'render',
        value: function render() {
          var elementsTree = babelHelpers.get(MobileSafariBounceFix.prototype.__proto__ || Object.getPrototypeOf(MobileSafariBounceFix.prototype), 'render', this).call(this);
          var newProps = {
            onTouchStart: this.onTouchStart,
            onTouchEnd: this.onTouchEnd,
            onTouchMove: this.onTouchMove
          };
          var props = (0, _assign2.default)({}, elementsTree.props, newProps);

          var newElementsTree = _react2.default.cloneElement(elementsTree, props, elementsTree.props.children);

          return newElementsTree;
        }
      }, {
        key: 'isScrolledToBottom',
        value: function isScrolledToBottom() {
          var element = this.getDOMNode(); // See https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight (Problems and solutions)

          return element.scrollHeight - element.scrollTop === element.clientHeight;
        }
      }, {
        key: 'isScrolledToTop',
        value: function isScrolledToTop() {
          return this.getDOMNode().scrollTop === 0;
        }
      }, {
        key: 'hackilyMakeContentStillScrollableAtTop',
        value: function hackilyMakeContentStillScrollableAtTop() {
          this.getDOMNode().scrollTop = 1;
        }
      }, {
        key: 'hackilyMakeContentStillScrollableAtBottom',
        value: function hackilyMakeContentStillScrollableAtBottom() {
          this.getDOMNode().scrollTop = this.getDOMNode().scrollTop - 1;
        }
      }, {
        key: 'getDOMNode',
        value: function getDOMNode() {
          return _reactDom2.default.findDOMNode(this);
        }
      }]);
      return MobileSafariBounceFix;
    }(Component);

    MobileSafariBounceFix.propTypes = {
      isScrollable: _propTypes2.default.bool
    };
    return MobileSafariBounceFix;
  }
  /***/

},
/* 477 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;

  var _perfectScrollbar = __webpack_require__(478);

  var _perfectScrollbar2 = babelHelpers.interopRequireDefault(_perfectScrollbar);

  var _reactDom = __webpack_require__(63);

  var _reactDom2 = babelHelpers.interopRequireDefault(_reactDom);

  var SCROLL_EPS = 4;

  function prettifyScrollbar(Component) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _getTopOffset = _ref.getTopOffset,
        _getBottomOffset = _ref.getBottomOffset; // Note: to get the DOM node of the component we're wrapping,
    // without having to do something complicated with refs, we need to
    // *extend* rather than wrap Component.


    var PrettyScrollbar = function (_Component) {
      babelHelpers.inherits(PrettyScrollbar, _Component);

      function PrettyScrollbar() {
        babelHelpers.classCallCheck(this, PrettyScrollbar);
        return babelHelpers.possibleConstructorReturn(this, (PrettyScrollbar.__proto__ || Object.getPrototypeOf(PrettyScrollbar)).apply(this, arguments));
      }

      babelHelpers.createClass(PrettyScrollbar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          if (babelHelpers.get(PrettyScrollbar.prototype.__proto__ || Object.getPrototypeOf(PrettyScrollbar.prototype), 'componentDidMount', this)) {
            babelHelpers.get(PrettyScrollbar.prototype.__proto__ || Object.getPrototypeOf(PrettyScrollbar.prototype), 'componentDidMount', this).call(this);
          }

          _perfectScrollbar2.default.initialize(this.getDOMNode(), {
            getTopOffset: function getTopOffset() {
              return _getTopOffset ? _getTopOffset.apply(_this2) : 0;
            },
            getBottomOffset: function getBottomOffset() {
              return _getBottomOffset ? _getBottomOffset.apply(_this2) : 0;
            },
            scrollXMarginOffset: SCROLL_EPS,
            scrollYMarginOffset: SCROLL_EPS
          });
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          if (babelHelpers.get(PrettyScrollbar.prototype.__proto__ || Object.getPrototypeOf(PrettyScrollbar.prototype), 'componentDidUpdate', this)) {
            babelHelpers.get(PrettyScrollbar.prototype.__proto__ || Object.getPrototypeOf(PrettyScrollbar.prototype), 'componentDidUpdate', this).call(this);
          }

          _perfectScrollbar2.default.update(this.getDOMNode());
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (babelHelpers.get(PrettyScrollbar.prototype.__proto__ || Object.getPrototypeOf(PrettyScrollbar.prototype), 'componentWillUnmount', this)) {
            babelHelpers.get(PrettyScrollbar.prototype.__proto__ || Object.getPrototypeOf(PrettyScrollbar.prototype), 'componentWillUnmount', this).call(this);
          }

          _perfectScrollbar2.default.destroy(this.getDOMNode());
        }
      }, {
        key: 'getDOMNode',
        value: function getDOMNode() {
          return _reactDom2.default.findDOMNode(this);
        }
      }]);
      return PrettyScrollbar;
    }(Component);

    return PrettyScrollbar;
  }

  exports.default = prettifyScrollbar;
  /***/
},
/* 478 */

/***/
function (module, exports) {
  module.exports = require("perfect-scrollbar");
  /***/
},
/* 479 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "scrollable": "ScrollableArea__scrollable___3cX58",
    "isMobile": "ScrollableArea__isMobile___1mH50"
  };
  /***/
},
/* 480 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _LoadingSpinner = __webpack_require__(481);

  var _LoadingSpinner2 = babelHelpers.interopRequireDefault(_LoadingSpinner);

  exports.default = (0, _reactRedux.connect)(function (state) {
    return {
      backgroundColour: state.project.config.backgroundColour
    };
  })(_LoadingSpinner2.default);
  /***/
},
/* 481 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _spin = __webpack_require__(482);

  var _spin2 = babelHelpers.interopRequireDefault(_spin);

  var LoadingSpinner = function (_React$Component) {
    babelHelpers.inherits(LoadingSpinner, _React$Component);

    function LoadingSpinner() {
      babelHelpers.classCallCheck(this, LoadingSpinner);
      return babelHelpers.possibleConstructorReturn(this, (LoadingSpinner.__proto__ || Object.getPrototypeOf(LoadingSpinner)).apply(this, arguments));
    }

    babelHelpers.createClass(LoadingSpinner, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var backgroundColour = this.props.backgroundColour;
        var rgb = parseInt(backgroundColour, 16); // convert rrggbb to decimal

        var luminance = getColourLuminance(rgb);
        var white = luminance < 0.5;
        var opts = {
          lines: 11,
          // The number of lines to draw
          length: 8,
          // The length of each line
          width: 2,
          // The line thickness
          radius: 8,
          // The radius of the inner circle
          corners: 1,
          // Corner roundness (0..1)
          rotate: 0,
          // The rotation offset
          direction: 1,
          // 1: clockwise, -1: counterclockwise
          color: white ? '#FFF' : '#000',
          // #rgb or #rrggbb or array of colors
          speed: 1,
          // Rounds per second
          trail: 60,
          // Afterglow percentage
          shadow: false,
          // Whether to render a shadow
          hwaccel: false,
          // Whether to use hardware acceleration
          className: 'spinner',
          // The CSS class to assign to the spinner
          zIndex: 2e9,
          // The z-index (defaults to 2000000000)
          top: '50%',
          // Top position relative to parent
          left: '50%' // Left position relative to parent

        };
        new _spin2.default(opts).spin(this.refs.spinner);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement('div', {
          ref: 'spinner'
        });
      }
    }]);
    return LoadingSpinner;
  }(_react2.default.Component);

  LoadingSpinner.propTypes = {
    backgroundColour: _propTypes2.default.string.isRequired
  };
  exports.default = LoadingSpinner;

  function getColourLuminance(rgb) {
    /* eslint-disable no-bitwise */
    var r = rgb >> 16 & 0xff; // extract red

    var g = rgb >> 8 & 0xff; // extract green

    var b = rgb >> 0 & 0xff; // extract blue

    return 0.213 * (r / 255) + 0.715 * (g / 255) + 0.072 * (b / 255);
  }
  /***/

},
/* 482 */

/***/
function (module, exports) {
  module.exports = require("spin.js");
  /***/
},
/* 483 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _velocityReact = __webpack_require__(23);

  var _reactRedux = __webpack_require__(2);

  var _redux = __webpack_require__(7);

  var _getContext = __webpack_require__(29);

  var _getContext2 = babelHelpers.interopRequireDefault(_getContext);

  var _partial = __webpack_require__(22);

  var _partial2 = babelHelpers.interopRequireDefault(_partial);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _Overlay = __webpack_require__(484);

  var _Overlay2 = babelHelpers.interopRequireDefault(_Overlay);

  var _overlay = __webpack_require__(36);

  var _actionCreators = __webpack_require__(4);

  var _annotation = __webpack_require__(20);

  var _layout = __webpack_require__(15);

  var _handoff = __webpack_require__(5);

  var _tracking = __webpack_require__(98);

  function mapStateToProps(state, _ref) {
    var isCurrentScreen = _ref.isCurrentScreen;
    var screenStyles = (0, _layout.getScreenStyles)(state, isCurrentScreen);
    return babelHelpers.extends({}, (0, _overlay.getOverlayProps)(state, isCurrentScreen), {
      annotations: (0, _annotation.getOverlayAnnotations)(state),
      imageWidth: screenStyles.imageWidth,
      imageMargin: screenStyles.imageMargin,
      isOverlay: true,
      scrollTop: state.overlay.scrollPos,
      smoothScroll: state.overlay.smoothScroll,
      isHandoffMode: (0, _handoff.isInHandoffMode)(state),
      isMobile: state.deviceDetection.isMobile,
      isIOS: state.deviceDetection.isIPad || state.deviceDetection.isIPhone,
      getMissedClickPosition: (0, _partial2.default)(_tracking.getOverlayMissedClickPosition, state)
    });
  }

  var Container = function Container(props) {
    if (props.id) {
      if (props.animation) {
        return _react2.default.createElement(_velocityReact.VelocityComponent, babelHelpers.extends({}, props.animation, {
          runOnMount: true
        }), _react2.default.createElement(_Overlay2.default, props));
      }

      return _react2.default.createElement(_Overlay2.default, props);
    }

    return null;
  };

  Container.propTypes = {
    id: _propTypes2.default.number,
    animation: _propTypes2.default.object
  };

  function mergeProps(stateProps, _ref2, ownProps) {
    var dispatch = _ref2.dispatch;
    var newProps = {
      onClick: function onClick(clickArea, e) {
        e.stopPropagation();
        dispatch((0, _actionCreators.missedClick)(stateProps.getMissedClickPosition(stateProps.id, clickArea, e)));
        dispatch((0, _actionCreators.flashHotspots)());
      },
      onBackgroundClick: function onBackgroundClick(e) {
        e.stopPropagation();
        dispatch((0, _actionCreators.hideOverlay)());
      },
      onSetScrollEnd: function onSetScrollEnd() {
        dispatch((0, _actionCreators.unsetOverlayScrollPos)());
      }
    };
    return babelHelpers.extends({}, ownProps, stateProps, newProps);
  }

  var isNotInHandoffMode = function isNotInHandoffMode(props) {
    return !props.isHandoffMode;
  };

  exports.default = (0, _redux.compose)((0, _getContext2.default)({
    isCurrentScreen: _propTypes2.default.bool.isRequired
  }), (0, _reactRedux.connect)(mapStateToProps, null, mergeProps), (0, _onlyIf2.default)(isNotInHandoffMode))(Container);
  /***/
},
/* 484 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _toClass = __webpack_require__(42);

  var _toClass2 = babelHelpers.interopRequireDefault(_toClass);

  var _marvelCore = __webpack_require__(25);

  var _Image = __webpack_require__(50);

  var _Image2 = babelHelpers.interopRequireDefault(_Image);

  var _Overlay = __webpack_require__(485);

  var _Overlay2 = babelHelpers.interopRequireDefault(_Overlay);

  var _controlScroll = __webpack_require__(102);

  var _controlScroll2 = babelHelpers.interopRequireDefault(_controlScroll);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);

  var _OverlayScrollableArea = __webpack_require__(487);

  var _OverlayScrollableArea2 = babelHelpers.interopRequireDefault(_OverlayScrollableArea);

  var _OverlayHeader = __webpack_require__(488);

  var _OverlayHeader2 = babelHelpers.interopRequireDefault(_OverlayHeader);

  var _OverlayFooter = __webpack_require__(489);

  var _OverlayFooter2 = babelHelpers.interopRequireDefault(_OverlayFooter);

  var BaseOverlay = function BaseOverlay(_ref) {
    var screenID = _ref.screenID,
        transition = _ref.transition,
        position = _ref.position,
        top = _ref.top,
        left = _ref.left,
        width = _ref.width,
        height = _ref.height,
        imgURL = _ref.imgURL,
        hotspots = _ref.hotspots,
        annotations = _ref.annotations,
        getScreenScrollPos = _ref.getScreenScrollPos,
        scrollTop = _ref.scrollTop,
        statusBarTrimHeight = _ref.statusBarTrimHeight,
        renderedScreenDimensions = _ref.renderedScreenDimensions,
        imageWidth = _ref.imageWidth,
        imageMargin = _ref.imageMargin,
        _onClick = _ref.onClick,
        onBackgroundClick = _ref.onBackgroundClick,
        withRef = _ref.withRef,
        getScrollPos = _ref.getScrollPos,
        isScrollable = _ref.isScrollable;
    var imgStyle = babelHelpers.extends({
      backgroundImage: 'url(' + imgURL + ')',
      width: width,
      height: height
    }, getPositionStyles(position, width, height, imageWidth, renderedScreenDimensions.height, top, left, scrollTop, statusBarTrimHeight));
    var containerStyle = babelHelpers.extends({
      top: -renderedScreenDimensions.height,
      height: renderedScreenDimensions.height,
      overflowY: 'hidden'
    }, getScrollableProps(imgStyle, imageWidth, imageMargin, width, renderedScreenDimensions));
    var containerClass = (0, _classnames2.default)(_Overlay2.default.container, _Overlay2.default[transition], babelHelpers.defineProperty({}, _Overlay2.default.scrollable, isScrollable));
    var getOverlayScrollPos = isScrollable ? getScrollPos : function () {
      return 0;
    };
    return _react2.default.createElement('div', {
      className: containerClass,
      style: containerStyle,
      onClick: onBackgroundClick
    }, isScrollable && _react2.default.createElement('div', {
      onClick: function onClick(e) {
        return _onClick(screenLocation.BODY, e);
      },
      style: {
        marginLeft: imgStyle.left,
        marginTop: Math.max(0, imgStyle.top),
        height: height
      }
    }, _react2.default.createElement(_OverlayScrollableArea2.default, {
      screenID: screenID,
      width: width,
      height: height,
      withRef: withRef
    }, _react2.default.createElement(_Image2.default, babelHelpers.extends({
      screenID: screenID,
      src: imgURL,
      type: screenLocation.OVERLAY,
      hotspots: hotspots,
      annotations: annotations,
      getScreenScrollPos: getScreenScrollPos,
      getOverlayScrollPos: getOverlayScrollPos
    }, babelHelpers.extends({}, imgStyle, {
      left: 0,
      top: 0
    })))), _react2.default.createElement(_OverlayHeader2.default, {
      screenID: screenID,
      getScreenScrollPos: getScreenScrollPos,
      getOverlayScrollPos: getOverlayScrollPos,
      width: width,
      height: height,
      onClick: function onClick(e) {
        return _onClick(screenLocation.HEADER, e);
      }
    }), _react2.default.createElement(_OverlayFooter2.default, {
      screenID: screenID,
      getScreenScrollPos: getScreenScrollPos,
      getOverlayScrollPos: getOverlayScrollPos,
      width: width,
      height: height,
      onClick: function onClick(e) {
        return _onClick(screenLocation.FOOTER, e);
      }
    })), !isScrollable && _react2.default.createElement(_Image2.default, babelHelpers.extends({
      screenID: screenID,
      onClick: function onClick(e) {
        return _onClick(screenLocation.BODY, e);
      },
      src: imgURL,
      type: screenLocation.OVERLAY,
      hotspots: hotspots,
      annotations: annotations,
      getScreenScrollPos: getScreenScrollPos,
      getOverlayScrollPos: getOverlayScrollPos
    }, imgStyle)));
  };

  BaseOverlay.propTypes = {
    imgURL: _propTypes2.default.string.isRequired,
    position: _propTypes2.default.oneOf([_marvelCore.constants.OVERLAY_CUSTOM, _marvelCore.constants.OVERLAY_CENTERED, _marvelCore.constants.OVERLAY_TOP_LEFT, _marvelCore.constants.OVERLAY_TOP_CENTER, _marvelCore.constants.OVERLAY_TOP_RIGHT, _marvelCore.constants.OVERLAY_BOTTOM_LEFT, _marvelCore.constants.OVERLAY_BOTTOM_CENTER, _marvelCore.constants.OVERLAY_BOTTOM_RIGHT]).isRequired,
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired,
    top: _propTypes2.default.number,
    left: _propTypes2.default.number,
    imageWidth: _propTypes2.default.number.isRequired,
    imageMargin: _propTypes2.default.object.isRequired,
    hotspots: _propTypes2.default.arrayOf(_propTypes2.default.object),
    annotations: _propTypes2.default.arrayOf(_propTypes2.default.object),
    getScreenScrollPos: _propTypes2.default.func.isRequired,
    onClick: _propTypes2.default.func,
    onBackgroundClick: _propTypes2.default.func,
    renderedScreenDimensions: _propTypes2.default.shape({
      width: _propTypes2.default.number.isRequired,
      height: _propTypes2.default.number.isRequired
    }),
    transition: _propTypes2.default.string,
    scrollTop: _propTypes2.default.number,
    statusBarTrimHeight: _propTypes2.default.number.isRequired,
    withRef: _propTypes2.default.func,
    getScrollPos: _propTypes2.default.func,
    isScrollable: _propTypes2.default.bool,
    screenID: _propTypes2.default.number
  };

  function getPositionStyles(positionCode, width, height, screenWidth, screenHeight, top, left, scrollTop, statusBarTrimHeight) {
    switch (positionCode) {
      case _marvelCore.constants.OVERLAY_CUSTOM:
        {
          var shiftedTop = top - statusBarTrimHeight;

          if (scrollTop) {
            shiftedTop -= scrollTop;
          }

          return {
            top: shiftedTop,
            left: left
          };
        }

      case _marvelCore.constants.OVERLAY_CENTERED:
        return {
          top: (screenHeight - height) / 2,
          left: (screenWidth - width) / 2
        };

      case _marvelCore.constants.OVERLAY_TOP_LEFT:
        return {
          left: 0,
          top: 0
        };

      case _marvelCore.constants.OVERLAY_TOP_CENTER:
        return {
          left: (screenWidth - width) / 2,
          top: 0
        };

      case _marvelCore.constants.OVERLAY_TOP_RIGHT:
        return {
          left: screenWidth - width,
          top: 0
        };

      case _marvelCore.constants.OVERLAY_BOTTOM_LEFT:
        return {
          left: 0,
          top: screenHeight - height
        };

      case _marvelCore.constants.OVERLAY_BOTTOM_CENTER:
        return {
          left: (screenWidth - width) / 2,
          top: screenHeight - height
        };

      case _marvelCore.constants.OVERLAY_BOTTOM_RIGHT:
        return {
          left: screenWidth - width,
          top: screenHeight - height
        };

      default:
        throw new Error('\'' + positionCode + '\' is not a valid overlay position');
    }
  } // TODO do we need this?? Elle, what's it for again?


  function getScrollableProps(imgStyle, imageWidth, imageMargin, width) {
    // if the overlay width is wider than base image we want to show the whole image, otherwise contain and position it inside the base image size
    if (width > imageWidth) {
      return {
        width: width,
        marginLeft: imgStyle.marginLeft,
        left: imgStyle.left
      };
    }

    return {
      width: imageWidth,
      marginLeft: imageMargin.marginLeft
    };
  }

  var Overlay = (0, _controlScroll2.default)((0, _toClass2.default)(BaseOverlay));
  exports.default = Overlay;
  /***/
},
/* 485 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "container": "Overlay__container___2SD4p",
    "scrollable": "Overlay__scrollable___3GehR",
    "pop-enter": "Overlay__pop-enter___3sO9j",
    "fade-enter": "Overlay__fade-enter___29N_N",
    "slidefade-enter": "Overlay__slidefade-enter___mTBxJ",
    "pushleft-enter": "Overlay__pushleft-enter___3Neix",
    "pushright-enter": "Overlay__pushright-enter___19noP",
    "slideup-enter": "Overlay__slideup-enter___2--6_",
    "slidedown-enter": "Overlay__slidedown-enter___2I6uc",
    "slide-right-enter": "Overlay__slide-right-enter___ObFXR",
    "slide-left-enter": "Overlay__slide-left-enter___3mAHW",
    "flow-enter": "Overlay__flow-enter___3IZlR",
    "flowReverse-enter": "Overlay__flowReverse-enter___28UJp"
  };
  /***/
},
/* 486 */

/***/
function (module, exports) {
  module.exports = require("velocity-react/lib/velocity-animate-shim");
  /***/
},
/* 487 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _compose = __webpack_require__(24);

  var _compose2 = babelHelpers.interopRequireDefault(_compose);

  var _toClass = __webpack_require__(42);

  var _toClass2 = babelHelpers.interopRequireDefault(_toClass);

  var _ScrollableArea = __webpack_require__(170);

  var _ScrollableArea2 = babelHelpers.interopRequireDefault(_ScrollableArea);

  var _layout = __webpack_require__(15);

  var _screen = __webpack_require__(9);

  function mapStateToProps(state, _ref) {
    var screenID = _ref.screenID,
        width = _ref.width,
        height = _ref.height;
    var screenStyles = (0, _layout.getScreenStyles)(state, null, (0, _screen.getScreen)(state, screenID), width, height);

    var _getRenderedScreenDim = (0, _screen.getRenderedScreenDimensions)(state),
        theHeight = _getRenderedScreenDim.height;

    return {
      height: theHeight,
      width: screenStyles.scrollableAreaWidth,
      padding: screenStyles.scrollableAreaPadding,
      isScrollable: screenStyles.isScrollableAreaScrollable,
      isMobile: state.deviceDetection.isMobile,
      isIOS: state.deviceDetection.isIPad || state.deviceDetection.isIPhone
    };
  }

  exports.default = (0, _compose2.default)(_toClass2.default, (0, _reactRedux.connect)(mapStateToProps))(_ScrollableArea2.default);
  /***/
},
/* 488 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _redux = __webpack_require__(7);

  var _Image = __webpack_require__(50);

  var _Image2 = babelHelpers.interopRequireDefault(_Image);

  var _fixedArea = __webpack_require__(66);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state, _ref) {
    var screenID = _ref.screenID,
        width = _ref.width,
        height = _ref.height;
    return (0, _fixedArea.getOverlayHeaderProps)(state, screenID, width, height);
  }

  var exists = function exists(_ref2) {
    var header = _ref2.header;
    return !!header;
  };

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(exists))(_Image2.default);
  /***/
},
/* 489 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _redux = __webpack_require__(7);

  var _Image = __webpack_require__(50);

  var _Image2 = babelHelpers.interopRequireDefault(_Image);

  var _fixedArea = __webpack_require__(66);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state, _ref) {
    var screenID = _ref.screenID,
        width = _ref.width,
        height = _ref.height;
    return (0, _fixedArea.getOverlayFooterProps)(state, screenID, width, height);
  }

  var exists = function exists(_ref2) {
    var footer = _ref2.footer;
    return !!footer;
  };

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _onlyIf2.default)(exists))(_Image2.default);
  /***/
},
/* 490 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _redux = __webpack_require__(7);

  var _getContext = __webpack_require__(29);

  var _getContext2 = babelHelpers.interopRequireDefault(_getContext);

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _OverlayBackground = __webpack_require__(491);

  var _OverlayBackground2 = babelHelpers.interopRequireDefault(_OverlayBackground);

  var _overlay = __webpack_require__(36);

  var _handoff = __webpack_require__(5);

  var _actionCreators = __webpack_require__(4);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  function mapStateToProps(state, _ref) {
    var isCurrentScreen = _ref.isCurrentScreen;
    var overlay = (0, _overlay.getOverlayProps)(state, isCurrentScreen);
    var animationDuration = (0, _get2.default)(overlay, 'animation.duration');
    return {
      colour: (0, _overlay.getOverlayBackgroundColour)(state, isCurrentScreen),
      animate: (0, _overlay.getOverlayBackgroundAnimate)(state, isCurrentScreen),
      animationDuration: animationDuration,
      key: overlay.id,
      isHandoffMode: (0, _handoff.isInHandoffMode)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      onClick: function onClick(e) {
        e.stopPropagation();
        dispatch((0, _actionCreators.hideOverlay)());
      }
    };
  }

  var isNotInHandoffMode = function isNotInHandoffMode(props) {
    return !props.isHandoffMode;
  };

  exports.default = (0, _redux.compose)((0, _getContext2.default)({
    isCurrentScreen: _propTypes2.default.bool.isRequired
  }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _onlyIf2.default)(isNotInHandoffMode))(_OverlayBackground2.default);
  /***/
},
/* 491 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _velocityReact = __webpack_require__(23);

  var _toClass = __webpack_require__(42);

  var _toClass2 = babelHelpers.interopRequireDefault(_toClass);

  var _compose = __webpack_require__(24);

  var _compose2 = babelHelpers.interopRequireDefault(_compose);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _disableiOSScroll = __webpack_require__(492);

  var _disableiOSScroll2 = babelHelpers.interopRequireDefault(_disableiOSScroll);

  var OverlayBackground = function OverlayBackground(_ref) {
    var colour = _ref.colour,
        animate = _ref.animate,
        animationDuration = _ref.animationDuration,
        onClick = _ref.onClick;

    var overlay = _react2.default.createElement('div', {
      onClick: onClick,
      className: 'position-absolute pinAll',
      style: {
        backgroundColor: colour
      }
    });

    if (animate) {
      return _react2.default.createElement(_velocityReact.VelocityTransitionGroup, {
        enter: {
          animation: {
            opacity: 1
          },
          duration: animationDuration,
          easing: 'ease'
        },
        leave: {
          animation: {
            opacity: 0
          },
          duration: animationDuration,
          easing: 'ease'
        },
        runOnMount: true
      }, colour ? overlay : undefined);
    }

    return !!colour && overlay;
  };

  OverlayBackground.propTypes = {
    colour: _propTypes2.default.string,
    animate: _propTypes2.default.bool,
    animationDuration: _propTypes2.default.number,
    onClick: _propTypes2.default.func.isRequired
  };
  OverlayBackground.defaultProps = {
    onClick: _noop2.default
  };
  exports.default = (0, _compose2.default)(_disableiOSScroll2.default, _toClass2.default)(OverlayBackground);
  /***/
},
/* 492 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = disableiOSScroll;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _assign = __webpack_require__(21);

  var _assign2 = babelHelpers.interopRequireDefault(_assign);

  function disableiOSScroll(Component) {
    var DisablediOSScroll = function (_Component) {
      babelHelpers.inherits(DisablediOSScroll, _Component);

      function DisablediOSScroll() {
        var _ref;

        var _temp, _this, _ret;

        babelHelpers.classCallCheck(this, DisablediOSScroll);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = DisablediOSScroll.__proto__ || Object.getPrototypeOf(DisablediOSScroll)).call.apply(_ref, [this].concat(args))), _this), _this.onTouchMove = function (e) {
          e.preventDefault();
        }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
      }

      babelHelpers.createClass(DisablediOSScroll, [{
        key: 'render',
        value: function render() {
          var elementsTree = babelHelpers.get(DisablediOSScroll.prototype.__proto__ || Object.getPrototypeOf(DisablediOSScroll.prototype), 'render', this).call(this);

          if (!elementsTree) {
            return null;
          }

          var newProps = {
            onTouchMove: this.onTouchMove
          };
          var props = (0, _assign2.default)({}, elementsTree.props, newProps);

          var newElementsTree = _react2.default.cloneElement(elementsTree, props, elementsTree.props.children);

          return newElementsTree;
        }
      }]);
      return DisablediOSScroll;
    }(Component);

    return DisablediOSScroll;
  }
  /***/

},
/* 493 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _reactRedux = __webpack_require__(2);

  var _redux = __webpack_require__(7);

  var _getContext = __webpack_require__(29);

  var _getContext2 = babelHelpers.interopRequireDefault(_getContext);

  var _TopBackground = __webpack_require__(494);

  var _TopBackground2 = babelHelpers.interopRequireDefault(_TopBackground);

  var _screen = __webpack_require__(9);

  var _layout = __webpack_require__(15);

  function mapStateToProps(state, _ref) {
    var isCurrentScreen = _ref.isCurrentScreen;
    return {
      backgroundColor: (0, _screen.getTopBackgroundColour)(state, isCurrentScreen),
      width: (0, _layout.getScreenStyles)(state, isCurrentScreen).imageWidth
    };
  }

  exports.default = (0, _redux.compose)((0, _getContext2.default)({
    isCurrentScreen: _propTypes2.default.bool.isRequired
  }), (0, _reactRedux.connect)(mapStateToProps))(_TopBackground2.default);
  /***/
},
/* 494 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = TopBackground;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _TopBackground = __webpack_require__(495);

  var _TopBackground2 = babelHelpers.interopRequireDefault(_TopBackground);

  function TopBackground(_ref) {
    var width = _ref.width,
        backgroundColor = _ref.backgroundColor;
    return _react2.default.createElement('div', {
      className: _TopBackground2.default.topBackground
    }, _react2.default.createElement('div', {
      className: _TopBackground2.default.inner,
      style: {
        backgroundColor: backgroundColor,
        width: width
      }
    }));
  }

  TopBackground.propTypes = {
    width: _propTypes2.default.number,
    backgroundColor: _propTypes2.default.string
  };
  /***/
},
/* 495 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "topBackground": "TopBackground__topBackground___3JTCc",
    "inner": "TopBackground__inner___3_0eQ"
  };
  /***/
},
/* 496 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _reactRedux = __webpack_require__(2);

  var _redux = __webpack_require__(7);

  var _getContext = __webpack_require__(29);

  var _getContext2 = babelHelpers.interopRequireDefault(_getContext);

  var _BottomBackground = __webpack_require__(497);

  var _BottomBackground2 = babelHelpers.interopRequireDefault(_BottomBackground);

  var _screen = __webpack_require__(9);

  var _layout = __webpack_require__(15);

  function mapStateToProps(state, _ref) {
    var isCurrentScreen = _ref.isCurrentScreen;
    return {
      backgroundColor: (0, _screen.getBottomBackgroundColour)(state, isCurrentScreen),
      width: (0, _layout.getScreenStyles)(state, isCurrentScreen).imageWidth
    };
  }

  exports.default = (0, _redux.compose)((0, _getContext2.default)({
    isCurrentScreen: _propTypes2.default.bool.isRequired
  }), (0, _reactRedux.connect)(mapStateToProps))(_BottomBackground2.default);
  /***/
},
/* 497 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = BottomBackground;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _BottomBackground = __webpack_require__(498);

  var _BottomBackground2 = babelHelpers.interopRequireDefault(_BottomBackground);

  function BottomBackground(_ref) {
    var width = _ref.width,
        backgroundColor = _ref.backgroundColor;
    return _react2.default.createElement('div', {
      className: _BottomBackground2.default.bottomBackground
    }, _react2.default.createElement('div', {
      className: _BottomBackground2.default.inner,
      style: {
        backgroundColor: backgroundColor,
        width: width
      }
    }));
  }

  BottomBackground.propTypes = {
    width: _propTypes2.default.number,
    backgroundColor: _propTypes2.default.string
  };
  /***/
},
/* 498 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "bottomBackground": "BottomBackground__bottomBackground___1EcX3",
    "inner": "BottomBackground__inner___NmXen"
  };
  /***/
},
/* 499 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactRedux = __webpack_require__(2);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _TouchGesture = __webpack_require__(162);

  var _TouchGesture2 = babelHelpers.interopRequireDefault(_TouchGesture);

  function mapStateToProps(state) {
    return {
      isEnabled: !state.project.isLoading && state.deviceDetection.hasTouch && state.project.config.swipeThroughScreens
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      onSwipeHorizontally: function onSwipeHorizontally(_ref) {
        var direction = _ref.direction;

        if (direction === _TouchGesture.DIRECTION_LEFT) {
          dispatch(actionCreators.showNext('pushright'));
        } else if (direction === _TouchGesture.DIRECTION_RIGHT) {
          dispatch(actionCreators.showPrevious('pushleft'));
        }
      }
    };
  }

  function SwipeThroughScreens(_ref2) {
    var isEnabled = _ref2.isEnabled,
        onSwipeHorizontally = _ref2.onSwipeHorizontally,
        children = _ref2.children;

    if (!isEnabled) {
      return children;
    }

    return _react2.default.createElement(_TouchGesture2.default, {
      action: 'swipehorizontally',
      eventHandler: onSwipeHorizontally
    }, children);
  }

  SwipeThroughScreens.propTypes = {
    isEnabled: _propTypes2.default.bool.isRequired,
    onSwipeHorizontally: _propTypes2.default.func.isRequired,
    children: _propTypes2.default.node.isRequired
  };
  exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SwipeThroughScreens);
  /***/
},
/* 500 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "screenWrap": "Screen__screenWrap___E6WBR",
    "screenWrapPlacingAnnotation": "Screen__screenWrapPlacingAnnotation___2Hs0Q",
    "fade": "Screen__fade___3w5QI",
    "fade-current": "Screen__fade-current___CdBkT",
    "fadein": "Screen__fadein___1WWg5",
    "fade-reverse-previous": "Screen__fade-reverse-previous___37i9a",
    "fadeout": "Screen__fadeout___2t_A9",
    "fade-reverse-current": "Screen__fade-reverse-current___mxdxY",
    "pushleft": "Screen__pushleft___3Lr10",
    "pushright": "Screen__pushright___22U0B",
    "pushleft-previous": "Screen__pushleft-previous___11tO7",
    "pushouttoright": "Screen__pushouttoright___1oAte",
    "pushleft-current": "Screen__pushleft-current___3b3sI",
    "pushinfromleftbelow": "Screen__pushinfromleftbelow___2IKXK",
    "pushright-previous": "Screen__pushright-previous___1FnLB",
    "pushouttoleftbelow": "Screen__pushouttoleftbelow___1135B",
    "pushright-current": "Screen__pushright-current___1mxlk",
    "pushinfromright": "Screen__pushinfromright___2n3F-",
    "pushleft-reverse-previous": "Screen__pushleft-reverse-previous___2qRxv",
    "pushleft-reverse-current": "Screen__pushleft-reverse-current___3n8B6",
    "pushright-reverse-previous": "Screen__pushright-reverse-previous___upFxc",
    "pushright-reverse-current": "Screen__pushright-reverse-current___eX6Fk",
    "slide": "Screen__slide___25jCx",
    "slide-left": "Screen__slide-left___2Ea-5",
    "slide-previous": "Screen__slide-previous___2Gp6W",
    "slideouttoleft": "Screen__slideouttoleft___2gU9I",
    "slide-current": "Screen__slide-current___3RAY9",
    "slideinfromright": "Screen__slideinfromright___2M1t0",
    "slide-reverse-previous": "Screen__slide-reverse-previous___2V4F2",
    "slideouttoright": "Screen__slideouttoright___3lDHD",
    "slide-reverse-current": "Screen__slide-reverse-current___2-m02",
    "slideinfromleft": "Screen__slideinfromleft___3dNu7",
    "slide-left-previous": "Screen__slide-left-previous___287cW",
    "slide-left-current": "Screen__slide-left-current___1DTsG",
    "slide-left-reverse-previous": "Screen__slide-left-reverse-previous___3R-5Q",
    "slide-left-reverse-current": "Screen__slide-left-reverse-current___1kRSq",
    "slidedown": "Screen__slidedown___yo2tp",
    "slideup": "Screen__slideup___3iaet",
    "slidedown-previous": "Screen__slidedown-previous___2ugCu",
    "slidedown-reverse-current": "Screen__slidedown-reverse-current___fMOIp",
    "slideup-reverse-previous": "Screen__slideup-reverse-previous___3mWi4",
    "slideup-current": "Screen__slideup-current___2NYxn",
    "slideouttobottom": "Screen__slideouttobottom___3QILU",
    "slidedown-current": "Screen__slidedown-current___1hBpy",
    "slideinfrombottom": "Screen__slideinfrombottom___2z1lM",
    "slideup-reverse-current": "Screen__slideup-reverse-current___1Ygdf",
    "pop": "Screen__pop___3co5w",
    "pop-current": "Screen__pop-current___1xdSS",
    "pop-reverse-current": "Screen__pop-reverse-current___2sLCy",
    "popin": "Screen__popin___TPD9u",
    "pop-previous": "Screen__pop-previous___2bIMl",
    "pop-reverse-previous": "Screen__pop-reverse-previous___1MaDc",
    "popout": "Screen__popout___fI5K9",
    "flip": "Screen__flip___1Q61G",
    "flip-previous": "Screen__flip-previous___3Pa4h",
    "flipouttoleft": "Screen__flipouttoleft___jg3Z6",
    "flip-reverse-previous": "Screen__flip-reverse-previous___22MOB",
    "flipouttoright": "Screen__flipouttoright___2jHcC",
    "flip-current": "Screen__flip-current___10pE6",
    "flipintoright": "Screen__flipintoright___2sX-B",
    "flip-reverse-current": "Screen__flip-reverse-current___3SRPC",
    "flipintoleft": "Screen__flipintoleft___1Z8Ug",
    "flow": "Screen__flow___24z1z",
    "flow-current": "Screen__flow-current___omuks",
    "flow-reverse-current": "Screen__flow-reverse-current___cCu3F",
    "flow-previous": "Screen__flow-previous___2p9O0",
    "flowouttoleft": "Screen__flowouttoleft___22ADQ",
    "flowinfromright": "Screen__flowinfromright___bRPmG",
    "flow-reverse-previous": "Screen__flow-reverse-previous___LSB7y",
    "flowouttoright": "Screen__flowouttoright___2PKin",
    "flowinfromleft": "Screen__flowinfromleft___3nX-U",
    "slidefade": "Screen__slidefade___34HZc",
    "slidefade-previous": "Screen__slidefade-previous___2NP4M",
    "slidefade-reverse-previous": "Screen__slidefade-reverse-previous___130Ub",
    "slidefade-current": "Screen__slidefade-current___3wL6a",
    "slidefade-reverse-current": "Screen__slidefade-reverse-current___10Q69"
  };
  /***/
},
/* 501 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _Screen = __webpack_require__(158);

  var _Screen2 = babelHelpers.interopRequireDefault(_Screen);

  var _screen = __webpack_require__(9);

  var _actionCreators = __webpack_require__(4);

  var _controlScroll = __webpack_require__(102);

  var _controlScroll2 = babelHelpers.interopRequireDefault(_controlScroll);

  var _layout = __webpack_require__(15);

  function mapStateToProps(state) {
    var props = (0, _screen.getPreviousScreenProps)(state);
    var scrollTop = void 0;

    if (props.isVisible) {
      scrollTop = (0, _layout.getScreenStyles)(state).scrollTop;
    }

    return babelHelpers.extends({}, props, {
      scrollTop: scrollTop
    });
  }

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      onAnimationComplete: function onAnimationComplete() {
        dispatch((0, _actionCreators.screenTransitionCompleted)({
          isCurrent: false
        }));
      }
    };
  };

  exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _controlScroll2.default)(_Screen2.default));
  /***/
},
/* 502 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _StatusBarUnderlay = __webpack_require__(503);

  var _StatusBarUnderlay2 = babelHelpers.interopRequireDefault(_StatusBarUnderlay);

  var _statusBar = __webpack_require__(35);

  var mapStateToProps = function mapStateToProps(state) {
    return {
      backgroundColor: (0, _statusBar.getStatusBarUnderlayColor)(state),
      height: (0, _statusBar.getStatusBarUnderlayHeight)(state)
    };
  };

  exports.default = (0, _reactRedux.connect)(mapStateToProps)(_StatusBarUnderlay2.default);
  /***/
},
/* 503 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = StatusBarUnderlay;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function StatusBarUnderlay(_ref) {
    var backgroundColor = _ref.backgroundColor,
        height = _ref.height;
    return _react2.default.createElement('div', {
      style: {
        backgroundColor: backgroundColor,
        height: height
      }
    });
  }

  StatusBarUnderlay.propTypes = {
    backgroundColor: _propTypes2.default.string.isRequired,
    height: _propTypes2.default.number.isRequired
  };
  /***/
},
/* 504 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = EmptyProject;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _EmptyProject = __webpack_require__(505);

  var _EmptyProject2 = babelHelpers.interopRequireDefault(_EmptyProject);

  function EmptyProject() {
    return _react2.default.createElement('div', {
      className: _EmptyProject2.default.container
    }, _react2.default.createElement('span', {
      className: _EmptyProject2.default.text
    }, 'This prototype is empty. Add some images first!'));
  }
  /***/

},
/* 505 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "container": "EmptyProject__container___2KuFb",
    "text": "EmptyProject__text___8BSZe c-silver"
  };
  /***/
},
/* 506 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "player": "Player__player___1Cqud",
    "flip": "Player__flip___kW5sN",
    "handoffMode": "Player__handoffMode___2uqtq bg-snow--d"
  };
  /***/
},
/* 507 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _ExitAnnotationMode = __webpack_require__(508);

  var _ExitAnnotationMode2 = babelHelpers.interopRequireDefault(_ExitAnnotationMode);

  var _actionCreators = __webpack_require__(4);

  function mapDispatchToProps(dispatch) {
    return {
      onClick: function onClick() {
        dispatch((0, _actionCreators.leaveAnnotationMode)());
      }
    };
  }

  exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_ExitAnnotationMode2.default);
  /***/
},
/* 508 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ExitAnnotationMode;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _ExitAnnotationMode = __webpack_require__(509);

  var _ExitAnnotationMode2 = babelHelpers.interopRequireDefault(_ExitAnnotationMode);

  var _icons = __webpack_require__(14);

  function ExitAnnotationMode(_ref) {
    var onClick = _ref.onClick;
    return _react2.default.createElement('div', {
      className: _ExitAnnotationMode2.default.closeWrap
    }, _react2.default.createElement('div', {
      className: _ExitAnnotationMode2.default.close,
      onClick: onClick
    }, _react2.default.createElement('div', {
      className: _ExitAnnotationMode2.default.iconWrap
    }, _react2.default.createElement(_icons.CloseBigIcon, null))));
  }

  ExitAnnotationMode.propTypes = {
    onClick: _propTypes2.default.func
  };
  ExitAnnotationMode.defaultProps = {
    onClick: _noop2.default
  };
  /***/
},
/* 509 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "closeWrap": "ExitAnnotationMode__closeWrap___2rF3S position-fixed pinTR padding-m zi-strong",
    "close": "ExitAnnotationMode__close___2NiwG bg-marvel--hover bg-snow--xd borderRadius-circle cursor-pointer fill-silver fill-white--hover padding-m transitionDuration-m transitionProperty-all",
    "iconWrap": "ExitAnnotationMode__iconWrap___zKrzB position-absolute pinCenter"
  };
  /***/
},
/* 510 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = AnnotationHelp;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _AnnotationHint = __webpack_require__(511);

  var _AnnotationHint2 = babelHelpers.interopRequireDefault(_AnnotationHint);

  function AnnotationHelp() {
    return _react2.default.createElement('div', {
      className: _AnnotationHint2.default.modal
    }, _react2.default.createElement('div', {
      className: _AnnotationHint2.default.overlay
    }), _react2.default.createElement('div', {
      className: _AnnotationHint2.default.table
    }, _react2.default.createElement('div', {
      className: _AnnotationHint2.default.tableCell
    }, _react2.default.createElement('div', {
      className: _AnnotationHint2.default.hint
    }, 'Click anywhere on the image to add your annotation.'))));
  }
  /***/

},
/* 511 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "modal": "AnnotationHint__modal___1FnGY pointerEvents-none position-absolute pinAll zi-modal",
    "overlay": "AnnotationHint__overlay___1x1Qq bg-black opacity-50 pinAll position-absolute",
    "table": "AnnotationHint__table___rLSy7 display-table height-100 position-relative width-100",
    "tableCell": "AnnotationHint__tableCell___2jZYa display-tableCell verticalAlign-middle width-100",
    "hint": "AnnotationHint__hint___ZKvgC bg-black--transparent borderRadius-l c-white centered lineHeight-m padding-s textAlign-center"
  };
  /***/
},
/* 512 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _handoff = __webpack_require__(5);

  var _Zoom = __webpack_require__(513);

  var _Zoom2 = babelHelpers.interopRequireDefault(_Zoom);

  var _actionCreators = __webpack_require__(4);

  function mapStateToProps(state) {
    return {
      zoom: (0, _handoff.getZoomPercentage)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
      incrementZoom: _actionCreators.incrementZoom,
      decrementZoom: _actionCreators.decrementZoom
    }, dispatch);
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Zoom2.default);
  /***/
},
/* 513 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Zoom;

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _Minus = __webpack_require__(514);

  var _Minus2 = babelHelpers.interopRequireDefault(_Minus);

  var _Plus = __webpack_require__(515);

  var _Plus2 = babelHelpers.interopRequireDefault(_Plus);

  var _Zoom = __webpack_require__(516);

  var _Zoom2 = babelHelpers.interopRequireDefault(_Zoom);

  function Zoom(_ref) {
    var zoom = _ref.zoom,
        incrementZoom = _ref.incrementZoom,
        decrementZoom = _ref.decrementZoom;
    return _react2.default.createElement('div', {
      className: _Zoom2.default.position
    }, _react2.default.createElement('div', {
      onClick: decrementZoom,
      className: _Zoom2.default.button
    }, _react2.default.createElement(_Minus2.default, null)), _react2.default.createElement('div', {
      className: _Zoom2.default.valueLayout
    }, _react2.default.createElement('div', {
      className: _Zoom2.default.valueAppearance
    }, zoom, '%')), _react2.default.createElement('div', {
      onClick: incrementZoom,
      className: _Zoom2.default.button
    }, _react2.default.createElement(_Plus2.default, null)));
  }

  Zoom.propTypes = {
    zoom: _propTypes2.default.number.isRequired,
    incrementZoom: _propTypes2.default.func.isRequired,
    decrementZoom: _propTypes2.default.func.isRequired
  };
  Zoom.defaultProps = {
    incrementZoom: _noop2.default,
    decrementZoom: _noop2.default
  };
  /***/
},
/* 514 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Minus;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function Minus() {
    return _react2.default.createElement("svg", {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12"
    }, _react2.default.createElement("path", {
      d: "M6,0a6,6,0,1,0,6,6A6,6,0,0,0,6,0ZM8,7H4A1,1,0,0,1,4,5H8A1,1,0,0,1,8,7Z"
    }));
  }
  /***/

},
/* 515 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Plus;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  function Plus() {
    return _react2.default.createElement("svg", {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12"
    }, _react2.default.createElement("path", {
      d: "M6,0a6,6,0,1,0,6,6A6,6,0,0,0,6,0ZM8,7H7V8A1,1,0,0,1,5,8V7H4A1,1,0,0,1,4,5H5V4A1,1,0,0,1,7,4V5H8A1,1,0,0,1,8,7Z"
    }));
  }
  /***/

},
/* 516 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "position": "Zoom__position___1lkvS inline position-absolute pinTR marginTop-m marginRight-m userSelect-none",
    "button": "Zoom__button___22R3N link verticalAlign-middle fill-silver fill-slate--hover",
    "valueLayout": "Zoom__valueLayout___6phrM paddingLeftRight-xxs verticalAlign-middle",
    "valueAppearance": "Zoom__valueAppearance___1HDd6 level c-silver fontSize-m textAlign-center"
  };
  /***/
},
/* 517 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "project": "Project__project___3KZeN height-100 width-100",
    "annotationMode": "Project__annotationMode___28pBr",
    "handoffMode": "Project__handoffMode___HlsPC bg-snow"
  };
  /***/
},
/* 518 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = NotFound;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _badLuck = __webpack_require__(519);

  var _badLuck2 = babelHelpers.interopRequireDefault(_badLuck);

  var _icons = __webpack_require__(14);

  var _NotFound = __webpack_require__(520);

  var _NotFound2 = babelHelpers.interopRequireDefault(_NotFound);

  function NotFound() {
    return _react2.default.createElement('section', {
      className: _NotFound2.default.table
    }, _react2.default.createElement('div', {
      className: _NotFound2.default.tablecell
    }, _react2.default.createElement('div', {
      className: _NotFound2.default.pagewrap
    }, _react2.default.createElement('a', {
      href: '/',
      className: _NotFound2.default.logo
    }, _react2.default.createElement(_icons.MarvelLogo, null)), _react2.default.createElement('img', {
      alt: 'Oh no, bad luck!',
      className: _NotFound2.default.image,
      src: _badLuck2.default
    }), _react2.default.createElement('h1', {
      className: _NotFound2.default.heading
    }, 'Oh no, bad luck!'), _react2.default.createElement('h2', {
      className: _NotFound2.default.subheading
    }, "The project you\u2019re looking for could have been deleted or never have existed."))));
  }
  /***/

},
/* 519 */

/***/
function (module, exports) {
  module.exports = require("./assets/images/bad-luck.gif");
  /***/
},
/* 520 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "table": "NotFound__table___pazLP breakPointM-display-table breakPointM-height-100 height-auto",
    "tablecell": "NotFound__tablecell___31Kev breakPointM-display-tableCell breakPointM-verticalAlign-middle",
    "pagewrap": "NotFound__pagewrap___3ymA9 breakPointM-paddingTopBottom-xl paddingTopBottom-l pageWrap--s pageWrap textAlign-center",
    "logo": "NotFound__logo___137N9 display-inlineBlock fill-marvel marginBottom-l",
    "image": "NotFound__image___1D_WC centered marginBottom-l width-100",
    "heading": "NotFound__heading___16ahq c-slate fontSize-xxl fontWeight-5 lineHeight-xxl marginBottom-xs",
    "subheading": "NotFound__subheading___1cYTF c-silver fontSize-xl fontWeight-3 lineHeight-xl"
  };
  /***/
},
/* 521 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _Password = __webpack_require__(522);

  var _Password2 = babelHelpers.interopRequireDefault(_Password);

  var _actionCreators = __webpack_require__(4);

  function mapStateToProps(state) {
    return babelHelpers.extends({
      projectID: state.project.config.id
    }, state.password);
  }

  function mapDispatchToProps(dispatch) {
    return {
      onSubmit: function onSubmit(projectID, password) {
        return dispatch((0, _actionCreators.verifyPassword)(projectID, password));
      }
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Password2.default);
  /***/
},
/* 522 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _classnames = __webpack_require__(6);

  var _classnames2 = babelHelpers.interopRequireDefault(_classnames);

  var _Password = __webpack_require__(523);

  var _Password2 = babelHelpers.interopRequireDefault(_Password);

  var Password = function (_React$Component) {
    babelHelpers.inherits(Password, _React$Component);

    function Password(props) {
      babelHelpers.classCallCheck(this, Password);

      var _this = babelHelpers.possibleConstructorReturn(this, (Password.__proto__ || Object.getPrototypeOf(Password)).call(this, props));

      _this._updateValue = function (e) {
        var value = e.target.value;
        var isSubmittable = !!value;

        _this.setState({
          value: value,
          isSubmittable: isSubmittable
        });
      };

      _this._onSubmit = function (e) {
        e.preventDefault();

        _this.props.onSubmit(_this.props.projectID, _this.state.value);
      };

      _this.state = {
        value: _this.props.value || '',
        isSubmittable: false
      };
      return _this;
    }

    babelHelpers.createClass(Password, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            isValid = _props.isValid,
            isBeingVerified = _props.isBeingVerified;
        var _state = this.state,
            value = _state.value,
            isSubmittable = _state.isSubmittable;
        var inputClass = (0, _classnames2.default)(_Password2.default.input, {
          'has-error': isValid !== null && !isValid
        });
        var buttonClass = (0, _classnames2.default)(_Password2.default.submit, {
          'is-loading': isBeingVerified,
          'has-responded': isValid,
          'is-delayed': isValid,
          'has-succeeded': isValid
        });
        return _react2.default.createElement('div', {
          className: _Password2.default.table
        }, _react2.default.createElement('div', {
          className: _Password2.default.cell
        }, _react2.default.createElement('div', {
          className: _Password2.default.box
        }, _react2.default.createElement('form', null, _react2.default.createElement('h1', {
          className: _Password2.default.heading
        }, 'This prototype is password protected'), _react2.default.createElement('input', {
          className: inputClass,
          type: 'password',
          placeholder: 'Enter password',
          value: value,
          onChange: this._updateValue
        }), _react2.default.createElement('button', {
          className: buttonClass,
          type: 'submit',
          onClick: this._onSubmit,
          disabled: !isSubmittable
        }, _react2.default.createElement('span', null, 'Submit'))))));
      }
    }]);
    return Password;
  }(_react2.default.Component);

  exports.default = Password;
  Password.propTypes = {
    projectID: _propTypes2.default.string.isRequired,
    onSubmit: _propTypes2.default.func,
    value: _propTypes2.default.string.isRequired,
    isValid: _propTypes2.default.bool,
    isBeingVerified: _propTypes2.default.bool
  };
  Password.defaultProps = {
    onSubmit: _noop2.default
  };
  /***/
},
/* 523 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "table": "Password__table___155H- display-table position-absolute pinAll textAlign-center",
    "cell": "Password__cell___1wYCV display-tableCell verticalAlign-middle",
    "box": "Password__box___3Q3_E centered",
    "heading": "Password__heading___2qfkM c-slate marginBottom-l fontSize-l",
    "input": "Password__input___2dQEO input input--default input--l width-100 marginBottom-m",
    "submit": "Password__submit___3sbLB button button--l button--flat bg-positive button--stateful width-100"
  };
  /***/
},
/* 524 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = RotateDevice;

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _icons = __webpack_require__(14);

  var _RotateDevice = __webpack_require__(525);

  var _RotateDevice2 = babelHelpers.interopRequireDefault(_RotateDevice);

  function RotateDevice() {
    return _react2.default.createElement('div', {
      className: _RotateDevice2.default.table
    }, _react2.default.createElement('div', {
      className: _RotateDevice2.default.cell
    }, _react2.default.createElement('div', {
      className: _RotateDevice2.default.icon
    }, _react2.default.createElement(_icons.RotateIcon, null)), _react2.default.createElement('div', {
      className: _RotateDevice2.default.text
    }, 'Rotate your device')));
  }
  /***/

},
/* 525 */

/***/
function (module, exports) {
  // removed by extract-text-webpack-plugin
  module.exports = {
    "table": "RotateDevice__table___3Rk26 display-table height-100 textAlign-center width-100",
    "cell": "RotateDevice__cell___1sHXg display-tableCell verticalAlign-middle width-100",
    "icon": "RotateDevice__icon___3Dh6J marginBottom-m",
    "text": "RotateDevice__text___3-Ys7 fontSize-l fontWeight-3 lineHeight-l"
  };
  /***/
},
/* 526 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _DeviceOrientation = __webpack_require__(527);

  var _DeviceOrientation2 = babelHelpers.interopRequireDefault(_DeviceOrientation);

  var _actionCreators = __webpack_require__(4);

  var _deviceOrientation = __webpack_require__(99);

  function mapStateToProps(state) {
    return {
      shouldDetectDeviceOrientation: (0, _deviceOrientation.shouldDetectDeviceOrientation)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      orientationChanged: function orientationChanged(orientation) {
        dispatch((0, _actionCreators.orientationChanged)(orientation));
      }
    };
  }

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _onlyIf2.default)(function (props) {
    return props.shouldDetectDeviceOrientation;
  }))(_DeviceOrientation2.default);
  /***/
},
/* 527 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _orientation = __webpack_require__(44);

  var orientation = babelHelpers.interopRequireWildcard(_orientation);

  var DeviceOrientation = function (_Component) {
    babelHelpers.inherits(DeviceOrientation, _Component);

    function DeviceOrientation() {
      var _ref;

      var _temp, _this, _ret;

      babelHelpers.classCallCheck(this, DeviceOrientation);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = DeviceOrientation.__proto__ || Object.getPrototypeOf(DeviceOrientation)).call.apply(_ref, [this].concat(args))), _this), _this.onOrientationChange = function () {
        var orientationChanged = _this.props.orientationChanged;
        var currentOrientation = getScreenOrientation();
        orientationChanged(currentOrientation);
      }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
    }

    babelHelpers.createClass(DeviceOrientation, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('resize', this.onOrientationChange);
        window.addEventListener('orientationchange', this.onOrientationChange);
        this.onOrientationChange();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.onOrientationChange);
        window.removeEventListener('orientationchange', this.onOrientationChange);
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);
    return DeviceOrientation;
  }(_react.Component);

  DeviceOrientation.propTypes = {
    orientationChanged: _propTypes2.default.func.isRequired
  };
  DeviceOrientation.defaultProps = {
    orientationChanged: _noop2.default
  };
  exports.default = DeviceOrientation;

  function getScreenOrientation() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation
    // Not supported in Safari, and some older browsers, so won't cover all cases
    if (screen.orientation) {
      return /landscape/i.test(screen.orientation.type) ? orientation.LANDSCAPE : orientation.PORTRAIT; // Deprecated, but still supported by some browsers
      // https://developer.mozilla.org/en-US/docs/Web/API/Window/orientation
      // We need this for iOS 11, because the fallback below does not work in it
    } else if (window.orientation !== undefined) {
      return Math.abs(window.orientation) === 90 ? orientation.LANDSCAPE : orientation.PORTRAIT;
    } // If `screen.orientation` and `window.orientation` are not available,
    // fallback to checking window width and height


    return window.innerHeight > window.innerWidth ? orientation.PORTRAIT : orientation.LANDSCAPE;
  }
  /***/

},
/* 528 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reactRedux = __webpack_require__(2);

  var _onlyIf = __webpack_require__(8);

  var _onlyIf2 = babelHelpers.interopRequireDefault(_onlyIf);

  var _EmbedlySizer = __webpack_require__(529);

  var _EmbedlySizer2 = babelHelpers.interopRequireDefault(_EmbedlySizer);

  var _device = __webpack_require__(96);

  var device = babelHelpers.interopRequireWildcard(_device);

  var _actionCreators = __webpack_require__(4);

  var _embedly = __webpack_require__(163);

  function mapStateToProps(state) {
    var shouldRender = (0, _embedly.shouldSizeEmbedlyContainer)(state);

    if (!shouldRender) {
      return {};
    }

    var dimensions = void 0;

    try {
      // If the project hasn't loaded yet we don't know the device
      dimensions = device.getDimensions(state);
    } catch (e) {
      return {};
    }

    return {
      naturalDeviceWidth: dimensions.width,
      naturalDeviceHeight: dimensions.height
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      setContainerHeight: function setContainerHeight(height) {
        dispatch((0, _actionCreators.setContainerHeight)(height));
      }
    };
  }

  exports.default = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _onlyIf2.default)(function (props) {
    return props.naturalDeviceWidth;
  }))(_EmbedlySizer2.default);
  /***/
},
/* 529 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var EmbedlySizer = function (_Component) {
    babelHelpers.inherits(EmbedlySizer, _Component);

    function EmbedlySizer() {
      var _ref;

      var _temp, _this, _ret;

      babelHelpers.classCallCheck(this, EmbedlySizer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = EmbedlySizer.__proto__ || Object.getPrototypeOf(EmbedlySizer)).call.apply(_ref, [this].concat(args))), _this), _this.setContainerHeight = function () {
        var _this$props = _this.props,
            naturalDeviceWidth = _this$props.naturalDeviceWidth,
            naturalDeviceHeight = _this$props.naturalDeviceHeight;
        var containerWidth = window.innerWidth;

        if (containerWidth > naturalDeviceWidth) {
          _this.props.setContainerHeight(naturalDeviceHeight);
        } else {
          var scale = containerWidth / naturalDeviceWidth;
          var height = scale * naturalDeviceHeight;

          _this.props.setContainerHeight(height);
        }
      }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
    }

    babelHelpers.createClass(EmbedlySizer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('resize', this.setContainerHeight);
        this.setContainerHeight();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.setContainerHeight);
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);
    return EmbedlySizer;
  }(_react.Component);

  EmbedlySizer.propTypes = {
    naturalDeviceWidth: _propTypes2.default.number.isRequired,
    naturalDeviceHeight: _propTypes2.default.number.isRequired,
    setContainerHeight: _propTypes2.default.func.isRequired
  };
  EmbedlySizer.defaultProps = {
    setContainerHeight: _noop2.default
  };
  exports.default = EmbedlySizer;
  /***/
},
/* 530 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var _reactDnd = __webpack_require__(52);

  var _Annotation = __webpack_require__(166);

  var _Annotation2 = babelHelpers.interopRequireDefault(_Annotation);

  var layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 10000,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  };
  /* eslint-disable react/no-unused-prop-types */

  function getItemStyles(props) {
    var currentOffset = props.currentOffset,
        initialPointerOffset = props.initialPointerOffset,
        item = props.item;
    var dragOffset = {
      x: initialPointerOffset.x - item.initialPosition.left,
      y: initialPointerOffset.y - item.initialPosition.top
    };
    var x = currentOffset.x,
        y = currentOffset.y;
    x += dragOffset.x;
    y += dragOffset.y;
    var transform = 'translate(' + x + 'px, ' + y + 'px)';
    return {
      transform: transform,
      WebkitTransform: transform
    };
  }

  var CustomDragLayer = function (_Component) {
    babelHelpers.inherits(CustomDragLayer, _Component);

    function CustomDragLayer() {
      babelHelpers.classCallCheck(this, CustomDragLayer);
      return babelHelpers.possibleConstructorReturn(this, (CustomDragLayer.__proto__ || Object.getPrototypeOf(CustomDragLayer)).apply(this, arguments));
    }

    babelHelpers.createClass(CustomDragLayer, [{
      key: 'renderItem',
      value: function renderItem(item) {
        return _react2.default.createElement(_Annotation2.default, item);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            item = _props.item,
            itemType = _props.itemType,
            isDragging = _props.isDragging;

        if (!isDragging || itemType !== 'annotation') {
          return null;
        }

        return _react2.default.createElement('div', {
          style: layerStyles
        }, _react2.default.createElement('div', {
          style: getItemStyles(this.props)
        }, this.renderItem(item)));
      }
    }]);
    return CustomDragLayer;
  }(_react.Component);

  CustomDragLayer.propTypes = {
    item: _propTypes2.default.object,
    itemType: _propTypes2.default.string,
    initialPointerOffset: _propTypes2.default.shape({
      x: _propTypes2.default.number.isRequired,
      y: _propTypes2.default.number.isRequired
    }),
    currentOffset: _propTypes2.default.shape({
      x: _propTypes2.default.number.isRequired,
      y: _propTypes2.default.number.isRequired
    }),
    isDragging: _propTypes2.default.bool.isRequired
  };

  function collect(monitor) {
    var defaultOffset = {
      x: 0,
      y: 0
    };
    return {
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialPointerOffset: monitor.getInitialClientOffset() || defaultOffset,
      currentOffset: monitor.getSourceClientOffset() || defaultOffset,
      isDragging: monitor.isDragging()
    };
  }

  exports.default = (0, _reactDnd.DragLayer)(collect)(CustomDragLayer);
  /***/
},
/* 531 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactRedux = __webpack_require__(2);

  var _ImageReloader = __webpack_require__(532);

  var _ImageReloader2 = babelHelpers.interopRequireDefault(_ImageReloader);

  var _actionCreators = __webpack_require__(4);

  var _screen = __webpack_require__(9);

  function mapStateToProps(state) {
    return {
      currentScreenID: (0, _screen.getCurrentScreen)(state).id
    };
  }

  function mergeProps(stateProps, _ref) {
    var dispatch = _ref.dispatch;
    return {
      reloadImages: function reloadImages() {
        dispatch((0, _actionCreators.reloadImages)(stateProps.currentScreenID));
      }
    };
  }

  exports.default = (0, _reactRedux.connect)(mapStateToProps, null, mergeProps)(_ImageReloader2.default);
  /***/
},
/* 532 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes = __webpack_require__(1);

  var _propTypes2 = babelHelpers.interopRequireDefault(_propTypes);

  var _react = __webpack_require__(0);

  var _react2 = babelHelpers.interopRequireDefault(_react);

  var ImageReloader = function (_React$Component) {
    babelHelpers.inherits(ImageReloader, _React$Component);

    function ImageReloader() {
      var _ref;

      var _temp, _this, _ret;

      babelHelpers.classCallCheck(this, ImageReloader);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = babelHelpers.possibleConstructorReturn(this, (_ref = ImageReloader.__proto__ || Object.getPrototypeOf(ImageReloader)).call.apply(_ref, [this].concat(args))), _this), _this.handleVisibilityChange = function () {
        if (!document.hidden) {
          _this.props.reloadImages();
        }
      }, _temp), babelHelpers.possibleConstructorReturn(_this, _ret);
    }

    babelHelpers.createClass(ImageReloader, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange, false);
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);
    return ImageReloader;
  }(_react2.default.Component);

  ImageReloader.propTypes = {
    reloadImages: _propTypes2.default.func.isRequired
  };
  exports.default = ImageReloader;
  /***/
},
/* 533 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = bindKeyboardShortcuts;

  var _mousetrap = __webpack_require__(534);

  var _forEach = __webpack_require__(54);

  var _forEach2 = babelHelpers.interopRequireDefault(_forEach);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _annotation = __webpack_require__(20);

  function bindKeyboardShortcuts(store, keyboardControlsCheckerFunc) {
    var boundActionCreators = {};
    (0, _forEach2.default)(actionCreators, function (method, name) {
      boundActionCreators[name] = function () {
        if (areEnabled(keyboardControlsCheckerFunc) && !(0, _annotation.isInAnnotationMode)(store.getState())) {
          store.dispatch(method());
        }
      };
    });
    (0, _mousetrap.bind)('h', boundActionCreators.showHome);
    (0, _mousetrap.bind)('left', boundActionCreators.showPrevious);
    (0, _mousetrap.bind)('right', boundActionCreators.showNext);
    (0, _mousetrap.bind)('g', boundActionCreators.showGrid);
    (0, _mousetrap.bind)('esc', boundActionCreators.hideGrid);
    (0, _mousetrap.bind)('s', boundActionCreators.showHotspots, 'keydown');
    (0, _mousetrap.bind)('s', boundActionCreators.hideHotspots, 'keyup');
    (0, _mousetrap.bind)('-', boundActionCreators.decrementZoom);
    (0, _mousetrap.bind)('=', boundActionCreators.incrementZoom); // Not all keyboard layouts have +,= together?

    (0, _mousetrap.bind)('+', boundActionCreators.incrementZoom);
    return _mousetrap.reset;
  }

  function areEnabled(keyboardControlsCheckerFunc) {
    if (!keyboardControlsCheckerFunc) {
      return true;
    }

    return keyboardControlsCheckerFunc();
  }
  /***/

},
/* 534 */

/***/
function (module, exports) {
  module.exports = require("mousetrap");
  /***/
},
/* 535 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = addPublicAPIs;

  var _assign = __webpack_require__(21);

  var _assign2 = babelHelpers.interopRequireDefault(_assign);

  var _redux = __webpack_require__(7);

  var _actionCreators = __webpack_require__(4);

  var _annotation = __webpack_require__(20);

  var _screen = __webpack_require__(9); // This is more verbose than something like lodash.pick,
  // but eslint-plugin-import will prevent issues with
  // misspelled / non-existent import names


  var publicActionCreators = {
    setProject: _actionCreators.setProject,
    setPartialProject: _actionCreators.setPartialProject,
    loadProject: _actionCreators.loadProject,
    setCommentCount: _actionCreators.setCommentCount,
    showCommentNotification: _actionCreators.showCommentNotification,
    hideCommentNotification: _actionCreators.hideCommentNotification,
    enterAnnotationMode: _actionCreators.enterAnnotationMode,
    leaveAnnotationMode: _actionCreators.leaveAnnotationMode,
    cancelCurrentAnnotation: _actionCreators.cancelCurrentAnnotation,
    addAnnotation: _actionCreators.addAnnotation,
    scrollToAnnotation: _actionCreators.scrollToAnnotation,
    clearAnnotations: _actionCreators.clearAnnotations,
    hideComments: _actionCreators.hideComments,
    highlightAnnotation: _actionCreators.highlightAnnotation,
    unhighlightAnnotation: _actionCreators.unhighlightAnnotation,
    makeAnnotationMoveable: _actionCreators.makeAnnotationMoveable,
    markAnnotationSaved: _actionCreators.markAnnotationSaved,
    annotationCommentUpdated: _actionCreators.annotationCommentUpdated,
    updateAnnotation: _actionCreators.updateAnnotation,
    removeAnnotation: _actionCreators.removeAnnotation,
    closeGridNavigation: _actionCreators.hideGrid,
    showHome: _actionCreators.showHome
  };

  function addPublicAPIs(instance, store) {
    (0, _assign2.default)(instance, (0, _redux.bindActionCreators)(publicActionCreators, store.dispatch), {
      setCommentMention: function setCommentMention() {// TODO Move to action creators
      },
      isInAnnotationMode: function isInAnnotationMode() {
        return (0, _annotation.isInAnnotationMode)(store.getState());
      },
      getCurrentScreen: function getCurrentScreen() {
        return (0, _screen.getCurrentScreen)(store.getState());
      }
    });
  }
  /***/

},
/* 536 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = configureStore;

  var _redux = __webpack_require__(7);

  var _reduxThunk = __webpack_require__(537);

  var _reduxThunk2 = babelHelpers.interopRequireDefault(_reduxThunk);

  var _reduxSaga = __webpack_require__(34);

  var _reduxSaga2 = babelHelpers.interopRequireDefault(_reduxSaga);

  var _reducers = __webpack_require__(538);

  var _reducers2 = babelHelpers.interopRequireDefault(_reducers);

  var _sagas = __webpack_require__(564);

  var _sagas2 = babelHelpers.interopRequireDefault(_sagas);

  var _createStoreListener = __webpack_require__(600);

  var _createStoreListener2 = babelHelpers.interopRequireDefault(_createStoreListener);

  var _listen = __webpack_require__(601);

  var _listen2 = babelHelpers.interopRequireDefault(_listen);

  function configureStore(initialState) {
    var listeners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isDownloaded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isAppBuild = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var sagaMiddleware = (0, _reduxSaga2.default)(); // const logger = store => next => action => {
    //   console.log('current state', store.getState());
    //   console.log('dispatching', action);
    //   let result = next(action);
    //   console.log('next state', store.getState());
    //   return result;
    // };

    var enhancers = (0, _redux.applyMiddleware)(_reduxThunk2.default, sagaMiddleware, // logger,
    (0, _listen2.default)((0, _createStoreListener2.default)(listeners)));

    if (false) {
      if (window.__REDUX_DEVTOOLS_EXTENSION__) {
        var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
        enhancers = composeEnhancers(enhancers);
      } else {
        var DevTools = require('../containers/DevTools').default;

        enhancers = (0, _redux.compose)(enhancers, DevTools.instrument());
      }
    }

    var store = (0, _redux.createStore)(_reducers2.default, initialState, enhancers); // Run the saga

    sagaMiddleware.run(_sagas2.default, store.dispatch, isAppBuild, isDownloaded).done.catch(function (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }); // Enable Webpack hot module replacement for reducers

    if (false) {
      module.hot.accept('../reducers', function () {
        var nextReducer = require('../reducers').default;

        store.replaceReducer(nextReducer);
      });
    }

    return store;
  }
  /***/

},
/* 537 */

/***/
function (module, exports) {
  module.exports = require("redux-thunk");
  /***/
},
/* 538 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _redux = __webpack_require__(7);

  var _reduceReducers = __webpack_require__(539);

  var _reduceReducers2 = babelHelpers.interopRequireDefault(_reduceReducers);

  var _modalRedux = __webpack_require__(540);

  var _annotation = __webpack_require__(541);

  var _annotation2 = babelHelpers.interopRequireDefault(_annotation);

  var _homeScreen = __webpack_require__(542);

  var _homeScreen2 = babelHelpers.interopRequireDefault(_homeScreen);

  var _clipboard = __webpack_require__(543);

  var _clipboard2 = babelHelpers.interopRequireDefault(_clipboard);

  var _code = __webpack_require__(544);

  var _code2 = babelHelpers.interopRequireDefault(_code);

  var _comment = __webpack_require__(545);

  var _comment2 = babelHelpers.interopRequireDefault(_comment);

  var _device = __webpack_require__(546);

  var _device2 = babelHelpers.interopRequireDefault(_device);

  var _deviceDetection = __webpack_require__(547);

  var _deviceDetection2 = babelHelpers.interopRequireDefault(_deviceDetection);

  var _devTools = __webpack_require__(548);

  var _devTools2 = babelHelpers.interopRequireDefault(_devTools);

  var _assetDownload = __webpack_require__(549);

  var _assetDownload2 = babelHelpers.interopRequireDefault(_assetDownload);

  var _grid = __webpack_require__(550);

  var _grid2 = babelHelpers.interopRequireDefault(_grid);

  var _handoff = __webpack_require__(551);

  var _handoff2 = babelHelpers.interopRequireDefault(_handoff);

  var _hotspot = __webpack_require__(554);

  var _hotspot2 = babelHelpers.interopRequireDefault(_hotspot);

  var _hover = __webpack_require__(555);

  var _hover2 = babelHelpers.interopRequireDefault(_hover);

  var _imagePreloading = __webpack_require__(556);

  var _imagePreloading2 = babelHelpers.interopRequireDefault(_imagePreloading);

  var _layoutOverlay = __webpack_require__(557);

  var _layoutOverlay2 = babelHelpers.interopRequireDefault(_layoutOverlay);

  var _overlay = __webpack_require__(558);

  var _overlay2 = babelHelpers.interopRequireDefault(_overlay);

  var _password = __webpack_require__(559);

  var _password2 = babelHelpers.interopRequireDefault(_password);

  var _player = __webpack_require__(560);

  var _player2 = babelHelpers.interopRequireDefault(_player);

  var _project = __webpack_require__(561);

  var _project2 = babelHelpers.interopRequireDefault(_project);

  var _screen = __webpack_require__(562);

  var _screen2 = babelHelpers.interopRequireDefault(_screen);

  var _user = __webpack_require__(563);

  var _user2 = babelHelpers.interopRequireDefault(_user);

  var reducers = (0, _redux.combineReducers)({
    // Not sure how to define an initial state when using reduceReducers o.O
    addToHomeScreenVisible: _homeScreen2.default,
    annotation: function annotation() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _annotation.initialState;
      return state;
    },
    clipboard: _clipboard2.default,
    code: _code2.default,
    comment: _comment2.default,
    device: _device2.default,
    deviceDetection: _deviceDetection2.default,
    downloadAssets: _assetDownload2.default,
    grid: _grid2.default,
    handoff: _handoff2.default,
    hotspots: _hotspot2.default,
    hoverStack: _hover2.default,
    imagePreloading: _imagePreloading2.default,
    layoutOverlay: _layoutOverlay2.default,
    modals: _modalRedux.modalReducer,
    overlay: _overlay2.default,
    password: _password2.default,
    player: _player2.default,
    project: _project2.default,
    screen: _screen2.default,
    user: _user2.default
  });
  exports.default = (0, _reduceReducers2.default)(reducers, _annotation2.default, _devTools2.default);
  /***/
},
/* 539 */

/***/
function (module, exports) {
  module.exports = require("reduce-reducers");
  /***/
},
/* 540 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/marvel-ui/modal-redux");
  /***/
},
/* 541 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.initialState = undefined;
  exports.default = annotationReducer;

  var _pickBy = __webpack_require__(171);

  var _pickBy2 = babelHelpers.interopRequireDefault(_pickBy);

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _hotspot = __webpack_require__(87);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _screenLocation = __webpack_require__(19);

  var screenLocation = babelHelpers.interopRequireWildcard(_screenLocation);

  var _layout = __webpack_require__(15);

  var initialState = exports.initialState = {
    annotations: {},
    nextAnnotation: null,
    highlightAnnotation: null,
    pulseAnnotation: null,
    isAnnotationMoveable: {}
  }; // The input of this reducer is the entire application state.
  // we use reduceReducers because annotations need to know about the rendered
  // screen size, header, footer, etc.

  function annotationReducer(globalState, action) {
    switch (action.type) {
      case actionTypes.ENTER_ANNOTATION_MODE:
        {
          var commentUUID = action.nextCommentUUID,
              reference = action.nextReference;
          var nextAnnotation = {
            commentUUID: commentUUID,
            reference: reference
          };
          return updateAnnotation(globalState, {
            nextAnnotation: {
              $set: nextAnnotation
            }
          });
        }

      case actionTypes.LEAVE_ANNOTATION_MODE:
        {
          return updateAnnotation(globalState, {
            nextAnnotation: {
              $set: null
            },
            highlightAnnotation: {
              $set: null
            }
          });
        }

      case actionTypes.HIDE_COMMENTS:
      case actionTypes.CANCEL_ANNOTATION:
        {
          return removeUnsavedAnnotation(globalState);
        }

      case actionTypes.ADD_NEW_ANNOTATION:
        {
          var _globalState$annotati = globalState.annotation.nextAnnotation,
              _commentUUID = _globalState$annotati.commentUUID,
              _reference = _globalState$annotati.reference;
          var screenArea = action.screenArea,
              offset = action.offset;
          var renderingScale = (0, _layout.getCurrentScale)(globalState);
          var newPosition = updateAnnotationAnnotationPosition({
            scale: renderingScale,
            position: getAnnotationInitialPosition(screenArea, globalState.screen.currentScreen),
            offset: offset
          });
          var annotation = babelHelpers.extends({}, newPosition, {
            screenArea: screenArea,
            ownerScreenID: globalState.screen.currentScreen.id,
            commentUUID: _commentUUID,
            reference: _reference
          });
          return updateAnnotation(globalState, {
            annotations: {
              $merge: babelHelpers.defineProperty({}, _commentUUID, annotation)
            },
            nextAnnotation: {
              $set: null
            }
          });
        }

      case actionTypes.POSITION_ANNOTATION:
        {
          var _commentUUID2 = action.commentUUID,
              toScreenArea = action.toScreenArea,
              _offset = action.offset;

          var _renderingScale = (0, _layout.getCurrentScale)(globalState);

          var _newPosition = updateAnnotationAnnotationPosition({
            scale: _renderingScale,
            position: getAnnotationInitialPosition(toScreenArea, globalState.screen.currentScreen),
            offset: _offset
          });

          var _annotation = babelHelpers.extends({}, _newPosition, {
            screenArea: toScreenArea
          });

          return updateAnnotation(globalState, {
            annotations: babelHelpers.defineProperty({}, _commentUUID2, {
              $merge: _annotation
            })
          });
        }

      case actionTypes.ADD_ANNOTATION:
        {
          var _screenArea = void 0;

          if (globalState.screen.currentOverlayHotspot.id) {
            _screenArea = screenLocation.OVERLAY;
          } else {
            _screenArea = getAnnotationScreenArea(action.annotation, globalState.screen.currentScreen);
          }

          var _annotation2 = babelHelpers.extends({}, action.annotation, {
            screenArea: _screenArea
          });

          var _commentUUID3 = _annotation2.commentUUID;

          if (globalState.annotation.annotations[_commentUUID3]) {
            return updateAnnotation(globalState, {
              annotations: babelHelpers.defineProperty({}, _commentUUID3, {
                $set: _annotation2
              })
            });
          }

          return updateAnnotation(globalState, {
            annotations: {
              $merge: babelHelpers.defineProperty({}, _commentUUID3, babelHelpers.extends({}, _annotation2, {
                isSaved: true
              }))
            }
          });
        }

      case actionTypes.MARK_ANNOTATION_SAVED:
        {
          var _commentUUID4 = action.commentUUID;
          return updateAnnotation(globalState, {
            annotations: babelHelpers.defineProperty({}, _commentUUID4, {
              isSaved: {
                $set: true
              }
            })
          });
        }

      case actionTypes.ANNOTATION_COMMENT_UPDATED:
        {
          var _commentUUID5 = action.commentUUID,
              isDone = action.isDone;
          return updateAnnotation(globalState, {
            annotations: babelHelpers.defineProperty({}, _commentUUID5, {
              isDone: {
                $set: isDone
              }
            })
          });
        }

      case actionTypes.UPDATE_ANNOTATION:
        {
          var _commentUUID6 = action.commentUUID,
              _annotation3 = action.annotation;
          return updateAnnotation(globalState, {
            annotations: babelHelpers.defineProperty({}, _commentUUID6, {
              $merge: _annotation3
            })
          });
        }

      case actionTypes.REMOVE_ANNOTATION:
        {
          var _commentUUID7 = action.commentUUID;
          /* eslint-disable eqeqeq */

          var annotationsAfterRemoval = (0, _pickBy2.default)(globalState.annotation.annotations, function (_, key) {
            return key != _commentUUID7;
          });
          /* eslint-enable eqeqeq */

          return updateAnnotation(globalState, {
            annotations: {
              $set: annotationsAfterRemoval
            },
            highlightAnnotation: {
              $set: null
            }
          });
        }

      case actionTypes.SCROLL_TO_ANNOTATION:
        {
          var _commentUUID8 = action.commentUUID;
          var _annotation4 = globalState.annotation.annotations[_commentUUID8];

          if (!_annotation4) {
            return globalState;
          }

          var scrollTo = _annotation4.y;
          return (0, _immutabilityHelper2.default)(globalState, {
            screen: {
              scrollTo: {
                $set: scrollTo
              },
              scrollingToAnnotation: {
                $set: _commentUUID8
              }
            }
          });
        }

      case actionTypes.HIGHLIGHT_ANNOTATION:
        {
          var _commentUUID9 = action.commentUUID;
          return updateAnnotation(globalState, {
            highlightAnnotation: {
              $set: _commentUUID9
            }
          });
        }

      case actionTypes.UNHIGHLIGHT_ANNOTATION:
        {
          return updateAnnotation(globalState, {
            highlightAnnotation: {
              $set: null
            }
          });
        }

      case actionTypes.PULSE_ANNOTATION:
        {
          return (0, _immutabilityHelper2.default)(globalState, {
            screen: {
              scrollingToAnnotation: {
                $set: null
              }
            }
          });
        }

      case actionTypes.MAKE_ANNOTATION_MOVEABLE:
        {
          var _commentUUID10 = action.commentUUID;
          return updateAnnotation(globalState, {
            isAnnotationMoveable: {
              $merge: babelHelpers.defineProperty({}, _commentUUID10, true)
            }
          });
        }

      case actionTypes.CLEAR_ANNOTATIONS:
        {
          return updateAnnotation(globalState, {
            annotations: {
              $set: {}
            },
            highlightAnnotation: {
              $set: null
            },
            isAnnotationMoveable: {
              $set: {}
            }
          });
        }

      default:
        return globalState;
    }
  }

  function updateAnnotation(globalState, specFragment) {
    return (0, _immutabilityHelper2.default)(globalState, {
      annotation: specFragment
    });
  }

  function removeUnsavedAnnotation(globalState) {
    var saveAnnotations = (0, _pickBy2.default)(globalState.annotation.annotations, function (annotation) {
      return annotation.isSaved;
    });
    return updateAnnotation(globalState, {
      annotations: {
        $set: saveAnnotations
      }
    });
  }

  function getAnnotationInitialPosition(type, screen) {
    switch (type) {
      case screenLocation.HEADER:
        return getHeaderAnnotationInitialPosition();

      case screenLocation.BODY:
        return getBodyAnnotationInitialPosition(screen);

      case screenLocation.FOOTER:
        return getFooterAnnotationInitialPosition(screen);

      case screenLocation.OVERLAY:
        return getOverlayAnnotationInitialPosition();

      default:
        throw new Error('\'' + type + '\' is not a valid annotation type');
    }
  }

  function getAnnotationScreenArea(_ref, screen) {
    var y = _ref.y;

    if ((0, _hotspot.overlapsHeader)(screen.header, {
      y: y
    })) {
      return screenLocation.HEADER;
    }

    if ((0, _hotspot.overlapsFooter)(screen.footer, {
      y: y
    })) {
      return screenLocation.FOOTER;
    }

    return screenLocation.BODY; // TODO: handle screenLocation.OVERLAY?
  }

  function updateAnnotationAnnotationPosition(_ref2) {
    var scale = _ref2.scale,
        position = _ref2.position,
        offset = _ref2.offset; // TODO remove this hack to get actual scale value

    var actualScale = scale(100000) / 100000; //////////////////////////////////////////////////

    var xOffset = offset.x / actualScale;
    var yOffset = offset.y / actualScale;
    return {
      x: position.x + xOffset,
      y: position.y + yOffset
    };
  }

  function getHeaderAnnotationInitialPosition() {
    return {
      x: 0,
      y: 0
    };
  }

  function getBodyAnnotationInitialPosition(screen) {
    return {
      x: 0,
      y: screen.header ? screen.header.height : 0
    };
  }

  function getFooterAnnotationInitialPosition(screen) {
    return {
      x: 0,
      y: screen.img.height - screen.footer.height
    };
  }

  function getOverlayAnnotationInitialPosition() {
    return {
      x: 0,
      y: 0
    };
  }
  /***/

},
/* 542 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = homeScreenReducer;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function homeScreenReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
      case actionTypes.SHOW_ADD_TO_HOME_SCREEN:
        return true;

      case actionTypes.SET_ADD_TO_HOME_SCREEN_COOKIE:
      case actionTypes.HIDE_ADD_TO_HOME_SCREEN:
        return false;

      case actionTypes.RECEIVE_ADD_TO_HOME_SCREEN_COOKIE:
        return !action.value;

      default:
        return state;
    }
  }
  /***/

},
/* 543 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = clipboard;

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function clipboard() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (action.type === actionTypes.SHOW_COPYING) {
      var target = action.target;
      return (0, _immutabilityHelper2.default)(state, {
        $merge: babelHelpers.defineProperty({}, target, true)
      });
    }

    if (action.type === actionTypes.SHOW_COPYING_DONE) {
      var _target = action.target;
      return (0, _immutabilityHelper2.default)(state, {
        $merge: babelHelpers.defineProperty({}, _target, false)
      });
    }

    return state;
  }
  /***/

},
/* 544 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.initialState = undefined;
  exports.default = codeReducer;

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _requestStatus = __webpack_require__(31);

  var requestStatus = babelHelpers.interopRequireWildcard(_requestStatus);
  var initialState = exports.initialState = {
    code: {},
    requestStatus: {},
    currentLang: null
  };

  function codeReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case actionTypes.SHOW_SCREEN:
        return babelHelpers.extends({}, initialState, {
          currentLang: state.currentLang
        });

      case actionTypes.LOAD_CODE_START:
        return (0, _immutabilityHelper2.default)(state, {
          requestStatus: {
            $merge: babelHelpers.defineProperty({}, action.lang, requestStatus.PENDING)
          }
        });

      case actionTypes.LOAD_CODE_DONE:
        return (0, _immutabilityHelper2.default)(state, {
          code: {
            $merge: babelHelpers.defineProperty({}, action.lang, action.code)
          },
          requestStatus: {
            $merge: babelHelpers.defineProperty({}, action.lang, requestStatus.SUCCESS)
          }
        });

      case actionTypes.LOAD_CODE_FAILED:
        return (0, _immutabilityHelper2.default)(state, {
          code: {
            $merge: babelHelpers.defineProperty({}, action.lang, action.err)
          },
          requestStatus: {
            $merge: babelHelpers.defineProperty({}, action.lang, requestStatus.ERROR)
          }
        });

      case actionTypes.SET_DEFAULT_PROJECT_LANG:
      case actionTypes.SET_CURRENT_LANG:
        return (0, _immutabilityHelper2.default)(state, {
          currentLang: {
            $set: action.lang
          }
        });

      default:
        return state;
    }
  }
  /***/

},
/* 545 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case actionTypes.SET_COMMENT_COUNT:
        return (0, _immutabilityHelper2.default)(state, {
          count: {
            $set: action.count
          }
        });

      case actionTypes.SHOW_COMMENTS:
        return (0, _immutabilityHelper2.default)(state, {
          areVisible: {
            $set: true
          }
        });

      case actionTypes.HIDE_COMMENTS:
        return (0, _immutabilityHelper2.default)(state, {
          areVisible: {
            $set: false
          },
          highlightedComment: {
            $set: null
          }
        });

      case actionTypes.HIGHLIGHT_COMMENT:
        return (0, _immutabilityHelper2.default)(state, {
          highlightedComment: {
            $set: action.id
          }
        });

      case actionTypes.UNHIGHLIGHT_COMMENT:
        return (0, _immutabilityHelper2.default)(state, {
          highlightedComment: {
            $set: null
          }
        });

      case actionTypes.RECEIVE_LEAVE_COMMENT_POPOVER_COOKIE:
        return (0, _immutabilityHelper2.default)(state, {
          leaveCommentPopoverVisible: {
            $set: !action.value
          }
        });

      case actionTypes.SHOW_COMMENT_NOTIFICATION:
        return (0, _immutabilityHelper2.default)(state, {
          notification: {
            $set: action.notification
          },
          leaveCommentPopoverVisible: {
            $set: false
          }
        });

      case actionTypes.HIDE_COMMENT_NOTIFICATION:
        return (0, _immutabilityHelper2.default)(state, {
          notification: {
            $set: null
          }
        });

      case actionTypes.LOCATION_CHANGED:
        {
          var highlightedComment = action.highlightedComment;

          if (highlightedComment) {
            return (0, _immutabilityHelper2.default)(state, {
              areVisible: {
                $set: true
              },
              highlightedComment: {
                $set: action.id
              }
            });
          }

          return (0, _immutabilityHelper2.default)(state, {
            highlightedComment: {
              $set: null
            }
          });
        }

      default:
        return state;
    }
  };

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);
  var initialState = {
    // TODO need to get this from init param as can default to open
    areVisible: false,
    count: 0,
    highlightedComment: null,
    leaveCommentPopoverVisible: false,
    notification: null
  };
  /***/
},
/* 546 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = deviceReducer;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);
  var initialState = {
    orientation: null
  };

  function deviceReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case actionTypes.ORIENTATION_CHANGED:
        return {
          orientation: action.orientation
        };

      default:
        return state;
    }
  }
  /***/

},
/* 547 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = deviceDetectionReducer;

  var _deviceDetection = __webpack_require__(86);

  var deviceDetection = babelHelpers.interopRequireWildcard(_deviceDetection);

  function deviceDetectionReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : deviceDetection;
    return state;
  }
  /***/

},
/* 548 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = devToolsReducer;

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _orientation = __webpack_require__(44);

  function devToolsReducer(state, action) {
    switch (action.type) {
      case actionTypes.CHANGE_PROJECT_DEVICE_FRAME:
        {
          var name = action.frame;
          return (0, _immutabilityHelper2.default)(state, {
            project: {
              config: {
                device: {
                  frame: {
                    $set: name
                  },
                  orientation: {
                    $set: _orientation.PORTRAIT
                  }
                }
              }
            }
          });
        }

      case actionTypes.CHANGE_PROJECT_DEVICE_ORIENTATION:
        return (0, _immutabilityHelper2.default)(state, {
          project: {
            config: {
              device: {
                orientation: {
                  $set: action.orientation
                }
              }
            }
          }
        });

      case actionTypes.CHANGE_DEVICE_ORIENTATION:
        return (0, _immutabilityHelper2.default)(state, {
          device: {
            orientation: {
              $set: action.orientation
            }
          }
        });

      case actionTypes.CHANGE_DEVICE_DETECTION:
        return (0, _immutabilityHelper2.default)(state, {
          deviceDetection: {
            $merge: action.deviceDetection
          }
        });

      case actionTypes.SET_PROJECT_PLAN:
        return (0, _immutabilityHelper2.default)(state, {
          project: {
            config: {
              plan: {
                $set: action.plan
              }
            }
          }
        });

      default:
        return state;
    }
  }
  /***/

},
/* 549 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = assetDownload;

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _requestStatus = __webpack_require__(31);

  var status = babelHelpers.interopRequireWildcard(_requestStatus);
  var initialState = {};

  function assetDownload() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case actionTypes.DOWNLOAD_ASSETS_START:
        return updateRequestStatus(state, action, status.PENDING);

      case actionTypes.ASSETS_ZIP_CREATED:
        return updateRequestStatus(state, action, status.SUCCESS);

      case actionTypes.ASSETS_ZIP_DOWNLOADED:
        return updateRequestStatus(state, action, status.IDLE);

      default:
        return state;
    }
  }

  function updateRequestStatus(state, _ref, requestStatus) {
    var screenID = _ref.screenID,
        elementID = _ref.elementID,
        assetType = _ref.assetType,
        requestID = _ref.requestID;
    var currentStatus = state[requestID];
    var change = void 0;

    if (currentStatus) {
      change = babelHelpers.defineProperty({}, requestID, {
        status: {
          $set: requestStatus
        }
      });
    } else {
      change = {
        $merge: babelHelpers.defineProperty({}, requestID, {
          screenID: screenID,
          elementID: elementID,
          assetType: assetType,
          status: requestStatus
        })
      };
    }

    return (0, _immutabilityHelper2.default)(state, change);
  }
  /***/

},
/* 550 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isGridOpen;

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _imagePreloading = __webpack_require__(30);

  var status = babelHelpers.interopRequireWildcard(_imagePreloading);
  var initialState = {
    isOpen: false,
    isThumbLoaded: {}
  };

  function isGridOpen() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action.type === actionTypes.SHOW_GRID) {
      return updateIsOpen(state, true);
    }

    if (action.type === actionTypes.HIDE_GRID) {
      return updateIsOpen(state, false);
    }

    if (action.type === actionTypes.SHOW_SCREEN) {
      return updateIsOpen(state, false);
    }

    if (action.type === actionTypes.IMAGE_THUMB_LOADED) {
      var id = action.id;
      return (0, _immutabilityHelper2.default)(state, {
        isThumbLoaded: babelHelpers.defineProperty({}, id, {
          $set: status.DONE
        })
      });
    }

    if (action.type === actionTypes.IMAGE_THUMB_FAILED) {
      var _id = action.id;
      return (0, _immutabilityHelper2.default)(state, {
        isThumbLoaded: babelHelpers.defineProperty({}, _id, {
          $set: status.ERROR
        })
      });
    }

    return state;
  }

  function updateIsOpen(state, isOpen) {
    return (0, _immutabilityHelper2.default)(state, {
      isOpen: {
        $set: isOpen
      }
    });
  }
  /***/

},
/* 551 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.initialState = undefined;
  exports.default = handoffReducer;

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _clamp = __webpack_require__(552);

  var _clamp2 = babelHelpers.interopRequireDefault(_clamp);

  var _findIndex = __webpack_require__(53);

  var _findIndex2 = babelHelpers.interopRequireDefault(_findIndex);

  var _cloneDeep = __webpack_require__(71);

  var _cloneDeep2 = babelHelpers.interopRequireDefault(_cloneDeep);

  var _utils = __webpack_require__(553);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _zoom = __webpack_require__(117);

  var zoom = babelHelpers.interopRequireWildcard(_zoom);

  var _tree = __webpack_require__(121);

  var tree = babelHelpers.interopRequireWildcard(_tree);

  var _measurementUnits = __webpack_require__(137);

  var units = babelHelpers.interopRequireWildcard(_measurementUnits);

  var _requestStatus = __webpack_require__(31);

  var requestStatus = babelHelpers.interopRequireWildcard(_requestStatus);

  var _handoff = __webpack_require__(5);

  var _sourcePlatform = __webpack_require__(94);

  var initialState = exports.initialState = {
    isOpen: false,
    selectedItemID: null,
    hoveredItemID: null,
    zoomPosition: zoom.DEFAULT_POSITION,
    zoomFit: true,
    canvas: null,
    flatCanvas: null,
    unit: units.PIXEL,
    requestStatus: requestStatus.IDLE
  };

  function handoffReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case actionTypes.SHOW_SCREEN:
        return (0, _immutabilityHelper2.default)(state, {
          canvas: {
            $set: null
          },
          flatCanvas: {
            $set: null
          },
          selectedItemID: {
            $set: null
          },
          hoveredItemID: {
            $set: null
          },
          requestStatus: {
            $set: requestStatus.IDLE
          }
        });

      case actionTypes.LOAD_CANVAS_STARTING:
        return (0, _immutabilityHelper2.default)(state, {
          requestStatus: {
            $set: requestStatus.PENDING
          }
        });

      case actionTypes.LOAD_CANVAS_DONE:
        return setCanvas(state, action.canvas, action.sourcePlatform);

      case actionTypes.LOAD_CANVAS_FAILED:
        return (0, _immutabilityHelper2.default)(state, {
          requestStatus: {
            $set: requestStatus.ERROR
          }
        });

      case actionTypes.SHOW_HANDOFF:
        return enterHandoffMode(state);

      case actionTypes.HIDE_HANDOFF:
        return leaveHandoffMode(state);

      case actionTypes.CHANGE_HANDOFF_SELECTED_ITEM:
        {
          var newState = updateSelectedElement(state, action.index);
          newState = updateHoveredElement(newState, action.index);
          return newState;
        }

      case actionTypes.INCREMENT_ZOOM:
        return incrementZoom(state);

      case actionTypes.DECREMENT_ZOOM:
        return decrementZoom(state);

      case actionTypes.DESELECT_HANDOFF_ITEM:
        return deselectHandoffItem(state);

      case actionTypes.CHANGE_HANDOFF_HOVERED_ITEM:
        return updateHoveredElement(state, action.index);

      case actionTypes.SET_CANVAS:
        return setCanvas(state, action.canvas, action.sourcePlatform);

      case actionTypes.LOAD_FULL_PROJECT_DONE:
        return setInitalUnit(state, action.project.isWeb);

      case actionTypes.SET_UNIT:
        return (0, _immutabilityHelper2.default)(state, {
          unit: {
            $set: action.unit
          }
        });

      case actionTypes.LOCATION_CHANGED:
        if (action.inHandoff !== state.isOpen) {
          if (action.inHandoff) {
            return enterHandoffMode(state);
          }

          return leaveHandoffMode(state);
        }

        return state;

      case actionTypes.UPDATE_ZOOM_POSITION:
        return updateZoomPosition(state, action.zoomPosition);

      default:
        return state;
    }
  }

  function updateZoomPosition(state, zoomPosition) {
    var zoomFit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return (0, _immutabilityHelper2.default)(state, {
      zoomPosition: {
        $set: zoomPosition
      },
      zoomFit: {
        $set: zoomFit
      }
    });
  }

  function enterHandoffMode(state) {
    return (0, _immutabilityHelper2.default)(state, {
      isOpen: {
        $set: true
      }
    });
  }

  function leaveHandoffMode(state) {
    if (state.selectedItemID !== null) {
      return (0, _immutabilityHelper2.default)(state, {
        selectedItemID: {
          $set: null
        }
      });
    }

    return (0, _immutabilityHelper2.default)(state, {
      isOpen: {
        $set: false
      }
    });
  }

  function incrementZoom(state) {
    return updateZoomPosition(state, clampZoom(state.zoomPosition + 1), false);
  }

  function decrementZoom(state) {
    return updateZoomPosition(state, clampZoom(state.zoomPosition - 1), false);
  }

  function updateSelectedElement(state, index) {
    var actualIndexToSelect = (0, _handoff.getSelectedElementIndex)({
      handoff: state
    }, index);
    return (0, _immutabilityHelper2.default)(state, {
      selectedItemID: {
        $set: actualIndexToSelect
      }
    });
  }

  function deselectHandoffItem(state) {
    return (0, _immutabilityHelper2.default)(state, {
      selectedItemID: {
        $set: null
      }
    });
  }

  function updateHoveredElement(state, index) {
    if (index !== null) {
      var selected = state.flatCanvas[state.selectedItemID];
      var element = state.flatCanvas[index];

      if (tree.isElementNested(element)) {
        var hovered = tree.getAncestorOfElementThatIsChildOfCurrrentSelection(selected, element);

        if (!hovered) {
          hovered = tree.getAncestorOfElementThatIsSiblingOfCurrrentSelection(selected, element);
        }

        if (!hovered) {
          hovered = tree.getAncestorOfElementThatIsParentOfCurrrentSelection(selected, element);
        }

        if (!hovered) {
          if (tree.isElementInSameTopLevelGroupAsCurrentSelection(selected, element)) {
            hovered = element;
          }
        }

        if (!hovered) {
          hovered = tree.getTopLevelGroup(element, selected);
        }
        /* eslint-disable no-param-reassign */


        index = getElementIndex(state, hovered);
      }
    }

    return (0, _immutabilityHelper2.default)(state, {
      hoveredItemID: {
        $set: index
      }
    });
  }

  function clampZoom(value) {
    return (0, _clamp2.default)(value, zoom.MIN_POSITION, zoom.MAX_POSITION);
  }

  function setCanvas(state, canvas, sourcePlatform) {
    var flatCanvas = (0, _utils.getElements)(canvas, sourcePlatform === _sourcePlatform.DESIGN_TOOL); // getElements takes care of designRatio for the elements so here we
    // need to handle for the artboard

    var cloned = (0, _cloneDeep2.default)(canvas);
    var _canvas$artboard = canvas.artboard,
        _canvas$artboard$desi = _canvas$artboard.designRatio,
        designRatio = _canvas$artboard$desi === undefined ? 1 : _canvas$artboard$desi,
        _canvas$artboard$pixe = _canvas$artboard.pixelRatio,
        pixelRatio = _canvas$artboard$pixe === undefined ? 1 : _canvas$artboard$pixe;
    cloned.artboard.size = (0, _utils.divideValues)(cloned.artboard.size, designRatio);
    cloned.artboard.pixelRatio = pixelRatio * designRatio;
    return (0, _immutabilityHelper2.default)(state, {
      canvas: {
        $set: cloned
      },
      flatCanvas: {
        $set: flatCanvas
      },
      requestStatus: {
        $set: requestStatus.SUCCESS
      }
    });
  }

  function getElementIndex(state, element) {
    return (0, _findIndex2.default)(state.flatCanvas, function (el) {
      return el === element;
    });
  }

  function setInitalUnit(state, isWeb) {
    var unit = isWeb ? units.PIXEL : units.POINT;
    return (0, _immutabilityHelper2.default)(state, {
      unit: {
        $set: unit
      }
    });
  }
  /***/

},
/* 552 */

/***/
function (module, exports) {
  module.exports = require("lodash/clamp");
  /***/
},
/* 553 */

/***/
function (module, exports) {
  module.exports = require("@marvelapp/design-to-code/lib/utils");
  /***/
},
/* 554 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = hotspots;

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);
  var initalState = {
    areVisible: false,
    areLoaded: false
  };

  function hotspots() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
    var action = arguments[1];

    switch (action.type) {
      case actionTypes.SHOW_HOTSPOTS:
        return (0, _immutabilityHelper2.default)(state, {
          areVisible: {
            $set: true
          }
        });

      case actionTypes.HIDE_HOTSPOTS:
        return (0, _immutabilityHelper2.default)(state, {
          areVisible: {
            $set: false
          }
        });

      case actionTypes.LOAD_HOTSPOTS_DONE:
        return (0, _immutabilityHelper2.default)(state, {
          areLoaded: {
            $set: true
          }
        });

      case actionTypes.SET_PROJECT:
        return (0, _immutabilityHelper2.default)(state, {
          areLoaded: {
            $set: true
          }
        });

      default:
        return state;
    }
  }
  /***/

},
/* 555 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.initialState = undefined;
  exports.default = hoverStack;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);
  var initialState = exports.initialState = [];

  function hoverStack() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case actionTypes.ADD_TO_HOVER_STACK:
        return [].concat(babelHelpers.toConsumableArray(state), [action.hoverOutInfo]);

      case actionTypes.REMOVE_FROM_HOVER_STACK:
        return state.slice(0, -action.numberOfLevels);

      case actionTypes.SHOW_SCREEN:
      case actionTypes.SHOW_OVERLAY:
      case actionTypes.HIDE_OVERLAY:
        return initialState;

      default:
        return state;
    }
  }
  /***/

},
/* 556 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = imagePreloading;

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _filter = __webpack_require__(68);

  var _filter2 = babelHelpers.interopRequireDefault(_filter);

  var _mapValues = __webpack_require__(26);

  var _mapValues2 = babelHelpers.interopRequireDefault(_mapValues);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _imagePreloading = __webpack_require__(30);

  var status = babelHelpers.interopRequireWildcard(_imagePreloading);

  var _contentStatus = __webpack_require__(37);

  var contentStatus = babelHelpers.interopRequireWildcard(_contentStatus);

  function imagePreloading() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (action.type === actionTypes.LOAD_FULL_PROJECT_DONE || action.type === actionTypes.SET_PROJECT) {
      var screens = action.project.screens;
      var changes = {};
      (0, _filter2.default)(screens, isLoadable).forEach(function (_ref) {
        var id = _ref.id;
        var image = state[id];

        if (!image) {
          changes[id] = {
            $set: status.IDLE
          };
        }
      });
      return (0, _immutabilityHelper2.default)(state, changes);
    }

    if (action.type === actionTypes.IMAGE_LOADING_START) {
      var id = action.id;
      return (0, _immutabilityHelper2.default)(state, babelHelpers.defineProperty({}, id, {
        $set: status.PRELOADING
      }));
    }

    if (action.type === actionTypes.RELOAD_IMAGES) {
      var currentScreenID = action.currentScreenID;
      return (0, _mapValues2.default)(state, function (currentStatus, screenID) {
        return (// don't want to set status of RELOADING for current screen
          // and images that were not loaded yet
          parseInt(screenID) === currentScreenID || currentStatus !== status.DONE ? currentStatus : status.RELOADING
        );
      });
    }

    if (action.type === actionTypes.IMAGE_LOADED) {
      var _id = action.id;
      return (0, _immutabilityHelper2.default)(state, babelHelpers.defineProperty({}, _id, {
        $set: status.DONE
      }));
    }

    if (action.type === actionTypes.IMAGE_LOAD_FAILED) {
      var _id2 = action.id;
      return (0, _immutabilityHelper2.default)(state, babelHelpers.defineProperty({}, _id2, {
        $set: status.ERROR
      }));
    }

    return state;
  }

  function isLoadable(screen) {
    return screen.contentStatus === contentStatus.IMAGE_UPLOAD_DONE;
  }
  /***/

},
/* 557 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.initialState = undefined;
  exports.default = reducer;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);
  var initialState = exports.initialState = {
    isRowOverlayOn: false,
    isColumnOverlayOn: false
  };

  function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case actionTypes.TOGGLE_ROW_OVERLAY:
        return {
          isRowOverlayOn: !state.isRowOverlayOn,
          isColumnOverlayOn: state.isColumnOverlayOn
        };

      case actionTypes.TOGGLE_COLUMN_OVERLAY:
        return {
          isRowOverlayOn: state.isRowOverlayOn,
          isColumnOverlayOn: !state.isColumnOverlayOn
        };

      default:
        return state;
    }
  }
  /***/

},
/* 558 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = overlay;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);
  var initialState = {
    scrollPos: null,
    smoothScroll: false
  };

  function overlay() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case actionTypes.SHOW_OVERLAY:
      case actionTypes.SHOW_HOVER_OVERLAY:
        return {
          scrollPos: action.scrollPos
        };

      case actionTypes.SET_OVERLAY_SCROLL_POS:
        return {
          scrollPos: action.scrollPos,
          smoothScroll: action.smoothScroll
        };

      case actionTypes.UNSET_OVERLAY_SCROLL_POS:
        return {
          scrollPos: null
        };

      default:
        return state;
    }
  }
  /***/

},
/* 559 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = password;

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);
  var initialState = {
    isRequired: null,
    // not known until API request is made
    isValid: null,
    value: '',
    isBeingVerified: false
  };

  function password() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action.type === actionTypes.PASSWORD_REQUIRED) {
      return (0, _immutabilityHelper2.default)(state, {
        isRequired: {
          $set: true
        }
      });
    }

    if (action.type === actionTypes.VERIFY_PASSWORD) {
      return (0, _immutabilityHelper2.default)(state, {
        isBeingVerified: {
          $set: true
        }
      });
    }

    if (action.type === actionTypes.PASSWORD_INVALID) {
      return (0, _immutabilityHelper2.default)(state, {
        isValid: {
          $set: false
        },
        isBeingVerified: {
          $set: false
        }
      });
    }

    if (action.type === actionTypes.PASSWORD_VALID) {
      return (0, _immutabilityHelper2.default)(state, {
        isValid: {
          $set: true
        },
        isBeingVerified: {
          $set: false
        }
      });
    }

    return state;
  }
  /***/

},
/* 560 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = player;

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);
  var initialState = {
    // User clicked play button so we're waiting for full project data
    // to load
    isAboutToPlay: false,
    isPlaying: false
  };

  function player() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action.type === actionTypes.PLAY) {
      return (0, _immutabilityHelper2.default)(state, {
        isAboutToPlay: {
          $set: true
        }
      });
    }

    if ((action.type === actionTypes.LOAD_FULL_PROJECT_DONE || action.type === actionTypes.SET_PROJECT) && state.isAboutToPlay) {
      return (0, _immutabilityHelper2.default)(state, {
        isAboutToPlay: {
          $set: false
        },
        isPlaying: {
          $set: true
        }
      });
    }

    return state;
  }
  /***/

},
/* 561 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = project;

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);
  var initialState = {
    isDownloaded: false,
    isLoading: true,
    isFrameless: false,
    error: null,
    notFound: null,
    config: {},
    canvasEaselHost: 'https://easel.marvelapp.com'
  };

  function project() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action.type === actionTypes.LOCATION_CHANGED) {
      var projectID = action.projectID,
          isEmbedded = action.isEmbedded,
          isInTheExploreView = action.isInTheExploreView,
          hideAddToHomeScreen = action.hideAddToHomeScreen,
          isFrameless = action.isFrameless;
      var newState = (0, _immutabilityHelper2.default)(state, {
        config: {
          id: {
            $set: projectID
          }
        },
        isEmbedded: {
          $set: isEmbedded
        },
        isInTheExploreView: {
          $set: isInTheExploreView
        },
        hideAddToHomeScreen: {
          $set: hideAddToHomeScreen
        },
        isFrameless: {
          $set: isFrameless
        }
      });
      return newState;
    }

    if (action.type === actionTypes.LOAD_PROJECT) {
      return (0, _immutabilityHelper2.default)(state, {
        isLoading: {
          $set: true
        }
      });
    }

    if (action.type === actionTypes.LOAD_FULL_PROJECT_DONE || action.type === actionTypes.SET_PROJECT) {
      // TODO need to be smarter here as part of project will have
      // been loaded if in embedded mode and first image will have
      // been preloaded
      return (0, _immutabilityHelper2.default)(state, {
        config: {
          $set: action.project
        },
        isLoading: {
          $set: false
        }
      });
    }

    if (action.type === actionTypes.NOT_FOUND) {
      return (0, _immutabilityHelper2.default)(state, {
        notFound: {
          $set: true
        }
      });
    }

    if (action.type === actionTypes.LOAD_FULL_PROJECT_FAILED) {
      return (0, _immutabilityHelper2.default)(state, {
        error: {
          $set: action.err
        }
      });
    }

    if (action.type === actionTypes.SET_IS_DOWNLOADED) {
      return (0, _immutabilityHelper2.default)(state, {
        isDownloaded: {
          $set: action.isDownloaded
        }
      });
    }

    if (action.type === actionTypes.SET_CANVAS_EASEL_URLS) {
      return (0, _immutabilityHelper2.default)(state, {
        canvasEaselHost: {
          $set: action.canvasEaselHost
        }
      });
    }

    if (action.type === actionTypes.SET_FRAMELESS) {
      return (0, _immutabilityHelper2.default)(state, {
        isFrameless: {
          $set: action.isFrameless
        }
      });
    }

    return state;
  }
  /***/

},
/* 562 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.initialState = undefined;
  exports.default = screen;
  exports.getScreenByID = getScreenByID;
  exports.getScreenIndex = getScreenIndex;

  var _findIndex = __webpack_require__(53);

  var _findIndex2 = babelHelpers.interopRequireDefault(_findIndex);

  var _immutabilityHelper = __webpack_require__(18);

  var _immutabilityHelper2 = babelHelpers.interopRequireDefault(_immutabilityHelper);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _image = __webpack_require__(51);

  var _isBrowserInFullScreenMode = __webpack_require__(56);

  var _isBrowserInFullScreenMode2 = babelHelpers.interopRequireDefault(_isBrowserInFullScreenMode);

  var initialState = exports.initialState = {
    scrollPos: {
      current: null,
      previous: null
    },
    scrollTo: null,
    scrollingToAnnotation: null,
    smoothScroll: false,
    // TODO just reference project.screens
    screenSequence: [],
    currentScreen: null,
    resetGIF: null,
    // We need to know about the last screen so we can animate it away correctly
    previousScreen: null,
    transition: null,
    backTransition: null,
    isTransitionComplete: {
      previous: true,
      current: false
    },
    renderedDimensions: null,
    showScreenInfo: false,
    // TODO move to comment reducer
    commentCount: 0,
    // Overlays
    // We can't split to a separate reducer as we
    // need to know about the current screen
    // TODO  better solution might be to move all LOCATION_CHANGED
    // handlers into the location reducer?
    // We use the hotspot ID not the overlay ID so we can position and
    // animate the overlay correctly when deep linked
    currentOverlayHotspot: {
      id: null,
      animate: true,
      screenScrollPos: null,
      positionParent: null
    },
    // We need to know about the last overlay so we can animate it away correctly
    previousOverlayHotspot: {
      id: null,
      animate: false,
      screenScrollPos: null,
      positionParent: null
    }
  };

  function screen() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action.type === actionTypes.SET_INITIAL_SCREEN) {
      return (0, _immutabilityHelper2.default)(state, {
        currentScreen: {
          $set: {
            id: action.screenID
          }
        }
      });
    }

    if (action.type === actionTypes.LOCATION_CHANGED) {
      var screenID = action.screenID,
          hotspotID = action.hotspotID;
      var screenStateChanges = void 0;
      var isNavigatingBack = false;
      var transition = void 0;
      var backTransition = void 0;

      if (screenID !== (state.currentScreen && state.currentScreen.id)) {
        var screenTransition = action.screenTransition;
        var currentScreen = null;

        if (screenID) {
          currentScreen = getScreenByID(state.screenSequence, screenID);
        }

        isNavigatingBack = isBackNavigation(state, screenID);

        if (!isNavigatingBack) {
          transition = screenTransition;
          backTransition = screenTransition;
        } else {
          transition = state.backTransition;
          backTransition = screenTransition;
        }

        if (isInitialPageLoad(state)) {
          screenTransition = null;
        }

        screenStateChanges = {
          currentScreen: {
            $set: currentScreen
          },
          previousScreen: {
            $set: state.currentScreen
          },
          transition: {
            $set: transition
          },
          backTransition: {
            $set: backTransition
          },
          isTransitionReversed: {
            $set: isNavigatingBack
          },
          isTransitionComplete: {
            current: {
              $set: false
            },
            previous: {
              $set: !transition
            }
          }
        };

        if (currentScreen && currentScreen.img && (0, _image.isGIF)(currentScreen.img.url)) {
          screenStateChanges.resetGIF = {
            $set: currentScreen.img.url
          };
        }
      }

      var overlayTransition = action.overlayTransition;

      if (isHidingOverlay(state, screenID, hotspotID)) {
        return (0, _immutabilityHelper2.default)(state, babelHelpers.extends({}, screenStateChanges, updateHotspotID(state, hotspotID, {
          animatePrevious: true,
          animateCurrent: !isNavigatingBack,
          previousTransition: overlayTransition
        })));
      } // Showing overlay


      var animateCurrent = !isNavigatingBack || overlayTransition;
      return (0, _immutabilityHelper2.default)(state, babelHelpers.extends({}, screenStateChanges, updateHotspotID(state, hotspotID, {
        animatePrevious: false,
        animateCurrent: animateCurrent,
        currentTransition: overlayTransition
      }))); // TODO changing overlay!
    }

    if (action.type === actionTypes.LOAD_FULL_PROJECT_DONE || action.type === actionTypes.SET_PROJECT) {
      var _action$project = action.project,
          screens = _action$project.screens,
          hotspotMap = _action$project.hotspotMap;
      var _currentScreen = state.currentScreen;

      if ((0, _isBrowserInFullScreenMode2.default)()) {
        _currentScreen = screens[0];
      } else if (_currentScreen && _currentScreen.id) {
        _currentScreen = getScreenByID(screens, _currentScreen.id);
      } else {
        _currentScreen = screens[0];
      }

      return (0, _immutabilityHelper2.default)(state, {
        // TODO no need to copy this here, just access on state.project
        screenSequence: {
          $set: screens
        },
        hotspotMap: {
          $set: hotspotMap
        },
        // ////////////////////////////////////////////////////////////
        currentScreen: {
          $set: _currentScreen
        },
        overScreen: {
          $set: _currentScreen
        }
      });
    }

    if (action.type === actionTypes.SHOW_SCREEN || action.type === actionTypes.SHOW_HOVER_SCREEN) {
      var _screenID = action.screenID,
          _transition = action.transition,
          scrollPos = action.scrollPos;
      var screenIndex = getScreenIndex(state.screenSequence, _screenID);
      return updateStateToAdjacentScreen(state, function () {
        return screenIndex;
      }, _transition, scrollPos);
    }

    if (action.type === actionTypes.SCREEN_RESIZED) {
      return (0, _immutabilityHelper2.default)(state, {
        renderedDimensions: {
          $set: action.renderedScreenDimensions
        },
        currentOverlayHotspot: {
          screenScrollPos: {
            $set: null
          }
        }
      });
    }

    if (action.type === actionTypes.SCROLL_TO) {
      var position = action.position,
          smoothScroll = action.smoothScroll;
      return (0, _immutabilityHelper2.default)(state, {
        scrollTo: {
          $set: position
        },
        smoothScroll: {
          $set: smoothScroll
        }
      });
    }

    if (action.type === actionTypes.UNSET_SCROLL_POS) {
      return (0, _immutabilityHelper2.default)(state, {
        scrollPos: {
          current: {
            $set: null
          }
        },
        scrollTo: {
          $set: null
        },
        smoothScroll: {
          $set: false
        }
      });
    }

    if (action.type === actionTypes.SCREEN_TRANSITION_COMPLETED) {
      var whichScreen = action.isCurrent ? 'current' : 'previous';
      var change = {
        isTransitionComplete: babelHelpers.defineProperty({}, whichScreen, {
          $set: true
        })
      };
      return (0, _immutabilityHelper2.default)(state, change);
    }

    if (action.type === actionTypes.SHOW_SCREEN_INFO) {
      return (0, _immutabilityHelper2.default)(state, {
        showScreenInfo: {
          $set: true
        }
      });
    }

    if (action.type === actionTypes.HIDE_SCREEN_INFO) {
      return (0, _immutabilityHelper2.default)(state, {
        showScreenInfo: {
          $set: false
        }
      });
    }

    if (action.type === actionTypes.SHOW_OVERLAY || action.type === actionTypes.SHOW_HOVER_OVERLAY) {
      var _hotspotID = action.hotspotID;
      return (0, _immutabilityHelper2.default)(state, updateHotspotID(state, _hotspotID, {
        animatePrevious: false
      }));
    }

    if (action.type === actionTypes.HIDE_OVERLAY) {
      var _hotspotID2 = null;
      var _transition2 = action.transition;
      return (0, _immutabilityHelper2.default)(state, updateHotspotID(state, _hotspotID2, {
        animatePrevious: true,
        previousTransition: _transition2
      }));
    }

    if (action.type === actionTypes.GIF_RESET_DONE) {
      return (0, _immutabilityHelper2.default)(state, {
        resetGIF: {
          $set: null
        }
      });
    }

    return state;
  }

  function updateStateToAdjacentScreen(state, moveFunc, transition) {
    var scrollPos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
      current: 0,
      previous: null
    };
    var hotspotID = null;
    var noOfScreens = state.screenSequence.length;
    var currentScreenIndex = getScreenIndex(state.screenSequence, state.currentScreen.id);
    var nextScreenIndex = moveFunc(currentScreenIndex, noOfScreens);
    var nextScreen = state.screenSequence[nextScreenIndex];

    if (state.currentScreen.id === nextScreen.id) {
      return (0, _immutabilityHelper2.default)(state, updateHotspotID(state, hotspotID, {
        animatePrevious: false
      }));
    }

    var changes = babelHelpers.extends({
      currentScreen: {
        $set: nextScreen
      },
      overScreen: {
        $set: nextScreen
      },
      previousScreen: {
        $set: state.currentScreen
      },
      underScreen: {
        $set: state.currentScreen
      },
      transition: {
        $set: transition
      },
      backTransition: {
        $set: transition
      },
      isTransitionComplete: {
        $set: {
          current: false,
          previous: !transition
        }
      },
      isTransitionReversed: {
        $set: false
      }
    }, updateHotspotID(state, hotspotID, {
      animatePrevious: false
    }));

    if ((0, _image.isGIF)(nextScreen.img.url)) {
      changes.resetGIF = {
        $set: nextScreen.img.url
      };
    }

    if (scrollPos) {
      changes.scrollPos = {
        $set: scrollPos
      };
    }

    return (0, _immutabilityHelper2.default)(state, changes);
  }

  function updateHotspotID(state, hotspotID, _ref) {
    var _ref$animateCurrent = _ref.animateCurrent,
        animateCurrent = _ref$animateCurrent === undefined ? true : _ref$animateCurrent,
        animatePrevious = _ref.animatePrevious,
        previousTransition = _ref.previousTransition,
        currentTransition = _ref.currentTransition; // When navigating back with navigation buttons, the reducer
    // will try to `updateHotspotID` on LOCATION_CHANGE, setting
    // `previousOverlayHotspot` to be the same as `currentOverlayHotspot`.
    // This is incorrect and hence we should make sure that `hotspotID`
    // is not equal `state.currentOverlayHotspot.id` before updating
    // First time this runs, both `state.currentOverlayHotspot.id` and
    // `hotspotID` will be null

    if (!state.currentOverlayHotspot.id || hotspotID !== state.currentOverlayHotspot.id) {
      return {
        currentOverlayHotspot: {
          $set: {
            id: hotspotID,
            animate: animateCurrent,
            transition: currentTransition,
            screenScrollPos: null,
            positionParent: state.currentOverlayHotspot.id
          }
        },
        previousOverlayHotspot: {
          $set: {
            id: state.currentOverlayHotspot.id,
            screenScrollPos: state.currentOverlayHotspot.screenScrollPos,
            positionParent: state.currentOverlayHotspot.positionParent,
            animate: animatePrevious,
            transition: previousTransition
          }
        }
      };
    }

    return {};
  }

  function isInitialPageLoad(_ref2) {
    var previousScreen = _ref2.previousScreen;
    return !previousScreen;
  }

  function isHidingOverlay(state, screenID, hotspotID) {
    return state.currentOverlayHotspot.id && !hotspotID && state.currentScreen.id === screenID;
  }

  function isBackNavigation(state, destinationScreenID) {
    if (!state.isTransitionReversed) {
      return state.previousScreen && state.previousScreen.id === destinationScreenID;
    }

    return state.previousScreen && state.previousScreen.id !== destinationScreenID;
  } // TODO move to selector


  function getScreenByID(screens, screenID) {
    if (!screens.length) {
      return {
        id: screenID
      };
    }

    return screens[getScreenIndex(screens, screenID)] || screens[0];
  } // TODO move to selectors/screen or utils or ...?


  function getScreenIndex(screens, screenID) {
    return (0, _findIndex2.default)(screens, function (s) {
      return s.id === screenID;
    });
  }
  /***/

},
/* 563 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = userReducer;

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  function userReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case actionTypes.SET_USER_PROP:
        return babelHelpers.extends({}, state, babelHelpers.defineProperty({}, action.key, action.value));

      default:
        return state;
    }
  }
  /***/

},
/* 564 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = root;

  var _effects = __webpack_require__(10);

  var _changeScreen = __webpack_require__(565);

  var _changeScreen2 = babelHelpers.interopRequireDefault(_changeScreen);

  var _cookies = __webpack_require__(566);

  var _cookies2 = babelHelpers.interopRequireDefault(_cookies);

  var _downloadAssets = __webpack_require__(568);

  var _downloadAssets2 = babelHelpers.interopRequireDefault(_downloadAssets);

  var _flashHotspots = __webpack_require__(573);

  var _flashHotspots2 = babelHelpers.interopRequireDefault(_flashHotspots);

  var _handoffZoomFit = __webpack_require__(574);

  var _handoffZoomFit2 = babelHelpers.interopRequireDefault(_handoffZoomFit);

  var _historyBack = __webpack_require__(575);

  var _historyBack2 = babelHelpers.interopRequireDefault(_historyBack);

  var _loadCode = __webpack_require__(576);

  var _loadCode2 = babelHelpers.interopRequireDefault(_loadCode);

  var _loadHotspots = __webpack_require__(577);

  var _loadHotspots2 = babelHelpers.interopRequireDefault(_loadHotspots);

  var _preloadImages = __webpack_require__(580);

  var _preloadImages2 = babelHelpers.interopRequireDefault(_preloadImages);

  var _loadProject = __webpack_require__(583);

  var _loadProject2 = babelHelpers.interopRequireDefault(_loadProject);

  var _loadThumbnails = __webpack_require__(584);

  var _loadThumbnails2 = babelHelpers.interopRequireDefault(_loadThumbnails);

  var _location = __webpack_require__(585);

  var _location2 = babelHelpers.interopRequireDefault(_location);

  var _pusher = __webpack_require__(587);

  var _pusher2 = babelHelpers.interopRequireDefault(_pusher);

  var _reloadImages = __webpack_require__(588);

  var _reloadImages2 = babelHelpers.interopRequireDefault(_reloadImages);

  var _screenTimer = __webpack_require__(590);

  var _screenTimer2 = babelHelpers.interopRequireDefault(_screenTimer);

  var _setDefaultCodeLang = __webpack_require__(591);

  var _setDefaultCodeLang2 = babelHelpers.interopRequireDefault(_setDefaultCodeLang);

  var _setEmbedlyContainerHeight = __webpack_require__(592);

  var _setEmbedlyContainerHeight2 = babelHelpers.interopRequireDefault(_setEmbedlyContainerHeight);

  var _showCopying = __webpack_require__(593);

  var _showCopying2 = babelHelpers.interopRequireDefault(_showCopying);

  var _showScreenInfo = __webpack_require__(594);

  var _showScreenInfo2 = babelHelpers.interopRequireDefault(_showScreenInfo);

  var _triggerAssetDownload = __webpack_require__(595);

  var _triggerAssetDownload2 = babelHelpers.interopRequireDefault(_triggerAssetDownload);

  var _hover = __webpack_require__(596);

  var _hover2 = babelHelpers.interopRequireDefault(_hover);

  var _history = __webpack_require__(597);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(root);

  function root(dispatch, isAppBuild, isDownloaded) {
    var history, loadCanvas, sagas;
    return _regeneratorRuntime.wrap(function root$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            history = (0, _history.createEnhancedHistory)({
              isAppBuild: isAppBuild,
              isDownloaded: isDownloaded
            });
            window.enhancedHistory = history;
            loadCanvas = __webpack_require__(599).default;
            sagas = [(0, _effects.fork)(_changeScreen2.default), (0, _effects.fork)(_cookies2.default), (0, _effects.fork)(_downloadAssets2.default, dispatch), (0, _effects.fork)(_flashHotspots2.default), (0, _effects.fork)(_handoffZoomFit2.default), (0, _effects.fork)(_historyBack2.default, history), (0, _effects.fork)(loadCanvas), (0, _effects.fork)(_loadCode2.default), (0, _effects.fork)(_loadHotspots2.default), (0, _effects.fork)(_preloadImages2.default, dispatch), (0, _effects.fork)(_loadProject2.default), (0, _effects.fork)(_loadThumbnails2.default, dispatch), (0, _effects.fork)(_location2.default, dispatch, history), (0, _effects.fork)(_reloadImages2.default, dispatch), (0, _effects.fork)(_pusher2.default, dispatch), (0, _effects.fork)(_screenTimer2.default), (0, _effects.fork)(_setDefaultCodeLang2.default), (0, _effects.fork)(_setEmbedlyContainerHeight2.default), (0, _effects.fork)(_showCopying2.default), (0, _effects.fork)(_showScreenInfo2.default), (0, _effects.fork)(_triggerAssetDownload2.default), (0, _effects.fork)(_hover2.default)];
            _context.next = 6;
            return (0, _effects.all)(sagas);

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 565 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = changeScreen;

  var _effects = __webpack_require__(10);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _actionCreators = __webpack_require__(4);

  var _screen = __webpack_require__(9);

  var _project = __webpack_require__(11);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(changeScreen);

  var actions = [actionTypes.SHOW_HOME, actionTypes.SHOW_NEXT, actionTypes.SHOW_PREVIOUS];

  function changeScreen() {
    return _regeneratorRuntime.wrap(function changeScreen$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeEvery)(actions,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(_ref) {
              var type = _ref.type;
              var currentScreen, currentScreenId, noOfScreens, currentScreenIndex, newIndex, newScreenId;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.select)(_screen.getCurrentScreen);

                    case 2:
                      currentScreen = _context.sent;
                      currentScreenId = currentScreen.id;

                      if (currentScreenId) {
                        _context.next = 6;
                        break;
                      }

                      return _context.abrupt('return');

                    case 6:
                      _context.next = 8;
                      return (0, _effects.select)(_project.getNoOfScreens);

                    case 8:
                      noOfScreens = _context.sent;

                      if (!(noOfScreens < 2)) {
                        _context.next = 11;
                        break;
                      }

                      return _context.abrupt('return');

                    case 11:
                      _context.next = 13;
                      return (0, _effects.select)(function (state) {
                        return (0, _project.getScreenById)(state, currentScreenId);
                      });

                    case 13:
                      _context.t0 = _context.sent.order;
                      currentScreenIndex = _context.t0 - 1;
                      newIndex = getNextScreenIndex(type, currentScreenIndex, noOfScreens);
                      _context.next = 18;
                      return (0, _effects.select)(function (state) {
                        return (0, _project.getScreenByIndex)(state, newIndex);
                      });

                    case 18:
                      newScreenId = _context.sent.id;

                      if (!(currentScreenId !== newScreenId)) {
                        _context.next = 22;
                        break;
                      }

                      _context.next = 22;
                      return (0, _effects.put)((0, _actionCreators.showScreen)(newScreenId));

                    case 22:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }

  function getNextScreenIndex(actionType, currentIndex, noOfScreens) {
    switch (actionType) {
      case actionTypes.SHOW_HOME:
        return 0;

      case actionTypes.SHOW_NEXT:
        return (currentIndex + 1) % noOfScreens;

      case actionTypes.SHOW_PREVIOUS:
        return (currentIndex - 1 + noOfScreens) % noOfScreens;

      default:
        throw new Error('Invalid action type: ' + actionType);
    }
  }
  /***/

},
/* 566 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = cookiesSaga;

  var _effects = __webpack_require__(10);

  var _jsCookie = __webpack_require__(67);

  var _jsCookie2 = babelHelpers.interopRequireDefault(_jsCookie);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _cookies = __webpack_require__(567);

  var _project = __webpack_require__(11);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(readHomeScreenCookie),
      _marked2 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(setHomeScreenCookie),
      _marked3 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(readLeaveCommentCookie),
      _marked4 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(setLeaveCommentCookie),
      _marked5 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(cookiesSaga);

  var ONE_YEAR = 365;

  function readHomeScreenCookie() {
    return _regeneratorRuntime.wrap(function readHomeScreenCookie$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeEvery)(actionTypes.GET_ADD_TO_HOME_SCREEN_COOKIE,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee() {
              var value;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      value = _jsCookie2.default.get(_cookies.ADD_TO_HOME_SCREEN_COOKIE);
                      _context.next = 3;
                      return (0, _effects.put)(actionCreators.receiveAddToHomeScreenCookie(value === 'true'));

                    case 3:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }

  function setHomeScreenCookie() {
    return _regeneratorRuntime.wrap(function setHomeScreenCookie$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (0, _effects.takeLatest)(actionTypes.SET_ADD_TO_HOME_SCREEN_COOKIE,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee2() {
              var projectID;
              return _regeneratorRuntime.wrap(function _callee2$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return (0, _effects.select)(_project.getProjectID);

                    case 2:
                      projectID = _context3.sent;

                      _jsCookie2.default.set(_cookies.ADD_TO_HOME_SCREEN_COOKIE, 'true', {
                        expires: ONE_YEAR,
                        path: '/' + projectID
                      });

                    case 4:
                    case 'end':
                      return _context3.stop();
                  }
                }
              }, _callee2, this);
            }));

          case 2:
          case 'end':
            return _context4.stop();
        }
      }
    }, _marked2, this);
  }

  function readLeaveCommentCookie() {
    return _regeneratorRuntime.wrap(function readLeaveCommentCookie$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return (0, _effects.takeEvery)(actionTypes.GET_LEAVE_COMMENT_POPOVER_COOKIE,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee3() {
              var value;
              return _regeneratorRuntime.wrap(function _callee3$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      value = _jsCookie2.default.get(_cookies.LEAVE_COMMENT_POPOVER_COOKIE);
                      _context5.next = 3;
                      return (0, _effects.put)(actionCreators.receiveLeaveCommentPopoverCookie(value === 'true'));

                    case 3:
                    case 'end':
                      return _context5.stop();
                  }
                }
              }, _callee3, this);
            }));

          case 2:
          case 'end':
            return _context6.stop();
        }
      }
    }, _marked3, this);
  }

  function setLeaveCommentCookie() {
    return _regeneratorRuntime.wrap(function setLeaveCommentCookie$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return (0, _effects.takeLatest)(actionTypes.SET_LEAVE_COMMENT_POPOVER_COOKIE,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee4() {
              var projectID;
              return _regeneratorRuntime.wrap(function _callee4$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 2;
                      return (0, _effects.select)(_project.getProjectID);

                    case 2:
                      projectID = _context7.sent;

                      _jsCookie2.default.set(_cookies.LEAVE_COMMENT_POPOVER_COOKIE, 'true', {
                        expires: ONE_YEAR,
                        path: '/' + projectID
                      });

                    case 4:
                    case 'end':
                      return _context7.stop();
                  }
                }
              }, _callee4, this);
            }));

          case 2:
          case 'end':
            return _context8.stop();
        }
      }
    }, _marked4, this);
  }

  function cookiesSaga() {
    return _regeneratorRuntime.wrap(function cookiesSaga$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return (0, _effects.all)([(0, _effects.fork)(readHomeScreenCookie), (0, _effects.fork)(setHomeScreenCookie), (0, _effects.fork)(readLeaveCommentCookie), (0, _effects.fork)(setLeaveCommentCookie)]);

          case 2:
          case 'end':
            return _context9.stop();
        }
      }
    }, _marked5, this);
  }
  /***/

},
/* 567 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var ADD_TO_HOME_SCREEN_COOKIE = exports.ADD_TO_HOME_SCREEN_COOKIE = 'addToHomeScreen';
  var LEAVE_COMMENT_POPOVER_COOKIE = exports.LEAVE_COMMENT_POPOVER_COOKIE = 'leaveCommentPopover';
  /***/
},
/* 568 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = downloadAssetType;

  var _reduxSaga = __webpack_require__(34);

  var _effects = __webpack_require__(10);

  var _isNil = __webpack_require__(72);

  var _isNil2 = babelHelpers.interopRequireDefault(_isNil);

  var _md = __webpack_require__(569);

  var _md2 = babelHelpers.interopRequireDefault(_md);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _api = __webpack_require__(103);

  var api = babelHelpers.interopRequireWildcard(_api);

  var _pusher = __webpack_require__(172);

  var _pusher2 = __webpack_require__(104);

  var pusherConstants = babelHelpers.interopRequireWildcard(_pusher2);

  var _assets = __webpack_require__(151);

  var _handoff = __webpack_require__(5);

  var _sourcePlatform = __webpack_require__(94);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(downloadAssetType),
      _marked2 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(getZipRequestPayload),
      _marked3 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(connectToAssetChannel);

  function downloadAssetType() {
    return _regeneratorRuntime.wrap(function downloadAssetType$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeEvery)(actionTypes.DOWNLOAD_ASSETS,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(_ref) {
              var screenID = _ref.screenID,
                  elementID = _ref.elementID,
                  assetType = _ref.assetType;

              var zip, requestID, actionParams, _ref2, unsubscribe, zipCreatedPromise, response, zipUrl, message;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      return _context.delegateYield(getZipRequestPayload(elementID, assetType), 't0', 1);

                    case 1:
                      zip = _context.t0;
                      requestID = (0, _md2.default)(JSON.stringify(zip));
                      zip.channel = requestID;
                      actionParams = {
                        screenID: screenID,
                        elementID: elementID,
                        assetType: assetType,
                        requestID: requestID
                      };
                      _context.next = 7;
                      return (0, _effects.put)(actionCreators.downloadAssetsStart(actionParams));

                    case 7:
                      return _context.delegateYield(connectToAssetChannel(requestID), 't1', 8);

                    case 8:
                      _ref2 = _context.t1;
                      unsubscribe = _ref2.unsubscribe;
                      zipCreatedPromise = _ref2.zipCreatedPromise;
                      _context.next = 13;
                      return (0, _effects.call)(api.getZip, zip);

                    case 13:
                      response = _context.sent;
                      zipUrl = void 0;

                      if (!response.zip_url) {
                        _context.next = 20;
                        break;
                      } // download is available immediately


                      zipUrl = response.zip_url;
                      unsubscribe();
                      _context.next = 24;
                      break;

                    case 20:
                      _context.next = 22;
                      return zipCreatedPromise;

                    case 22:
                      message = _context.sent;
                      zipUrl = message.content.zip_url;

                    case 24:
                      _context.next = 26;
                      return (0, _effects.put)(actionCreators.assetsZipCreated(zipUrl, actionParams));

                    case 26:
                      _context.next = 28;
                      return (0, _effects.call)(_reduxSaga.delay, 3000);

                    case 28:
                      _context.next = 30;
                      return (0, _effects.put)(actionCreators.assetsZipDownloaded(actionParams));

                    case 30:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }

  function getZipRequestPayload(elementID, assetType) {
    var element, elements, screenName, sourcePlatform;
    return _regeneratorRuntime.wrap(function getZipRequestPayload$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _effects.select)(function (state) {
              return state.handoff.flatCanvas[elementID];
            });

          case 2:
            element = _context3.sent;

            if (!(0, _isNil2.default)(elementID)) {
              _context3.next = 18;
              break;
            }

            _context3.next = 6;
            return (0, _effects.select)(_handoff.getElements);

          case 6:
            elements = _context3.sent;
            _context3.next = 9;
            return (0, _effects.select)(_handoff.getArtboardTitle);

          case 9:
            screenName = _context3.sent;
            _context3.next = 12;
            return (0, _effects.select)(function (state) {
              return state.screen.currentScreen.sourcePlatform;
            });

          case 12:
            sourcePlatform = _context3.sent;

            if (!(sourcePlatform === _sourcePlatform.SKETCH)) {
              _context3.next = 15;
              break;
            }

            return _context3.abrupt('return', (0, _assets.getScreenAssets)(screenName, elements));

          case 15:
            return _context3.abrupt('return', (0, _assets.getDesignToolScreenAssets)(screenName, elements));

          case 18:
            if (assetType) {
              _context3.next = 20;
              break;
            }

            return _context3.abrupt('return', (0, _assets.getElementAssets)(element));

          case 20:
            return _context3.abrupt('return', (0, _assets.getElementAssetsOfType)(element, assetType));

          case 21:
          case 'end':
            return _context3.stop();
        }
      }
    }, _marked2, this);
  }

  function connectToAssetChannel(requestID) {
    var prefix, pusherChannel, _pusherConnect, channel, unsubscribe, zipCreatedPromise;

    return _regeneratorRuntime.wrap(function connectToAssetChannel$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (0, _effects.select)(function (state) {
              return state.project.config.pusherAnonChannelPrefix;
            });

          case 2:
            prefix = _context4.sent;
            pusherChannel = prefix + '-' + requestID;
            _pusherConnect = (0, _pusher.connect)(pusherChannel), channel = _pusherConnect.channel, unsubscribe = _pusherConnect.unsubscribe;
            zipCreatedPromise = new Promise(function (resolve) {
              channel.bind(pusherConstants.EVENT_ASSESTS_ZIP_CREATED, function (response) {
                unsubscribe();
                resolve(response);
              });
            });
            return _context4.abrupt('return', {
              unsubscribe: unsubscribe,
              zipCreatedPromise: zipCreatedPromise
            });

          case 7:
          case 'end':
            return _context4.stop();
        }
      }
    }, _marked3, this);
  }
  /***/

},
/* 569 */

/***/
function (module, exports) {
  module.exports = require("md5");
  /***/
},
/* 570 */

/***/
function (module, exports) {
  module.exports = require("url");
  /***/
},
/* 571 */

/***/
function (module, exports) {
  module.exports = require("lodash/merge");
  /***/
},
/* 572 */

/***/
function (module, exports) {
  module.exports = require("pusher-js");
  /***/
},
/* 573 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = flashHotspots;

  var _effects = __webpack_require__(10);

  var _reduxSaga = __webpack_require__(34);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _actionCreators = __webpack_require__(4);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(flashHotspots);

  var actions = [actionTypes.FLASH_HOTSPOTS, actionTypes.SHOW_SCREEN];

  function flashHotspots() {
    return _regeneratorRuntime.wrap(function flashHotspots$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeLatest)(actions,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(_ref) {
              var type = _ref.type;
              var areHotspotHintsEnabled;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.select)(function (state) {
                        return state.project.config.areHotspotHintsEnabled;
                      });

                    case 2:
                      areHotspotHintsEnabled = _context.sent;

                      if (areHotspotHintsEnabled) {
                        _context.next = 5;
                        break;
                      }

                      return _context.abrupt('return');

                    case 5:
                      if (!(type === actionTypes.FLASH_HOTSPOTS)) {
                        _context.next = 10;
                        break;
                      }

                      _context.next = 8;
                      return (0, _effects.put)((0, _actionCreators.showHotspots)());

                    case 8:
                      _context.next = 10;
                      return (0, _effects.call)(_reduxSaga.delay, 300);

                    case 10:
                      _context.next = 12;
                      return (0, _effects.put)((0, _actionCreators.hideHotspots)());

                    case 12:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 574 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = handoffZoomFit;

  var _effects = __webpack_require__(10);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _handoff = __webpack_require__(5);

  var _handoffSidebar = __webpack_require__(89);

  var _screen = __webpack_require__(9);

  var _actionCreators = __webpack_require__(4);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(handoffZoomFit),
      _marked2 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(getAvailableWidth);

  function handoffZoomFit() {
    return _regeneratorRuntime.wrap(function handoffZoomFit$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeEvery)([actionTypes.LOAD_FULL_PROJECT_DONE, actionTypes.SHOW_SCREEN, actionTypes.SHOW_HANDOFF],
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee() {
              var inHandoffMode, zoomFit, availableWidth, zoomPosition;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.select)(_handoff.isInHandoffMode);

                    case 2:
                      inHandoffMode = _context.sent;
                      _context.next = 5;
                      return (0, _effects.select)(_handoff.getZoomFit);

                    case 5:
                      zoomFit = _context.sent;

                      if (!(inHandoffMode && zoomFit)) {
                        _context.next = 15;
                        break;
                      }

                      _context.next = 9;
                      return (0, _effects.call)(getAvailableWidth);

                    case 9:
                      availableWidth = _context.sent;
                      _context.next = 12;
                      return (0, _effects.select)(_handoff.getInitialZoom, availableWidth);

                    case 12:
                      zoomPosition = _context.sent;
                      _context.next = 15;
                      return (0, _effects.put)((0, _actionCreators.updateZoomPosition)(zoomPosition));

                    case 15:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }

  function getAvailableWidth() {
    var renderedDimensions, availableWidth;
    return _regeneratorRuntime.wrap(function getAvailableWidth$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _effects.select)(_screen.getRenderedScreenDimensions);

          case 2:
            renderedDimensions = _context3.sent;
            availableWidth = void 0;

            if (renderedDimensions.width < window.innerWidth) {
              availableWidth = renderedDimensions.width - _handoffSidebar.PADDING * 2;
            } else {
              // We subtract the sidebar WIDTH here because it is animating so
              // at the time if this calculation the screen width is larger than
              // it will be when the sidebar is open.
              availableWidth = renderedDimensions.width - _handoffSidebar.WIDTH - _handoffSidebar.PADDING * 2;
            }

            return _context3.abrupt('return', availableWidth);

          case 6:
          case 'end':
            return _context3.stop();
        }
      }
    }, _marked2, this);
  }
  /***/

},
/* 575 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = historyBack;

  var _effects = __webpack_require__(10);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(historyBack);

  function historyBack(history) {
    return _regeneratorRuntime.wrap(function historyBack$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _effects.takeLatest)(actionTypes.HISTORY_BACK, function () {
              history.goBack();
            });

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 576 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = loadCode;

  var _effects = __webpack_require__(10);

  var _partial = __webpack_require__(22);

  var _partial2 = babelHelpers.interopRequireDefault(_partial);

  var _jsCookie = __webpack_require__(67);

  var _jsCookie2 = babelHelpers.interopRequireDefault(_jsCookie);

  var _easelClient = __webpack_require__(173);

  var _api = __webpack_require__(174);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _project = __webpack_require__(11);

  var _screen = __webpack_require__(9);

  var _handoff = __webpack_require__(5);

  var _code = __webpack_require__(48);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(loadCode);

  var actions = [actionTypes.LOAD_CANVAS_STARTING, actionTypes.SET_CURRENT_LANG];

  function loadCode() {
    return _regeneratorRuntime.wrap(function loadCode$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeLatest)(actions,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee() {
              var lang, easelConfig, projectID, currentScreen, canvasClient, easelResponse;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.select)(function (state) {
                        return state.code.currentLang;
                      });

                    case 2:
                      lang = _context.sent;

                      if (lang) {
                        _context.next = 7;
                        break;
                      }

                      _context.next = 6;
                      return (0, _effects.select)(_code.getDefaultCodeLang);

                    case 6:
                      lang = _context.sent;

                    case 7:
                      _context.next = 9;
                      return (0, _effects.select)(_handoff.getEaselConfig);

                    case 9:
                      easelConfig = _context.sent;
                      configureEasel(easelConfig);
                      _context.next = 13;
                      return (0, _effects.select)(_project.getProjectNumericID);

                    case 13:
                      projectID = _context.sent;
                      _context.next = 16;
                      return (0, _effects.select)(_screen.getCurrentScreen);

                    case 16:
                      currentScreen = _context.sent;

                      if (currentScreen.canvasID) {
                        _context.next = 19;
                        break;
                      }

                      return _context.abrupt('return');

                    case 19:
                      _context.next = 21;
                      return (0, _effects.put)(actionCreators.loadCodeStart());

                    case 21:
                      _context.prev = 21;
                      _context.next = 24;
                      return (0, _effects.call)((0, _partial2.default)(_easelClient.Canvas.load, projectID, currentScreen.canvasID));

                    case 24:
                      canvasClient = _context.sent;
                      _context.next = 27;
                      return (0, _effects.call)(function () {
                        return canvasClient.fetchCode(lang);
                      });

                    case 27:
                      easelResponse = _context.sent;
                      _context.next = 30;
                      return (0, _effects.put)(actionCreators.loadCodeDone(lang, easelResponse));

                    case 30:
                      _context.next = 36;
                      break;

                    case 32:
                      _context.prev = 32;
                      _context.t0 = _context['catch'](21);
                      _context.next = 36;
                      return (0, _effects.put)(actionCreators.loadCodeFailed(lang, _context.t0));

                    case 36:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this, [[21, 32]]);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  } // TODO: Kill this copy pasta shit


  function configureEasel(_ref) {
    var canvasEaselHost = _ref.canvasEaselHost; // This is blank because it will then use the URL that the environment is on.
    // Mostly useful for local development, where an explicit value would break the proxy

    _api.tokenProvider.baseUri = '';
    _api.easel.baseUri = canvasEaselHost;
    _api.easel.versionPathString = 'v2';
    _api.images.csrfToken = _jsCookie2.default.get('csrftoken');
  }
  /***/

},
/* 577 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = loadHotspots;

  var _effects = __webpack_require__(10);

  var _partial = __webpack_require__(22);

  var _partial2 = babelHelpers.interopRequireDefault(_partial);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _api = __webpack_require__(103);

  var api = babelHelpers.interopRequireWildcard(_api);

  var _updateProjectConfig = __webpack_require__(175);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(loadHotspots),
      _marked2 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(fetchHotspots);

  function loadHotspots() {
    return _regeneratorRuntime.wrap(function loadHotspots$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeLatest)(actionTypes.LOAD_FULL_PROJECT_DONE,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(_ref) {
              var project = _ref.project,
                  token = _ref.token;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.put)(actionCreators.loadHotspotsStarting());

                    case 2:
                      return _context.delegateYield(fetchHotspots(project.id, (0, _partial2.default)(api.getHotspots, project.id, token), (0, _partial2.default)(updateHotspots, project), actionCreators.loadHotspotsFailed), 't0', 3);

                    case 3:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }

  function fetchHotspots(id, apiFn, done, failed) {
    var hotspots, response;
    return _regeneratorRuntime.wrap(function fetchHotspots$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return (0, _effects.call)(apiFn);

          case 3:
            hotspots = _context3.sent;
            _context3.next = 6;
            return (0, _effects.put)(done(hotspots));

          case 6:
            _context3.next = 8;
            return (0, _effects.put)(actionCreators.loadHotspotsDone());

          case 8:
            _context3.next = 20;
            break;

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3['catch'](0);

            if (!(_context3.t0 instanceof window.Response)) {
              _context3.next = 18;
              break;
            }

            response = _context3.t0;

            if (!(response.status === 404)) {
              _context3.next = 18;
              break;
            } // eslint-disable-next-line no-console


            console.error('Hotspots with id \'' + id + '\' does not exist.');
            _context3.next = 18;
            return (0, _effects.put)(actionCreators.notFound(id));

          case 18:
            _context3.next = 20;
            return (0, _effects.put)(failed(id, _context3.t0));

          case 20:
          case 'end':
            return _context3.stop();
        }
      }
    }, _marked2, this, [[0, 10]]);
  }

  function updateHotspots(project, hotspots) {
    var origProjectConfig = project.origProjectConfig;
    return actionCreators.setProject((0, _updateProjectConfig.addHotspots)(origProjectConfig, hotspots));
  }
  /***/

},
/* 578 */

/***/
function (module, exports) {
  module.exports = require("lodash/remove");
  /***/
},
/* 579 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var HOTSPOT_ACTIVE = exports.HOTSPOT_ACTIVE = 1;
  var HOTSPOT_DETACHED = exports.HOTSPOT_DETACHED = 2;
  var HOTSPOT_DELETED = exports.HOTSPOT_DELETED = 3;
  /***/
},
/* 580 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = preloadImages;

  var _effects = __webpack_require__(10);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _screen = __webpack_require__(76);

  var _selectors = __webpack_require__(64);

  var _getImageBatch = __webpack_require__(581);

  var _getImageBatch2 = babelHelpers.interopRequireDefault(_getImageBatch);

  var _image = __webpack_require__(51);

  var imgUtils = babelHelpers.interopRequireWildcard(_image);

  var _imagePreloading = __webpack_require__(30);

  var status = babelHelpers.interopRequireWildcard(_imagePreloading);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(preloadImages);

  var actions = [actionTypes.LOAD_HOTSPOTS_DONE, actionTypes.SET_PROJECT, actionTypes.SHOW_SCREEN, actionTypes.SHOW_OVERLAY];

  function preloadImages(dispatch) {
    return _regeneratorRuntime.wrap(function preloadImages$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeLatest)(actions,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee() {
              var currentScreen, project, screens, imageBatch, imagePreloadingStatus, imagesToPreload, batch;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.select)(_selectors.getCurrentScreen);

                    case 2:
                      currentScreen = _context.sent;
                      _context.next = 5;
                      return (0, _effects.select)(function (state) {
                        return state.project;
                      });

                    case 5:
                      project = _context.sent; // We need screens so we can get the adjacent screens to currentScreen

                      screens = project.config.screens.filter(function (screen) {
                        return (0, _selectors.isImageLoadable)(screen);
                      });
                      imageBatch = void 0;

                      if (false) {
                        // Most tests reqiure _all_ images to be loaded
                        imageBatch = screens.map(function (s) {
                          return {
                            id: s.id,
                            url: s.img.url
                          };
                        });
                      } else {
                        imageBatch = (0, _getImageBatch2.default)({
                          screen: currentScreen,
                          screens: screens,
                          screenMap: project.config.screenMap,
                          depth: _screen.PRELOADING_DEPTH
                        });
                      }

                      _context.next = 11;
                      return (0, _effects.select)(function (state) {
                        return state.imagePreloading;
                      });

                    case 11:
                      imagePreloadingStatus = _context.sent;
                      imagesToPreload = imageBatch.filter(function (image) {
                        return (// TODO why does === IDLE here not work?
                          imagePreloadingStatus[image.id] !== status.DONE && imagePreloadingStatus[image.id] !== status.PRELOADING
                        );
                      });

                    case 13:
                      if (!imagesToPreload.length) {
                        _context.next = 19;
                        break;
                      }

                      batch = imagesToPreload.splice(0, _screen.IMAGE_PRELOAD_BATCH_SIZE);
                      _context.next = 17;
                      return (0, _effects.call)(imgUtils.preloadImages, {
                        dispatch: dispatch,
                        images: batch,
                        successActionCreator: actionCreators.imageLoaded,
                        failureActionCreator: actionCreators.imageLoadFailed,
                        loadingStartActionCreator: actionCreators.imageLoadingStart
                      });

                    case 17:
                      _context.next = 13;
                      break;

                    case 19:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 581 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getImageBatch = getImageBatch;

  var _find = __webpack_require__(55);

  var _find2 = babelHelpers.interopRequireDefault(_find);

  var _uniqBy = __webpack_require__(147);

  var _uniqBy2 = babelHelpers.interopRequireDefault(_uniqBy);

  var _memoize = __webpack_require__(582);

  var _memoize2 = babelHelpers.interopRequireDefault(_memoize);

  var _contentStatus = __webpack_require__(37);

  var status = babelHelpers.interopRequireWildcard(_contentStatus);

  function getImageBatch(_ref) {
    var screen = _ref.screen,
        screens = _ref.screens,
        screenMap = _ref.screenMap,
        depth = _ref.depth; // each depth of screens stored as an array

    var queue = [[screen]];
    var batch = [];
    var iteration = 0;

    var _loop = function _loop() {
      var isLastScreen = depth - iteration <= 1; // don't want linked screens for images already in the batch

      var screensToGetLinkedScreensFor = queue[0].filter(function (_ref2) {
        var id = _ref2.id;
        return !(0, _find2.default)(batch, ['id', id]);
      });
      var linkedScreens = (0, _uniqBy2.default)(screensToGetLinkedScreensFor, 'id').reduce(function (queueAndBatch, currentScreen) {
        return getAllLinkedScreens({
          queueAndBatch: queueAndBatch,
          currentScreen: currentScreen,
          isLastScreen: isLastScreen,
          screens: screens,
          screenMap: screenMap
        });
      }, {
        screensToQueue: [],
        screensToAddToBatch: []
      });
      var screensToQueue = linkedScreens.screensToQueue,
          screensToAddToBatch = linkedScreens.screensToAddToBatch;
      if (screensToQueue.length) queue.push(screensToQueue);
      if (screensToAddToBatch.length) batch.push.apply(batch, babelHelpers.toConsumableArray(screensToAddToBatch)); // done with current depth, remove

      queue.shift();
      iteration += 1;
    };

    while (queue.length && iteration < depth) {
      _loop();
    }

    return batch;
  }

  function getAllLinkedScreens(_ref3) {
    var _ref3$queueAndBatch = _ref3.queueAndBatch,
        screensToAddToBatch = _ref3$queueAndBatch.screensToAddToBatch,
        screensToQueue = _ref3$queueAndBatch.screensToQueue,
        currentScreen = _ref3.currentScreen,
        isLastScreen = _ref3.isLastScreen,
        screens = _ref3.screens,
        screenMap = _ref3.screenMap;
    var id = currentScreen.id,
        url = currentScreen.img.url,
        order = currentScreen.order,
        contentStatus = currentScreen.contentStatus;
    var i = order - 1;
    var addToBatchScreens = screensToAddToBatch;

    if (isLoadable(contentStatus)) {
      addToBatchScreens = [].concat(babelHelpers.toConsumableArray(screensToAddToBatch), [{
        id: id,
        url: url
      }]);
    } // no need to queue screens for last iteration


    if (!isLastScreen) {
      var queueScreens = getScreensToQueue({
        screens: screens,
        i: i,
        currentScreen: currentScreen,
        screenMap: screenMap
      });
      return {
        screensToQueue: [].concat(babelHelpers.toConsumableArray(screensToQueue), babelHelpers.toConsumableArray(queueScreens)),
        screensToAddToBatch: addToBatchScreens
      };
    }

    return {
      screensToQueue: [].concat(babelHelpers.toConsumableArray(screensToQueue)),
      screensToAddToBatch: addToBatchScreens
    };
  }

  function getScreensToQueue(_ref4) {
    var screens = _ref4.screens,
        i = _ref4.i,
        currentScreen = _ref4.currentScreen,
        screenMap = _ref4.screenMap;
    var nextScreen = getAdjacentScreen(screens, i, 'next');
    var prevScreen = getAdjacentScreen(screens, i);
    var linkedScreens = getHotspotLinkedScreens({
      currentScreen: currentScreen,
      screenMap: screenMap
    });
    var screensToQueue = [nextScreen, prevScreen].concat(babelHelpers.toConsumableArray(linkedScreens)).filter(function (screen) {
      return isLoadable(screen.contentStatus);
    });
    return screensToQueue;
  }

  function getAdjacentScreen(screens, i, screenType) {
    var noOfScreens = screens.length;
    var screenIndex = void 0;

    if (screenType === 'next') {
      screenIndex = (i + 1) % noOfScreens;
    } else {
      screenIndex = (i - 1 + noOfScreens) % noOfScreens;
    }

    return screens[screenIndex];
  }

  function getHotspotLinkedScreens(_ref5) {
    var currentScreen = _ref5.currentScreen,
        screenMap = _ref5.screenMap;
    var linkedScreens = [];
    currentScreen.allHotspots.forEach(function (hotspot) {
      var id = hotspot.destinationScreenID;
      var screen = getScreenById(screenMap, id);
      linkedScreens.push(screen);
    });
    return linkedScreens;
  }

  function getScreenById(screenMap, id) {
    return screenMap[id];
  }

  function isLoadable(contentStatus) {
    return contentStatus === status.IMAGE_UPLOAD_DONE;
  }

  function cacheResolver(_ref6) {
    var screen = _ref6.screen,
        depth = _ref6.depth;
    return JSON.stringify({
      id: screen.id,
      depth: depth
    });
  }

  var getImagesToPreload = (0, _memoize2.default)(getImageBatch, cacheResolver);
  exports.default = getImagesToPreload;
  /***/
},
/* 582 */

/***/
function (module, exports) {
  module.exports = require("lodash/memoize");
  /***/
},
/* 583 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = loadProject;

  var _effects = __webpack_require__(10);

  var _partial = __webpack_require__(22);

  var _partial2 = babelHelpers.interopRequireDefault(_partial);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _api = __webpack_require__(103);

  var api = babelHelpers.interopRequireWildcard(_api);

  var _createProjectConfig = __webpack_require__(127);

  var _project = __webpack_require__(11);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(loadProject),
      _marked2 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(loadFullProject),
      _marked3 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(loadProjectPreview),
      _marked4 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(fetchProject);

  function loadProject() {
    return _regeneratorRuntime.wrap(function loadProject$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _effects.all)([(0, _effects.fork)(loadFullProject), (0, _effects.fork)(loadProjectPreview)]);

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this);
  }

  function loadFullProject() {
    return _regeneratorRuntime.wrap(function loadFullProject$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _effects.takeLatest)(actionTypes.LOAD_FULL_PROJECT,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(_ref) {
              var id = _ref.id,
                  token = _ref.token;
              return _regeneratorRuntime.wrap(function _callee$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (id) {
                        _context2.next = 4;
                        break;
                      }

                      _context2.next = 3;
                      return (0, _effects.select)(_project.getProjectID);

                    case 3:
                      id = _context2.sent;

                    case 4:
                      _context2.next = 6;
                      return (0, _effects.put)(actionCreators.loadFullProjectStarting(id));

                    case 6:
                      return _context2.delegateYield(fetchProject(id, (0, _partial2.default)(api.getProject, id, token), actionCreators.loadFullProjectDone, actionCreators.loadFullProjectFailed, token), 't0', 7);

                    case 7:
                    case 'end':
                      return _context2.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context3.stop();
        }
      }
    }, _marked2, this);
  }

  function loadProjectPreview() {
    return _regeneratorRuntime.wrap(function loadProjectPreview$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return (0, _effects.takeLatest)(actionTypes.LOAD_PROJECT_PREVIEW,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee2(_ref2) {
              var id = _ref2.id,
                  screenID = _ref2.screenID,
                  token = _ref2.token;
              return _regeneratorRuntime.wrap(function _callee2$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return (0, _effects.put)(actionCreators.loadProjectPreviewStarting(id));

                    case 2:
                      return _context4.delegateYield(fetchProject(id, (0, _partial2.default)(api.getProjectPreview, id, screenID, token), actionCreators.loadProjectPreviewDone, actionCreators.loadProjectPreviewFailed), 't0', 3);

                    case 3:
                    case 'end':
                      return _context4.stop();
                  }
                }
              }, _callee2, this);
            }));

          case 2:
          case 'end':
            return _context5.stop();
        }
      }
    }, _marked3, this);
  }

  function fetchProject(id, apiFn, done, failed, token) {
    var project, projectConfig, response;
    return _regeneratorRuntime.wrap(function fetchProject$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return (0, _effects.call)(apiFn);

          case 3:
            project = _context6.sent;
            projectConfig = (0, _createProjectConfig.createProjectConfig)(project);
            _context6.next = 7;
            return (0, _effects.put)(done(projectConfig, token));

          case 7:
            _context6.next = 25;
            break;

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6['catch'](0);

            if (!(_context6.t0 instanceof window.Response)) {
              _context6.next = 23;
              break;
            }

            response = _context6.t0;

            if (!(response.status === 404)) {
              _context6.next = 19;
              break;
            } // eslint-disable-next-line no-console


            console.error('Project with id \'' + id + '\' does not exist.');
            _context6.next = 17;
            return (0, _effects.put)(actionCreators.notFound(id));

          case 17:
            _context6.next = 23;
            break;

          case 19:
            if (!(response.status === 403)) {
              _context6.next = 23;
              break;
            }

            _context6.next = 22;
            return (0, _effects.put)(actionCreators.passwordRequired(id));

          case 22:
            // eslint-disable-next-line no-console
            console.error('Project with id \'' + id + '\' requires a password.');

          case 23:
            _context6.next = 25;
            return (0, _effects.put)(failed(id, _context6.t0));

          case 25:
          case 'end':
            return _context6.stop();
        }
      }
    }, _marked4, this, [[0, 9]]);
  }
  /***/

},
/* 584 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = loadThumbnails;

  var _effects = __webpack_require__(10);

  var _image = __webpack_require__(51);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _screen = __webpack_require__(76);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(loadThumbnails);

  var actions = [actionTypes.SHOW_GRID];

  function loadThumbnails(dispatch) {
    return _regeneratorRuntime.wrap(function loadThumbnails$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeLatest)(actions,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee() {
              var project, loadThumbs, isLoaded, imageThumbs, images;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.select)(function (state) {
                        return state.project;
                      });

                    case 2:
                      project = _context.sent;
                      _context.next = 5;
                      return (0, _effects.select)(function (state) {
                        return !(state.deviceDetection.isMobile || project.isEmbedded);
                      });

                    case 5:
                      loadThumbs = _context.sent;

                      if (!loadThumbs) {
                        _context.next = 17;
                        break;
                      }

                      _context.next = 9;
                      return (0, _effects.select)(function (state) {
                        return state.grid.isThumbLoaded;
                      });

                    case 9:
                      isLoaded = _context.sent;
                      imageThumbs = project.config.screens.filter(function (_ref) {
                        var id = _ref.id;
                        return !isLoaded[id];
                      }).map(function (screen) {
                        return {
                          id: screen.id,
                          url: screen.img.previewURL
                        };
                      });

                    case 11:
                      if (!(imageThumbs.length > 0)) {
                        _context.next = 17;
                        break;
                      }

                      images = imageThumbs.splice(0, _screen.IMAGE_PRELOAD_BATCH_SIZE);
                      _context.next = 15;
                      return (0, _effects.call)(_image.preloadImages, {
                        dispatch: dispatch,
                        images: images,
                        successActionCreator: actionCreators.imageThumbLoaded,
                        failureActionCreator: actionCreators.imageThumbFailed
                      });

                    case 15:
                      _context.next = 11;
                      break;

                    case 17:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 585 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = locationSaga;

  var _effects = __webpack_require__(10);

  var _reduxSaga = __webpack_require__(34);

  var _history = __webpack_require__(586);

  var _actionCreators = __webpack_require__(4);

  var _location = __webpack_require__(65);

  var locationUtils = babelHelpers.interopRequireWildcard(_location);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(locationSaga);

  function locationSaga(dispatch, history) {
    var savedState, currentLocation, match, historyChannel, location, newMatch;
    return _regeneratorRuntime.wrap(function locationSaga$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            savedState = void 0;
            currentLocation = history.location;
            match = getURLParts(currentLocation);
            /*
             * This event triggers project information to be saved
             * in the store. Without this, the project will not load
             */

            _context.next = 5;
            return (0, _effects.put)((0, _actionCreators.locationChanged)(match, currentLocation));

          case 5:
            _context.next = 7;
            return (0, _effects.fork)(_history.syncHistory, history, savedState);

          case 7:
            _context.next = 9;
            return (0, _effects.call)(createHistoryChannel, history);

          case 9:
            historyChannel = _context.sent;

          case 10:
            if (false) {
              _context.next = 19;
              break;
            }

            _context.next = 13;
            return (0, _effects.take)(historyChannel);

          case 13:
            location = _context.sent;
            newMatch = getURLParts(location);
            _context.next = 17;
            return (0, _effects.put)((0, _actionCreators.locationChanged)(newMatch, location));

          case 17:
            _context.next = 10;
            break;

          case 19:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this);
  }

  function getURLParts(location) {
    var match = locationUtils.parse(location);

    if (location.state) {
      match = babelHelpers.extends({}, match, location.state);
    }

    if (!match.hotspotID) {
      match.hotspotID = null;
    }

    return match;
  }
  /*
    * Listen to navigation events, e.g. back button 
    * location - location that we're navigating to
    * action - current location action
    */


  function createHistoryChannel(history) {
    return (0, _reduxSaga.eventChannel)(function (emit) {
      var locationHandler = function locationHandler(location) {
        // puts location into the channel to give the Saga access to it
        emit(location);
      };

      var unlisten = history.listen(function (location, action) {
        if (action === 'POP') {
          locationHandler(location);
        }
      }); // The subscriber must return an unsubscribe function

      return unlisten;
    });
  }
  /***/

},
/* 586 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.syncHistory = syncHistory;

  var _effects = __webpack_require__(10);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _location = __webpack_require__(65);

  var locationUtils = babelHelpers.interopRequireWildcard(_location);

  var _isBrowserInFullScreenMode = __webpack_require__(56);

  var _isBrowserInFullScreenMode2 = babelHelpers.interopRequireDefault(_isBrowserInFullScreenMode);

  var _selectors = __webpack_require__(64);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(syncHistory),
      _marked2 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(updateLocation),
      _marked3 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(updateLocationWithState);

  function syncHistory(history) {
    return _regeneratorRuntime.wrap(function syncHistory$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeEvery)('*',
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(action) {
              var applicationState, _locationUtils$parse, screenID, pathname, transition, screenTransition, locationObject, projectID;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.select)();

                    case 2:
                      applicationState = _context.sent;
                      _context.t0 = action.type;
                      _context.next = _context.t0 === actionTypes.LOAD_HOTSPOTS_DONE ? 6 : _context.t0 === actionTypes.LOAD_PROJECT_PREVIEW_DONE ? 6 : _context.t0 === actionTypes.SHOW_OVERLAY ? 13 : _context.t0 === actionTypes.SHOW_HANDOFF ? 13 : _context.t0 === actionTypes.HIDE_HANDOFF ? 13 : _context.t0 === actionTypes.HIDE_COMMENTS ? 13 : _context.t0 === actionTypes.HIDE_OVERLAY ? 16 : _context.t0 === actionTypes.SHOW_SCREEN ? 20 : _context.t0 === actionTypes.SET_PROJECT ? 24 : 31;
                      break;

                    case 6:
                      _locationUtils$parse = locationUtils.parse(history.location), screenID = _locationUtils$parse.screenID;

                      if (screenID) {
                        _context.next = 12;
                        break;
                      }

                      _context.next = 10;
                      return (0, _effects.select)(_selectors.getPathnameFromState);

                    case 10:
                      pathname = _context.sent;
                      history.replace(pathname);

                    case 12:
                      return _context.abrupt('break', 32);

                    case 13:
                      _context.next = 15;
                      return updateLocation(history);

                    case 15:
                      return _context.abrupt('break', 32);

                    case 16:
                      transition = applicationState.screen.previousOverlayHotspot.transition;
                      _context.next = 19;
                      return updateLocationWithState(history, {
                        overlayTransition: transition
                      });

                    case 19:
                      return _context.abrupt('break', 32);

                    case 20:
                      screenTransition = applicationState.screen.transition;
                      _context.next = 23;
                      return updateLocationWithState(history, {
                        screenTransition: screenTransition
                      });

                    case 23:
                      return _context.abrupt('break', 32);

                    case 24:
                      locationObject = history.location;
                      projectID = void 0;

                      if (locationObject) {
                        projectID = locationUtils.parse(locationObject).projectID;
                      }

                      if (!((0, _isBrowserInFullScreenMode2.default)() || !projectID)) {
                        _context.next = 30;
                        break;
                      }

                      _context.next = 30;
                      return updateLocation(history);

                    case 30:
                      return _context.abrupt('break', 32);

                    case 31:
                      return _context.abrupt('break', 32);

                    case 32:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }

  function updateLocation(history) {
    var pathname, inHandoff;
    return _regeneratorRuntime.wrap(function updateLocation$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _effects.select)(_selectors.getPathnameFromState);

          case 2:
            pathname = _context3.sent;
            _context3.next = 5;
            return (0, _effects.select)(_selectors.isInHandoffMode);

          case 5:
            inHandoff = _context3.sent; // Don't push a pathname that is the same as the current one. This
            // fixes the issue with being able to navigate back to the bare
            // project url when a prototype is opened from pie. Pie always calls
            // HIDE_COMMENTS which was causing us to push /<vanity> onto the
            // stack *before* the replace was called to replace /<vanity> with /<vanity>/screen/<screen>/

            if (pathname !== history.location.pathname && pathname + '/' !== history.location.pathname) {
              history.push(pathname, {
                inHandoff: inHandoff
              });
            }

          case 7:
          case 'end':
            return _context3.stop();
        }
      }
    }, _marked2, this);
  }

  function updateLocationWithState(history, stateObj) {
    var pathname, inHandoff, newLocationState;
    return _regeneratorRuntime.wrap(function updateLocationWithState$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (0, _effects.select)(_selectors.getPathnameFromState);

          case 2:
            pathname = _context4.sent;
            _context4.next = 5;
            return (0, _effects.select)(_selectors.isInHandoffMode);

          case 5:
            inHandoff = _context4.sent;
            newLocationState = Object.assign({}, stateObj, {
              inHandoff: inHandoff
            });
            history.push(pathname, newLocationState);

          case 8:
          case 'end':
            return _context4.stop();
        }
      }
    }, _marked3, this);
  }
  /***/

},
/* 587 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = pusherSaga;

  var _get = __webpack_require__(13);

  var _get2 = babelHelpers.interopRequireDefault(_get);

  var _effects = __webpack_require__(10);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _pusher = __webpack_require__(172);

  var _pusher2 = __webpack_require__(104);

  var pusherConstants = babelHelpers.interopRequireWildcard(_pusher2);

  var _updateProjectConfig = __webpack_require__(175);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(pusherSaga);

  var projectActions = [actionTypes.LOAD_FULL_PROJECT_DONE, actionTypes.LOAD_PROJECT_PREVIEW_DONE, actionTypes.SET_PROJECT];

  function pusherSaga(dispatch) {
    var projectID, channel, unsubscribe, origProjectConfig;
    return _regeneratorRuntime.wrap(function pusherSaga$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            projectID = void 0;
            channel = void 0;
            unsubscribe = void 0;
            origProjectConfig = void 0;
            _context2.next = 6;
            return (0, _effects.takeEvery)(projectActions,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(_ref) {
              var projectConfig = _ref.project;

              var channelName, isDownloaded, _connect;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      channelName = projectConfig.pusherChannel;
                      _context.next = 3;
                      return (0, _effects.select)(function (state) {
                        return state.project.isDownloaded;
                      });

                    case 3:
                      isDownloaded = _context.sent;

                      if (!(!channelName || isDownloaded)) {
                        _context.next = 6;
                        break;
                      }

                      return _context.abrupt('return');

                    case 6:
                      origProjectConfig = projectConfig.origProjectConfig;

                      if (projectID !== projectConfig.numericID) {
                        projectID = projectConfig.numericID;

                        if (unsubscribe) {
                          unsubscribe();
                        }

                        _connect = (0, _pusher.connect)(channelName);
                        channel = _connect.channel;
                        unsubscribe = _connect.unsubscribe;
                        channel.bind(pusherConstants.EVENT_HOTSPOT, function (res) {
                          var hotspot = (0, _get2.default)(res, 'content.object');

                          if (hotspot) {
                            dispatch(actionCreators.setProject((0, _updateProjectConfig.updateHotspot)(origProjectConfig, hotspot)));
                          }
                        });
                        channel.bind(pusherConstants.EVENT_CONTENT_UPDATED, function () {
                          // TODO: smart update
                          dispatch(actionCreators.loadFullProject(projectConfig.id));
                        });
                        channel.bind(pusherConstants.EVENT_CONTENT_CREATED, function () {
                          // TODO: smart update
                          dispatch(actionCreators.loadFullProject(projectConfig.id));
                        });
                      }

                    case 8:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 6:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 588 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = reloadImages;

  var _effects = __webpack_require__(10);

  var _pickBy = __webpack_require__(171);

  var _pickBy2 = babelHelpers.interopRequireDefault(_pickBy);

  var _keys = __webpack_require__(589);

  var _keys2 = babelHelpers.interopRequireDefault(_keys);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _imagePreloading = __webpack_require__(30);

  var status = babelHelpers.interopRequireWildcard(_imagePreloading);

  var _image = __webpack_require__(51);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(reloadImages); // It seems that sometimes pre-loaded images are dumped from the browser's memory
  // when you change tab away from the prototype viewer.
  // To combat this we trigger a reload of all the images that are DONE, ie
  // those the application _think_ are loaded but may have been dumped out of memory


  function reloadImages(dispatch) {
    return _regeneratorRuntime.wrap(function reloadImages$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeLatest)(actionTypes.RELOAD_IMAGES,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee() {
              var project, screensToReload, imagesToReload;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.select)(function (state) {
                        return state.project;
                      });

                    case 2:
                      project = _context.sent;

                      if (project.config.screens) {
                        _context.next = 5;
                        break;
                      }

                      return _context.abrupt('return');

                    case 5:
                      _context.next = 7;
                      return (0, _effects.select)(function (state) {
                        return (0, _pickBy2.default)(state.imagePreloading, function (value) {
                          return value === status.RELOADING;
                        });
                      });

                    case 7:
                      screensToReload = _context.sent;
                      imagesToReload = (0, _keys2.default)(screensToReload).map(function (screenID) {
                        return {
                          id: screenID,
                          url: project.config.screenMap[screenID].img.url
                        };
                      }); // TODO not sure whether to batch these or not -- should be quick as reloading from cache

                      _context.next = 11;
                      return (0, _effects.call)(_image.preloadImages, {
                        dispatch: dispatch,
                        images: imagesToReload,
                        successActionCreator: actionCreators.imageLoaded,
                        failureActionCreator: actionCreators.imageLoadFailed
                      });

                    case 11:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 589 */

/***/
function (module, exports) {
  module.exports = require("lodash/keys");
  /***/
},
/* 590 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = screenTimer;

  var _effects = __webpack_require__(10);

  var _reduxSaga = __webpack_require__(34);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _actionCreators = __webpack_require__(4);

  var _timer = __webpack_require__(165);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(screenTimer);

  function screenTimer() {
    return _regeneratorRuntime.wrap(function screenTimer$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeLatest)(actionTypes.SCREEN_TIMER,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(_ref) {
              var timer = _ref.timer;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!timer) {
                        _context.next = 8;
                        break;
                      }

                      _context.next = 3;
                      return (0, _effects.call)(_reduxSaga.delay, timer.ms);

                    case 3:
                      _context.next = 5;
                      return (0, _effects.select)(_timer.areTimersEnabled);

                    case 5:
                      if (!_context.sent) {
                        _context.next = 8;
                        break;
                      }

                      _context.next = 8;
                      return (0, _effects.put)((0, _actionCreators.showScreen)(timer.destScreenID, timer.transition));

                    case 8:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 591 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = setCodeLang;

  var _effects = __webpack_require__(10);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _code = __webpack_require__(48);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(setCodeLang);

  var projectActions = [actionTypes.LOAD_FULL_PROJECT_DONE, actionTypes.LOAD_PROJECT_PREVIEW_DONE, actionTypes.SET_PROJECT];

  function setCodeLang() {
    return _regeneratorRuntime.wrap(function setCodeLang$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeLatest)(projectActions,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee() {
              var codeLang;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.select)(_code.getDefaultCodeLang);

                    case 2:
                      codeLang = _context.sent;
                      _context.next = 5;
                      return (0, _effects.put)(actionCreators.setDefaultProjectLang(codeLang));

                    case 5:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 592 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = setEmbedlyContainerHeight;

  var _effects = __webpack_require__(10);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(setEmbedlyContainerHeight);

  function setEmbedlyContainerHeight() {
    return _regeneratorRuntime.wrap(function setEmbedlyContainerHeight$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _effects.takeLatest)(actionTypes.SET_CONTAINER_HEIGHT, function (_ref) {
              var height = _ref.height; // See http://docs.embed.ly/v1.0/docs/provider-height-resizing

              window.parent.postMessage(JSON.stringify({
                src: window.location.toString(),
                context: 'iframe.resize',
                height: height
              }), '*');
            });

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 593 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = _callee2;

  var _effects = __webpack_require__(10);

  var _reduxSaga = __webpack_require__(34);

  var _actionCreators = __webpack_require__(4);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(_callee2);

  function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeEvery)(actionTypes.SHOW_COPYING,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(_ref) {
              var target = _ref.target;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.call)(_reduxSaga.delay, 500);

                    case 2:
                      _context.next = 4;
                      return (0, _effects.put)((0, _actionCreators.showCopyingDone)(target));

                    case 4:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 594 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = showScreenInfoSaga;

  var _effects = __webpack_require__(10);

  var _reduxSaga = __webpack_require__(34);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _actionCreators = __webpack_require__(4);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(showScreenInfoSaga);

  var actions = [actionTypes.SHOW_NEXT, actionTypes.SHOW_PREVIOUS, actionTypes.SHOW_HOME];

  function showScreenInfoSaga() {
    return _regeneratorRuntime.wrap(function showScreenInfoSaga$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeLatest)(actions,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.put)((0, _actionCreators.showScreenInfo)());

                    case 2:
                      _context.next = 4;
                      return (0, _effects.call)(_reduxSaga.delay, 1000);

                    case 4:
                      _context.next = 6;
                      return (0, _effects.put)((0, _actionCreators.hideScreenInfo)());

                    case 6:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 595 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = triggerAssetDownload;

  var _effects = __webpack_require__(10);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(triggerAssetDownload);

  function triggerAssetDownload() {
    return _regeneratorRuntime.wrap(function triggerAssetDownload$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _effects.takeEvery)(actionTypes.ASSETS_ZIP_CREATED, function (_ref) {
              var url = _ref.url; // TODO this work in IE/Edge?

              window.location.href = url;
            });

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this);
  }
  /***/

},
/* 596 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.hoverOut = hoverOut;
  exports.default = watchHoverOut;

  var _effects = __webpack_require__(10);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _hover = __webpack_require__(100);

  var _actionCreators = __webpack_require__(4);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(hoverOut),
      _marked2 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(watchHoverOut);

  function hoverOut(_ref) {
    var numberOfLevels = _ref.numberOfLevels,
        scrollPos = _ref.scrollPos;
    var hoverStack, currentHotspot;
    return _regeneratorRuntime.wrap(function hoverOut$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _effects.select)(_hover.getHoverStack);

          case 2:
            hoverStack = _context.sent;
            currentHotspot = hoverStack[hoverStack.length - numberOfLevels];
            _context.next = 6;
            return (0, _effects.put)((0, _actionCreators.removeFromHoverStack)(numberOfLevels));

          case 6:
            if (currentHotspot.maintainScroll) {
              // update scrollPos in case user has scrolled while hovered in
              currentHotspot.scrollPos.current = scrollPos;
            }

            _context.next = 9;
            return (0, _effects.put)((0, _actionCreators.showHoverScreen)(currentHotspot.screenID, currentHotspot.scrollPos));

          case 9:
            if (!currentHotspot.layerID) {
              _context.next = 12;
              break;
            }

            _context.next = 12;
            return (0, _effects.put)((0, _actionCreators.showHoverOverlay)(currentHotspot.layerID));

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this);
  }

  function watchHoverOut() {
    return _regeneratorRuntime.wrap(function watchHoverOut$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeLatest)(actionTypes.HOVER_OUT, hoverOut);

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked2, this);
  }
  /***/

},
/* 597 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createEnhancedHistory = createEnhancedHistory;

  var _history = __webpack_require__(598);

  var _location = __webpack_require__(65); // Create an enhanced history used to trigger navigation events


  function createEnhancedHistory() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        isAppBuild = _ref.isAppBuild,
        isDownloaded = _ref.isDownloaded;

    var enhancedHistory = void 0;

    if ( // wen can't use history.pushState() in tests
    "production" === 'test' || // Prevent embedded prototypes hijacking the host page's history
    (0, _location.isEmbedded)() || // The player runs from the local file system when is dowloaded as zip
    window.location.protocol === 'file:' || // The webview that app builds use don't implement browser
    // history properly
    isAppBuild) {
      enhancedHistory = (0, _history.createMemoryHistory)({
        initialEntries: [(0, _location.getFullPath)()]
      });
    } else if (isDownloaded) {
      enhancedHistory = (0, _history.createHashHistory)();
    } else {
      enhancedHistory = (0, _history.createBrowserHistory)();
    }

    return enhancedHistory;
  }
  /***/

},
/* 598 */

/***/
function (module, exports) {
  module.exports = require("history");
  /***/
},
/* 599 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = loadCanvas;

  var _effects = __webpack_require__(10);

  var _partial = __webpack_require__(22);

  var _partial2 = babelHelpers.interopRequireDefault(_partial);

  var _jsCookie = __webpack_require__(67);

  var _jsCookie2 = babelHelpers.interopRequireDefault(_jsCookie);

  var _easelClient = __webpack_require__(173);

  var _api = __webpack_require__(174);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _actionCreators = __webpack_require__(4);

  var actionCreators = babelHelpers.interopRequireWildcard(_actionCreators);

  var _selectors = __webpack_require__(64);

  var _marked =
  /*#__PURE__*/
  _regeneratorRuntime.mark(loadCanvas),
      _marked2 =
  /*#__PURE__*/
  _regeneratorRuntime.mark(isCanvasAlreadyLoaded);
  /*
    SHOW_SCREEN - switching between screens in handoff mode
    SHOW_HANDOFF - entering handoff (needed in case a layer is shown
      and we need to load its canvas data)
    LOAD_HOTSPOTS_DONE - initial load (We need to listen to this 
      to make sure hotspotMap is available (hotspots load after project loads), 
      in case we open handoff before hotspots fully loaded)
  */


  var screenChangeActions = [actionTypes.SHOW_SCREEN, actionTypes.SHOW_HANDOFF, actionTypes.LOAD_HOTSPOTS_DONE];

  function loadCanvas() {
    return _regeneratorRuntime.wrap(function loadCanvas$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.takeEvery)(screenChangeActions,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee() {
              var easelConfig, projectID, currentScreen, canvasClient, easelResponse;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return (0, _effects.select)(_selectors.getEaselConfig);

                    case 2:
                      easelConfig = _context.sent;
                      configureEasel(easelConfig);
                      _context.next = 6;
                      return (0, _effects.select)(_selectors.getProjectNumericID);

                    case 6:
                      projectID = _context.sent;
                      _context.next = 9;
                      return (0, _effects.select)(_selectors.getCurrentScreen);

                    case 9:
                      currentScreen = _context.sent;

                      if (currentScreen.canvasID) {
                        _context.next = 12;
                        break;
                      }

                      return _context.abrupt('return');

                    case 12:
                      return _context.delegateYield(isCanvasAlreadyLoaded(currentScreen), 't0', 13);

                    case 13:
                      if (!_context.t0) {
                        _context.next = 15;
                        break;
                      }

                      return _context.abrupt('return');

                    case 15:
                      _context.next = 17;
                      return (0, _effects.put)(actionCreators.loadCanvasStarting());

                    case 17:
                      _context.prev = 17;
                      _context.next = 20;
                      return (0, _effects.call)((0, _partial2.default)(_easelClient.Canvas.load, projectID, currentScreen.canvasID));

                    case 20:
                      canvasClient = _context.sent;
                      _context.next = 23;
                      return (0, _effects.call)(function () {
                        return canvasClient.fetch();
                      });

                    case 23:
                      easelResponse = _context.sent;
                      _context.next = 26;
                      return (0, _effects.put)(actionCreators.loadCanvasDone(easelResponse.canvas, currentScreen.sourcePlatform));

                    case 26:
                      _context.next = 32;
                      break;

                    case 28:
                      _context.prev = 28;
                      _context.t1 = _context['catch'](17);
                      _context.next = 32;
                      return (0, _effects.put)(actionCreators.loadCanvasFailed(currentScreen.id, _context.t1));

                    case 32:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this, [[17, 28]]);
            }));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked, this);
  }

  function isCanvasAlreadyLoaded(currentScreen) {
    var currentCanvasID;
    return _regeneratorRuntime.wrap(function isCanvasAlreadyLoaded$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _effects.select)(_selectors.getCurrentCanvasID);

          case 2:
            currentCanvasID = _context3.sent;
            return _context3.abrupt('return', currentCanvasID === currentScreen.canvasID);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _marked2, this);
  }

  function configureEasel(_ref) {
    var canvasEaselHost = _ref.canvasEaselHost; // This is blank because it will then use the URL that the environment is on.
    // Mostly useful for local development, where an explicit value would break the proxy

    _api.tokenProvider.baseUri = '';
    _api.easel.baseUri = canvasEaselHost;
    _api.easel.versionPathString = 'v2';
    _api.images.csrfToken = _jsCookie2.default.get('csrftoken');
  }
  /***/

},
/* 600 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _noop = __webpack_require__(12);

  var _noop2 = babelHelpers.interopRequireDefault(_noop);

  var _actionTypes = __webpack_require__(3);

  var actionTypes = babelHelpers.interopRequireWildcard(_actionTypes);

  var _screen2 = __webpack_require__(9);

  var _overlay = __webpack_require__(36);

  exports.default = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$onScreenChange = _ref.onScreenChange,
        onScreenChange = _ref$onScreenChange === undefined ? _noop2.default : _ref$onScreenChange,
        _ref$onShowComments = _ref.onShowComments,
        onShowComments = _ref$onShowComments === undefined ? _noop2.default : _ref$onShowComments,
        _ref$onAddNewAnnotati = _ref.onAddNewAnnotation,
        onAddNewAnnotation = _ref$onAddNewAnnotati === undefined ? _noop2.default : _ref$onAddNewAnnotati,
        _ref$onMoveAnnotation = _ref.onMoveAnnotation,
        onMoveAnnotation = _ref$onMoveAnnotation === undefined ? _noop2.default : _ref$onMoveAnnotation,
        _ref$onHighlightComme = _ref.onHighlightComment,
        onHighlightComment = _ref$onHighlightComme === undefined ? _noop2.default : _ref$onHighlightComme,
        _ref$onUnHighlightCom = _ref.onUnHighlightComment,
        onUnHighlightComment = _ref$onUnHighlightCom === undefined ? _noop2.default : _ref$onUnHighlightCom,
        _ref$onShowOverlay = _ref.onShowOverlay,
        onShowOverlay = _ref$onShowOverlay === undefined ? _noop2.default : _ref$onShowOverlay,
        _ref$onHideOverlay = _ref.onHideOverlay,
        onHideOverlay = _ref$onHideOverlay === undefined ? _noop2.default : _ref$onHideOverlay,
        _ref$onLeaveAnnotatio = _ref.onLeaveAnnotationMode,
        onLeaveAnnotationMode = _ref$onLeaveAnnotatio === undefined ? _noop2.default : _ref$onLeaveAnnotatio,
        _ref$onPlayerReady = _ref.onPlayerReady,
        onPlayerReady = _ref$onPlayerReady === undefined ? _noop2.default : _ref$onPlayerReady,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? _noop2.default : _ref$onClick,
        _ref$onMissedClick = _ref.onMissedClick,
        onMissedClick = _ref$onMissedClick === undefined ? _noop2.default : _ref$onMissedClick;

    var previousScreenID = void 0;
    var isPlayerReady = false;
    return function (action, state, previousState) {
      switch (action.type) {
        case actionTypes.CLICK:
          onClick(action.position);
          break;

        case actionTypes.MISSED_CLICK:
          onMissedClick(action.position);
          break;

        case actionTypes.SCREEN_TRANSITION_COMPLETED:
          {
            // This will encompass any action where the screen is set or changes
            if (areScreenTransitionsComplete(state)) {
              var screen = (0, _screen2.getCurrentScreen)(state);
              var hoverStack = state.hoverStack;

              if (screen.id !== previousScreenID && hoverStack.length === 0) {
                onScreenChange(screen);
                /* 
                 * SCREEN_TRANSITION_COMPLETED gets dispatched multiple times per screen.
                 * Reset previous screen to prevent onScreenChange 
                 * being called multiple times for one screen
                 */

                previousScreenID = screen.id;
              }
            }

            break;
          }

        case actionTypes.SHOW_SCREEN:
          {
            /* 
             * SHOW_SCREEN sets screen id when called, which means previous screen id 
             * will not be available within SCREEN_TRANSITION_COMPLETED
             */
            var prevScreen = (0, _screen2.getCurrentScreen)(previousState);

            if (prevScreen) {
              previousScreenID = prevScreen.id;
            }

            break;
          }

        case actionTypes.SHOW_OVERLAY:
          {
            // TODO probably want a single event for screen and overlay transitions
            var _getOverlay = (0, _overlay.getOverlay)(state, true),
                overlay = _getOverlay.overlay;

            onShowOverlay(overlay);
            break;
          }

        case actionTypes.HIDE_OVERLAY:
          {
            var _screen = (0, _screen2.getCurrentScreen)(state);

            onHideOverlay(_screen);
            break;
          }

        case actionTypes.SHOW_COMMENTS:
          onShowComments();
          break;

        case actionTypes.HIGHLIGHT_COMMENT:
          onHighlightComment(action.id);
          break;

        case actionTypes.UNHIGHLIGHT_COMMENT:
          onUnHighlightComment();
          break;

        case actionTypes.ADD_NEW_ANNOTATION:
          {
            var _previousState$annota = previousState.annotation.nextAnnotation,
                commentUUID = _previousState$annota.commentUUID,
                reference = _previousState$annota.reference;
            var newAnnotation = state.annotation.annotations[commentUUID];
            onAddNewAnnotation(commentUUID, reference, newAnnotation);
          }
          break;

        case actionTypes.POSITION_ANNOTATION:
          {
            var _commentUUID = action.commentUUID;
            var annotation = state.annotation.annotations[_commentUUID];
            onMoveAnnotation(annotation);
            break;
          }

        case actionTypes.LOCATION_CHANGED:
          {
            var highlightedComment = action.highlightedComment;

            if (highlightedComment) {
              onHighlightComment(highlightedComment);
            }

            break;
          }

        case actionTypes.LEAVE_ANNOTATION_MODE:
          onLeaveAnnotationMode();
          break;

        case actionTypes.IMAGE_LOADED:
          {
            var _getPendingAndLoadedS = (0, _screen2.getPendingAndLoadedScreenCounts)(state),
                noOfPendingImages = _getPendingAndLoadedS.noOfPendingImages;

            if (noOfPendingImages === 0 && !isPlayerReady) {
              onPlayerReady();
              isPlayerReady = true;
            }
          }
          break;

        default:
          break;
      }
    };
  };

  function areScreenTransitionsComplete(state) {
    var _state$screen = state.screen,
        previousScreen = _state$screen.previousScreen,
        isTransitionComplete = _state$screen.isTransitionComplete;
    return isInitialPageLoadAndCurrentScreenTransitioned(previousScreen, isTransitionComplete) || areBothScreensTransitioned(isTransitionComplete);
  }

  function isInitialPageLoadAndCurrentScreenTransitioned(previousScreen, isTransitionComplete) {
    return !previousScreen && isTransitionComplete.current;
  }

  function areBothScreensTransitioned(isTransitionComplete) {
    var previous = isTransitionComplete.previous,
        current = isTransitionComplete.current;
    return previous && current;
  }
  /***/

},
/* 601 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var listenMiddleware = function listenMiddleware(listener) {
    return function (store) {
      return function (next) {
        return function (action) {
          var previousState = store.getState();
          var result = next(action);
          listener(action, store.getState(), previousState);
          return result;
        };
      };
    };
  };

  exports.default = listenMiddleware;
  /***/
}]);